var _excluded = ["inputs"],
    _excluded2 = ["inputId"],
    _excluded3 = ["inputs"],
    _excluded4 = ["inputId"],
    _excluded5 = ["type"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __defProp = Object.defineProperty;

var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

var _a;

var __defProp$1 = Object.defineProperty;

var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __publicField$1 = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);

var NodeType$3 = /* @__PURE__ */(NodeType2 => {
  NodeType2[NodeType2["Document"] = 0] = "Document";
  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
  NodeType2[NodeType2["Element"] = 2] = "Element";
  NodeType2[NodeType2["Text"] = 3] = "Text";
  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
  NodeType2[NodeType2["Comment"] = 5] = "Comment";
  return NodeType2;
})(NodeType$3 || {});

var testableAccessors$1 = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
};
var testableMethods$1 = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
};
var untaintedBasePrototype$1 = {};

var isAngularZonePresent$1 = () => {
  return !!globalThis.Zone;
};

function getUntaintedPrototype$1(key) {
  if (untaintedBasePrototype$1[key]) return untaintedBasePrototype$1[key];
  var defaultObj = globalThis[key];
  var defaultPrototype = defaultObj.prototype;
  var accessorNames = key in testableAccessors$1 ? testableAccessors$1[key] : void 0;
  var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
  accessorNames.every(accessor => {
    var _a2, _b;

    return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
  }));
  var methodNames = key in testableMethods$1 ? testableMethods$1[key] : void 0;
  var isUntaintedMethods = Boolean(methodNames && methodNames.every( // @ts-expect-error 2345
  method => {
    var _a2;

    return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
  }));

  if (isUntaintedAccessors && isUntaintedMethods && !isAngularZonePresent$1()) {
    untaintedBasePrototype$1[key] = defaultObj.prototype;
    return defaultObj.prototype;
  }

  try {
    var iframeEl = document.createElement("iframe");
    document.body.appendChild(iframeEl);
    var win = iframeEl.contentWindow;
    if (!win) return defaultObj.prototype;
    var untaintedObject = win[key].prototype;
    document.body.removeChild(iframeEl);
    if (!untaintedObject) return defaultPrototype;
    return untaintedBasePrototype$1[key] = untaintedObject;
  } catch (_unused) {
    return defaultPrototype;
  }
}

var untaintedAccessorCache$1 = {};

function getUntaintedAccessor$1(key, instance, accessor) {
  var _a2;

  var cacheKey = "".concat(key, ".").concat(String(accessor));
  if (untaintedAccessorCache$1[cacheKey]) return untaintedAccessorCache$1[cacheKey].call(instance);
  var untaintedPrototype = getUntaintedPrototype$1(key);
  var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
  if (!untaintedAccessor) return instance[accessor];
  untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
  return untaintedAccessor.call(instance);
}

var untaintedMethodCache$1 = {};

function getUntaintedMethod$1(key, instance, method) {
  var cacheKey = "".concat(key, ".").concat(String(method));
  if (untaintedMethodCache$1[cacheKey]) return untaintedMethodCache$1[cacheKey].bind(instance);
  var untaintedPrototype = getUntaintedPrototype$1(key);
  var untaintedMethod = untaintedPrototype[method];
  if (typeof untaintedMethod !== "function") return instance[method];
  untaintedMethodCache$1[cacheKey] = untaintedMethod;
  return untaintedMethod.bind(instance);
}

function childNodes$1(n2) {
  return getUntaintedAccessor$1("Node", n2, "childNodes");
}

function parentNode$1(n2) {
  return getUntaintedAccessor$1("Node", n2, "parentNode");
}

function parentElement$1(n2) {
  return getUntaintedAccessor$1("Node", n2, "parentElement");
}

function textContent$1(n2) {
  return getUntaintedAccessor$1("Node", n2, "textContent");
}

function contains$1(n2, other) {
  return getUntaintedMethod$1("Node", n2, "contains")(other);
}

function getRootNode$1(n2) {
  return getUntaintedMethod$1("Node", n2, "getRootNode")();
}

function host$1(n2) {
  if (!n2 || !("host" in n2)) return null;
  return getUntaintedAccessor$1("ShadowRoot", n2, "host");
}

function styleSheets$1(n2) {
  return n2.styleSheets;
}

function shadowRoot$1(n2) {
  if (!n2 || !("shadowRoot" in n2)) return null;
  return getUntaintedAccessor$1("Element", n2, "shadowRoot");
}

function querySelector$1(n2, selectors) {
  return getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}

function querySelectorAll$1(n2, selectors) {
  return getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}

function mutationObserverCtor$1() {
  return getUntaintedPrototype$1("MutationObserver").constructor;
}

var index$1 = {
  childNodes: childNodes$1,
  parentNode: parentNode$1,
  parentElement: parentElement$1,
  textContent: textContent$1,
  contains: contains$1,
  getRootNode: getRootNode$1,
  host: host$1,
  styleSheets: styleSheets$1,
  shadowRoot: shadowRoot$1,
  querySelector: querySelector$1,
  querySelectorAll: querySelectorAll$1,
  mutationObserver: mutationObserverCtor$1
};

function isElement(n2) {
  return n2.nodeType === n2.ELEMENT_NODE;
}

function isShadowRoot(n2) {
  var hostEl = // anchor and textarea elements also have a `host` property
  // but only shadow roots have a `mode` property
  n2 && "host" in n2 && "mode" in n2 && index$1.host(n2) || null;
  return Boolean(hostEl && "shadowRoot" in hostEl && index$1.shadowRoot(hostEl) === n2);
}

function isNativeShadowDom(shadowRoot2) {
  return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}

function fixBrowserCompatibilityIssuesInCSS(cssText) {
  if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) {
    cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
  }

  return cssText;
}

function escapeImportStatement(rule2) {
  var {
    cssText
  } = rule2;
  if (cssText.split('"').length < 3) return cssText;
  var statement = ["@import", "url(".concat(JSON.stringify(rule2.href), ")")];

  if (rule2.layerName === "") {
    statement.push("layer");
  } else if (rule2.layerName) {
    statement.push("layer(".concat(rule2.layerName, ")"));
  }

  if (rule2.supportsText) {
    statement.push("supports(".concat(rule2.supportsText, ")"));
  }

  if (rule2.media.length) {
    statement.push(rule2.media.mediaText);
  }

  return statement.join(" ") + ";";
}

function stringifyStylesheet(s2) {
  try {
    var rules2 = s2.rules || s2.cssRules;

    if (!rules2) {
      return null;
    }

    var sheetHref = s2.href;

    if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) {
      sheetHref = s2.ownerNode.ownerDocument.location.href;
    }

    var stringifiedRules = Array.from(rules2, rule2 => stringifyRule(rule2, sheetHref)).join("");
    return fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
  } catch (error) {
    return null;
  }
}

function stringifyRule(rule2, sheetHref) {
  if (isCSSImportRule(rule2)) {
    var importStringified;

    try {
      importStringified = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      escapeImportStatement(rule2);
    } catch (error) {
      importStringified = rule2.cssText;
    }

    if (rule2.styleSheet.href) {
      return absolutifyURLs(importStringified, rule2.styleSheet.href);
    }

    return importStringified;
  } else {
    var ruleStringified = rule2.cssText;

    if (isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) {
      ruleStringified = fixSafariColons(ruleStringified);
    }

    if (sheetHref) {
      return absolutifyURLs(ruleStringified, sheetHref);
    }

    return ruleStringified;
  }
}

function fixSafariColons(cssStringified) {
  var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return cssStringified.replace(regex, "$1\\$2");
}

function isCSSImportRule(rule2) {
  return "styleSheet" in rule2;
}

function isCSSStyleRule(rule2) {
  return "selectorText" in rule2;
}

class Mirror {
  constructor() {
    __publicField$1(this, "idNodeMap", /* @__PURE__ */new Map());

    __publicField$1(this, "nodeMetaMap", /* @__PURE__ */new WeakMap());
  }

  getId(n2) {
    var _a2;

    if (!n2) return -1;
    var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
    return id !== null && id !== void 0 ? id : -1;
  }

  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }

  getIds() {
    return Array.from(this.idNodeMap.keys());
  }

  getMeta(n2) {
    return this.nodeMetaMap.get(n2) || null;
  } // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap


  removeNodeFromMap(n2) {
    var id = this.getId(n2);
    this.idNodeMap.delete(id);

    if (n2.childNodes) {
      n2.childNodes.forEach(childNode => this.removeNodeFromMap(childNode));
    }
  }

  has(id) {
    return this.idNodeMap.has(id);
  }

  hasNode(node2) {
    return this.nodeMetaMap.has(node2);
  }

  add(n2, meta) {
    var id = meta.id;
    this.idNodeMap.set(id, n2);
    this.nodeMetaMap.set(n2, meta);
  }

  replace(id, n2) {
    var oldNode = this.getNode(id);

    if (oldNode) {
      var meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n2, meta);
    }

    this.idNodeMap.set(id, n2);
  }

  reset() {
    this.idNodeMap = /* @__PURE__ */new Map();
    this.nodeMetaMap = /* @__PURE__ */new WeakMap();
  }

}

function createMirror$2() {
  return new Mirror();
}

function maskInputValue(_ref) {
  var {
    element,
    maskInputOptions,
    tagName,
    type,
    value,
    maskInputFn
  } = _ref;
  var text = value || "";
  var actualType = type && toLowerCase(type);

  if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
    if (maskInputFn) {
      text = maskInputFn(text, element);
    } else {
      text = "*".repeat(text.length);
    }
  }

  return text;
}

function toLowerCase(str) {
  return str.toLowerCase();
}

var ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";

function is2DCanvasBlank(canvas) {
  var ctx = canvas.getContext("2d");
  if (!ctx) return true;
  var chunkSize = 50;

  for (var x2 = 0; x2 < canvas.width; x2 += chunkSize) {
    for (var y = 0; y < canvas.height; y += chunkSize) {
      var getImageData = ctx.getImageData;
      var originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
      var pixelBuffer = new Uint32Array( // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
      if (pixelBuffer.some(pixel => pixel !== 0)) return false;
    }
  }

  return true;
}

function isNodeMetaEqual(a2, b) {
  if (!a2 || !b || a2.type !== b.type) return false;
  if (a2.type === NodeType$3.Document) return a2.compatMode === b.compatMode;else if (a2.type === NodeType$3.DocumentType) return a2.name === b.name && a2.publicId === b.publicId && a2.systemId === b.systemId;else if (a2.type === NodeType$3.Comment || a2.type === NodeType$3.Text || a2.type === NodeType$3.CDATA) return a2.textContent === b.textContent;else if (a2.type === NodeType$3.Element) return a2.tagName === b.tagName && JSON.stringify(a2.attributes) === JSON.stringify(b.attributes) && a2.isSVG === b.isSVG && a2.needBlock === b.needBlock;
  return false;
}

function getInputType(element) {
  var type = element.type;
  return element.hasAttribute("data-rr-is-password") ? "password" : type ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  toLowerCase(type) : null;
}

function extractFileExtension(path, baseURL) {
  var _ref2;

  var url;

  try {
    url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
  } catch (err) {
    return null;
  }

  var regex = /\.([0-9a-z]+)(?:$)/i;
  var match = url.pathname.match(regex);
  return (_ref2 = match == null ? void 0 : match[1]) !== null && _ref2 !== void 0 ? _ref2 : null;
}

function extractOrigin(url) {
  var origin = "";

  if (url.indexOf("//") > -1) {
    origin = url.split("/").slice(0, 3).join("/");
  } else {
    origin = url.split("/")[0];
  }

  origin = origin.split("?")[0];
  return origin;
}

var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var URL_WWW_MATCH = /^www\..*/i;
var DATA_URI = /^(data:)([^,]*),(.*)/i;

function absolutifyURLs(cssText, href) {
  return (cssText || "").replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3) => {
    var filePath = path1 || path2 || path3;
    var maybeQuote = quote1 || quote2 || "";

    if (!filePath) {
      return origin;
    }

    if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
      return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
    }

    if (DATA_URI.test(filePath)) {
      return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
    }

    if (filePath[0] === "/") {
      return "url(".concat(maybeQuote).concat(extractOrigin(href) + filePath).concat(maybeQuote, ")");
    }

    var stack = href.split("/");
    var parts = filePath.split("/");
    stack.pop();

    for (var part of parts) {
      if (part === ".") {
        continue;
      } else if (part === "..") {
        stack.pop();
      } else {
        stack.push(part);
      }
    }

    return "url(".concat(maybeQuote).concat(stack.join("/")).concat(maybeQuote, ")");
  });
}

function normalizeCssString(cssText) {
  var _testNoPxNorm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (_testNoPxNorm) {
    return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
  } else {
    return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
  }
}

function splitCssText(cssText, style) {
  var _testNoPxNorm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var childNodes2 = Array.from(style.childNodes);
  var splits = [];
  var iterCount = 0;

  if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
    var cssTextNorm = normalizeCssString(cssText, _testNoPxNorm);
    var normFactor = cssTextNorm.length / cssText.length;

    for (var i2 = 1; i2 < childNodes2.length; i2++) {
      if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
        var textContentNorm = normalizeCssString(childNodes2[i2].textContent, _testNoPxNorm);
        var jLimit = 100;
        var j = 3;

        for (; j < textContentNorm.length; j++) {
          if ( // keep consuming css identifiers (to get a decent chunk more quickly)
          textContentNorm[j].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
          textContentNorm.indexOf(textContentNorm.substring(0, j), 1) !== -1) {
            continue;
          }

          break;
        }

        for (; j < textContentNorm.length; j++) {
          var startSubstring = textContentNorm.substring(0, j);
          var cssNormSplits = cssTextNorm.split(startSubstring);
          var splitNorm = -1;

          if (cssNormSplits.length === 2) {
            splitNorm = cssNormSplits[0].length;
          } else if (cssNormSplits.length > 2 && cssNormSplits[0] === "" && childNodes2[i2 - 1].textContent !== "") {
            splitNorm = cssTextNorm.indexOf(startSubstring, 1);
          } else if (cssNormSplits.length === 1) {
            startSubstring = startSubstring.substring(0, startSubstring.length - 1);
            cssNormSplits = cssTextNorm.split(startSubstring);

            if (cssNormSplits.length <= 1) {
              splits.push(cssText);
              return splits;
            }

            j = jLimit + 1;
          } else if (j === textContentNorm.length - 1) {
            splitNorm = cssTextNorm.indexOf(startSubstring);
          }

          if (cssNormSplits.length >= 2 && j > jLimit) {
            var prevTextContent = childNodes2[i2 - 1].textContent;

            if (prevTextContent && typeof prevTextContent === "string") {
              var prevMinLength = normalizeCssString(prevTextContent).length;
              splitNorm = cssTextNorm.indexOf(startSubstring, prevMinLength);
            }

            if (splitNorm === -1) {
              splitNorm = cssNormSplits[0].length;
            }
          }

          if (splitNorm !== -1) {
            var k = Math.floor(splitNorm / normFactor);

            for (; k > 0 && k < cssText.length;) {
              iterCount += 1;

              if (iterCount > 50 * childNodes2.length) {
                splits.push(cssText);
                return splits;
              }

              var normPart = normalizeCssString(cssText.substring(0, k), _testNoPxNorm);

              if (normPart.length === splitNorm) {
                splits.push(cssText.substring(0, k));
                cssText = cssText.substring(k);
                cssTextNorm = cssTextNorm.substring(splitNorm);
                break;
              } else if (normPart.length < splitNorm) {
                k += Math.max(1, Math.floor((splitNorm - normPart.length) / normFactor));
              } else {
                k -= Math.max(1, Math.floor((normPart.length - splitNorm) * normFactor));
              }
            }

            break;
          }
        }
      }
    }
  }

  splits.push(cssText);
  return splits;
}

function markCssSplits(cssText, style) {
  return splitCssText(cssText, style).join("/* rr_split */");
}

var _id = 1;
var tagNameRegex = new RegExp("[^a-z0-9-_:]");
var IGNORED_NODE = -2;

function genId() {
  return _id++;
}

function getValidTagName$1(element) {
  if (element instanceof HTMLFormElement) {
    return "form";
  }

  var processedTagName = toLowerCase(element.tagName);

  if (tagNameRegex.test(processedTagName)) {
    return "div";
  }

  return processedTagName;
}

var canvasService;
var canvasCtx;
var SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;

function getAbsoluteSrcsetString(doc, attributeValue) {
  if (attributeValue.trim() === "") {
    return attributeValue;
  }

  var pos = 0;

  function collectCharacters(regEx) {
    var chars2;
    var match = regEx.exec(attributeValue.substring(pos));

    if (match) {
      chars2 = match[0];
      pos += chars2.length;
      return chars2;
    }

    return "";
  }

  var output = [];

  while (true) {
    collectCharacters(SRCSET_COMMAS_OR_SPACES);

    if (pos >= attributeValue.length) {
      break;
    }

    var url = collectCharacters(SRCSET_NOT_SPACES);

    if (url.slice(-1) === ",") {
      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
      output.push(url);
    } else {
      var descriptorsStr = "";
      url = absoluteToDoc(doc, url);
      var inParens = false;

      while (true) {
        var c2 = attributeValue.charAt(pos);

        if (c2 === "") {
          output.push((url + descriptorsStr).trim());
          break;
        } else if (!inParens) {
          if (c2 === ",") {
            pos += 1;
            output.push((url + descriptorsStr).trim());
            break;
          } else if (c2 === "(") {
            inParens = true;
          }
        } else {
          if (c2 === ")") {
            inParens = false;
          }
        }

        descriptorsStr += c2;
        pos += 1;
      }
    }
  }

  return output.join(", ");
}

var cachedDocument = /* @__PURE__ */new WeakMap();

function absoluteToDoc(doc, attributeValue) {
  if (!attributeValue || attributeValue.trim() === "") {
    return attributeValue;
  }

  return getHref(doc, attributeValue);
}

function isSVGElement(el) {
  return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}

function getHref(doc, customHref) {
  var a2 = cachedDocument.get(doc);

  if (!a2) {
    a2 = doc.createElement("a");
    cachedDocument.set(doc, a2);
  }

  if (!customHref) {
    customHref = "";
  } else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) {
    return customHref;
  }

  a2.setAttribute("href", customHref);
  return a2.href;
}

function transformAttribute(doc, tagName, name, value) {
  if (!value) {
    return value;
  }

  if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) {
    return absoluteToDoc(doc, value);
  } else if (name === "xlink:href" && value[0] !== "#") {
    return absoluteToDoc(doc, value);
  } else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) {
    return absoluteToDoc(doc, value);
  } else if (name === "srcset") {
    return getAbsoluteSrcsetString(doc, value);
  } else if (name === "style") {
    return absolutifyURLs(value, getHref(doc));
  } else if (tagName === "object" && name === "data") {
    return absoluteToDoc(doc, value);
  }

  return value;
}

function ignoreAttribute(tagName, name, _value) {
  return (tagName === "video" || tagName === "audio") && name === "autoplay";
}

function _isBlockedElement(element, blockClass, blockSelector) {
  try {
    if (typeof blockClass === "string") {
      if (element.classList.contains(blockClass)) {
        return true;
      }
    } else {
      for (var eIndex = element.classList.length; eIndex--;) {
        var className = element.classList[eIndex];

        if (blockClass.test(className)) {
          return true;
        }
      }
    }

    if (blockSelector) {
      return element.matches(blockSelector);
    }
  } catch (e2) {}

  return false;
}

function classMatchesRegex(node2, regex, checkAncestors) {
  if (!node2) return false;

  if (node2.nodeType !== node2.ELEMENT_NODE) {
    if (!checkAncestors) return false;
    return classMatchesRegex(index$1.parentNode(node2), regex, checkAncestors);
  }

  for (var eIndex = node2.classList.length; eIndex--;) {
    var className = node2.classList[eIndex];

    if (regex.test(className)) {
      return true;
    }
  }

  if (!checkAncestors) return false;
  return classMatchesRegex(index$1.parentNode(node2), regex, checkAncestors);
}

function needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
  var el;

  if (isElement(node2)) {
    el = node2;

    if (!index$1.childNodes(el).length) {
      return false;
    }
  } else if (index$1.parentElement(node2) === null) {
    return false;
  } else {
    el = index$1.parentElement(node2);
  }

  try {
    if (typeof maskTextClass === "string") {
      if (checkAncestors) {
        if (el.closest(".".concat(maskTextClass))) return true;
      } else {
        if (el.classList.contains(maskTextClass)) return true;
      }
    } else {
      if (classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
    }

    if (maskTextSelector) {
      if (checkAncestors) {
        if (el.closest(maskTextSelector)) return true;
      } else {
        if (el.matches(maskTextSelector)) return true;
      }
    }
  } catch (e2) {}

  return false;
}

function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
  var win = iframeEl.contentWindow;

  if (!win) {
    return;
  }

  var fired = false;
  var readyState;

  try {
    readyState = win.document.readyState;
  } catch (error) {
    return;
  }

  if (readyState !== "complete") {
    var timer = setTimeout(() => {
      if (!fired) {
        listener();
        fired = true;
      }
    }, iframeLoadTimeout);
    iframeEl.addEventListener("load", () => {
      clearTimeout(timer);
      fired = true;
      listener();
    });
    return;
  }

  var blankUrl = "about:blank";

  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
    setTimeout(listener, 0);
    return iframeEl.addEventListener("load", listener);
  }

  iframeEl.addEventListener("load", listener);
}

function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
  var fired = false;
  var styleSheetLoaded;

  try {
    styleSheetLoaded = link.sheet;
  } catch (error) {
    return;
  }

  if (styleSheetLoaded) return;
  var timer = setTimeout(() => {
    if (!fired) {
      listener();
      fired = true;
    }
  }, styleSheetLoadTimeout);
  link.addEventListener("load", () => {
    clearTimeout(timer);
    fired = true;
    listener();
  });
}

function serializeNode(n2, options) {
  var {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    needsMask,
    inlineStylesheet,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    cssCaptured = false
  } = options;
  var rootId = getRootId(doc, mirror2);

  switch (n2.nodeType) {
    case n2.DOCUMENT_NODE:
      if (n2.compatMode !== "CSS1Compat") {
        return {
          type: NodeType$3.Document,
          childNodes: [],
          compatMode: n2.compatMode // probably "BackCompat"

        };
      } else {
        return {
          type: NodeType$3.Document,
          childNodes: []
        };
      }

    case n2.DOCUMENT_TYPE_NODE:
      return {
        type: NodeType$3.DocumentType,
        name: n2.name,
        publicId: n2.publicId,
        systemId: n2.systemId,
        rootId
      };

    case n2.ELEMENT_NODE:
      return serializeElementNode(n2, {
        doc,
        blockClass,
        blockSelector,
        inlineStylesheet,
        maskInputOptions,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement,
        rootId
      });

    case n2.TEXT_NODE:
      return serializeTextNode(n2, {
        doc,
        needsMask,
        maskTextFn,
        rootId,
        cssCaptured
      });

    case n2.CDATA_SECTION_NODE:
      return {
        type: NodeType$3.CDATA,
        textContent: "",
        rootId
      };

    case n2.COMMENT_NODE:
      return {
        type: NodeType$3.Comment,
        textContent: index$1.textContent(n2) || "",
        rootId
      };

    default:
      return false;
  }
}

function getRootId(doc, mirror2) {
  if (!mirror2.hasNode(doc)) return void 0;
  var docId = mirror2.getId(doc);
  return docId === 1 ? void 0 : docId;
}

function serializeTextNode(n2, options) {
  var {
    needsMask,
    maskTextFn,
    rootId,
    cssCaptured
  } = options;
  var parent = index$1.parentNode(n2);
  var parentTagName = parent && parent.tagName;
  var textContent2 = "";
  var isStyle = parentTagName === "STYLE" ? true : void 0;
  var isScript = parentTagName === "SCRIPT" ? true : void 0;

  if (isScript) {
    textContent2 = "SCRIPT_PLACEHOLDER";
  } else if (!cssCaptured) {
    textContent2 = index$1.textContent(n2);

    if (isStyle && textContent2) {
      textContent2 = absolutifyURLs(textContent2, getHref(options.doc));
    }
  }

  if (!isStyle && !isScript && textContent2 && needsMask) {
    textContent2 = maskTextFn ? maskTextFn(textContent2, index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
  }

  return {
    type: NodeType$3.Text,
    textContent: textContent2 || "",
    rootId
  };
}

function serializeElementNode(n2, options) {
  var {
    doc,
    blockClass,
    blockSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    rootId
  } = options;

  var needBlock = _isBlockedElement(n2, blockClass, blockSelector);

  var tagName = getValidTagName$1(n2);
  var attributes = {};
  var len = n2.attributes.length;

  for (var i2 = 0; i2 < len; i2++) {
    var attr = n2.attributes[i2];

    if (!ignoreAttribute(tagName, attr.name, attr.value)) {
      attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value);
    }
  }

  if (tagName === "link" && inlineStylesheet) {
    var stylesheet = Array.from(doc.styleSheets).find(s2 => {
      return s2.href === n2.href;
    });
    var cssText = null;

    if (stylesheet) {
      cssText = stringifyStylesheet(stylesheet);
    }

    if (cssText) {
      delete attributes.rel;
      delete attributes.href;
      attributes._cssText = cssText;
    }
  }

  if (tagName === "style" && n2.sheet) {
    var _cssText = stringifyStylesheet(n2.sheet);

    if (_cssText) {
      if (n2.childNodes.length > 1) {
        _cssText = markCssSplits(_cssText, n2);
      }

      attributes._cssText = _cssText;
    }
  }

  if (tagName === "input" || tagName === "textarea" || tagName === "select") {
    var value = n2.value;
    var checked = n2.checked;

    if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) {
      attributes.value = maskInputValue({
        element: n2,
        type: getInputType(n2),
        tagName,
        value,
        maskInputOptions,
        maskInputFn
      });
    } else if (checked) {
      attributes.checked = checked;
    }
  }

  if (tagName === "option") {
    if (n2.selected && !maskInputOptions["select"]) {
      attributes.selected = true;
    } else {
      delete attributes.selected;
    }
  }

  if (tagName === "dialog" && n2.open) {
    attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
  }

  if (tagName === "canvas" && recordCanvas) {
    if (n2.__context === "2d") {
      if (!is2DCanvasBlank(n2)) {
        attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      }
    } else if (!("__context" in n2)) {
      var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      var blankCanvas = doc.createElement("canvas");
      blankCanvas.width = n2.width;
      blankCanvas.height = n2.height;
      var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);

      if (canvasDataURL !== blankCanvasDataURL) {
        attributes.rr_dataURL = canvasDataURL;
      }
    }
  }

  if (tagName === "img" && inlineImages) {
    if (!canvasService) {
      canvasService = doc.createElement("canvas");
      canvasCtx = canvasService.getContext("2d");
    }

    var image = n2;
    var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
    var priorCrossOrigin = image.crossOrigin;

    var recordInlineImage = () => {
      image.removeEventListener("load", recordInlineImage);

      try {
        canvasService.width = image.naturalWidth;
        canvasService.height = image.naturalHeight;
        canvasCtx.drawImage(image, 0, 0);
        attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
      } catch (err) {
        if (image.crossOrigin !== "anonymous") {
          image.crossOrigin = "anonymous";
          if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener("load", recordInlineImage);
          return;
        } else {
          console.warn("Cannot inline img src=".concat(imageSrc, "! Error: ").concat(err));
        }
      }

      if (image.crossOrigin === "anonymous") {
        priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
      }
    };

    if (image.complete && image.naturalWidth !== 0) recordInlineImage();else image.addEventListener("load", recordInlineImage);
  }

  if (tagName === "audio" || tagName === "video") {
    var mediaAttributes = attributes;
    mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
    mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
    mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
    mediaAttributes.rr_mediaMuted = n2.muted;
    mediaAttributes.rr_mediaLoop = n2.loop;
    mediaAttributes.rr_mediaVolume = n2.volume;
  }

  if (!newlyAddedElement) {
    if (n2.scrollLeft) {
      attributes.rr_scrollLeft = n2.scrollLeft;
    }

    if (n2.scrollTop) {
      attributes.rr_scrollTop = n2.scrollTop;
    }
  }

  if (needBlock) {
    var {
      width,
      height
    } = n2.getBoundingClientRect();
    attributes = {
      class: attributes.class,
      rr_width: "".concat(width, "px"),
      rr_height: "".concat(height, "px")
    };
  }

  if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
    if (!n2.contentDocument) {
      attributes.rr_src = attributes.src;
    }

    delete attributes.src;
  }

  var isCustomElement;

  try {
    if (customElements.get(tagName)) isCustomElement = true;
  } catch (e2) {}

  return {
    type: NodeType$3.Element,
    tagName,
    attributes,
    childNodes: [],
    isSVG: isSVGElement(n2) || void 0,
    needBlock,
    rootId,
    isCustom: isCustomElement
  };
}

function lowerIfExists(maybeAttr) {
  if (maybeAttr === void 0 || maybeAttr === null) {
    return "";
  } else {
    return maybeAttr.toLowerCase();
  }
}

function slimDOMExcluded(sn, slimDOMOptions) {
  if (slimDOMOptions.comment && sn.type === NodeType$3.Comment) {
    return true;
  } else if (sn.type === NodeType$3.Element) {
    if (slimDOMOptions.script && ( // script tag
    sn.tagName === "script" || // (module)preload link
    sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
    sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && extractFileExtension(sn.attributes.href) === "js")) {
      return true;
    } else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) {
      return true;
    } else if (sn.tagName === "meta") {
      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
        return true;
      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) {
        return true;
      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) {
        return true;
      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) {
        return true;
      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
        return true;
      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) {
        return true;
      }
    }
  }

  return false;
}

function serializeNodeWithId(n2, options) {
  var {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    skipChild = false,
    inlineStylesheet = true,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions = {},
    inlineImages = false,
    recordCanvas = false,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout = 5e3,
    onStylesheetLoad,
    stylesheetLoadTimeout = 5e3,
    keepIframeSrcFn = () => false,
    newlyAddedElement = false,
    cssCaptured = false
  } = options;
  var {
    needsMask
  } = options;
  var {
    preserveWhiteSpace = true
  } = options;

  if (!needsMask) {
    var checkAncestors = needsMask === void 0;
    needsMask = needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
  }

  var _serializedNode = serializeNode(n2, {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    needsMask,
    inlineStylesheet,
    maskInputOptions,
    maskTextFn,
    maskInputFn,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement,
    cssCaptured
  });

  if (!_serializedNode) {
    console.warn(n2, "not serialized");
    return null;
  }

  var id;

  if (mirror2.hasNode(n2)) {
    id = mirror2.getId(n2);
  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) {
    id = IGNORED_NODE;
  } else {
    id = genId();
  }

  var serializedNode = Object.assign(_serializedNode, {
    id
  });
  mirror2.add(n2, serializedNode);

  if (id === IGNORED_NODE) {
    return null;
  }

  if (onSerialize) {
    onSerialize(n2);
  }

  var recordChild = !skipChild;

  if (serializedNode.type === NodeType$3.Element) {
    recordChild = recordChild && !serializedNode.needBlock;
    delete serializedNode.needBlock;
    var shadowRootEl = index$1.shadowRoot(n2);
    if (shadowRootEl && isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
  }

  if ((serializedNode.type === NodeType$3.Document || serializedNode.type === NodeType$3.Element) && recordChild) {
    if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$3.Element && serializedNode.tagName === "head") {
      preserveWhiteSpace = false;
    }

    var bypassOptions = {
      doc,
      mirror: mirror2,
      blockClass,
      blockSelector,
      needsMask,
      maskTextClass,
      maskTextSelector,
      skipChild,
      inlineStylesheet,
      maskInputOptions,
      maskTextFn,
      maskInputFn,
      slimDOMOptions,
      dataURLOptions,
      inlineImages,
      recordCanvas,
      preserveWhiteSpace,
      onSerialize,
      onIframeLoad,
      iframeLoadTimeout,
      onStylesheetLoad,
      stylesheetLoadTimeout,
      keepIframeSrcFn,
      cssCaptured: false
    };
    if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;else {
      if (serializedNode.type === NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") {
        bypassOptions.cssCaptured = true;
      }

      for (var childN of Array.from(index$1.childNodes(n2))) {
        var serializedChildNode = serializeNodeWithId(childN, bypassOptions);

        if (serializedChildNode) {
          serializedNode.childNodes.push(serializedChildNode);
        }
      }
    }
    var _shadowRootEl = null;

    if (isElement(n2) && (_shadowRootEl = index$1.shadowRoot(n2))) {
      for (var _childN of Array.from(index$1.childNodes(_shadowRootEl))) {
        var _serializedChildNode = serializeNodeWithId(_childN, bypassOptions);

        if (_serializedChildNode) {
          isNativeShadowDom(_shadowRootEl) && (_serializedChildNode.isShadow = true);
          serializedNode.childNodes.push(_serializedChildNode);
        }
      }
    }
  }

  var parent = index$1.parentNode(n2);

  if (parent && isShadowRoot(parent) && isNativeShadowDom(parent)) {
    serializedNode.isShadow = true;
  }

  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === "iframe") {
    onceIframeLoaded(n2, () => {
      var iframeDoc = n2.contentDocument;

      if (iframeDoc && onIframeLoad) {
        var serializedIframeNode = serializeNodeWithId(iframeDoc, {
          doc: iframeDoc,
          mirror: mirror2,
          blockClass,
          blockSelector,
          needsMask,
          maskTextClass,
          maskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });

        if (serializedIframeNode) {
          onIframeLoad(n2, serializedIframeNode);
        }
      }
    }, iframeLoadTimeout);
  }

  if (serializedNode.type === NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && extractFileExtension(serializedNode.attributes.href) === "css")) {
    onceStylesheetLoaded(n2, () => {
      if (onStylesheetLoad) {
        var serializedLinkNode = serializeNodeWithId(n2, {
          doc,
          mirror: mirror2,
          blockClass,
          blockSelector,
          needsMask,
          maskTextClass,
          maskTextSelector,
          skipChild: false,
          inlineStylesheet,
          maskInputOptions,
          maskTextFn,
          maskInputFn,
          slimDOMOptions,
          dataURLOptions,
          inlineImages,
          recordCanvas,
          preserveWhiteSpace,
          onSerialize,
          onIframeLoad,
          iframeLoadTimeout,
          onStylesheetLoad,
          stylesheetLoadTimeout,
          keepIframeSrcFn
        });

        if (serializedLinkNode) {
          onStylesheetLoad(n2, serializedLinkNode);
        }
      }
    }, stylesheetLoadTimeout);
  }

  return serializedNode;
}

function snapshot(n2, options) {
  var {
    mirror: mirror2 = new Mirror(),
    blockClass = "rr-block",
    blockSelector = null,
    maskTextClass = "rr-mask",
    maskTextSelector = null,
    inlineStylesheet = true,
    inlineImages = false,
    recordCanvas = false,
    maskAllInputs = false,
    maskTextFn,
    maskInputFn,
    slimDOM = false,
    dataURLOptions,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn = () => false
  } = options || {};
  var maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    password: true
  } : maskAllInputs === false ? {
    password: true
  } : maskAllInputs;
  var slimDOMOptions = slimDOM === true || slimDOM === "all" ? // if true: set of sensible options that should not throw away any information
  {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaDescKeywords: slimDOM === "all",
    // destructive
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaAuthorship: true,
    headMetaVerification: true
  } : slimDOM === false ? {} : slimDOM;
  return serializeNodeWithId(n2, {
    doc: n2,
    mirror: mirror2,
    blockClass,
    blockSelector,
    maskTextClass,
    maskTextSelector,
    skipChild: false,
    inlineStylesheet,
    maskInputOptions,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn,
    newlyAddedElement: false
  });
}

var MEDIA_SELECTOR = /(max|min)-device-(width|height)/;
var MEDIA_SELECTOR_GLOBAL = new RegExp(MEDIA_SELECTOR.source, "g");
var mediaSelectorPlugin = {
  postcssPlugin: "postcss-custom-selectors",

  prepare() {
    return {
      postcssPlugin: "postcss-custom-selectors",
      AtRule: function AtRule(atrule) {
        if (atrule.params.match(MEDIA_SELECTOR_GLOBAL)) {
          atrule.params = atrule.params.replace(MEDIA_SELECTOR_GLOBAL, "$1-$2");
        }
      }
    };
  }

};
var pseudoClassPlugin = {
  postcssPlugin: "postcss-hover-classes",
  prepare: function prepare() {
    var fixed = [];
    return {
      Rule: function Rule(rule2) {
        if (fixed.indexOf(rule2) !== -1) {
          return;
        }

        fixed.push(rule2);
        rule2.selectors.forEach(function (selector) {
          if (selector.includes(":hover")) {
            rule2.selector += ",\n" + selector.replace(/:hover/g, ".\\:hover");
          }
        });
      }
    };
  }
};

function getDefaultExportFromCjs$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}

function getAugmentedNamespace$1(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;

  if (typeof f2 == "function") {
    var a2 = function a22() {
      if (this instanceof a22) {
        return Reflect.construct(f2, arguments, this.constructor);
      }

      return f2.apply(this, arguments);
    };

    a2.prototype = f2.prototype;
  } else a2 = {};

  Object.defineProperty(a2, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a2, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n2[k];
      }
    });
  });
  return a2;
}

var picocolors_browser$1 = {
  exports: {}
};
var x$1 = String;

var create$1 = function create$1() {
  return {
    isColorSupported: false,
    reset: x$1,
    bold: x$1,
    dim: x$1,
    italic: x$1,
    underline: x$1,
    inverse: x$1,
    hidden: x$1,
    strikethrough: x$1,
    black: x$1,
    red: x$1,
    green: x$1,
    yellow: x$1,
    blue: x$1,
    magenta: x$1,
    cyan: x$1,
    white: x$1,
    gray: x$1,
    bgBlack: x$1,
    bgRed: x$1,
    bgGreen: x$1,
    bgYellow: x$1,
    bgBlue: x$1,
    bgMagenta: x$1,
    bgCyan: x$1,
    bgWhite: x$1
  };
};

picocolors_browser$1.exports = create$1();
picocolors_browser$1.exports.createColors = create$1;
var picocolors_browserExports$1 = picocolors_browser$1.exports;
var __viteBrowserExternal$2 = {};

var __viteBrowserExternal$1$1 = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal$2
}, Symbol.toStringTag, {
  value: "Module"
}));

var require$$2$1 = /* @__PURE__ */getAugmentedNamespace$1(__viteBrowserExternal$1$1);
var pico$1 = picocolors_browserExports$1;
var terminalHighlight$1$1 = require$$2$1;
var CssSyntaxError$3$1 = class CssSyntaxError extends Error {
  constructor(message, line, column, source, file, plugin22) {
    super(message);
    this.name = "CssSyntaxError";
    this.reason = message;

    if (file) {
      this.file = file;
    }

    if (source) {
      this.source = source;
    }

    if (plugin22) {
      this.plugin = plugin22;
    }

    if (typeof line !== "undefined" && typeof column !== "undefined") {
      if (typeof line === "number") {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }

    this.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError);
    }
  }

  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "";
    this.message += this.file ? this.file : "<css input>";

    if (typeof this.line !== "undefined") {
      this.message += ":" + this.line + ":" + this.column;
    }

    this.message += ": " + this.reason;
  }

  showSourceCode(color) {
    if (!this.source) return "";
    var css = this.source;
    if (color == null) color = pico$1.isColorSupported;

    if (terminalHighlight$1$1) {
      if (color) css = terminalHighlight$1$1(css);
    }

    var lines = css.split(/\r?\n/);
    var start = Math.max(this.line - 3, 0);
    var end = Math.min(this.line + 2, lines.length);
    var maxWidth = String(end).length;
    var mark, aside;

    if (color) {
      var {
        bold,
        gray,
        red
      } = pico$1.createColors(true);

      mark = text => bold(red(text));

      aside = text => gray(text);
    } else {
      mark = aside = str => str;
    }

    return lines.slice(start, end).map((line, index2) => {
      var number = start + 1 + index2;
      var gutter = " " + (" " + number).slice(-maxWidth) + " | ";

      if (number === this.line) {
        var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
      }

      return " " + aside(gutter) + line;
    }).join("\n");
  }

  toString() {
    var code = this.showSourceCode();

    if (code) {
      code = "\n\n" + code + "\n";
    }

    return this.name + ": " + this.message + code;
  }

};
var cssSyntaxError$1 = CssSyntaxError$3$1;
CssSyntaxError$3$1.default = CssSyntaxError$3$1;
var symbols$1 = {};
symbols$1.isClean = Symbol("isClean");
symbols$1.my = Symbol("my");
var DEFAULT_RAW$1 = {
  after: "\n",
  beforeClose: "\n",
  beforeComment: "\n",
  beforeDecl: "\n",
  beforeOpen: " ",
  beforeRule: "\n",
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: false
};

function capitalize$1(str) {
  return str[0].toUpperCase() + str.slice(1);
}

var Stringifier$2$1 = class Stringifier {
  constructor(builder) {
    this.builder = builder;
  }

  atrule(node2, semicolon) {
    var name = "@" + node2.name;
    var params = node2.params ? this.rawValue(node2, "params") : "";

    if (typeof node2.raws.afterName !== "undefined") {
      name += node2.raws.afterName;
    } else if (params) {
      name += " ";
    }

    if (node2.nodes) {
      this.block(node2, name + params);
    } else {
      var end = (node2.raws.between || "") + (semicolon ? ";" : "");
      this.builder(name + params + end, node2);
    }
  }

  beforeAfter(node2, detect) {
    var value;

    if (node2.type === "decl") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (node2.type === "comment") {
      value = this.raw(node2, null, "beforeComment");
    } else if (detect === "before") {
      value = this.raw(node2, null, "beforeRule");
    } else {
      value = this.raw(node2, null, "beforeClose");
    }

    var buf = node2.parent;
    var depth = 0;

    while (buf && buf.type !== "root") {
      depth += 1;
      buf = buf.parent;
    }

    if (value.includes("\n")) {
      var indent = this.raw(node2, null, "indent");

      if (indent.length) {
        for (var step = 0; step < depth; step++) {
          value += indent;
        }
      }
    }

    return value;
  }

  block(node2, start) {
    var between = this.raw(node2, "between", "beforeOpen");
    this.builder(start + between + "{", node2, "start");
    var after;

    if (node2.nodes && node2.nodes.length) {
      this.body(node2);
      after = this.raw(node2, "after");
    } else {
      after = this.raw(node2, "after", "emptyBody");
    }

    if (after) this.builder(after);
    this.builder("}", node2, "end");
  }

  body(node2) {
    var last = node2.nodes.length - 1;

    while (last > 0) {
      if (node2.nodes[last].type !== "comment") break;
      last -= 1;
    }

    var semicolon = this.raw(node2, "semicolon");

    for (var i2 = 0; i2 < node2.nodes.length; i2++) {
      var child = node2.nodes[i2];
      var before = this.raw(child, "before");
      if (before) this.builder(before);
      this.stringify(child, last !== i2 || semicolon);
    }
  }

  comment(node2) {
    var left = this.raw(node2, "left", "commentLeft");
    var right = this.raw(node2, "right", "commentRight");
    this.builder("/*" + left + node2.text + right + "*/", node2);
  }

  decl(node2, semicolon) {
    var between = this.raw(node2, "between", "colon");
    var string = node2.prop + between + this.rawValue(node2, "value");

    if (node2.important) {
      string += node2.raws.important || " !important";
    }

    if (semicolon) string += ";";
    this.builder(string, node2);
  }

  document(node2) {
    this.body(node2);
  }

  raw(node2, own, detect) {
    var value;
    if (!detect) detect = own;

    if (own) {
      value = node2.raws[own];
      if (typeof value !== "undefined") return value;
    }

    var parent = node2.parent;

    if (detect === "before") {
      if (!parent || parent.type === "root" && parent.first === node2) {
        return "";
      }

      if (parent && parent.type === "document") {
        return "";
      }
    }

    if (!parent) return DEFAULT_RAW$1[detect];
    var root2 = node2.root();
    if (!root2.rawCache) root2.rawCache = {};

    if (typeof root2.rawCache[detect] !== "undefined") {
      return root2.rawCache[detect];
    }

    if (detect === "before" || detect === "after") {
      return this.beforeAfter(node2, detect);
    } else {
      var method = "raw" + capitalize$1(detect);

      if (this[method]) {
        value = this[method](root2, node2);
      } else {
        root2.walk(i2 => {
          value = i2.raws[own];
          if (typeof value !== "undefined") return false;
        });
      }
    }

    if (typeof value === "undefined") value = DEFAULT_RAW$1[detect];
    root2.rawCache[detect] = value;
    return value;
  }

  rawBeforeClose(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length > 0) {
        if (typeof i2.raws.after !== "undefined") {
          value = i2.raws.after;

          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, "");
    return value;
  }

  rawBeforeComment(root2, node2) {
    var value;
    root2.walkComments(i2 => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;

        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }

        return false;
      }
    });

    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }

    return value;
  }

  rawBeforeDecl(root2, node2) {
    var value;
    root2.walkDecls(i2 => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;

        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }

        return false;
      }
    });

    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeRule");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }

    return value;
  }

  rawBeforeOpen(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.type !== "decl") {
        value = i2.raws.between;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawBeforeRule(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
        if (typeof i2.raws.before !== "undefined") {
          value = i2.raws.before;

          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, "");
    return value;
  }

  rawColon(root2) {
    var value;
    root2.walkDecls(i2 => {
      if (typeof i2.raws.between !== "undefined") {
        value = i2.raws.between.replace(/[^\s:]/g, "");
        return false;
      }
    });
    return value;
  }

  rawEmptyBody(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length === 0) {
        value = i2.raws.after;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawIndent(root2) {
    if (root2.raws.indent) return root2.raws.indent;
    var value;
    root2.walk(i2 => {
      var p = i2.parent;

      if (p && p !== root2 && p.parent && p.parent === root2) {
        if (typeof i2.raws.before !== "undefined") {
          var parts = i2.raws.before.split("\n");
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, "");
          return false;
        }
      }
    });
    return value;
  }

  rawSemicolon(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
        value = i2.raws.semicolon;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawValue(node2, prop) {
    var value = node2[prop];
    var raw = node2.raws[prop];

    if (raw && raw.value === value) {
      return raw.raw;
    }

    return value;
  }

  root(node2) {
    this.body(node2);
    if (node2.raws.after) this.builder(node2.raws.after);
  }

  rule(node2) {
    this.block(node2, this.rawValue(node2, "selector"));

    if (node2.raws.ownSemicolon) {
      this.builder(node2.raws.ownSemicolon, node2, "end");
    }
  }

  stringify(node2, semicolon) {
    if (!this[node2.type]) {
      throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
    }

    this[node2.type](node2, semicolon);
  }

};
var stringifier$1 = Stringifier$2$1;
Stringifier$2$1.default = Stringifier$2$1;
var Stringifier$1$1 = stringifier$1;

function stringify$4$1(node2, builder) {
  var str = new Stringifier$1$1(builder);
  str.stringify(node2);
}

var stringify_1$1 = stringify$4$1;
stringify$4$1.default = stringify$4$1;
var {
  isClean: isClean$2$1,
  my: my$2$1
} = symbols$1;
var CssSyntaxError$2$1 = cssSyntaxError$1;
var Stringifier2$1 = stringifier$1;
var stringify$3$1 = stringify_1$1;

function cloneNode$1(obj, parent) {
  var cloned = new obj.constructor();

  for (var i2 in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
      continue;
    }

    if (i2 === "proxyCache") continue;
    var value = obj[i2];
    var type = typeof value;

    if (i2 === "parent" && type === "object") {
      if (parent) cloned[i2] = parent;
    } else if (i2 === "source") {
      cloned[i2] = value;
    } else if (Array.isArray(value)) {
      cloned[i2] = value.map(j => cloneNode$1(j, cloned));
    } else {
      if (type === "object" && value !== null) value = cloneNode$1(value);
      cloned[i2] = value;
    }
  }

  return cloned;
}

var Node$4$1 = class Node2 {
  constructor() {
    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.raws = {};
    this[isClean$2$1] = false;
    this[my$2$1] = true;

    for (var name in defaults) {
      if (name === "nodes") {
        this.nodes = [];

        for (var node2 of defaults[name]) {
          if (typeof node2.clone === "function") {
            this.append(node2.clone());
          } else {
            this.append(node2);
          }
        }
      } else {
        this[name] = defaults[name];
      }
    }
  }

  addToError(error) {
    error.postcssNode = this;

    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
      var s2 = this.source;
      error.stack = error.stack.replace(/\n\s{4}at /, "$&".concat(s2.input.from, ":").concat(s2.start.line, ":").concat(s2.start.column, "$&"));
    }

    return error;
  }

  after(add) {
    this.parent.insertAfter(this, add);
    return this;
  }

  assign() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    for (var name in overrides) {
      this[name] = overrides[name];
    }

    return this;
  }

  before(add) {
    this.parent.insertBefore(this, add);
    return this;
  }

  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  }

  clone() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = cloneNode$1(this);

    for (var name in overrides) {
      cloned[name] = overrides[name];
    }

    return cloned;
  }

  cloneAfter() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned;
  }

  cloneBefore() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned;
  }

  error(message) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.source) {
      var {
        end,
        start
      } = this.rangeBy(opts);
      return this.source.input.error(message, {
        column: start.column,
        line: start.line
      }, {
        column: end.column,
        line: end.line
      }, opts);
    }

    return new CssSyntaxError$2$1(message);
  }

  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else {
          return node2[prop];
        }
      },

      set(node2, prop, value) {
        if (node2[prop] === value) return true;
        node2[prop] = value;

        if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" ||
        /* c8 ignore next */
        prop === "text") {
          node2.markDirty();
        }

        return true;
      }

    };
  }

  markDirty() {
    if (this[isClean$2$1]) {
      this[isClean$2$1] = false;
      var next = this;

      while (next = next.parent) {
        next[isClean$2$1] = false;
      }
    }
  }

  next() {
    if (!this.parent) return void 0;
    var index2 = this.parent.index(this);
    return this.parent.nodes[index2 + 1];
  }

  positionBy(opts, stringRepresentation) {
    var pos = this.source.start;

    if (opts.index) {
      pos = this.positionInside(opts.index, stringRepresentation);
    } else if (opts.word) {
      stringRepresentation = this.toString();
      var index2 = stringRepresentation.indexOf(opts.word);
      if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
    }

    return pos;
  }

  positionInside(index2, stringRepresentation) {
    var string = stringRepresentation || this.toString();
    var column = this.source.start.column;
    var line = this.source.start.line;

    for (var i2 = 0; i2 < index2; i2++) {
      if (string[i2] === "\n") {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }

    return {
      column,
      line
    };
  }

  prev() {
    if (!this.parent) return void 0;
    var index2 = this.parent.index(this);
    return this.parent.nodes[index2 - 1];
  }

  rangeBy(opts) {
    var start = {
      column: this.source.start.column,
      line: this.source.start.line
    };
    var end = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: start.column + 1,
      line: start.line
    };

    if (opts.word) {
      var stringRepresentation = this.toString();
      var index2 = stringRepresentation.indexOf(opts.word);

      if (index2 !== -1) {
        start = this.positionInside(index2, stringRepresentation);
        end = this.positionInside(index2 + opts.word.length, stringRepresentation);
      }
    } else {
      if (opts.start) {
        start = {
          column: opts.start.column,
          line: opts.start.line
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }

      if (opts.end) {
        end = {
          column: opts.end.column,
          line: opts.end.line
        };
      } else if (typeof opts.endIndex === "number") {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }

    if (end.line < start.line || end.line === start.line && end.column <= start.column) {
      end = {
        column: start.column + 1,
        line: start.line
      };
    }

    return {
      end,
      start
    };
  }

  raw(prop, defaultType) {
    var str = new Stringifier2$1();
    return str.raw(this, prop, defaultType);
  }

  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }

    this.parent = void 0;
    return this;
  }

  replaceWith() {
    if (this.parent) {
      var bookmark = this;
      var foundSelf = false;

      for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
        nodes[_key] = arguments[_key];
      }

      for (var node2 of nodes) {
        if (node2 === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node2);
          bookmark = node2;
        } else {
          this.parent.insertBefore(bookmark, node2);
        }
      }

      if (!foundSelf) {
        this.remove();
      }
    }

    return this;
  }

  root() {
    var result2 = this;

    while (result2.parent && result2.parent.type !== "document") {
      result2 = result2.parent;
    }

    return result2;
  }

  toJSON(_, inputs) {
    var fixed = {};
    var emitInputs = inputs == null;
    inputs = inputs || /* @__PURE__ */new Map();
    var inputsNextIndex = 0;

    for (var name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        continue;
      }

      if (name === "parent" || name === "proxyCache") continue;
      var value = this[name];

      if (Array.isArray(value)) {
        fixed[name] = value.map(i2 => {
          if (typeof i2 === "object" && i2.toJSON) {
            return i2.toJSON(null, inputs);
          } else {
            return i2;
          }
        });
      } else if (typeof value === "object" && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === "source") {
        var inputId = inputs.get(value.input);

        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }

        fixed[name] = {
          end: value.end,
          inputId,
          start: value.start
        };
      } else {
        fixed[name] = value;
      }
    }

    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map(input2 => input2.toJSON());
    }

    return fixed;
  }

  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }

    return this.proxyCache;
  }

  toString() {
    var stringifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stringify$3$1;
    if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
    var result2 = "";
    stringifier2(this, i2 => {
      result2 += i2;
    });
    return result2;
  }

  warn(result2, text, opts) {
    var data = {
      node: this
    };

    for (var i2 in opts) {
      data[i2] = opts[i2];
    }

    return result2.warn(text, data);
  }

  get proxyOf() {
    return this;
  }

};
var node$1 = Node$4$1;
Node$4$1.default = Node$4$1;
var Node$3$1 = node$1;
var Declaration$4$1 = class Declaration extends Node$3$1 {
  constructor(defaults) {
    if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }

    super(defaults);
    this.type = "decl";
  }

  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }

};
var declaration$1 = Declaration$4$1;
Declaration$4$1.default = Declaration$4$1;
var urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

var customAlphabet$1 = function customAlphabet$1(alphabet) {
  var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
  return function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
    var id = "";
    var i2 = size;

    while (i2--) {
      id += alphabet[Math.random() * alphabet.length | 0];
    }

    return id;
  };
};

var nanoid$1$1 = function nanoid$1$1() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  var id = "";
  var i2 = size;

  while (i2--) {
    id += urlAlphabet$1[Math.random() * 64 | 0];
  }

  return id;
};

var nonSecure$1 = {
  nanoid: nanoid$1$1,
  customAlphabet: customAlphabet$1
};
var {
  SourceMapConsumer: SourceMapConsumer$2$1,
  SourceMapGenerator: SourceMapGenerator$2$1
} = require$$2$1;
var {
  existsSync: existsSync$1,
  readFileSync: readFileSync$1
} = require$$2$1;
var {
  dirname: dirname$1$1,
  join: join$1
} = require$$2$1;

function fromBase64$1(str) {
  if (Buffer) {
    return Buffer.from(str, "base64").toString();
  } else {
    return window.atob(str);
  }
}

var PreviousMap$2$1 = class PreviousMap {
  constructor(css, opts) {
    if (opts.map === false) return;
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, "data:");
    var prev = opts.map ? opts.map.prev : void 0;
    var text = this.loadMap(opts.from, prev);

    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }

    if (this.mapFile) this.root = dirname$1$1(this.mapFile);
    if (text) this.text = text;
  }

  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer$2$1(this.text);
    }

    return this.consumerCache;
  }

  decodeInline(text) {
    var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    var baseUri = /^data:application\/json;base64,/;
    var charsetUri = /^data:application\/json;charset=utf-?8,/;
    var uri = /^data:application\/json,/;

    if (charsetUri.test(text) || uri.test(text)) {
      return decodeURIComponent(text.substr(RegExp.lastMatch.length));
    }

    if (baseCharsetUri.test(text) || baseUri.test(text)) {
      return fromBase64$1(text.substr(RegExp.lastMatch.length));
    }

    var encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + encoding);
  }

  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }

  isMap(map) {
    if (typeof map !== "object") return false;
    return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
  }

  loadAnnotation(css) {
    var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!comments) return;
    var start = css.lastIndexOf(comments.pop());
    var end = css.indexOf("*/", start);

    if (start > -1 && end > -1) {
      this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
  }

  loadFile(path) {
    this.root = dirname$1$1(path);

    if (existsSync$1(path)) {
      this.mapFile = path;
      return readFileSync$1(path, "utf-8").toString().trim();
    }
  }

  loadMap(file, prev) {
    if (prev === false) return false;

    if (prev) {
      if (typeof prev === "string") {
        return prev;
      } else if (typeof prev === "function") {
        var prevPath = prev(file);

        if (prevPath) {
          var map = this.loadFile(prevPath);

          if (!map) {
            throw new Error("Unable to load previous source map: " + prevPath.toString());
          }

          return map;
        }
      } else if (prev instanceof SourceMapConsumer$2$1) {
        return SourceMapGenerator$2$1.fromSourceMap(prev).toString();
      } else if (prev instanceof SourceMapGenerator$2$1) {
        return prev.toString();
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev);
      } else {
        throw new Error("Unsupported previous source map format: " + prev.toString());
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation);
    } else if (this.annotation) {
      var _map = this.annotation;
      if (file) _map = join$1(dirname$1$1(file), _map);
      return this.loadFile(_map);
    }
  }

  startWith(string, start) {
    if (!string) return false;
    return string.substr(0, start.length) === start;
  }

  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }

};
var previousMap$1 = PreviousMap$2$1;
PreviousMap$2$1.default = PreviousMap$2$1;
var {
  SourceMapConsumer: SourceMapConsumer$1$1,
  SourceMapGenerator: SourceMapGenerator$1$1
} = require$$2$1;
var {
  fileURLToPath: fileURLToPath$1,
  pathToFileURL: pathToFileURL$1$1
} = require$$2$1;
var {
  isAbsolute: isAbsolute$1,
  resolve: resolve$1$1
} = require$$2$1;
var {
  nanoid: nanoid$2
} = nonSecure$1;
var terminalHighlight$2 = require$$2$1;
var CssSyntaxError$1$1 = cssSyntaxError$1;
var PreviousMap$1$1 = previousMap$1;
var fromOffsetCache$1 = Symbol("fromOffsetCache");
var sourceMapAvailable$1$1 = Boolean(SourceMapConsumer$1$1 && SourceMapGenerator$1$1);
var pathAvailable$1$1 = Boolean(resolve$1$1 && isAbsolute$1);
var Input$4$1 = class Input {
  constructor(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
      throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
    }

    this.css = css.toString();

    if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    if (opts.from) {
      if (!pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || isAbsolute$1(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve$1$1(opts.from);
      }
    }

    if (pathAvailable$1$1 && sourceMapAvailable$1$1) {
      var map = new PreviousMap$1$1(this.css, opts);

      if (map.text) {
        this.map = map;
        var file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }

    if (!this.file) {
      this.id = "<input css " + nanoid$2(6) + ">";
    }

    if (this.map) this.map.file = this.from;
  }

  error(message, line, column) {
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var result2, endLine, endColumn;

    if (line && typeof line === "object") {
      var start = line;
      var end = column;

      if (typeof start.offset === "number") {
        var pos = this.fromOffset(start.offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
      }

      if (typeof end.offset === "number") {
        var _pos = this.fromOffset(end.offset);

        endLine = _pos.line;
        endColumn = _pos.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
      }
    } else if (!column) {
      var _pos2 = this.fromOffset(line);

      line = _pos2.line;
      column = _pos2.col;
    }

    var origin = this.origin(line, column, endLine, endColumn);

    if (origin) {
      result2 = new CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
        column: origin.column,
        line: origin.line
      }, origin.endLine === void 0 ? origin.column : {
        column: origin.endColumn,
        line: origin.endLine
      }, origin.source, origin.file, opts.plugin);
    } else {
      result2 = new CssSyntaxError$1$1(message, endLine === void 0 ? line : {
        column,
        line
      }, endLine === void 0 ? column : {
        column: endColumn,
        line: endLine
      }, this.css, this.file, opts.plugin);
    }

    result2.input = {
      column,
      endColumn,
      endLine,
      line,
      source: this.css
    };

    if (this.file) {
      if (pathToFileURL$1$1) {
        result2.input.url = pathToFileURL$1$1(this.file).toString();
      }

      result2.input.file = this.file;
    }

    return result2;
  }

  fromOffset(offset) {
    var lastLine, lineToIndex;

    if (!this[fromOffsetCache$1]) {
      var lines = this.css.split("\n");
      lineToIndex = new Array(lines.length);
      var prevIndex = 0;

      for (var i2 = 0, l2 = lines.length; i2 < l2; i2++) {
        lineToIndex[i2] = prevIndex;
        prevIndex += lines[i2].length + 1;
      }

      this[fromOffsetCache$1] = lineToIndex;
    } else {
      lineToIndex = this[fromOffsetCache$1];
    }

    lastLine = lineToIndex[lineToIndex.length - 1];
    var min = 0;

    if (offset >= lastLine) {
      min = lineToIndex.length - 1;
    } else {
      var max = lineToIndex.length - 2;
      var mid;

      while (min < max) {
        mid = min + (max - min >> 1);

        if (offset < lineToIndex[mid]) {
          max = mid - 1;
        } else if (offset >= lineToIndex[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break;
        }
      }
    }

    return {
      col: offset - lineToIndex[min] + 1,
      line: min + 1
    };
  }

  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file;
    }

    return resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
  }

  origin(line, column, endLine, endColumn) {
    if (!this.map) return false;
    var consumer = this.map.consumer();
    var from = consumer.originalPositionFor({
      column,
      line
    });
    if (!from.source) return false;
    var to;

    if (typeof endLine === "number") {
      to = consumer.originalPositionFor({
        column: endColumn,
        line: endLine
      });
    }

    var fromUrl;

    if (isAbsolute$1(from.source)) {
      fromUrl = pathToFileURL$1$1(from.source);
    } else {
      fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL$1$1(this.map.mapFile));
    }

    var result2 = {
      column: from.column,
      endColumn: to && to.column,
      endLine: to && to.line,
      line: from.line,
      url: fromUrl.toString()
    };

    if (fromUrl.protocol === "file:") {
      if (fileURLToPath$1) {
        result2.file = fileURLToPath$1(fromUrl);
      } else {
        throw new Error("file: protocol is not available in this PostCSS build");
      }
    }

    var source = consumer.sourceContentFor(from.source);
    if (source) result2.source = source;
    return result2;
  }

  toJSON() {
    var json = {};

    for (var name of ["hasBOM", "css", "file", "id"]) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }

    if (this.map) {
      json.map = _objectSpread({}, this.map);

      if (json.map.consumerCache) {
        json.map.consumerCache = void 0;
      }
    }

    return json;
  }

  get from() {
    return this.file || this.id;
  }

};
var input$1 = Input$4$1;
Input$4$1.default = Input$4$1;

if (terminalHighlight$2 && terminalHighlight$2.registerInput) {
  terminalHighlight$2.registerInput(Input$4$1);
}

var {
  SourceMapConsumer: SourceMapConsumer$3,
  SourceMapGenerator: SourceMapGenerator$3
} = require$$2$1;
var {
  dirname: dirname$2,
  relative: relative$1,
  resolve: resolve$2,
  sep: sep$1
} = require$$2$1;
var {
  pathToFileURL: pathToFileURL$2
} = require$$2$1;
var Input$3$1 = input$1;
var sourceMapAvailable$2 = Boolean(SourceMapConsumer$3 && SourceMapGenerator$3);
var pathAvailable$2 = Boolean(dirname$2 && resolve$2 && relative$1 && sep$1);
var MapGenerator$2$1 = class MapGenerator {
  constructor(stringify2, root2, opts, cssString) {
    this.stringify = stringify2;
    this.mapOpts = opts.map || {};
    this.root = root2;
    this.opts = opts;
    this.css = cssString;
    this.originalCSS = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    this.memoizedFileURLs = /* @__PURE__ */new Map();
    this.memoizedPaths = /* @__PURE__ */new Map();
    this.memoizedURLs = /* @__PURE__ */new Map();
  }

  addAnnotation() {
    var content;

    if (this.isInline()) {
      content = "data:application/json;base64," + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === "string") {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === "function") {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + ".map";
    }

    var eol = "\n";
    if (this.css.includes("\r\n")) eol = "\r\n";
    this.css += eol + "/*# sourceMappingURL=" + content + " */";
  }

  applyPrevMaps() {
    for (var prev of this.previous()) {
      var from = this.toUrl(this.path(prev.file));
      var root2 = prev.root || dirname$2(prev.file);
      var map = void 0;

      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer$3(prev.text);

        if (map.sourcesContent) {
          map.sourcesContent = null;
        }
      } else {
        map = prev.consumer();
      }

      this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
    }
  }

  clearAnnotation() {
    if (this.mapOpts.annotation === false) return;

    if (this.root) {
      var node2;

      for (var i2 = this.root.nodes.length - 1; i2 >= 0; i2--) {
        node2 = this.root.nodes[i2];
        if (node2.type !== "comment") continue;

        if (node2.text.indexOf("# sourceMappingURL=") === 0) {
          this.root.removeChild(i2);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    }
  }

  generate() {
    this.clearAnnotation();

    if (pathAvailable$2 && sourceMapAvailable$2 && this.isMap()) {
      return this.generateMap();
    } else {
      var result2 = "";
      this.stringify(this.root, i2 => {
        result2 += i2;
      });
      return [result2];
    }
  }

  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      var prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator$3.fromSourceMap(prev, {
        ignoreInvalidMapping: true
      });
    } else {
      this.map = new SourceMapGenerator$3({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      this.map.addMapping({
        generated: {
          column: 0,
          line: 1
        },
        original: {
          column: 0,
          line: 1
        },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    }

    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.root && this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();

    if (this.isInline()) {
      return [this.css];
    } else {
      return [this.css, this.map];
    }
  }

  generateString() {
    this.css = "";
    this.map = new SourceMapGenerator$3({
      file: this.outputFile(),
      ignoreInvalidMapping: true
    });
    var line = 1;
    var column = 1;
    var noSource = "<no source>";
    var mapping = {
      generated: {
        column: 0,
        line: 0
      },
      original: {
        column: 0,
        line: 0
      },
      source: ""
    };
    var lines, last;
    this.stringify(this.root, (str, node2, type) => {
      this.css += str;

      if (node2 && type !== "end") {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;

        if (node2.source && node2.source.start) {
          mapping.source = this.sourcePath(node2);
          mapping.original.line = node2.source.start.line;
          mapping.original.column = node2.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }

      lines = str.match(/\n/g);

      if (lines) {
        line += lines.length;
        last = str.lastIndexOf("\n");
        column = str.length - last;
      } else {
        column += str.length;
      }

      if (node2 && type !== "start") {
        var p = node2.parent || {
          raws: {}
        };
        var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;

        if (!childless || node2 !== p.last || p.raws.semicolon) {
          if (node2.source && node2.source.end) {
            mapping.source = this.sourcePath(node2);
            mapping.original.line = node2.source.end.line;
            mapping.original.column = node2.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }

  isAnnotation() {
    if (this.isInline()) {
      return true;
    }

    if (typeof this.mapOpts.annotation !== "undefined") {
      return this.mapOpts.annotation;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.annotation);
    }

    return true;
  }

  isInline() {
    if (typeof this.mapOpts.inline !== "undefined") {
      return this.mapOpts.inline;
    }

    var annotation = this.mapOpts.annotation;

    if (typeof annotation !== "undefined" && annotation !== true) {
      return false;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.inline);
    }

    return true;
  }

  isMap() {
    if (typeof this.opts.map !== "undefined") {
      return !!this.opts.map;
    }

    return this.previous().length > 0;
  }

  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== "undefined") {
      return this.mapOpts.sourcesContent;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.withContent());
    }

    return true;
  }

  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to);
    } else if (this.opts.from) {
      return this.path(this.opts.from);
    } else {
      return "to.css";
    }
  }

  path(file) {
    if (this.mapOpts.absolute) return file;
    if (file.charCodeAt(0) === 60) return file;
    if (/^\w+:\/\//.test(file)) return file;
    var cached = this.memoizedPaths.get(file);
    if (cached) return cached;
    var from = this.opts.to ? dirname$2(this.opts.to) : ".";

    if (typeof this.mapOpts.annotation === "string") {
      from = dirname$2(resolve$2(from, this.mapOpts.annotation));
    }

    var path = relative$1(from, file);
    this.memoizedPaths.set(file, path);
    return path;
  }

  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];

      if (this.root) {
        this.root.walk(node2 => {
          if (node2.source && node2.source.input.map) {
            var map = node2.source.input.map;

            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        var input2 = new Input$3$1(this.originalCSS, this.opts);
        if (input2.map) this.previousMaps.push(input2.map);
      }
    }

    return this.previousMaps;
  }

  setSourcesContent() {
    var already = {};

    if (this.root) {
      this.root.walk(node2 => {
        if (node2.source) {
          var from = node2.source.input.from;

          if (from && !already[from]) {
            already[from] = true;
            var fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
            this.map.setSourceContent(fromUrl, node2.source.input.css);
          }
        }
      });
    } else if (this.css) {
      var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(from, this.css);
    }
  }

  sourcePath(node2) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from);
    } else if (this.usesFileUrls) {
      return this.toFileUrl(node2.source.input.from);
    } else {
      return this.toUrl(this.path(node2.source.input.from));
    }
  }

  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString("base64");
    } else {
      return window.btoa(unescape(encodeURIComponent(str)));
    }
  }

  toFileUrl(path) {
    var cached = this.memoizedFileURLs.get(path);
    if (cached) return cached;

    if (pathToFileURL$2) {
      var fileURL = pathToFileURL$2(path).toString();
      this.memoizedFileURLs.set(path, fileURL);
      return fileURL;
    } else {
      throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
  }

  toUrl(path) {
    var cached = this.memoizedURLs.get(path);
    if (cached) return cached;

    if (sep$1 === "\\") {
      path = path.replace(/\\/g, "/");
    }

    var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    this.memoizedURLs.set(path, url);
    return url;
  }

};
var mapGenerator$1 = MapGenerator$2$1;
var Node$2$1 = node$1;
var Comment$4$1 = class Comment extends Node$2$1 {
  constructor(defaults) {
    super(defaults);
    this.type = "comment";
  }

};
var comment$1 = Comment$4$1;
Comment$4$1.default = Comment$4$1;
var {
  isClean: isClean$1$1,
  my: my$1$1
} = symbols$1;
var Declaration$3$1 = declaration$1;
var Comment$3$1 = comment$1;
var Node$1$1 = node$1;
var parse$4$1, Rule$4$1, AtRule$4$1, Root$6$1;

function cleanSource$1(nodes) {
  return nodes.map(i2 => {
    if (i2.nodes) i2.nodes = cleanSource$1(i2.nodes);
    delete i2.source;
    return i2;
  });
}

function markDirtyUp$1(node2) {
  node2[isClean$1$1] = false;

  if (node2.proxyOf.nodes) {
    for (var i2 of node2.proxyOf.nodes) {
      markDirtyUp$1(i2);
    }
  }
}

var Container$7$1 = class Container extends Node$1$1 {
  append() {
    for (var _len2 = arguments.length, children = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      children[_key2] = arguments[_key2];
    }

    for (var child of children) {
      var nodes = this.normalize(child, this.last);

      for (var node2 of nodes) {
        this.proxyOf.nodes.push(node2);
      }
    }

    this.markDirty();
    return this;
  }

  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);

    if (this.nodes) {
      for (var node2 of this.nodes) {
        node2.cleanRaws(keepBetween);
      }
    }
  }

  each(callback) {
    if (!this.proxyOf.nodes) return void 0;
    var iterator = this.getIterator();
    var index2, result2;

    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index2 = this.indexes[iterator];
      result2 = callback(this.proxyOf.nodes[index2], index2);
      if (result2 === false) break;
      this.indexes[iterator] += 1;
    }

    delete this.indexes[iterator];
    return result2;
  }

  every(condition) {
    return this.nodes.every(condition);
  }

  getIterator() {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};
    this.lastEach += 1;
    var iterator = this.lastEach;
    this.indexes[iterator] = 0;
    return iterator;
  }

  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (!node2[prop]) {
          return node2[prop];
        } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
          return function () {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            return node2[prop](...args.map(i2 => {
              if (typeof i2 === "function") {
                return (child, index2) => i2(child.toProxy(), index2);
              } else {
                return i2;
              }
            }));
          };
        } else if (prop === "every" || prop === "some") {
          return cb => {
            return node2[prop](function (child) {
              for (var _len4 = arguments.length, other = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                other[_key4 - 1] = arguments[_key4];
              }

              return cb(child.toProxy(), ...other);
            });
          };
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else if (prop === "nodes") {
          return node2.nodes.map(i2 => i2.toProxy());
        } else if (prop === "first" || prop === "last") {
          return node2[prop].toProxy();
        } else {
          return node2[prop];
        }
      },

      set(node2, prop, value) {
        if (node2[prop] === value) return true;
        node2[prop] = value;

        if (prop === "name" || prop === "params" || prop === "selector") {
          node2.markDirty();
        }

        return true;
      }

    };
  }

  index(child) {
    if (typeof child === "number") return child;
    if (child.proxyOf) child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child);
  }

  insertAfter(exist, add) {
    var existIndex = this.index(exist);
    var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
    existIndex = this.index(exist);

    for (var node2 of nodes) {
      this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
    }

    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (existIndex < index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  insertBefore(exist, add) {
    var existIndex = this.index(exist);
    var type = existIndex === 0 ? "prepend" : false;
    var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
    existIndex = this.index(exist);

    for (var node2 of nodes) {
      this.proxyOf.nodes.splice(existIndex, 0, node2);
    }

    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (existIndex <= index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  normalize(nodes, sample) {
    if (typeof nodes === "string") {
      nodes = cleanSource$1(parse$4$1(nodes).nodes);
    } else if (typeof nodes === "undefined") {
      nodes = [];
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);

      for (var i2 of nodes) {
        if (i2.parent) i2.parent.removeChild(i2, "ignore");
      }
    } else if (nodes.type === "root" && this.type !== "document") {
      nodes = nodes.nodes.slice(0);

      for (var _i of nodes) {
        if (_i.parent) _i.parent.removeChild(_i, "ignore");
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === "undefined") {
        throw new Error("Value field is missed in node creation");
      } else if (typeof nodes.value !== "string") {
        nodes.value = String(nodes.value);
      }

      nodes = [new Declaration$3$1(nodes)];
    } else if (nodes.selector) {
      nodes = [new Rule$4$1(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule$4$1(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment$3$1(nodes)];
    } else {
      throw new Error("Unknown node type in node creation");
    }

    var processed = nodes.map(i2 => {
      if (!i2[my$1$1]) Container.rebuild(i2);
      i2 = i2.proxyOf;
      if (i2.parent) i2.parent.removeChild(i2);
      if (i2[isClean$1$1]) markDirtyUp$1(i2);

      if (typeof i2.raws.before === "undefined") {
        if (sample && typeof sample.raws.before !== "undefined") {
          i2.raws.before = sample.raws.before.replace(/\S/g, "");
        }
      }

      i2.parent = this.proxyOf;
      return i2;
    });
    return processed;
  }

  prepend() {
    for (var _len5 = arguments.length, children = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      children[_key5] = arguments[_key5];
    }

    children = children.reverse();

    for (var child of children) {
      var nodes = this.normalize(child, this.first, "prepend").reverse();

      for (var node2 of nodes) {
        this.proxyOf.nodes.unshift(node2);
      }

      for (var id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this;
  }

  removeAll() {
    for (var node2 of this.proxyOf.nodes) {
      node2.parent = void 0;
    }

    this.proxyOf.nodes = [];
    this.markDirty();
    return this;
  }

  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = void 0;
    this.proxyOf.nodes.splice(child, 1);
    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (index2 >= child) {
        this.indexes[id] = index2 - 1;
      }
    }

    this.markDirty();
    return this;
  }

  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }

    this.walkDecls(decl => {
      if (opts.props && !opts.props.includes(decl.prop)) return;
      if (opts.fast && !decl.value.includes(opts.fast)) return;
      decl.value = decl.value.replace(pattern, callback);
    });
    this.markDirty();
    return this;
  }

  some(condition) {
    return this.nodes.some(condition);
  }

  walk(callback) {
    return this.each((child, i2) => {
      var result2;

      try {
        result2 = callback(child, i2);
      } catch (e2) {
        throw child.addToError(e2);
      }

      if (result2 !== false && child.walk) {
        result2 = child.walk(callback);
      }

      return result2;
    });
  }

  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i2) => {
        if (child.type === "atrule") {
          return callback(child, i2);
        }
      });
    }

    if (name instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "atrule" && name.test(child.name)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "atrule" && child.name === name) {
        return callback(child, i2);
      }
    });
  }

  walkComments(callback) {
    return this.walk((child, i2) => {
      if (child.type === "comment") {
        return callback(child, i2);
      }
    });
  }

  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i2) => {
        if (child.type === "decl") {
          return callback(child, i2);
        }
      });
    }

    if (prop instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "decl" && prop.test(child.prop)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "decl" && child.prop === prop) {
        return callback(child, i2);
      }
    });
  }

  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;
      return this.walk((child, i2) => {
        if (child.type === "rule") {
          return callback(child, i2);
        }
      });
    }

    if (selector instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "rule" && selector.test(child.selector)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "rule" && child.selector === selector) {
        return callback(child, i2);
      }
    });
  }

  get first() {
    if (!this.proxyOf.nodes) return void 0;
    return this.proxyOf.nodes[0];
  }

  get last() {
    if (!this.proxyOf.nodes) return void 0;
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }

};

Container$7$1.registerParse = dependant => {
  parse$4$1 = dependant;
};

Container$7$1.registerRule = dependant => {
  Rule$4$1 = dependant;
};

Container$7$1.registerAtRule = dependant => {
  AtRule$4$1 = dependant;
};

Container$7$1.registerRoot = dependant => {
  Root$6$1 = dependant;
};

var container$1 = Container$7$1;
Container$7$1.default = Container$7$1;

Container$7$1.rebuild = node2 => {
  if (node2.type === "atrule") {
    Object.setPrototypeOf(node2, AtRule$4$1.prototype);
  } else if (node2.type === "rule") {
    Object.setPrototypeOf(node2, Rule$4$1.prototype);
  } else if (node2.type === "decl") {
    Object.setPrototypeOf(node2, Declaration$3$1.prototype);
  } else if (node2.type === "comment") {
    Object.setPrototypeOf(node2, Comment$3$1.prototype);
  } else if (node2.type === "root") {
    Object.setPrototypeOf(node2, Root$6$1.prototype);
  }

  node2[my$1$1] = true;

  if (node2.nodes) {
    node2.nodes.forEach(child => {
      Container$7$1.rebuild(child);
    });
  }
};

var Container$6$1 = container$1;
var LazyResult$4$1, Processor$3$1;
var Document$3$1 = class Document2 extends Container$6$1 {
  constructor(defaults) {
    super(_objectSpread({
      type: "document"
    }, defaults));

    if (!this.nodes) {
      this.nodes = [];
    }
  }

  toResult() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lazy = new LazyResult$4$1(new Processor$3$1(), this, opts);
    return lazy.stringify();
  }

};

Document$3$1.registerLazyResult = dependant => {
  LazyResult$4$1 = dependant;
};

Document$3$1.registerProcessor = dependant => {
  Processor$3$1 = dependant;
};

var document$1$1 = Document$3$1;
Document$3$1.default = Document$3$1;
var printed$1 = {};

var warnOnce$2$1 = function warnOnce(message) {
  if (printed$1[message]) return;
  printed$1[message] = true;

  if (typeof console !== "undefined" && console.warn) {
    console.warn(message);
  }
};

var Warning$2$1 = class Warning {
  constructor(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.type = "warning";
    this.text = text;

    if (opts.node && opts.node.source) {
      var range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }

    for (var opt in opts) {
      this[opt] = opts[opt];
    }
  }

  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message;
    }

    if (this.plugin) {
      return this.plugin + ": " + this.text;
    }

    return this.text;
  }

};
var warning$1 = Warning$2$1;
Warning$2$1.default = Warning$2$1;
var Warning$1$1 = warning$1;
var Result$3$1 = class Result {
  constructor(processor2, root2, opts) {
    this.processor = processor2;
    this.messages = [];
    this.root = root2;
    this.opts = opts;
    this.css = void 0;
    this.map = void 0;
  }

  toString() {
    return this.css;
  }

  warn(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }

    var warning2 = new Warning$1$1(text, opts);
    this.messages.push(warning2);
    return warning2;
  }

  warnings() {
    return this.messages.filter(i2 => i2.type === "warning");
  }

  get content() {
    return this.css;
  }

};
var result$1 = Result$3$1;
Result$3$1.default = Result$3$1;
var SINGLE_QUOTE$1 = "'".charCodeAt(0);
var DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var BACKSLASH$1 = "\\".charCodeAt(0);
var SLASH$1 = "/".charCodeAt(0);
var NEWLINE$1 = "\n".charCodeAt(0);
var SPACE$1 = " ".charCodeAt(0);
var FEED$1 = "\f".charCodeAt(0);
var TAB$1 = "	".charCodeAt(0);
var CR$1 = "\r".charCodeAt(0);
var OPEN_SQUARE$1 = "[".charCodeAt(0);
var CLOSE_SQUARE$1 = "]".charCodeAt(0);
var OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var OPEN_CURLY$1 = "{".charCodeAt(0);
var CLOSE_CURLY$1 = "}".charCodeAt(0);
var SEMICOLON$1 = ";".charCodeAt(0);
var ASTERISK$1 = "*".charCodeAt(0);
var COLON$1 = ":".charCodeAt(0);
var AT$1 = "@".charCodeAt(0);
var RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var RE_HEX_ESCAPE$1 = /[\da-f]/i;

var tokenize$1 = function tokenizer(input2) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var css = input2.css.valueOf();
  var ignore = options.ignoreErrors;
  var code, next, quote, content, escape;
  var escaped, escapePos, prev, n2, currentToken;
  var length = css.length;
  var pos = 0;
  var buffer = [];
  var returned = [];

  function position() {
    return pos;
  }

  function unclosed(what) {
    throw input2.error("Unclosed " + what, pos);
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop();
    if (pos >= length) return;
    var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css.charCodeAt(pos);

    switch (code) {
      case NEWLINE$1:
      case SPACE$1:
      case TAB$1:
      case CR$1:
      case FEED$1:
        {
          next = pos;

          do {
            next += 1;
            code = css.charCodeAt(next);
          } while (code === SPACE$1 || code === NEWLINE$1 || code === TAB$1 || code === CR$1 || code === FEED$1);

          currentToken = ["space", css.slice(pos, next)];
          pos = next - 1;
          break;
        }

      case OPEN_SQUARE$1:
      case CLOSE_SQUARE$1:
      case OPEN_CURLY$1:
      case CLOSE_CURLY$1:
      case COLON$1:
      case SEMICOLON$1:
      case CLOSE_PARENTHESES$1:
        {
          var controlChar = String.fromCharCode(code);
          currentToken = [controlChar, controlChar, pos];
          break;
        }

      case OPEN_PARENTHESES$1:
        {
          prev = buffer.length ? buffer.pop()[1] : "";
          n2 = css.charCodeAt(pos + 1);

          if (prev === "url" && n2 !== SINGLE_QUOTE$1 && n2 !== DOUBLE_QUOTE$1 && n2 !== SPACE$1 && n2 !== NEWLINE$1 && n2 !== TAB$1 && n2 !== FEED$1 && n2 !== CR$1) {
            next = pos;

            do {
              escaped = false;
              next = css.indexOf(")", next + 1);

              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos;
                  break;
                } else {
                  unclosed("bracket");
                }
              }

              escapePos = next;

              while (css.charCodeAt(escapePos - 1) === BACKSLASH$1) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);

            currentToken = ["brackets", css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            next = css.indexOf(")", pos + 1);
            content = css.slice(pos, next + 1);

            if (next === -1 || RE_BAD_BRACKET$1.test(content)) {
              currentToken = ["(", "(", pos];
            } else {
              currentToken = ["brackets", content, pos, next];
              pos = next;
            }
          }

          break;
        }

      case SINGLE_QUOTE$1:
      case DOUBLE_QUOTE$1:
        {
          quote = code === SINGLE_QUOTE$1 ? "'" : '"';
          next = pos;

          do {
            escaped = false;
            next = css.indexOf(quote, next + 1);

            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos + 1;
                break;
              } else {
                unclosed("string");
              }
            }

            escapePos = next;

            while (css.charCodeAt(escapePos - 1) === BACKSLASH$1) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);

          currentToken = ["string", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case AT$1:
        {
          RE_AT_END$1.lastIndex = pos + 1;
          RE_AT_END$1.test(css);

          if (RE_AT_END$1.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_AT_END$1.lastIndex - 2;
          }

          currentToken = ["at-word", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case BACKSLASH$1:
        {
          next = pos;
          escape = true;

          while (css.charCodeAt(next + 1) === BACKSLASH$1) {
            next += 1;
            escape = !escape;
          }

          code = css.charCodeAt(next + 1);

          if (escape && code !== SLASH$1 && code !== SPACE$1 && code !== NEWLINE$1 && code !== TAB$1 && code !== CR$1 && code !== FEED$1) {
            next += 1;

            if (RE_HEX_ESCAPE$1.test(css.charAt(next))) {
              while (RE_HEX_ESCAPE$1.test(css.charAt(next + 1))) {
                next += 1;
              }

              if (css.charCodeAt(next + 1) === SPACE$1) {
                next += 1;
              }
            }
          }

          currentToken = ["word", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      default:
        {
          if (code === SLASH$1 && css.charCodeAt(pos + 1) === ASTERISK$1) {
            next = css.indexOf("*/", pos + 2) + 1;

            if (next === 0) {
              if (ignore || ignoreUnclosed) {
                next = css.length;
              } else {
                unclosed("comment");
              }
            }

            currentToken = ["comment", css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            RE_WORD_END$1.lastIndex = pos + 1;
            RE_WORD_END$1.test(css);

            if (RE_WORD_END$1.lastIndex === 0) {
              next = css.length - 1;
            } else {
              next = RE_WORD_END$1.lastIndex - 2;
            }

            currentToken = ["word", css.slice(pos, next + 1), pos, next];
            buffer.push(currentToken);
            pos = next;
          }

          break;
        }
    }

    pos++;
    return currentToken;
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back,
    endOfFile,
    nextToken,
    position
  };
};

var Container$5$1 = container$1;
var AtRule$3$1 = class AtRule extends Container$5$1 {
  constructor(defaults) {
    super(defaults);
    this.type = "atrule";
  }

  append() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...arguments);
  }

  prepend() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...arguments);
  }

};
var atRule$1 = AtRule$3$1;
AtRule$3$1.default = AtRule$3$1;
Container$5$1.registerAtRule(AtRule$3$1);
var Container$4$1 = container$1;
var LazyResult$3$1, Processor$2$1;
var Root$5$1 = class Root extends Container$4$1 {
  constructor(defaults) {
    super(defaults);
    this.type = "root";
    if (!this.nodes) this.nodes = [];
  }

  normalize(child, sample, type) {
    var nodes = super.normalize(child);

    if (sample) {
      if (type === "prepend") {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (var node2 of nodes) {
          node2.raws.before = sample.raws.before;
        }
      }
    }

    return nodes;
  }

  removeChild(child, ignore) {
    var index2 = this.index(child);

    if (!ignore && index2 === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index2].raws.before;
    }

    return super.removeChild(child);
  }

  toResult() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lazy = new LazyResult$3$1(new Processor$2$1(), this, opts);
    return lazy.stringify();
  }

};

Root$5$1.registerLazyResult = dependant => {
  LazyResult$3$1 = dependant;
};

Root$5$1.registerProcessor = dependant => {
  Processor$2$1 = dependant;
};

var root$1 = Root$5$1;
Root$5$1.default = Root$5$1;
Container$4$1.registerRoot(Root$5$1);
var list$2$1 = {
  comma(string) {
    return list$2$1.split(string, [","], true);
  },

  space(string) {
    var spaces = [" ", "\n", "	"];
    return list$2$1.split(string, spaces);
  },

  split(string, separators, last) {
    var array = [];
    var current = "";
    var split = false;
    var func = 0;
    var inQuote = false;
    var prevQuote = "";
    var escape = false;

    for (var letter of string) {
      if (escape) {
        escape = false;
      } else if (letter === "\\") {
        escape = true;
      } else if (inQuote) {
        if (letter === prevQuote) {
          inQuote = false;
        }
      } else if (letter === '"' || letter === "'") {
        inQuote = true;
        prevQuote = letter;
      } else if (letter === "(") {
        func += 1;
      } else if (letter === ")") {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter)) split = true;
      }

      if (split) {
        if (current !== "") array.push(current.trim());
        current = "";
        split = false;
      } else {
        current += letter;
      }
    }

    if (last || current !== "") array.push(current.trim());
    return array;
  }

};
var list_1$1 = list$2$1;
list$2$1.default = list$2$1;
var Container$3$1 = container$1;
var list$1$1 = list_1$1;
var Rule$3$1 = class Rule extends Container$3$1 {
  constructor(defaults) {
    super(defaults);
    this.type = "rule";
    if (!this.nodes) this.nodes = [];
  }

  get selectors() {
    return list$1$1.comma(this.selector);
  }

  set selectors(values) {
    var match = this.selector ? this.selector.match(/,\s*/) : null;
    var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
    this.selector = values.join(sep2);
  }

};
var rule$1 = Rule$3$1;
Rule$3$1.default = Rule$3$1;
Container$3$1.registerRule(Rule$3$1);
var Declaration$2$1 = declaration$1;
var tokenizer2$1 = tokenize$1;
var Comment$2$1 = comment$1;
var AtRule$2$1 = atRule$1;
var Root$4$1 = root$1;
var Rule$2$1 = rule$1;
var SAFE_COMMENT_NEIGHBOR$1 = {
  empty: true,
  space: true
};

function findLastWithPosition$1(tokens) {
  for (var i2 = tokens.length - 1; i2 >= 0; i2--) {
    var token = tokens[i2];
    var pos = token[3] || token[2];
    if (pos) return pos;
  }
}

var Parser$1$1 = class Parser {
  constructor(input2) {
    this.input = input2;
    this.root = new Root$4$1();
    this.current = this.root;
    this.spaces = "";
    this.semicolon = false;
    this.createTokenizer();
    this.root.source = {
      input: input2,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }

  atrule(token) {
    var node2 = new AtRule$2$1();
    node2.name = token[1].slice(1);

    if (node2.name === "") {
      this.unnamedAtrule(node2, token);
    }

    this.init(node2, token[2]);
    var type;
    var prev;
    var shift;
    var last = false;
    var open = false;
    var params = [];
    var brackets = [];

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];

      if (type === "(" || type === "[") {
        brackets.push(type === "(" ? ")" : "]");
      } else if (type === "{" && brackets.length > 0) {
        brackets.push("}");
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }

      if (brackets.length === 0) {
        if (type === ";") {
          node2.source.end = this.getPosition(token[2]);
          node2.source.end.offset++;
          this.semicolon = true;
          break;
        } else if (type === "{") {
          open = true;
          break;
        } else if (type === "}") {
          if (params.length > 0) {
            shift = params.length - 1;
            prev = params[shift];

            while (prev && prev[0] === "space") {
              prev = params[--shift];
            }

            if (prev) {
              node2.source.end = this.getPosition(prev[3] || prev[2]);
              node2.source.end.offset++;
            }
          }

          this.end(token);
          break;
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }

      if (this.tokenizer.endOfFile()) {
        last = true;
        break;
      }
    }

    node2.raws.between = this.spacesAndCommentsFromEnd(params);

    if (params.length) {
      node2.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node2, "params", params);

      if (last) {
        token = params[params.length - 1];
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        this.spaces = node2.raws.between;
        node2.raws.between = "";
      }
    } else {
      node2.raws.afterName = "";
      node2.params = "";
    }

    if (open) {
      node2.nodes = [];
      this.current = node2;
    }
  }

  checkMissedSemicolon(tokens) {
    var colon = this.colon(tokens);
    if (colon === false) return;
    var founded = 0;
    var token;

    for (var j = colon - 1; j >= 0; j--) {
      token = tokens[j];

      if (token[0] !== "space") {
        founded += 1;
        if (founded === 2) break;
      }
    }

    throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
  }

  colon(tokens) {
    var brackets = 0;
    var token, type, prev;

    for (var [i2, element] of tokens.entries()) {
      token = element;
      type = token[0];

      if (type === "(") {
        brackets += 1;
      }

      if (type === ")") {
        brackets -= 1;
      }

      if (brackets === 0 && type === ":") {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === "word" && prev[1] === "progid") {
          continue;
        } else {
          return i2;
        }
      }

      prev = token;
    }

    return false;
  }

  comment(token) {
    var node2 = new Comment$2$1();
    this.init(node2, token[2]);
    node2.source.end = this.getPosition(token[3] || token[2]);
    node2.source.end.offset++;
    var text = token[1].slice(2, -2);

    if (/^\s*$/.test(text)) {
      node2.text = "";
      node2.raws.left = text;
      node2.raws.right = "";
    } else {
      var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
      node2.text = match[2];
      node2.raws.left = match[1];
      node2.raws.right = match[3];
    }
  }

  createTokenizer() {
    this.tokenizer = tokenizer2$1(this.input);
  }

  decl(tokens, customProperty) {
    var node2 = new Declaration$2$1();
    this.init(node2, tokens[0][2]);
    var last = tokens[tokens.length - 1];

    if (last[0] === ";") {
      this.semicolon = true;
      tokens.pop();
    }

    node2.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition$1(tokens));
    node2.source.end.offset++;

    while (tokens[0][0] !== "word") {
      if (tokens.length === 1) this.unknownWord(tokens);
      node2.raws.before += tokens.shift()[1];
    }

    node2.source.start = this.getPosition(tokens[0][2]);
    node2.prop = "";

    while (tokens.length) {
      var type = tokens[0][0];

      if (type === ":" || type === "space" || type === "comment") {
        break;
      }

      node2.prop += tokens.shift()[1];
    }

    node2.raws.between = "";
    var token;

    while (tokens.length) {
      token = tokens.shift();

      if (token[0] === ":") {
        node2.raws.between += token[1];
        break;
      } else {
        if (token[0] === "word" && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }

        node2.raws.between += token[1];
      }
    }

    if (node2.prop[0] === "_" || node2.prop[0] === "*") {
      node2.raws.before += node2.prop[0];
      node2.prop = node2.prop.slice(1);
    }

    var firstSpaces = [];
    var next;

    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment") break;
      firstSpaces.push(tokens.shift());
    }

    this.precheckMissedSemicolon(tokens);

    for (var i2 = tokens.length - 1; i2 >= 0; i2--) {
      token = tokens[i2];

      if (token[1].toLowerCase() === "!important") {
        node2.important = true;
        var string = this.stringFrom(tokens, i2);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== " !important") node2.raws.important = string;
        break;
      } else if (token[1].toLowerCase() === "important") {
        var cache = tokens.slice(0);
        var str = "";

        for (var j = i2; j > 0; j--) {
          var _type = cache[j][0];

          if (str.trim().indexOf("!") === 0 && _type !== "space") {
            break;
          }

          str = cache.pop()[1] + str;
        }

        if (str.trim().indexOf("!") === 0) {
          node2.important = true;
          node2.raws.important = str;
          tokens = cache;
        }
      }

      if (token[0] !== "space" && token[0] !== "comment") {
        break;
      }
    }

    var hasWord = tokens.some(i2 => i2[0] !== "space" && i2[0] !== "comment");

    if (hasWord) {
      node2.raws.between += firstSpaces.map(i2 => i2[1]).join("");
      firstSpaces = [];
    }

    this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);

    if (node2.value.includes(":") && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }

  doubleColon(token) {
    throw this.input.error("Double colon", {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }

  emptyRule(token) {
    var node2 = new Rule$2$1();
    this.init(node2, token[2]);
    node2.selector = "";
    node2.raws.between = "";
    this.current = node2;
  }

  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.semicolon = false;
    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.spaces = "";

    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current.source.end.offset++;
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }

  endFile() {
    if (this.current.parent) this.unclosedBlock();

    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.root.source.end = this.getPosition(this.tokenizer.position());
  }

  freeSemicolon(token) {
    this.spaces += token[1];

    if (this.current.nodes) {
      var prev = this.current.nodes[this.current.nodes.length - 1];

      if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = "";
      }
    }
  } // Helpers


  getPosition(offset) {
    var pos = this.input.fromOffset(offset);
    return {
      column: pos.col,
      line: pos.line,
      offset
    };
  }

  init(node2, offset) {
    this.current.push(node2);
    node2.source = {
      input: this.input,
      start: this.getPosition(offset)
    };
    node2.raws.before = this.spaces;
    this.spaces = "";
    if (node2.type !== "comment") this.semicolon = false;
  }

  other(start) {
    var end = false;
    var type = null;
    var colon = false;
    var bracket = null;
    var brackets = [];
    var customProperty = start[1].startsWith("--");
    var tokens = [];
    var token = start;

    while (token) {
      type = token[0];
      tokens.push(token);

      if (type === "(" || type === "[") {
        if (!bracket) bracket = token;
        brackets.push(type === "(" ? ")" : "]");
      } else if (customProperty && colon && type === "{") {
        if (!bracket) bracket = token;
        brackets.push("}");
      } else if (brackets.length === 0) {
        if (type === ";") {
          if (colon) {
            this.decl(tokens, customProperty);
            return;
          } else {
            break;
          }
        } else if (type === "{") {
          this.rule(tokens);
          return;
        } else if (type === "}") {
          this.tokenizer.back(tokens.pop());
          end = true;
          break;
        } else if (type === ":") {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }

      token = this.tokenizer.nextToken();
    }

    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);

    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== "space" && token !== "comment") break;
          this.tokenizer.back(tokens.pop());
        }
      }

      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }

  parse() {
    var token;

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      switch (token[0]) {
        case "space":
          this.spaces += token[1];
          break;

        case ";":
          this.freeSemicolon(token);
          break;

        case "}":
          this.end(token);
          break;

        case "comment":
          this.comment(token);
          break;

        case "at-word":
          this.atrule(token);
          break;

        case "{":
          this.emptyRule(token);
          break;

        default:
          this.other(token);
          break;
      }
    }

    this.endFile();
  }

  precheckMissedSemicolon() {}

  raw(node2, prop, tokens, customProperty) {
    var token, type;
    var length = tokens.length;
    var value = "";
    var clean = true;
    var next, prev;

    for (var i2 = 0; i2 < length; i2 += 1) {
      token = tokens[i2];
      type = token[0];

      if (type === "space" && i2 === length - 1 && !customProperty) {
        clean = false;
      } else if (type === "comment") {
        prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
        next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";

        if (!SAFE_COMMENT_NEIGHBOR$1[prev] && !SAFE_COMMENT_NEIGHBOR$1[next]) {
          if (value.slice(-1) === ",") {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }

    if (!clean) {
      var raw = tokens.reduce((all, i2) => all + i2[1], "");
      node2.raws[prop] = {
        raw,
        value
      };
    }

    node2[prop] = value;
  }

  rule(tokens) {
    tokens.pop();
    var node2 = new Rule$2$1();
    this.init(node2, tokens[0][2]);
    node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node2, "selector", tokens);
    this.current = node2;
  }

  spacesAndCommentsFromEnd(tokens) {
    var lastTokenType;
    var spaces = "";

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space" && lastTokenType !== "comment") break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  } // Errors


  spacesAndCommentsFromStart(tokens) {
    var next;
    var spaces = "";

    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment") break;
      spaces += tokens.shift()[1];
    }

    return spaces;
  }

  spacesFromEnd(tokens) {
    var lastTokenType;
    var spaces = "";

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space") break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  }

  stringFrom(tokens, from) {
    var result2 = "";

    for (var i2 = from; i2 < tokens.length; i2++) {
      result2 += tokens[i2][1];
    }

    tokens.splice(from, tokens.length - from);
    return result2;
  }

  unclosedBlock() {
    var pos = this.current.source.start;
    throw this.input.error("Unclosed block", pos.line, pos.column);
  }

  unclosedBracket(bracket) {
    throw this.input.error("Unclosed bracket", {
      offset: bracket[2]
    }, {
      offset: bracket[2] + 1
    });
  }

  unexpectedClose(token) {
    throw this.input.error("Unexpected }", {
      offset: token[2]
    }, {
      offset: token[2] + 1
    });
  }

  unknownWord(tokens) {
    throw this.input.error("Unknown word", {
      offset: tokens[0][2]
    }, {
      offset: tokens[0][2] + tokens[0][1].length
    });
  }

  unnamedAtrule(node2, token) {
    throw this.input.error("At-rule without name", {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }

};
var parser$1 = Parser$1$1;
var Container$2$1 = container$1;
var Parser2$1 = parser$1;
var Input$2$1 = input$1;

function parse$3$1(css, opts) {
  var input2 = new Input$2$1(css, opts);
  var parser2 = new Parser2$1(input2);

  try {
    parser2.parse();
  } catch (e2) {
    if (process.env.NODE_ENV !== "production") {
      if (e2.name === "CssSyntaxError" && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e2.message += "\nYou tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser";
        } else if (/\.sass/i.test(opts.from)) {
          e2.message += "\nYou tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser";
        } else if (/\.less$/i.test(opts.from)) {
          e2.message += "\nYou tried to parse Less with the standard CSS parser; try again with the postcss-less parser";
        }
      }
    }

    throw e2;
  }

  return parser2.root;
}

var parse_1$1 = parse$3$1;
parse$3$1.default = parse$3$1;
Container$2$1.registerParse(parse$3$1);
var {
  isClean: isClean$3,
  my: my$3
} = symbols$1;
var MapGenerator$1$1 = mapGenerator$1;
var stringify$2$1 = stringify_1$1;
var Container$1$1 = container$1;
var Document$2$1 = document$1$1;
var warnOnce$1$1 = warnOnce$2$1;
var Result$2$1 = result$1;
var parse$2$1 = parse_1$1;
var Root$3$1 = root$1;
var TYPE_TO_CLASS_NAME$1 = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
};
var PLUGIN_PROPS$1 = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};
var NOT_VISITORS$1 = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};
var CHILDREN$1 = 0;

function isPromise$1(obj) {
  return typeof obj === "object" && typeof obj.then === "function";
}

function getEvents$1(node2) {
  var key = false;
  var type = TYPE_TO_CLASS_NAME$1[node2.type];

  if (node2.type === "decl") {
    key = node2.prop.toLowerCase();
  } else if (node2.type === "atrule") {
    key = node2.name.toLowerCase();
  }

  if (key && node2.append) {
    return [type, type + "-" + key, CHILDREN$1, type + "Exit", type + "Exit-" + key];
  } else if (key) {
    return [type, type + "-" + key, type + "Exit", type + "Exit-" + key];
  } else if (node2.append) {
    return [type, CHILDREN$1, type + "Exit"];
  } else {
    return [type, type + "Exit"];
  }
}

function toStack$1(node2) {
  var events;

  if (node2.type === "document") {
    events = ["Document", CHILDREN$1, "DocumentExit"];
  } else if (node2.type === "root") {
    events = ["Root", CHILDREN$1, "RootExit"];
  } else {
    events = getEvents$1(node2);
  }

  return {
    eventIndex: 0,
    events,
    iterator: 0,
    node: node2,
    visitorIndex: 0,
    visitors: []
  };
}

function cleanMarks$1(node2) {
  node2[isClean$3] = false;
  if (node2.nodes) node2.nodes.forEach(i2 => cleanMarks$1(i2));
  return node2;
}

var postcss$2$1 = {};
var LazyResult$2$1 = class LazyResult {
  constructor(processor2, css, opts) {
    this.stringified = false;
    this.processed = false;
    var root2;

    if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
      root2 = cleanMarks$1(css);
    } else if (css instanceof LazyResult || css instanceof Result$2$1) {
      root2 = cleanMarks$1(css.root);

      if (css.map) {
        if (typeof opts.map === "undefined") opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      var parser2 = parse$2$1;
      if (opts.syntax) parser2 = opts.syntax.parse;
      if (opts.parser) parser2 = opts.parser;
      if (parser2.parse) parser2 = parser2.parse;

      try {
        root2 = parser2(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root2 && !root2[my$3]) {
        Container$1$1.rebuild(root2);
      }
    }

    this.result = new Result$2$1(processor2, root2, opts);
    this.helpers = _objectSpread(_objectSpread({}, postcss$2$1), {}, {
      postcss: postcss$2$1,
      result: this.result
    });
    this.plugins = this.processor.plugins.map(plugin22 => {
      if (typeof plugin22 === "object" && plugin22.prepare) {
        return _objectSpread(_objectSpread({}, plugin22), plugin22.prepare(this.result));
      } else {
        return plugin22;
      }
    });
  }

  async() {
    if (this.error) return Promise.reject(this.error);
    if (this.processed) return Promise.resolve(this.result);

    if (!this.processing) {
      this.processing = this.runAsync();
    }

    return this.processing;
  }

  catch(onRejected) {
    return this.async().catch(onRejected);
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }

  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }

  handleError(error, node2) {
    var plugin22 = this.result.lastPlugin;

    try {
      if (node2) node2.addToError(error);
      this.error = error;

      if (error.name === "CssSyntaxError" && !error.plugin) {
        error.plugin = plugin22.postcssPlugin;
        error.setMessage();
      } else if (plugin22.postcssVersion) {
        if (process.env.NODE_ENV !== "production") {
          var pluginName = plugin22.postcssPlugin;
          var pluginVer = plugin22.postcssVersion;
          var runtimeVer = this.result.processor.version;
          var a2 = pluginVer.split(".");
          var b = runtimeVer.split(".");

          if (a2[0] !== b[0] || parseInt(a2[1]) > parseInt(b[1])) {
            console.error("Unknown error from PostCSS plugin. Your current PostCSS version is " + runtimeVer + ", but " + pluginName + " uses " + pluginVer + ". Perhaps this is the source of the error below.");
          }
        }
      }
    } catch (err) {
      if (console && console.error) console.error(err);
    }

    return error;
  }

  prepareVisitors() {
    this.listeners = {};

    var add = (plugin22, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin22, cb]);
    };

    for (var plugin22 of this.plugins) {
      if (typeof plugin22 === "object") {
        for (var event in plugin22) {
          if (!PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) {
            throw new Error("Unknown event ".concat(event, " in ").concat(plugin22.postcssPlugin, ". Try to update PostCSS (").concat(this.processor.version, " now)."));
          }

          if (!NOT_VISITORS$1[event]) {
            if (typeof plugin22[event] === "object") {
              for (var filter in plugin22[event]) {
                if (filter === "*") {
                  add(plugin22, event, plugin22[event][filter]);
                } else {
                  add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                }
              }
            } else if (typeof plugin22[event] === "function") {
              add(plugin22, event, plugin22[event]);
            }
          }
        }
      }
    }

    this.hasListener = Object.keys(this.listeners).length > 0;
  }

  runAsync() {
    var _this = this;

    return _asyncToGenerator(function* () {
      _this.plugin = 0;

      for (var i2 = 0; i2 < _this.plugins.length; i2++) {
        var plugin22 = _this.plugins[i2];

        var promise = _this.runOnRoot(plugin22);

        if (isPromise$1(promise)) {
          try {
            yield promise;
          } catch (error) {
            throw _this.handleError(error);
          }
        }
      }

      _this.prepareVisitors();

      if (_this.hasListener) {
        var root2 = _this.result.root;

        while (!root2[isClean$3]) {
          root2[isClean$3] = true;
          var stack = [toStack$1(root2)];

          while (stack.length > 0) {
            var _promise = _this.visitTick(stack);

            if (isPromise$1(_promise)) {
              try {
                yield _promise;
              } catch (e2) {
                var node2 = stack[stack.length - 1].node;
                throw _this.handleError(e2, node2);
              }
            }
          }
        }

        if (_this.listeners.OnceExit) {
          var _loop = function* _loop(visitor, _plugin) {
            _this.result.lastPlugin = _plugin;

            try {
              if (root2.type === "document") {
                var roots = root2.nodes.map(subRoot => visitor(subRoot, _this.helpers));
                yield Promise.all(roots);
              } else {
                yield visitor(root2, _this.helpers);
              }
            } catch (e2) {
              throw _this.handleError(e2);
            }
          };

          for (var [_plugin, visitor] of _this.listeners.OnceExit) {
            yield* _loop(visitor, _plugin);
          }
        }
      }

      _this.processed = true;
      return _this.stringify();
    })();
  }

  runOnRoot(plugin22) {
    this.result.lastPlugin = plugin22;

    try {
      if (typeof plugin22 === "object" && plugin22.Once) {
        if (this.result.root.type === "document") {
          var roots = this.result.root.nodes.map(root2 => plugin22.Once(root2, this.helpers));

          if (isPromise$1(roots[0])) {
            return Promise.all(roots);
          }

          return roots;
        }

        return plugin22.Once(this.result.root, this.helpers);
      } else if (typeof plugin22 === "function") {
        return plugin22(this.result.root, this.result);
      }
    } catch (error) {
      throw this.handleError(error);
    }
  }

  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = true;
    this.sync();
    var opts = this.result.opts;
    var str = stringify$2$1;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;
    var map = new MapGenerator$1$1(str, this.result.root, this.result.opts);
    var data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  }

  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    this.processed = true;

    if (this.processing) {
      throw this.getAsyncError();
    }

    for (var plugin22 of this.plugins) {
      var promise = this.runOnRoot(plugin22);

      if (isPromise$1(promise)) {
        throw this.getAsyncError();
      }
    }

    this.prepareVisitors();

    if (this.hasListener) {
      var root2 = this.result.root;

      while (!root2[isClean$3]) {
        root2[isClean$3] = true;
        this.walkSync(root2);
      }

      if (this.listeners.OnceExit) {
        if (root2.type === "document") {
          for (var subRoot of root2.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root2);
        }
      }
    }

    return this.result;
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== "production") {
      if (!("from" in this.opts)) {
        warnOnce$1$1("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.");
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }

  toString() {
    return this.css;
  }

  visitSync(visitors, node2) {
    for (var [plugin22, visitor] of visitors) {
      this.result.lastPlugin = plugin22;
      var promise = void 0;

      try {
        promise = visitor(node2, this.helpers);
      } catch (e2) {
        throw this.handleError(e2, node2.proxyOf);
      }

      if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
        return true;
      }

      if (isPromise$1(promise)) {
        throw this.getAsyncError();
      }
    }
  }

  visitTick(stack) {
    var visit2 = stack[stack.length - 1];
    var {
      node: node2,
      visitors
    } = visit2;

    if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
      stack.pop();
      return;
    }

    if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
      var [plugin22, visitor] = visitors[visit2.visitorIndex];
      visit2.visitorIndex += 1;

      if (visit2.visitorIndex === visitors.length) {
        visit2.visitors = [];
        visit2.visitorIndex = 0;
      }

      this.result.lastPlugin = plugin22;

      try {
        return visitor(node2.toProxy(), this.helpers);
      } catch (e2) {
        throw this.handleError(e2, node2);
      }
    }

    if (visit2.iterator !== 0) {
      var iterator = visit2.iterator;
      var child;

      while (child = node2.nodes[node2.indexes[iterator]]) {
        node2.indexes[iterator] += 1;

        if (!child[isClean$3]) {
          child[isClean$3] = true;
          stack.push(toStack$1(child));
          return;
        }
      }

      visit2.iterator = 0;
      delete node2.indexes[iterator];
    }

    var events = visit2.events;

    while (visit2.eventIndex < events.length) {
      var event = events[visit2.eventIndex];
      visit2.eventIndex += 1;

      if (event === CHILDREN$1) {
        if (node2.nodes && node2.nodes.length) {
          node2[isClean$3] = true;
          visit2.iterator = node2.getIterator();
        }

        return;
      } else if (this.listeners[event]) {
        visit2.visitors = this.listeners[event];
        return;
      }
    }

    stack.pop();
  }

  walkSync(node2) {
    node2[isClean$3] = true;
    var events = getEvents$1(node2);

    for (var event of events) {
      if (event === CHILDREN$1) {
        if (node2.nodes) {
          node2.each(child => {
            if (!child[isClean$3]) this.walkSync(child);
          });
        }
      } else {
        var visitors = this.listeners[event];

        if (visitors) {
          if (this.visitSync(visitors, node2.toProxy())) return;
        }
      }
    }
  }

  warnings() {
    return this.sync().warnings();
  }

  get content() {
    return this.stringify().content;
  }

  get css() {
    return this.stringify().css;
  }

  get map() {
    return this.stringify().map;
  }

  get messages() {
    return this.sync().messages;
  }

  get opts() {
    return this.result.opts;
  }

  get processor() {
    return this.result.processor;
  }

  get root() {
    return this.sync().root;
  }

  get [Symbol.toStringTag]() {
    return "LazyResult";
  }

};

LazyResult$2$1.registerPostcss = dependant => {
  postcss$2$1 = dependant;
};

var lazyResult$1 = LazyResult$2$1;
LazyResult$2$1.default = LazyResult$2$1;
Root$3$1.registerLazyResult(LazyResult$2$1);
Document$2$1.registerLazyResult(LazyResult$2$1);
var MapGenerator2$1 = mapGenerator$1;
var stringify$1$1 = stringify_1$1;
var warnOnce2$1 = warnOnce$2$1;
var parse$1$1 = parse_1$1;
var Result$1$1 = result$1;
var NoWorkResult$1$1 = class NoWorkResult {
  constructor(processor2, css, opts) {
    css = css.toString();
    this.stringified = false;
    this._processor = processor2;
    this._css = css;
    this._opts = opts;
    this._map = void 0;
    var root2;
    var str = stringify$1$1;
    this.result = new Result$1$1(this._processor, root2, this._opts);
    this.result.css = css;
    var self = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return self.root;
      }

    });
    var map = new MapGenerator2$1(str, root2, this._opts, css);

    if (map.isMap()) {
      var [generatedCSS, generatedMap] = map.generate();

      if (generatedCSS) {
        this.result.css = generatedCSS;
      }

      if (generatedMap) {
        this.result.map = generatedMap;
      }
    } else {
      map.clearAnnotation();
      this.result.css = map.css;
    }
  }

  async() {
    if (this.error) return Promise.reject(this.error);
    return Promise.resolve(this.result);
  }

  catch(onRejected) {
    return this.async().catch(onRejected);
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }

  sync() {
    if (this.error) throw this.error;
    return this.result;
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== "production") {
      if (!("from" in this._opts)) {
        warnOnce2$1("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.");
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }

  toString() {
    return this._css;
  }

  warnings() {
    return [];
  }

  get content() {
    return this.result.css;
  }

  get css() {
    return this.result.css;
  }

  get map() {
    return this.result.map;
  }

  get messages() {
    return [];
  }

  get opts() {
    return this.result.opts;
  }

  get processor() {
    return this.result.processor;
  }

  get root() {
    if (this._root) {
      return this._root;
    }

    var root2;
    var parser2 = parse$1$1;

    try {
      root2 = parser2(this._css, this._opts);
    } catch (error) {
      this.error = error;
    }

    if (this.error) {
      throw this.error;
    } else {
      this._root = root2;
      return root2;
    }
  }

  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }

};
var noWorkResult$1 = NoWorkResult$1$1;
NoWorkResult$1$1.default = NoWorkResult$1$1;
var NoWorkResult2$1 = noWorkResult$1;
var LazyResult$1$1 = lazyResult$1;
var Document$1$1 = document$1$1;
var Root$2$1 = root$1;
var Processor$1$1 = class Processor {
  constructor() {
    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.version = "8.4.38";
    this.plugins = this.normalize(plugins);
  }

  normalize(plugins) {
    var normalized = [];

    for (var i2 of plugins) {
      if (i2.postcss === true) {
        i2 = i2();
      } else if (i2.postcss) {
        i2 = i2.postcss;
      }

      if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
        normalized = normalized.concat(i2.plugins);
      } else if (typeof i2 === "object" && i2.postcssPlugin) {
        normalized.push(i2);
      } else if (typeof i2 === "function") {
        normalized.push(i2);
      } else if (typeof i2 === "object" && (i2.parse || i2.stringify)) {
        if (process.env.NODE_ENV !== "production") {
          throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.");
        }
      } else {
        throw new Error(i2 + " is not a PostCSS plugin");
      }
    }

    return normalized;
  }

  process(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
      return new NoWorkResult2$1(this, css, opts);
    } else {
      return new LazyResult$1$1(this, css, opts);
    }
  }

  use(plugin22) {
    this.plugins = this.plugins.concat(this.normalize([plugin22]));
    return this;
  }

};
var processor$1 = Processor$1$1;
Processor$1$1.default = Processor$1$1;
Root$2$1.registerProcessor(Processor$1$1);
Document$1$1.registerProcessor(Processor$1$1);
var Declaration$1$1 = declaration$1;
var PreviousMap2$1 = previousMap$1;
var Comment$1$1 = comment$1;
var AtRule$1$1 = atRule$1;
var Input$1$1 = input$1;
var Root$1$1 = root$1;
var Rule$1$1 = rule$1;

function fromJSON$1$1(json, inputs) {
  if (Array.isArray(json)) return json.map(n2 => fromJSON$1$1(n2));

  var {
    inputs: ownInputs
  } = json,
      defaults = _objectWithoutProperties(json, _excluded);

  if (ownInputs) {
    inputs = [];

    for (var input2 of ownInputs) {
      var inputHydrated = _objectSpread(_objectSpread({}, input2), {}, {
        __proto__: Input$1$1.prototype
      });

      if (inputHydrated.map) {
        inputHydrated.map = _objectSpread(_objectSpread({}, inputHydrated.map), {}, {
          __proto__: PreviousMap2$1.prototype
        });
      }

      inputs.push(inputHydrated);
    }
  }

  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n2 => fromJSON$1$1(n2, inputs));
  }

  if (defaults.source) {
    var _defaults$source = defaults.source,
        {
      inputId
    } = _defaults$source,
        source = _objectWithoutProperties(_defaults$source, _excluded2);

    defaults.source = source;

    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }

  if (defaults.type === "root") {
    return new Root$1$1(defaults);
  } else if (defaults.type === "decl") {
    return new Declaration$1$1(defaults);
  } else if (defaults.type === "rule") {
    return new Rule$1$1(defaults);
  } else if (defaults.type === "comment") {
    return new Comment$1$1(defaults);
  } else if (defaults.type === "atrule") {
    return new AtRule$1$1(defaults);
  } else {
    throw new Error("Unknown node type: " + json.type);
  }
}

var fromJSON_1$1 = fromJSON$1$1;
fromJSON$1$1.default = fromJSON$1$1;
var CssSyntaxError2$1 = cssSyntaxError$1;
var Declaration2$1 = declaration$1;
var LazyResult2$1 = lazyResult$1;
var Container2$1 = container$1;
var Processor2$1 = processor$1;
var stringify$5 = stringify_1$1;
var fromJSON$2 = fromJSON_1$1;
var Document22 = document$1$1;
var Warning2$1 = warning$1;
var Comment2$1 = comment$1;
var AtRule2$1 = atRule$1;
var Result2$1 = result$1;
var Input2$1 = input$1;
var parse$5 = parse_1$1;
var list$3 = list_1$1;
var Rule2$1 = rule$1;
var Root2$1 = root$1;
var Node2$1 = node$1;

function postcss$3() {
  for (var _len6 = arguments.length, plugins = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    plugins[_key6] = arguments[_key6];
  }

  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }

  return new Processor2$1(plugins);
}

postcss$3.plugin = function plugin(name, initializer) {
  var warningPrinted = false;

  function creator() {
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");

      if (process.env.LANG && process.env.LANG.startsWith("cn")) {
        console.warn(name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226");
      }
    }

    var transformer = initializer(...arguments);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor2$1().version;
    return transformer;
  }

  var cache;
  Object.defineProperty(creator, "postcss", {
    get() {
      if (!cache) cache = creator();
      return cache;
    }

  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss$3([creator(pluginOpts)]).process(css, processOpts);
  };

  return creator;
};

postcss$3.stringify = stringify$5;
postcss$3.parse = parse$5;
postcss$3.fromJSON = fromJSON$2;
postcss$3.list = list$3;

postcss$3.comment = defaults => new Comment2$1(defaults);

postcss$3.atRule = defaults => new AtRule2$1(defaults);

postcss$3.decl = defaults => new Declaration2$1(defaults);

postcss$3.rule = defaults => new Rule2$1(defaults);

postcss$3.root = defaults => new Root2$1(defaults);

postcss$3.document = defaults => new Document22(defaults);

postcss$3.CssSyntaxError = CssSyntaxError2$1;
postcss$3.Declaration = Declaration2$1;
postcss$3.Container = Container2$1;
postcss$3.Processor = Processor2$1;
postcss$3.Document = Document22;
postcss$3.Comment = Comment2$1;
postcss$3.Warning = Warning2$1;
postcss$3.AtRule = AtRule2$1;
postcss$3.Result = Result2$1;
postcss$3.Input = Input2$1;
postcss$3.Rule = Rule2$1;
postcss$3.Root = Root2$1;
postcss$3.Node = Node2$1;
LazyResult2$1.registerPostcss(postcss$3);
var postcss_1$1 = postcss$3;
postcss$3.default = postcss$3;
var postcss$1$1 = /* @__PURE__ */getDefaultExportFromCjs$1(postcss_1$1);
postcss$1$1.stringify;
postcss$1$1.fromJSON;
postcss$1$1.plugin;
postcss$1$1.parse;
postcss$1$1.list;
postcss$1$1.document;
postcss$1$1.comment;
postcss$1$1.atRule;
postcss$1$1.rule;
postcss$1$1.decl;
postcss$1$1.root;
postcss$1$1.CssSyntaxError;
postcss$1$1.Declaration;
postcss$1$1.Container;
postcss$1$1.Processor;
postcss$1$1.Document;
postcss$1$1.Comment;
postcss$1$1.Warning;
postcss$1$1.AtRule;
postcss$1$1.Result;
postcss$1$1.Input;
postcss$1$1.Rule;
postcss$1$1.Root;
postcss$1$1.Node;
var tagMap = {
  script: "noscript",
  // camel case svg element tag names
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};

function getTagName(n2) {
  var tagName = tagMap[n2.tagName] ? tagMap[n2.tagName] : n2.tagName;

  if (tagName === "link" && n2.attributes._cssText) {
    tagName = "style";
  }

  return tagName;
}

function adaptCssForReplay(cssText, cache) {
  var cachedStyle = cache == null ? void 0 : cache.stylesWithHoverClass.get(cssText);
  if (cachedStyle) return cachedStyle;
  var result2 = cssText;

  try {
    var ast = postcss$1$1([mediaSelectorPlugin, pseudoClassPlugin]).process(cssText);
    result2 = ast.css;
  } catch (error) {
    console.warn("Failed to adapt css for replay", error);
  }

  cache == null ? void 0 : cache.stylesWithHoverClass.set(cssText, result2);
  return result2;
}

function createCache() {
  var stylesWithHoverClass = /* @__PURE__ */new Map();
  return {
    stylesWithHoverClass
  };
}

function applyCssSplits(n2, cssText, hackCss, cache) {
  var childTextNodes = [];

  for (var scn of n2.childNodes) {
    if (scn.type === NodeType$3.Text) {
      childTextNodes.push(scn);
    }
  }

  var cssTextSplits = cssText.split("/* rr_split */");

  while (cssTextSplits.length > 1 && cssTextSplits.length > childTextNodes.length) {
    cssTextSplits.splice(-2, 2, cssTextSplits.slice(-2).join(""));
  }

  for (var i2 = 0; i2 < childTextNodes.length; i2++) {
    var childTextNode = childTextNodes[i2];
    var cssTextSection = cssTextSplits[i2];

    if (childTextNode && cssTextSection) {
      childTextNode.textContent = hackCss ? adaptCssForReplay(cssTextSection, cache) : cssTextSection;
    }
  }
}

function buildStyleNode(n2, styleEl, cssText, options) {
  var {
    doc,
    hackCss,
    cache
  } = options;

  if (n2.childNodes.length) {
    applyCssSplits(n2, cssText, hackCss, cache);
  } else {
    if (hackCss) {
      cssText = adaptCssForReplay(cssText, cache);
    }

    styleEl.appendChild(doc.createTextNode(cssText));
  }
}

function buildNode(n2, options) {
  var _a2;

  var {
    doc,
    hackCss,
    cache
  } = options;

  switch (n2.type) {
    case NodeType$3.Document:
      return doc.implementation.createDocument(null, "", null);

    case NodeType$3.DocumentType:
      return doc.implementation.createDocumentType(n2.name || "html", n2.publicId, n2.systemId);

    case NodeType$3.Element:
      {
        var _ret = function () {
          var tagName = getTagName(n2);
          var node2;

          if (n2.isSVG) {
            node2 = doc.createElementNS("http://www.w3.org/2000/svg", tagName);
          } else {
            if ( // If the tag name is a custom element name
            n2.isCustom && ( // If the browser supports custom elements
            (_a2 = doc.defaultView) == null ? void 0 : _a2.customElements) && // If the custom element hasn't been defined yet
            !doc.defaultView.customElements.get(n2.tagName)) doc.defaultView.customElements.define(n2.tagName, class extends doc.defaultView.HTMLElement {});
            node2 = doc.createElement(tagName);
          }

          var specialAttributes = {};

          for (var name in n2.attributes) {
            if (!Object.prototype.hasOwnProperty.call(n2.attributes, name)) {
              continue;
            }

            var value = n2.attributes[name];

            if (tagName === "option" && name === "selected" && value === false) {
              continue;
            }

            if (value === null) {
              continue;
            }

            if (value === true) value = "";

            if (name.startsWith("rr_")) {
              specialAttributes[name] = value;
              continue;
            }

            if (typeof value !== "string") ;else if (tagName === "style" && name === "_cssText") {
              buildStyleNode(n2, node2, value, options);
              continue;
            } else if (tagName === "textarea" && name === "value") {
              node2.appendChild(doc.createTextNode(value));
              n2.childNodes = [];
              continue;
            }

            try {
              if (n2.isSVG && name === "xlink:href") {
                node2.setAttributeNS("http://www.w3.org/1999/xlink", name, value.toString());
              } else if (name === "onload" || name === "onclick" || name.substring(0, 7) === "onmouse") {
                node2.setAttribute("_" + name, value.toString());
              } else if (tagName === "meta" && n2.attributes["http-equiv"] === "Content-Security-Policy" && name === "content") {
                node2.setAttribute("csp-content", value.toString());
                continue;
              } else if (tagName === "link" && (n2.attributes.rel === "preload" || n2.attributes.rel === "modulepreload") && n2.attributes.as === "script") {} else if (tagName === "link" && n2.attributes.rel === "prefetch" && typeof n2.attributes.href === "string" && n2.attributes.href.endsWith(".js")) {} else if (tagName === "img" && n2.attributes.srcset && n2.attributes.rr_dataURL) {
                node2.setAttribute("rrweb-original-srcset", n2.attributes.srcset);
              } else {
                node2.setAttribute(name, value.toString());
              }
            } catch (error) {}
          }

          for (var _name in specialAttributes) {
            var _value2 = specialAttributes[_name];

            if (tagName === "canvas" && _name === "rr_dataURL") {
              (function () {
                var image = doc.createElement("img");

                image.onload = () => {
                  var ctx = node2.getContext("2d");

                  if (ctx) {
                    ctx.drawImage(image, 0, 0, image.width, image.height);
                  }
                };

                image.src = _value2.toString();
                if (node2.RRNodeType) node2.rr_dataURL = _value2.toString();
              })();
            } else if (tagName === "img" && _name === "rr_dataURL") {
              var image = node2;

              if (!image.currentSrc.startsWith("data:")) {
                image.setAttribute("rrweb-original-src", n2.attributes.src);
                image.src = _value2.toString();
              }
            }

            if (_name === "rr_width") {
              node2.style.setProperty("width", _value2.toString());
            } else if (_name === "rr_height") {
              node2.style.setProperty("height", _value2.toString());
            } else if (_name === "rr_mediaCurrentTime" && typeof _value2 === "number") {
              node2.currentTime = _value2;
            } else if (_name === "rr_mediaState") {
              switch (_value2) {
                case "played":
                  node2.play().catch(e2 => console.warn("media playback error", e2));
                  break;

                case "paused":
                  node2.pause();
                  break;
              }
            } else if (_name === "rr_mediaPlaybackRate" && typeof _value2 === "number") {
              node2.playbackRate = _value2;
            } else if (_name === "rr_mediaMuted" && typeof _value2 === "boolean") {
              node2.muted = _value2;
            } else if (_name === "rr_mediaLoop" && typeof _value2 === "boolean") {
              node2.loop = _value2;
            } else if (_name === "rr_mediaVolume" && typeof _value2 === "number") {
              node2.volume = _value2;
            } else if (_name === "rr_open_mode") {
              node2.setAttribute("rr_open_mode", _value2);
            }
          }

          if (n2.isShadowHost) {
            if (!node2.shadowRoot) {
              node2.attachShadow({
                mode: "open"
              });
            } else {
              while (node2.shadowRoot.firstChild) {
                node2.shadowRoot.removeChild(node2.shadowRoot.firstChild);
              }
            }
          }

          return {
            v: node2
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }

    case NodeType$3.Text:
      if (n2.isStyle && hackCss) {
        return doc.createTextNode(adaptCssForReplay(n2.textContent, cache));
      }

      return doc.createTextNode(n2.textContent);

    case NodeType$3.CDATA:
      return doc.createCDATASection(n2.textContent);

    case NodeType$3.Comment:
      return doc.createComment(n2.textContent);

    default:
      return null;
  }
}

function buildNodeWithSN(n2, options) {
  var {
    doc,
    mirror: mirror2,
    skipChild = false,
    hackCss = true,
    afterAppend,
    cache
  } = options;

  if (mirror2.has(n2.id)) {
    var nodeInMirror = mirror2.getNode(n2.id);
    var meta = mirror2.getMeta(nodeInMirror);
    if (isNodeMetaEqual(meta, n2)) return mirror2.getNode(n2.id);
  }

  var node2 = buildNode(n2, {
    doc,
    hackCss,
    cache
  });

  if (!node2) {
    return null;
  }

  if (n2.rootId && mirror2.getNode(n2.rootId) !== doc) {
    mirror2.replace(n2.rootId, doc);
  }

  if (n2.type === NodeType$3.Document) {
    doc.close();
    doc.open();

    if (n2.compatMode === "BackCompat" && n2.childNodes && n2.childNodes[0].type !== NodeType$3.DocumentType) {
      if (n2.childNodes[0].type === NodeType$3.Element && "xmlns" in n2.childNodes[0].attributes && n2.childNodes[0].attributes.xmlns === "http://www.w3.org/1999/xhtml") {
        doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">');
      } else {
        doc.write('<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">');
      }
    }

    node2 = doc;
  }

  mirror2.add(node2, n2);

  if ((n2.type === NodeType$3.Document || n2.type === NodeType$3.Element) && !skipChild) {
    for (var childN of n2.childNodes) {
      var childNode = buildNodeWithSN(childN, {
        doc,
        mirror: mirror2,
        skipChild: false,
        hackCss,
        afterAppend,
        cache
      });

      if (!childNode) {
        console.warn("Failed to rebuild", childN);
        continue;
      }

      if (childN.isShadow && isElement(node2) && node2.shadowRoot) {
        node2.shadowRoot.appendChild(childNode);
      } else if (n2.type === NodeType$3.Document && childN.type == NodeType$3.Element) {
        var htmlElement = childNode;
        var body = null;
        htmlElement.childNodes.forEach(child => {
          if (child.nodeName === "BODY") body = child;
        });

        if (body) {
          htmlElement.removeChild(body);
          node2.appendChild(childNode);
          htmlElement.appendChild(body);
        } else {
          node2.appendChild(childNode);
        }
      } else {
        node2.appendChild(childNode);
      }

      if (afterAppend) {
        afterAppend(childNode, childN.id);
      }
    }
  }

  return node2;
}

function visit(mirror2, onVisit) {
  function walk(node2) {
    onVisit(node2);
  }

  for (var id of mirror2.getIds()) {
    if (mirror2.has(id)) {
      walk(mirror2.getNode(id));
    }
  }
}

function handleScroll(node2, mirror2) {
  var n2 = mirror2.getMeta(node2);

  if ((n2 == null ? void 0 : n2.type) !== NodeType$3.Element) {
    return;
  }

  var el = node2;

  for (var name in n2.attributes) {
    if (!(Object.prototype.hasOwnProperty.call(n2.attributes, name) && name.startsWith("rr_"))) {
      continue;
    }

    var value = n2.attributes[name];

    if (name === "rr_scrollLeft") {
      el.scrollLeft = value;
    }

    if (name === "rr_scrollTop") {
      el.scrollTop = value;
    }
  }
}

function rebuild(n2, options) {
  var {
    doc,
    onVisit,
    hackCss = true,
    afterAppend,
    cache,
    mirror: mirror2 = new Mirror()
  } = options;
  var node2 = buildNodeWithSN(n2, {
    doc,
    mirror: mirror2,
    skipChild: false,
    hackCss,
    afterAppend,
    cache
  });
  visit(mirror2, visitedNode => {
    if (onVisit) {
      onVisit(visitedNode);
    }

    handleScroll(visitedNode, mirror2);
  });
  return node2;
}

var __defProp2 = Object.defineProperty;

var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __publicField2 = (obj, key, value) => __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);

var __defProp22 = Object.defineProperty;

var __defNormalProp22 = (obj, key, value) => key in obj ? __defProp22(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __publicField22 = (obj, key, value) => __defNormalProp22(obj, typeof key !== "symbol" ? key + "" : key, value);

var Mirror$1 = class Mirror2 {
  constructor() {
    __publicField22(this, "idNodeMap", /* @__PURE__ */new Map());

    __publicField22(this, "nodeMetaMap", /* @__PURE__ */new WeakMap());
  }

  getId(n2) {
    var _a2;

    if (!n2) return -1;
    var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
    return id !== null && id !== void 0 ? id : -1;
  }

  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }

  getIds() {
    return Array.from(this.idNodeMap.keys());
  }

  getMeta(n2) {
    return this.nodeMetaMap.get(n2) || null;
  } // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap


  removeNodeFromMap(n2) {
    var id = this.getId(n2);
    this.idNodeMap.delete(id);

    if (n2.childNodes) {
      n2.childNodes.forEach(childNode => this.removeNodeFromMap(childNode));
    }
  }

  has(id) {
    return this.idNodeMap.has(id);
  }

  hasNode(node2) {
    return this.nodeMetaMap.has(node2);
  }

  add(n2, meta) {
    var id = meta.id;
    this.idNodeMap.set(id, n2);
    this.nodeMetaMap.set(n2, meta);
  }

  replace(id, n2) {
    var oldNode = this.getNode(id);

    if (oldNode) {
      var meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n2, meta);
    }

    this.idNodeMap.set(id, n2);
  }

  reset() {
    this.idNodeMap = /* @__PURE__ */new Map();
    this.nodeMetaMap = /* @__PURE__ */new WeakMap();
  }

};

function createMirror$1() {
  return new Mirror$1();
}

function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}

function getAugmentedNamespace(n2) {
  if (n2.__esModule) return n2;
  var f2 = n2.default;

  if (typeof f2 == "function") {
    var a2 = function a22() {
      if (this instanceof a22) {
        return Reflect.construct(f2, arguments, this.constructor);
      }

      return f2.apply(this, arguments);
    };

    a2.prototype = f2.prototype;
  } else a2 = {};

  Object.defineProperty(a2, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a2, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n2[k];
      }
    });
  });
  return a2;
}

var picocolors_browser = {
  exports: {}
};
var x = String;

var create = function create() {
  return {
    isColorSupported: false,
    reset: x,
    bold: x,
    dim: x,
    italic: x,
    underline: x,
    inverse: x,
    hidden: x,
    strikethrough: x,
    black: x,
    red: x,
    green: x,
    yellow: x,
    blue: x,
    magenta: x,
    cyan: x,
    white: x,
    gray: x,
    bgBlack: x,
    bgRed: x,
    bgGreen: x,
    bgYellow: x,
    bgBlue: x,
    bgMagenta: x,
    bgCyan: x,
    bgWhite: x
  };
};

picocolors_browser.exports = create();
picocolors_browser.exports.createColors = create;
var picocolors_browserExports = picocolors_browser.exports;
var __viteBrowserExternal = {};

var __viteBrowserExternal$1 = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, {
  value: "Module"
}));

var require$$2 = /* @__PURE__ */getAugmentedNamespace(__viteBrowserExternal$1);
var pico = picocolors_browserExports;
var terminalHighlight$1 = require$$2;
var CssSyntaxError$3 = class CssSyntaxError2 extends Error {
  constructor(message, line, column, source, file, plugin22) {
    super(message);
    this.name = "CssSyntaxError";
    this.reason = message;

    if (file) {
      this.file = file;
    }

    if (source) {
      this.source = source;
    }

    if (plugin22) {
      this.plugin = plugin22;
    }

    if (typeof line !== "undefined" && typeof column !== "undefined") {
      if (typeof line === "number") {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }

    this.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError2);
    }
  }

  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "";
    this.message += this.file ? this.file : "<css input>";

    if (typeof this.line !== "undefined") {
      this.message += ":" + this.line + ":" + this.column;
    }

    this.message += ": " + this.reason;
  }

  showSourceCode(color) {
    if (!this.source) return "";
    var css = this.source;
    if (color == null) color = pico.isColorSupported;

    if (terminalHighlight$1) {
      if (color) css = terminalHighlight$1(css);
    }

    var lines = css.split(/\r?\n/);
    var start = Math.max(this.line - 3, 0);
    var end = Math.min(this.line + 2, lines.length);
    var maxWidth = String(end).length;
    var mark, aside;

    if (color) {
      var {
        bold,
        gray,
        red
      } = pico.createColors(true);

      mark = text => bold(red(text));

      aside = text => gray(text);
    } else {
      mark = aside = str => str;
    }

    return lines.slice(start, end).map((line, index2) => {
      var number = start + 1 + index2;
      var gutter = " " + (" " + number).slice(-maxWidth) + " | ";

      if (number === this.line) {
        var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
      }

      return " " + aside(gutter) + line;
    }).join("\n");
  }

  toString() {
    var code = this.showSourceCode();

    if (code) {
      code = "\n\n" + code + "\n";
    }

    return this.name + ": " + this.message + code;
  }

};
var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;
var symbols = {};
symbols.isClean = Symbol("isClean");
symbols.my = Symbol("my");
var DEFAULT_RAW = {
  after: "\n",
  beforeClose: "\n",
  beforeComment: "\n",
  beforeDecl: "\n",
  beforeOpen: " ",
  beforeRule: "\n",
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: false
};

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

var Stringifier$2 = class Stringifier2 {
  constructor(builder) {
    this.builder = builder;
  }

  atrule(node2, semicolon) {
    var name = "@" + node2.name;
    var params = node2.params ? this.rawValue(node2, "params") : "";

    if (typeof node2.raws.afterName !== "undefined") {
      name += node2.raws.afterName;
    } else if (params) {
      name += " ";
    }

    if (node2.nodes) {
      this.block(node2, name + params);
    } else {
      var end = (node2.raws.between || "") + (semicolon ? ";" : "");
      this.builder(name + params + end, node2);
    }
  }

  beforeAfter(node2, detect) {
    var value;

    if (node2.type === "decl") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (node2.type === "comment") {
      value = this.raw(node2, null, "beforeComment");
    } else if (detect === "before") {
      value = this.raw(node2, null, "beforeRule");
    } else {
      value = this.raw(node2, null, "beforeClose");
    }

    var buf = node2.parent;
    var depth = 0;

    while (buf && buf.type !== "root") {
      depth += 1;
      buf = buf.parent;
    }

    if (value.includes("\n")) {
      var indent = this.raw(node2, null, "indent");

      if (indent.length) {
        for (var step = 0; step < depth; step++) {
          value += indent;
        }
      }
    }

    return value;
  }

  block(node2, start) {
    var between = this.raw(node2, "between", "beforeOpen");
    this.builder(start + between + "{", node2, "start");
    var after;

    if (node2.nodes && node2.nodes.length) {
      this.body(node2);
      after = this.raw(node2, "after");
    } else {
      after = this.raw(node2, "after", "emptyBody");
    }

    if (after) this.builder(after);
    this.builder("}", node2, "end");
  }

  body(node2) {
    var last = node2.nodes.length - 1;

    while (last > 0) {
      if (node2.nodes[last].type !== "comment") break;
      last -= 1;
    }

    var semicolon = this.raw(node2, "semicolon");

    for (var i2 = 0; i2 < node2.nodes.length; i2++) {
      var child = node2.nodes[i2];
      var before = this.raw(child, "before");
      if (before) this.builder(before);
      this.stringify(child, last !== i2 || semicolon);
    }
  }

  comment(node2) {
    var left = this.raw(node2, "left", "commentLeft");
    var right = this.raw(node2, "right", "commentRight");
    this.builder("/*" + left + node2.text + right + "*/", node2);
  }

  decl(node2, semicolon) {
    var between = this.raw(node2, "between", "colon");
    var string = node2.prop + between + this.rawValue(node2, "value");

    if (node2.important) {
      string += node2.raws.important || " !important";
    }

    if (semicolon) string += ";";
    this.builder(string, node2);
  }

  document(node2) {
    this.body(node2);
  }

  raw(node2, own, detect) {
    var value;
    if (!detect) detect = own;

    if (own) {
      value = node2.raws[own];
      if (typeof value !== "undefined") return value;
    }

    var parent = node2.parent;

    if (detect === "before") {
      if (!parent || parent.type === "root" && parent.first === node2) {
        return "";
      }

      if (parent && parent.type === "document") {
        return "";
      }
    }

    if (!parent) return DEFAULT_RAW[detect];
    var root2 = node2.root();
    if (!root2.rawCache) root2.rawCache = {};

    if (typeof root2.rawCache[detect] !== "undefined") {
      return root2.rawCache[detect];
    }

    if (detect === "before" || detect === "after") {
      return this.beforeAfter(node2, detect);
    } else {
      var method = "raw" + capitalize(detect);

      if (this[method]) {
        value = this[method](root2, node2);
      } else {
        root2.walk(i2 => {
          value = i2.raws[own];
          if (typeof value !== "undefined") return false;
        });
      }
    }

    if (typeof value === "undefined") value = DEFAULT_RAW[detect];
    root2.rawCache[detect] = value;
    return value;
  }

  rawBeforeClose(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length > 0) {
        if (typeof i2.raws.after !== "undefined") {
          value = i2.raws.after;

          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, "");
    return value;
  }

  rawBeforeComment(root2, node2) {
    var value;
    root2.walkComments(i2 => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;

        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }

        return false;
      }
    });

    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeDecl");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }

    return value;
  }

  rawBeforeDecl(root2, node2) {
    var value;
    root2.walkDecls(i2 => {
      if (typeof i2.raws.before !== "undefined") {
        value = i2.raws.before;

        if (value.includes("\n")) {
          value = value.replace(/[^\n]+$/, "");
        }

        return false;
      }
    });

    if (typeof value === "undefined") {
      value = this.raw(node2, null, "beforeRule");
    } else if (value) {
      value = value.replace(/\S/g, "");
    }

    return value;
  }

  rawBeforeOpen(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.type !== "decl") {
        value = i2.raws.between;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawBeforeRule(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
        if (typeof i2.raws.before !== "undefined") {
          value = i2.raws.before;

          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }

          return false;
        }
      }
    });
    if (value) value = value.replace(/\S/g, "");
    return value;
  }

  rawColon(root2) {
    var value;
    root2.walkDecls(i2 => {
      if (typeof i2.raws.between !== "undefined") {
        value = i2.raws.between.replace(/[^\s:]/g, "");
        return false;
      }
    });
    return value;
  }

  rawEmptyBody(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length === 0) {
        value = i2.raws.after;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawIndent(root2) {
    if (root2.raws.indent) return root2.raws.indent;
    var value;
    root2.walk(i2 => {
      var p = i2.parent;

      if (p && p !== root2 && p.parent && p.parent === root2) {
        if (typeof i2.raws.before !== "undefined") {
          var parts = i2.raws.before.split("\n");
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, "");
          return false;
        }
      }
    });
    return value;
  }

  rawSemicolon(root2) {
    var value;
    root2.walk(i2 => {
      if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
        value = i2.raws.semicolon;
        if (typeof value !== "undefined") return false;
      }
    });
    return value;
  }

  rawValue(node2, prop) {
    var value = node2[prop];
    var raw = node2.raws[prop];

    if (raw && raw.value === value) {
      return raw.raw;
    }

    return value;
  }

  root(node2) {
    this.body(node2);
    if (node2.raws.after) this.builder(node2.raws.after);
  }

  rule(node2) {
    this.block(node2, this.rawValue(node2, "selector"));

    if (node2.raws.ownSemicolon) {
      this.builder(node2.raws.ownSemicolon, node2, "end");
    }
  }

  stringify(node2, semicolon) {
    if (!this[node2.type]) {
      throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
    }

    this[node2.type](node2, semicolon);
  }

};
var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;
var Stringifier$1 = stringifier;

function stringify$4(node2, builder) {
  var str = new Stringifier$1(builder);
  str.stringify(node2);
}

var stringify_1 = stringify$4;
stringify$4.default = stringify$4;
var {
  isClean: isClean$2,
  my: my$2
} = symbols;
var CssSyntaxError$2 = cssSyntaxError;
var Stringifier22 = stringifier;
var stringify$3 = stringify_1;

function cloneNode(obj, parent) {
  var cloned = new obj.constructor();

  for (var i2 in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
      continue;
    }

    if (i2 === "proxyCache") continue;
    var value = obj[i2];
    var type = typeof value;

    if (i2 === "parent" && type === "object") {
      if (parent) cloned[i2] = parent;
    } else if (i2 === "source") {
      cloned[i2] = value;
    } else if (Array.isArray(value)) {
      cloned[i2] = value.map(j => cloneNode(j, cloned));
    } else {
      if (type === "object" && value !== null) value = cloneNode(value);
      cloned[i2] = value;
    }
  }

  return cloned;
}

var Node$4 = class Node3 {
  constructor() {
    var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.raws = {};
    this[isClean$2] = false;
    this[my$2] = true;

    for (var name in defaults) {
      if (name === "nodes") {
        this.nodes = [];

        for (var node2 of defaults[name]) {
          if (typeof node2.clone === "function") {
            this.append(node2.clone());
          } else {
            this.append(node2);
          }
        }
      } else {
        this[name] = defaults[name];
      }
    }
  }

  addToError(error) {
    error.postcssNode = this;

    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
      var s2 = this.source;
      error.stack = error.stack.replace(/\n\s{4}at /, "$&".concat(s2.input.from, ":").concat(s2.start.line, ":").concat(s2.start.column, "$&"));
    }

    return error;
  }

  after(add) {
    this.parent.insertAfter(this, add);
    return this;
  }

  assign() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    for (var name in overrides) {
      this[name] = overrides[name];
    }

    return this;
  }

  before(add) {
    this.parent.insertBefore(this, add);
    return this;
  }

  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  }

  clone() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = cloneNode(this);

    for (var name in overrides) {
      cloned[name] = overrides[name];
    }

    return cloned;
  }

  cloneAfter() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned;
  }

  cloneBefore() {
    var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned;
  }

  error(message) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.source) {
      var {
        end,
        start
      } = this.rangeBy(opts);
      return this.source.input.error(message, {
        column: start.column,
        line: start.line
      }, {
        column: end.column,
        line: end.line
      }, opts);
    }

    return new CssSyntaxError$2(message);
  }

  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else {
          return node2[prop];
        }
      },

      set(node2, prop, value) {
        if (node2[prop] === value) return true;
        node2[prop] = value;

        if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" ||
        /* c8 ignore next */
        prop === "text") {
          node2.markDirty();
        }

        return true;
      }

    };
  }

  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = false;
      var next = this;

      while (next = next.parent) {
        next[isClean$2] = false;
      }
    }
  }

  next() {
    if (!this.parent) return void 0;
    var index2 = this.parent.index(this);
    return this.parent.nodes[index2 + 1];
  }

  positionBy(opts, stringRepresentation) {
    var pos = this.source.start;

    if (opts.index) {
      pos = this.positionInside(opts.index, stringRepresentation);
    } else if (opts.word) {
      stringRepresentation = this.toString();
      var index2 = stringRepresentation.indexOf(opts.word);
      if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
    }

    return pos;
  }

  positionInside(index2, stringRepresentation) {
    var string = stringRepresentation || this.toString();
    var column = this.source.start.column;
    var line = this.source.start.line;

    for (var i2 = 0; i2 < index2; i2++) {
      if (string[i2] === "\n") {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }

    return {
      column,
      line
    };
  }

  prev() {
    if (!this.parent) return void 0;
    var index2 = this.parent.index(this);
    return this.parent.nodes[index2 - 1];
  }

  rangeBy(opts) {
    var start = {
      column: this.source.start.column,
      line: this.source.start.line
    };
    var end = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: start.column + 1,
      line: start.line
    };

    if (opts.word) {
      var stringRepresentation = this.toString();
      var index2 = stringRepresentation.indexOf(opts.word);

      if (index2 !== -1) {
        start = this.positionInside(index2, stringRepresentation);
        end = this.positionInside(index2 + opts.word.length, stringRepresentation);
      }
    } else {
      if (opts.start) {
        start = {
          column: opts.start.column,
          line: opts.start.line
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }

      if (opts.end) {
        end = {
          column: opts.end.column,
          line: opts.end.line
        };
      } else if (typeof opts.endIndex === "number") {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }

    if (end.line < start.line || end.line === start.line && end.column <= start.column) {
      end = {
        column: start.column + 1,
        line: start.line
      };
    }

    return {
      end,
      start
    };
  }

  raw(prop, defaultType) {
    var str = new Stringifier22();
    return str.raw(this, prop, defaultType);
  }

  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }

    this.parent = void 0;
    return this;
  }

  replaceWith() {
    if (this.parent) {
      var bookmark = this;
      var foundSelf = false;

      for (var _len7 = arguments.length, nodes = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        nodes[_key7] = arguments[_key7];
      }

      for (var node2 of nodes) {
        if (node2 === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node2);
          bookmark = node2;
        } else {
          this.parent.insertBefore(bookmark, node2);
        }
      }

      if (!foundSelf) {
        this.remove();
      }
    }

    return this;
  }

  root() {
    var result2 = this;

    while (result2.parent && result2.parent.type !== "document") {
      result2 = result2.parent;
    }

    return result2;
  }

  toJSON(_, inputs) {
    var fixed = {};
    var emitInputs = inputs == null;
    inputs = inputs || /* @__PURE__ */new Map();
    var inputsNextIndex = 0;

    for (var name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        continue;
      }

      if (name === "parent" || name === "proxyCache") continue;
      var value = this[name];

      if (Array.isArray(value)) {
        fixed[name] = value.map(i2 => {
          if (typeof i2 === "object" && i2.toJSON) {
            return i2.toJSON(null, inputs);
          } else {
            return i2;
          }
        });
      } else if (typeof value === "object" && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === "source") {
        var inputId = inputs.get(value.input);

        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }

        fixed[name] = {
          end: value.end,
          inputId,
          start: value.start
        };
      } else {
        fixed[name] = value;
      }
    }

    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map(input2 => input2.toJSON());
    }

    return fixed;
  }

  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }

    return this.proxyCache;
  }

  toString() {
    var stringifier2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stringify$3;
    if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
    var result2 = "";
    stringifier2(this, i2 => {
      result2 += i2;
    });
    return result2;
  }

  warn(result2, text, opts) {
    var data = {
      node: this
    };

    for (var i2 in opts) {
      data[i2] = opts[i2];
    }

    return result2.warn(text, data);
  }

  get proxyOf() {
    return this;
  }

};
var node = Node$4;
Node$4.default = Node$4;
var Node$3 = node;
var Declaration$4 = class Declaration2 extends Node$3 {
  constructor(defaults) {
    if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
      defaults = _objectSpread(_objectSpread({}, defaults), {}, {
        value: String(defaults.value)
      });
    }

    super(defaults);
    this.type = "decl";
  }

  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }

};
var declaration = Declaration$4;
Declaration$4.default = Declaration$4;
var urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

var customAlphabet = function customAlphabet(alphabet) {
  var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
  return function () {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
    var id = "";
    var i2 = size;

    while (i2--) {
      id += alphabet[Math.random() * alphabet.length | 0];
    }

    return id;
  };
};

var nanoid$1 = function nanoid$1() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  var id = "";
  var i2 = size;

  while (i2--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }

  return id;
};

var nonSecure = {
  nanoid: nanoid$1,
  customAlphabet
};
var {
  SourceMapConsumer: SourceMapConsumer$2,
  SourceMapGenerator: SourceMapGenerator$2
} = require$$2;
var {
  existsSync,
  readFileSync
} = require$$2;
var {
  dirname: dirname$1,
  join
} = require$$2;

function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, "base64").toString();
  } else {
    return window.atob(str);
  }
}

var PreviousMap$2 = class PreviousMap2 {
  constructor(css, opts) {
    if (opts.map === false) return;
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, "data:");
    var prev = opts.map ? opts.map.prev : void 0;
    var text = this.loadMap(opts.from, prev);

    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }

    if (this.mapFile) this.root = dirname$1(this.mapFile);
    if (text) this.text = text;
  }

  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer$2(this.text);
    }

    return this.consumerCache;
  }

  decodeInline(text) {
    var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    var baseUri = /^data:application\/json;base64,/;
    var charsetUri = /^data:application\/json;charset=utf-?8,/;
    var uri = /^data:application\/json,/;

    if (charsetUri.test(text) || uri.test(text)) {
      return decodeURIComponent(text.substr(RegExp.lastMatch.length));
    }

    if (baseCharsetUri.test(text) || baseUri.test(text)) {
      return fromBase64(text.substr(RegExp.lastMatch.length));
    }

    var encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + encoding);
  }

  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }

  isMap(map) {
    if (typeof map !== "object") return false;
    return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
  }

  loadAnnotation(css) {
    var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
    if (!comments) return;
    var start = css.lastIndexOf(comments.pop());
    var end = css.indexOf("*/", start);

    if (start > -1 && end > -1) {
      this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
  }

  loadFile(path) {
    this.root = dirname$1(path);

    if (existsSync(path)) {
      this.mapFile = path;
      return readFileSync(path, "utf-8").toString().trim();
    }
  }

  loadMap(file, prev) {
    if (prev === false) return false;

    if (prev) {
      if (typeof prev === "string") {
        return prev;
      } else if (typeof prev === "function") {
        var prevPath = prev(file);

        if (prevPath) {
          var map = this.loadFile(prevPath);

          if (!map) {
            throw new Error("Unable to load previous source map: " + prevPath.toString());
          }

          return map;
        }
      } else if (prev instanceof SourceMapConsumer$2) {
        return SourceMapGenerator$2.fromSourceMap(prev).toString();
      } else if (prev instanceof SourceMapGenerator$2) {
        return prev.toString();
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev);
      } else {
        throw new Error("Unsupported previous source map format: " + prev.toString());
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation);
    } else if (this.annotation) {
      var _map2 = this.annotation;
      if (file) _map2 = join(dirname$1(file), _map2);
      return this.loadFile(_map2);
    }
  }

  startWith(string, start) {
    if (!string) return false;
    return string.substr(0, start.length) === start;
  }

  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }

};
var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;
var {
  SourceMapConsumer: SourceMapConsumer$1,
  SourceMapGenerator: SourceMapGenerator$1
} = require$$2;
var {
  fileURLToPath,
  pathToFileURL: pathToFileURL$1
} = require$$2;
var {
  isAbsolute,
  resolve: resolve$1
} = require$$2;
var {
  nanoid
} = nonSecure;
var terminalHighlight = require$$2;
var CssSyntaxError$1 = cssSyntaxError;
var PreviousMap$1 = previousMap;
var fromOffsetCache = Symbol("fromOffsetCache");
var sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
var pathAvailable$1 = Boolean(resolve$1 && isAbsolute);
var Input$4 = class Input2 {
  constructor(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) {
      throw new Error("PostCSS received ".concat(css, " instead of CSS string"));
    }

    this.css = css.toString();

    if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    if (opts.from) {
      if (!pathAvailable$1 || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
        this.file = opts.from;
      } else {
        this.file = resolve$1(opts.from);
      }
    }

    if (pathAvailable$1 && sourceMapAvailable$1) {
      var map = new PreviousMap$1(this.css, opts);

      if (map.text) {
        this.map = map;
        var file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }

    if (!this.file) {
      this.id = "<input css " + nanoid(6) + ">";
    }

    if (this.map) this.map.file = this.from;
  }

  error(message, line, column) {
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var result2, endLine, endColumn;

    if (line && typeof line === "object") {
      var start = line;
      var end = column;

      if (typeof start.offset === "number") {
        var pos = this.fromOffset(start.offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
      }

      if (typeof end.offset === "number") {
        var _pos3 = this.fromOffset(end.offset);

        endLine = _pos3.line;
        endColumn = _pos3.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
      }
    } else if (!column) {
      var _pos4 = this.fromOffset(line);

      line = _pos4.line;
      column = _pos4.col;
    }

    var origin = this.origin(line, column, endLine, endColumn);

    if (origin) {
      result2 = new CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
        column: origin.column,
        line: origin.line
      }, origin.endLine === void 0 ? origin.column : {
        column: origin.endColumn,
        line: origin.endLine
      }, origin.source, origin.file, opts.plugin);
    } else {
      result2 = new CssSyntaxError$1(message, endLine === void 0 ? line : {
        column,
        line
      }, endLine === void 0 ? column : {
        column: endColumn,
        line: endLine
      }, this.css, this.file, opts.plugin);
    }

    result2.input = {
      column,
      endColumn,
      endLine,
      line,
      source: this.css
    };

    if (this.file) {
      if (pathToFileURL$1) {
        result2.input.url = pathToFileURL$1(this.file).toString();
      }

      result2.input.file = this.file;
    }

    return result2;
  }

  fromOffset(offset) {
    var lastLine, lineToIndex;

    if (!this[fromOffsetCache]) {
      var lines = this.css.split("\n");
      lineToIndex = new Array(lines.length);
      var prevIndex = 0;

      for (var i2 = 0, l2 = lines.length; i2 < l2; i2++) {
        lineToIndex[i2] = prevIndex;
        prevIndex += lines[i2].length + 1;
      }

      this[fromOffsetCache] = lineToIndex;
    } else {
      lineToIndex = this[fromOffsetCache];
    }

    lastLine = lineToIndex[lineToIndex.length - 1];
    var min = 0;

    if (offset >= lastLine) {
      min = lineToIndex.length - 1;
    } else {
      var max = lineToIndex.length - 2;
      var mid;

      while (min < max) {
        mid = min + (max - min >> 1);

        if (offset < lineToIndex[mid]) {
          max = mid - 1;
        } else if (offset >= lineToIndex[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break;
        }
      }
    }

    return {
      col: offset - lineToIndex[min] + 1,
      line: min + 1
    };
  }

  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file;
    }

    return resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
  }

  origin(line, column, endLine, endColumn) {
    if (!this.map) return false;
    var consumer = this.map.consumer();
    var from = consumer.originalPositionFor({
      column,
      line
    });
    if (!from.source) return false;
    var to;

    if (typeof endLine === "number") {
      to = consumer.originalPositionFor({
        column: endColumn,
        line: endLine
      });
    }

    var fromUrl;

    if (isAbsolute(from.source)) {
      fromUrl = pathToFileURL$1(from.source);
    } else {
      fromUrl = new URL(from.source, this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile));
    }

    var result2 = {
      column: from.column,
      endColumn: to && to.column,
      endLine: to && to.line,
      line: from.line,
      url: fromUrl.toString()
    };

    if (fromUrl.protocol === "file:") {
      if (fileURLToPath) {
        result2.file = fileURLToPath(fromUrl);
      } else {
        throw new Error("file: protocol is not available in this PostCSS build");
      }
    }

    var source = consumer.sourceContentFor(from.source);
    if (source) result2.source = source;
    return result2;
  }

  toJSON() {
    var json = {};

    for (var name of ["hasBOM", "css", "file", "id"]) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }

    if (this.map) {
      json.map = _objectSpread({}, this.map);

      if (json.map.consumerCache) {
        json.map.consumerCache = void 0;
      }
    }

    return json;
  }

  get from() {
    return this.file || this.id;
  }

};
var input = Input$4;
Input$4.default = Input$4;

if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input$4);
}

var {
  SourceMapConsumer,
  SourceMapGenerator
} = require$$2;
var {
  dirname,
  relative,
  resolve,
  sep
} = require$$2;
var {
  pathToFileURL
} = require$$2;
var Input$3 = input;
var sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
var pathAvailable = Boolean(dirname && resolve && relative && sep);
var MapGenerator$2 = class MapGenerator2 {
  constructor(stringify2, root2, opts, cssString) {
    this.stringify = stringify2;
    this.mapOpts = opts.map || {};
    this.root = root2;
    this.opts = opts;
    this.css = cssString;
    this.originalCSS = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    this.memoizedFileURLs = /* @__PURE__ */new Map();
    this.memoizedPaths = /* @__PURE__ */new Map();
    this.memoizedURLs = /* @__PURE__ */new Map();
  }

  addAnnotation() {
    var content;

    if (this.isInline()) {
      content = "data:application/json;base64," + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === "string") {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === "function") {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + ".map";
    }

    var eol = "\n";
    if (this.css.includes("\r\n")) eol = "\r\n";
    this.css += eol + "/*# sourceMappingURL=" + content + " */";
  }

  applyPrevMaps() {
    for (var prev of this.previous()) {
      var from = this.toUrl(this.path(prev.file));
      var root2 = prev.root || dirname(prev.file);
      var map = void 0;

      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer(prev.text);

        if (map.sourcesContent) {
          map.sourcesContent = null;
        }
      } else {
        map = prev.consumer();
      }

      this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
    }
  }

  clearAnnotation() {
    if (this.mapOpts.annotation === false) return;

    if (this.root) {
      var node2;

      for (var i2 = this.root.nodes.length - 1; i2 >= 0; i2--) {
        node2 = this.root.nodes[i2];
        if (node2.type !== "comment") continue;

        if (node2.text.indexOf("# sourceMappingURL=") === 0) {
          this.root.removeChild(i2);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    }
  }

  generate() {
    this.clearAnnotation();

    if (pathAvailable && sourceMapAvailable && this.isMap()) {
      return this.generateMap();
    } else {
      var result2 = "";
      this.stringify(this.root, i2 => {
        result2 += i2;
      });
      return [result2];
    }
  }

  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      var prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator.fromSourceMap(prev, {
        ignoreInvalidMapping: true
      });
    } else {
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      this.map.addMapping({
        generated: {
          column: 0,
          line: 1
        },
        original: {
          column: 0,
          line: 1
        },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    }

    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.root && this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();

    if (this.isInline()) {
      return [this.css];
    } else {
      return [this.css, this.map];
    }
  }

  generateString() {
    this.css = "";
    this.map = new SourceMapGenerator({
      file: this.outputFile(),
      ignoreInvalidMapping: true
    });
    var line = 1;
    var column = 1;
    var noSource = "<no source>";
    var mapping = {
      generated: {
        column: 0,
        line: 0
      },
      original: {
        column: 0,
        line: 0
      },
      source: ""
    };
    var lines, last;
    this.stringify(this.root, (str, node2, type) => {
      this.css += str;

      if (node2 && type !== "end") {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;

        if (node2.source && node2.source.start) {
          mapping.source = this.sourcePath(node2);
          mapping.original.line = node2.source.start.line;
          mapping.original.column = node2.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }

      lines = str.match(/\n/g);

      if (lines) {
        line += lines.length;
        last = str.lastIndexOf("\n");
        column = str.length - last;
      } else {
        column += str.length;
      }

      if (node2 && type !== "start") {
        var p = node2.parent || {
          raws: {}
        };
        var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;

        if (!childless || node2 !== p.last || p.raws.semicolon) {
          if (node2.source && node2.source.end) {
            mapping.source = this.sourcePath(node2);
            mapping.original.line = node2.source.end.line;
            mapping.original.column = node2.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }

  isAnnotation() {
    if (this.isInline()) {
      return true;
    }

    if (typeof this.mapOpts.annotation !== "undefined") {
      return this.mapOpts.annotation;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.annotation);
    }

    return true;
  }

  isInline() {
    if (typeof this.mapOpts.inline !== "undefined") {
      return this.mapOpts.inline;
    }

    var annotation = this.mapOpts.annotation;

    if (typeof annotation !== "undefined" && annotation !== true) {
      return false;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.inline);
    }

    return true;
  }

  isMap() {
    if (typeof this.opts.map !== "undefined") {
      return !!this.opts.map;
    }

    return this.previous().length > 0;
  }

  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== "undefined") {
      return this.mapOpts.sourcesContent;
    }

    if (this.previous().length) {
      return this.previous().some(i2 => i2.withContent());
    }

    return true;
  }

  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to);
    } else if (this.opts.from) {
      return this.path(this.opts.from);
    } else {
      return "to.css";
    }
  }

  path(file) {
    if (this.mapOpts.absolute) return file;
    if (file.charCodeAt(0) === 60) return file;
    if (/^\w+:\/\//.test(file)) return file;
    var cached = this.memoizedPaths.get(file);
    if (cached) return cached;
    var from = this.opts.to ? dirname(this.opts.to) : ".";

    if (typeof this.mapOpts.annotation === "string") {
      from = dirname(resolve(from, this.mapOpts.annotation));
    }

    var path = relative(from, file);
    this.memoizedPaths.set(file, path);
    return path;
  }

  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];

      if (this.root) {
        this.root.walk(node2 => {
          if (node2.source && node2.source.input.map) {
            var map = node2.source.input.map;

            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        var input2 = new Input$3(this.originalCSS, this.opts);
        if (input2.map) this.previousMaps.push(input2.map);
      }
    }

    return this.previousMaps;
  }

  setSourcesContent() {
    var already = {};

    if (this.root) {
      this.root.walk(node2 => {
        if (node2.source) {
          var from = node2.source.input.from;

          if (from && !already[from]) {
            already[from] = true;
            var fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
            this.map.setSourceContent(fromUrl, node2.source.input.css);
          }
        }
      });
    } else if (this.css) {
      var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(from, this.css);
    }
  }

  sourcePath(node2) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from);
    } else if (this.usesFileUrls) {
      return this.toFileUrl(node2.source.input.from);
    } else {
      return this.toUrl(this.path(node2.source.input.from));
    }
  }

  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString("base64");
    } else {
      return window.btoa(unescape(encodeURIComponent(str)));
    }
  }

  toFileUrl(path) {
    var cached = this.memoizedFileURLs.get(path);
    if (cached) return cached;

    if (pathToFileURL) {
      var fileURL = pathToFileURL(path).toString();
      this.memoizedFileURLs.set(path, fileURL);
      return fileURL;
    } else {
      throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
  }

  toUrl(path) {
    var cached = this.memoizedURLs.get(path);
    if (cached) return cached;

    if (sep === "\\") {
      path = path.replace(/\\/g, "/");
    }

    var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    this.memoizedURLs.set(path, url);
    return url;
  }

};
var mapGenerator = MapGenerator$2;
var Node$2 = node;
var Comment$4 = class Comment2 extends Node$2 {
  constructor(defaults) {
    super(defaults);
    this.type = "comment";
  }

};
var comment = Comment$4;
Comment$4.default = Comment$4;
var {
  isClean: isClean$1,
  my: my$1
} = symbols;
var Declaration$3 = declaration;
var Comment$3 = comment;
var Node$1 = node;
var parse$4, Rule$4, AtRule$4, Root$6;

function cleanSource(nodes) {
  return nodes.map(i2 => {
    if (i2.nodes) i2.nodes = cleanSource(i2.nodes);
    delete i2.source;
    return i2;
  });
}

function markDirtyUp(node2) {
  node2[isClean$1] = false;

  if (node2.proxyOf.nodes) {
    for (var i2 of node2.proxyOf.nodes) {
      markDirtyUp(i2);
    }
  }
}

var Container$7 = class Container2 extends Node$1 {
  append() {
    for (var _len8 = arguments.length, children = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      children[_key8] = arguments[_key8];
    }

    for (var child of children) {
      var nodes = this.normalize(child, this.last);

      for (var node2 of nodes) {
        this.proxyOf.nodes.push(node2);
      }
    }

    this.markDirty();
    return this;
  }

  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);

    if (this.nodes) {
      for (var node2 of this.nodes) {
        node2.cleanRaws(keepBetween);
      }
    }
  }

  each(callback) {
    if (!this.proxyOf.nodes) return void 0;
    var iterator = this.getIterator();
    var index2, result2;

    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index2 = this.indexes[iterator];
      result2 = callback(this.proxyOf.nodes[index2], index2);
      if (result2 === false) break;
      this.indexes[iterator] += 1;
    }

    delete this.indexes[iterator];
    return result2;
  }

  every(condition) {
    return this.nodes.every(condition);
  }

  getIterator() {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};
    this.lastEach += 1;
    var iterator = this.lastEach;
    this.indexes[iterator] = 0;
    return iterator;
  }

  getProxyProcessor() {
    return {
      get(node2, prop) {
        if (prop === "proxyOf") {
          return node2;
        } else if (!node2[prop]) {
          return node2[prop];
        } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
          return function () {
            for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
              args[_key9] = arguments[_key9];
            }

            return node2[prop](...args.map(i2 => {
              if (typeof i2 === "function") {
                return (child, index2) => i2(child.toProxy(), index2);
              } else {
                return i2;
              }
            }));
          };
        } else if (prop === "every" || prop === "some") {
          return cb => {
            return node2[prop](function (child) {
              for (var _len10 = arguments.length, other = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
                other[_key10 - 1] = arguments[_key10];
              }

              return cb(child.toProxy(), ...other);
            });
          };
        } else if (prop === "root") {
          return () => node2.root().toProxy();
        } else if (prop === "nodes") {
          return node2.nodes.map(i2 => i2.toProxy());
        } else if (prop === "first" || prop === "last") {
          return node2[prop].toProxy();
        } else {
          return node2[prop];
        }
      },

      set(node2, prop, value) {
        if (node2[prop] === value) return true;
        node2[prop] = value;

        if (prop === "name" || prop === "params" || prop === "selector") {
          node2.markDirty();
        }

        return true;
      }

    };
  }

  index(child) {
    if (typeof child === "number") return child;
    if (child.proxyOf) child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child);
  }

  insertAfter(exist, add) {
    var existIndex = this.index(exist);
    var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
    existIndex = this.index(exist);

    for (var node2 of nodes) {
      this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
    }

    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (existIndex < index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  insertBefore(exist, add) {
    var existIndex = this.index(exist);
    var type = existIndex === 0 ? "prepend" : false;
    var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
    existIndex = this.index(exist);

    for (var node2 of nodes) {
      this.proxyOf.nodes.splice(existIndex, 0, node2);
    }

    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (existIndex <= index2) {
        this.indexes[id] = index2 + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  normalize(nodes, sample) {
    if (typeof nodes === "string") {
      nodes = cleanSource(parse$4(nodes).nodes);
    } else if (typeof nodes === "undefined") {
      nodes = [];
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);

      for (var i2 of nodes) {
        if (i2.parent) i2.parent.removeChild(i2, "ignore");
      }
    } else if (nodes.type === "root" && this.type !== "document") {
      nodes = nodes.nodes.slice(0);

      for (var _i2 of nodes) {
        if (_i2.parent) _i2.parent.removeChild(_i2, "ignore");
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === "undefined") {
        throw new Error("Value field is missed in node creation");
      } else if (typeof nodes.value !== "string") {
        nodes.value = String(nodes.value);
      }

      nodes = [new Declaration$3(nodes)];
    } else if (nodes.selector) {
      nodes = [new Rule$4(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule$4(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment$3(nodes)];
    } else {
      throw new Error("Unknown node type in node creation");
    }

    var processed = nodes.map(i2 => {
      if (!i2[my$1]) Container2.rebuild(i2);
      i2 = i2.proxyOf;
      if (i2.parent) i2.parent.removeChild(i2);
      if (i2[isClean$1]) markDirtyUp(i2);

      if (typeof i2.raws.before === "undefined") {
        if (sample && typeof sample.raws.before !== "undefined") {
          i2.raws.before = sample.raws.before.replace(/\S/g, "");
        }
      }

      i2.parent = this.proxyOf;
      return i2;
    });
    return processed;
  }

  prepend() {
    for (var _len11 = arguments.length, children = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      children[_key11] = arguments[_key11];
    }

    children = children.reverse();

    for (var child of children) {
      var nodes = this.normalize(child, this.first, "prepend").reverse();

      for (var node2 of nodes) {
        this.proxyOf.nodes.unshift(node2);
      }

      for (var id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }

    this.markDirty();
    return this;
  }

  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this;
  }

  removeAll() {
    for (var node2 of this.proxyOf.nodes) {
      node2.parent = void 0;
    }

    this.proxyOf.nodes = [];
    this.markDirty();
    return this;
  }

  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = void 0;
    this.proxyOf.nodes.splice(child, 1);
    var index2;

    for (var id in this.indexes) {
      index2 = this.indexes[id];

      if (index2 >= child) {
        this.indexes[id] = index2 - 1;
      }
    }

    this.markDirty();
    return this;
  }

  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }

    this.walkDecls(decl => {
      if (opts.props && !opts.props.includes(decl.prop)) return;
      if (opts.fast && !decl.value.includes(opts.fast)) return;
      decl.value = decl.value.replace(pattern, callback);
    });
    this.markDirty();
    return this;
  }

  some(condition) {
    return this.nodes.some(condition);
  }

  walk(callback) {
    return this.each((child, i2) => {
      var result2;

      try {
        result2 = callback(child, i2);
      } catch (e2) {
        throw child.addToError(e2);
      }

      if (result2 !== false && child.walk) {
        result2 = child.walk(callback);
      }

      return result2;
    });
  }

  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i2) => {
        if (child.type === "atrule") {
          return callback(child, i2);
        }
      });
    }

    if (name instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "atrule" && name.test(child.name)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "atrule" && child.name === name) {
        return callback(child, i2);
      }
    });
  }

  walkComments(callback) {
    return this.walk((child, i2) => {
      if (child.type === "comment") {
        return callback(child, i2);
      }
    });
  }

  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i2) => {
        if (child.type === "decl") {
          return callback(child, i2);
        }
      });
    }

    if (prop instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "decl" && prop.test(child.prop)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "decl" && child.prop === prop) {
        return callback(child, i2);
      }
    });
  }

  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;
      return this.walk((child, i2) => {
        if (child.type === "rule") {
          return callback(child, i2);
        }
      });
    }

    if (selector instanceof RegExp) {
      return this.walk((child, i2) => {
        if (child.type === "rule" && selector.test(child.selector)) {
          return callback(child, i2);
        }
      });
    }

    return this.walk((child, i2) => {
      if (child.type === "rule" && child.selector === selector) {
        return callback(child, i2);
      }
    });
  }

  get first() {
    if (!this.proxyOf.nodes) return void 0;
    return this.proxyOf.nodes[0];
  }

  get last() {
    if (!this.proxyOf.nodes) return void 0;
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }

};

Container$7.registerParse = dependant => {
  parse$4 = dependant;
};

Container$7.registerRule = dependant => {
  Rule$4 = dependant;
};

Container$7.registerAtRule = dependant => {
  AtRule$4 = dependant;
};

Container$7.registerRoot = dependant => {
  Root$6 = dependant;
};

var container = Container$7;
Container$7.default = Container$7;

Container$7.rebuild = node2 => {
  if (node2.type === "atrule") {
    Object.setPrototypeOf(node2, AtRule$4.prototype);
  } else if (node2.type === "rule") {
    Object.setPrototypeOf(node2, Rule$4.prototype);
  } else if (node2.type === "decl") {
    Object.setPrototypeOf(node2, Declaration$3.prototype);
  } else if (node2.type === "comment") {
    Object.setPrototypeOf(node2, Comment$3.prototype);
  } else if (node2.type === "root") {
    Object.setPrototypeOf(node2, Root$6.prototype);
  }

  node2[my$1] = true;

  if (node2.nodes) {
    node2.nodes.forEach(child => {
      Container$7.rebuild(child);
    });
  }
};

var Container$6 = container;
var LazyResult$4, Processor$3;
var Document$3 = class Document23 extends Container$6 {
  constructor(defaults) {
    super(_objectSpread({
      type: "document"
    }, defaults));

    if (!this.nodes) {
      this.nodes = [];
    }
  }

  toResult() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lazy = new LazyResult$4(new Processor$3(), this, opts);
    return lazy.stringify();
  }

};

Document$3.registerLazyResult = dependant => {
  LazyResult$4 = dependant;
};

Document$3.registerProcessor = dependant => {
  Processor$3 = dependant;
};

var document$1 = Document$3;
Document$3.default = Document$3;
var printed = {};

var warnOnce$2 = function warnOnce2(message) {
  if (printed[message]) return;
  printed[message] = true;

  if (typeof console !== "undefined" && console.warn) {
    console.warn(message);
  }
};

var Warning$2 = class Warning2 {
  constructor(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.type = "warning";
    this.text = text;

    if (opts.node && opts.node.source) {
      var range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }

    for (var opt in opts) {
      this[opt] = opts[opt];
    }
  }

  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message;
    }

    if (this.plugin) {
      return this.plugin + ": " + this.text;
    }

    return this.text;
  }

};
var warning = Warning$2;
Warning$2.default = Warning$2;
var Warning$1 = warning;
var Result$3 = class Result2 {
  constructor(processor2, root2, opts) {
    this.processor = processor2;
    this.messages = [];
    this.root = root2;
    this.opts = opts;
    this.css = void 0;
    this.map = void 0;
  }

  toString() {
    return this.css;
  }

  warn(text) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }

    var warning2 = new Warning$1(text, opts);
    this.messages.push(warning2);
    return warning2;
  }

  warnings() {
    return this.messages.filter(i2 => i2.type === "warning");
  }

  get content() {
    return this.css;
  }

};
var result = Result$3;
Result$3.default = Result$3;
var SINGLE_QUOTE = "'".charCodeAt(0);
var DOUBLE_QUOTE = '"'.charCodeAt(0);
var BACKSLASH = "\\".charCodeAt(0);
var SLASH = "/".charCodeAt(0);
var NEWLINE = "\n".charCodeAt(0);
var SPACE = " ".charCodeAt(0);
var FEED = "\f".charCodeAt(0);
var TAB = "	".charCodeAt(0);
var CR = "\r".charCodeAt(0);
var OPEN_SQUARE = "[".charCodeAt(0);
var CLOSE_SQUARE = "]".charCodeAt(0);
var OPEN_PARENTHESES = "(".charCodeAt(0);
var CLOSE_PARENTHESES = ")".charCodeAt(0);
var OPEN_CURLY = "{".charCodeAt(0);
var CLOSE_CURLY = "}".charCodeAt(0);
var SEMICOLON = ";".charCodeAt(0);
var ASTERISK = "*".charCodeAt(0);
var COLON = ":".charCodeAt(0);
var AT = "@".charCodeAt(0);
var RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var RE_HEX_ESCAPE = /[\da-f]/i;

var tokenize = function tokenizer2(input2) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var css = input2.css.valueOf();
  var ignore = options.ignoreErrors;
  var code, next, quote, content, escape;
  var escaped, escapePos, prev, n2, currentToken;
  var length = css.length;
  var pos = 0;
  var buffer = [];
  var returned = [];

  function position() {
    return pos;
  }

  function unclosed(what) {
    throw input2.error("Unclosed " + what, pos);
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length;
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop();
    if (pos >= length) return;
    var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
    code = css.charCodeAt(pos);

    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED:
        {
          next = pos;

          do {
            next += 1;
            code = css.charCodeAt(next);
          } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);

          currentToken = ["space", css.slice(pos, next)];
          pos = next - 1;
          break;
        }

      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES:
        {
          var controlChar = String.fromCharCode(code);
          currentToken = [controlChar, controlChar, pos];
          break;
        }

      case OPEN_PARENTHESES:
        {
          prev = buffer.length ? buffer.pop()[1] : "";
          n2 = css.charCodeAt(pos + 1);

          if (prev === "url" && n2 !== SINGLE_QUOTE && n2 !== DOUBLE_QUOTE && n2 !== SPACE && n2 !== NEWLINE && n2 !== TAB && n2 !== FEED && n2 !== CR) {
            next = pos;

            do {
              escaped = false;
              next = css.indexOf(")", next + 1);

              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos;
                  break;
                } else {
                  unclosed("bracket");
                }
              }

              escapePos = next;

              while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);

            currentToken = ["brackets", css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            next = css.indexOf(")", pos + 1);
            content = css.slice(pos, next + 1);

            if (next === -1 || RE_BAD_BRACKET.test(content)) {
              currentToken = ["(", "(", pos];
            } else {
              currentToken = ["brackets", content, pos, next];
              pos = next;
            }
          }

          break;
        }

      case SINGLE_QUOTE:
      case DOUBLE_QUOTE:
        {
          quote = code === SINGLE_QUOTE ? "'" : '"';
          next = pos;

          do {
            escaped = false;
            next = css.indexOf(quote, next + 1);

            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos + 1;
                break;
              } else {
                unclosed("string");
              }
            }

            escapePos = next;

            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);

          currentToken = ["string", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case AT:
        {
          RE_AT_END.lastIndex = pos + 1;
          RE_AT_END.test(css);

          if (RE_AT_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_AT_END.lastIndex - 2;
          }

          currentToken = ["at-word", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      case BACKSLASH:
        {
          next = pos;
          escape = true;

          while (css.charCodeAt(next + 1) === BACKSLASH) {
            next += 1;
            escape = !escape;
          }

          code = css.charCodeAt(next + 1);

          if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
            next += 1;

            if (RE_HEX_ESCAPE.test(css.charAt(next))) {
              while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
                next += 1;
              }

              if (css.charCodeAt(next + 1) === SPACE) {
                next += 1;
              }
            }
          }

          currentToken = ["word", css.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }

      default:
        {
          if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
            next = css.indexOf("*/", pos + 2) + 1;

            if (next === 0) {
              if (ignore || ignoreUnclosed) {
                next = css.length;
              } else {
                unclosed("comment");
              }
            }

            currentToken = ["comment", css.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            RE_WORD_END.lastIndex = pos + 1;
            RE_WORD_END.test(css);

            if (RE_WORD_END.lastIndex === 0) {
              next = css.length - 1;
            } else {
              next = RE_WORD_END.lastIndex - 2;
            }

            currentToken = ["word", css.slice(pos, next + 1), pos, next];
            buffer.push(currentToken);
            pos = next;
          }

          break;
        }
    }

    pos++;
    return currentToken;
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back,
    endOfFile,
    nextToken,
    position
  };
};

var Container$5 = container;
var AtRule$3 = class AtRule2 extends Container$5 {
  constructor(defaults) {
    super(defaults);
    this.type = "atrule";
  }

  append() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...arguments);
  }

  prepend() {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...arguments);
  }

};
var atRule = AtRule$3;
AtRule$3.default = AtRule$3;
Container$5.registerAtRule(AtRule$3);
var Container$4 = container;
var LazyResult$3, Processor$2;
var Root$5 = class Root2 extends Container$4 {
  constructor(defaults) {
    super(defaults);
    this.type = "root";
    if (!this.nodes) this.nodes = [];
  }

  normalize(child, sample, type) {
    var nodes = super.normalize(child);

    if (sample) {
      if (type === "prepend") {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (var node2 of nodes) {
          node2.raws.before = sample.raws.before;
        }
      }
    }

    return nodes;
  }

  removeChild(child, ignore) {
    var index2 = this.index(child);

    if (!ignore && index2 === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index2].raws.before;
    }

    return super.removeChild(child);
  }

  toResult() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lazy = new LazyResult$3(new Processor$2(), this, opts);
    return lazy.stringify();
  }

};

Root$5.registerLazyResult = dependant => {
  LazyResult$3 = dependant;
};

Root$5.registerProcessor = dependant => {
  Processor$2 = dependant;
};

var root = Root$5;
Root$5.default = Root$5;
Container$4.registerRoot(Root$5);
var list$2 = {
  comma(string) {
    return list$2.split(string, [","], true);
  },

  space(string) {
    var spaces = [" ", "\n", "	"];
    return list$2.split(string, spaces);
  },

  split(string, separators, last) {
    var array = [];
    var current = "";
    var split = false;
    var func = 0;
    var inQuote = false;
    var prevQuote = "";
    var escape = false;

    for (var letter of string) {
      if (escape) {
        escape = false;
      } else if (letter === "\\") {
        escape = true;
      } else if (inQuote) {
        if (letter === prevQuote) {
          inQuote = false;
        }
      } else if (letter === '"' || letter === "'") {
        inQuote = true;
        prevQuote = letter;
      } else if (letter === "(") {
        func += 1;
      } else if (letter === ")") {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter)) split = true;
      }

      if (split) {
        if (current !== "") array.push(current.trim());
        current = "";
        split = false;
      } else {
        current += letter;
      }
    }

    if (last || current !== "") array.push(current.trim());
    return array;
  }

};
var list_1 = list$2;
list$2.default = list$2;
var Container$3 = container;
var list$1 = list_1;
var Rule$3 = class Rule2 extends Container$3 {
  constructor(defaults) {
    super(defaults);
    this.type = "rule";
    if (!this.nodes) this.nodes = [];
  }

  get selectors() {
    return list$1.comma(this.selector);
  }

  set selectors(values) {
    var match = this.selector ? this.selector.match(/,\s*/) : null;
    var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
    this.selector = values.join(sep2);
  }

};
var rule = Rule$3;
Rule$3.default = Rule$3;
Container$3.registerRule(Rule$3);
var Declaration$2 = declaration;
var tokenizer22 = tokenize;
var Comment$2 = comment;
var AtRule$2 = atRule;
var Root$4 = root;
var Rule$2 = rule;
var SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};

function findLastWithPosition(tokens) {
  for (var i2 = tokens.length - 1; i2 >= 0; i2--) {
    var token = tokens[i2];
    var pos = token[3] || token[2];
    if (pos) return pos;
  }
}

var Parser$1 = class Parser2 {
  constructor(input2) {
    this.input = input2;
    this.root = new Root$4();
    this.current = this.root;
    this.spaces = "";
    this.semicolon = false;
    this.createTokenizer();
    this.root.source = {
      input: input2,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }

  atrule(token) {
    var node2 = new AtRule$2();
    node2.name = token[1].slice(1);

    if (node2.name === "") {
      this.unnamedAtrule(node2, token);
    }

    this.init(node2, token[2]);
    var type;
    var prev;
    var shift;
    var last = false;
    var open = false;
    var params = [];
    var brackets = [];

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];

      if (type === "(" || type === "[") {
        brackets.push(type === "(" ? ")" : "]");
      } else if (type === "{" && brackets.length > 0) {
        brackets.push("}");
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }

      if (brackets.length === 0) {
        if (type === ";") {
          node2.source.end = this.getPosition(token[2]);
          node2.source.end.offset++;
          this.semicolon = true;
          break;
        } else if (type === "{") {
          open = true;
          break;
        } else if (type === "}") {
          if (params.length > 0) {
            shift = params.length - 1;
            prev = params[shift];

            while (prev && prev[0] === "space") {
              prev = params[--shift];
            }

            if (prev) {
              node2.source.end = this.getPosition(prev[3] || prev[2]);
              node2.source.end.offset++;
            }
          }

          this.end(token);
          break;
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }

      if (this.tokenizer.endOfFile()) {
        last = true;
        break;
      }
    }

    node2.raws.between = this.spacesAndCommentsFromEnd(params);

    if (params.length) {
      node2.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node2, "params", params);

      if (last) {
        token = params[params.length - 1];
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        this.spaces = node2.raws.between;
        node2.raws.between = "";
      }
    } else {
      node2.raws.afterName = "";
      node2.params = "";
    }

    if (open) {
      node2.nodes = [];
      this.current = node2;
    }
  }

  checkMissedSemicolon(tokens) {
    var colon = this.colon(tokens);
    if (colon === false) return;
    var founded = 0;
    var token;

    for (var j = colon - 1; j >= 0; j--) {
      token = tokens[j];

      if (token[0] !== "space") {
        founded += 1;
        if (founded === 2) break;
      }
    }

    throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
  }

  colon(tokens) {
    var brackets = 0;
    var token, type, prev;

    for (var [i2, element] of tokens.entries()) {
      token = element;
      type = token[0];

      if (type === "(") {
        brackets += 1;
      }

      if (type === ")") {
        brackets -= 1;
      }

      if (brackets === 0 && type === ":") {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === "word" && prev[1] === "progid") {
          continue;
        } else {
          return i2;
        }
      }

      prev = token;
    }

    return false;
  }

  comment(token) {
    var node2 = new Comment$2();
    this.init(node2, token[2]);
    node2.source.end = this.getPosition(token[3] || token[2]);
    node2.source.end.offset++;
    var text = token[1].slice(2, -2);

    if (/^\s*$/.test(text)) {
      node2.text = "";
      node2.raws.left = text;
      node2.raws.right = "";
    } else {
      var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
      node2.text = match[2];
      node2.raws.left = match[1];
      node2.raws.right = match[3];
    }
  }

  createTokenizer() {
    this.tokenizer = tokenizer22(this.input);
  }

  decl(tokens, customProperty) {
    var node2 = new Declaration$2();
    this.init(node2, tokens[0][2]);
    var last = tokens[tokens.length - 1];

    if (last[0] === ";") {
      this.semicolon = true;
      tokens.pop();
    }

    node2.source.end = this.getPosition(last[3] || last[2] || findLastWithPosition(tokens));
    node2.source.end.offset++;

    while (tokens[0][0] !== "word") {
      if (tokens.length === 1) this.unknownWord(tokens);
      node2.raws.before += tokens.shift()[1];
    }

    node2.source.start = this.getPosition(tokens[0][2]);
    node2.prop = "";

    while (tokens.length) {
      var type = tokens[0][0];

      if (type === ":" || type === "space" || type === "comment") {
        break;
      }

      node2.prop += tokens.shift()[1];
    }

    node2.raws.between = "";
    var token;

    while (tokens.length) {
      token = tokens.shift();

      if (token[0] === ":") {
        node2.raws.between += token[1];
        break;
      } else {
        if (token[0] === "word" && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }

        node2.raws.between += token[1];
      }
    }

    if (node2.prop[0] === "_" || node2.prop[0] === "*") {
      node2.raws.before += node2.prop[0];
      node2.prop = node2.prop.slice(1);
    }

    var firstSpaces = [];
    var next;

    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment") break;
      firstSpaces.push(tokens.shift());
    }

    this.precheckMissedSemicolon(tokens);

    for (var i2 = tokens.length - 1; i2 >= 0; i2--) {
      token = tokens[i2];

      if (token[1].toLowerCase() === "!important") {
        node2.important = true;
        var string = this.stringFrom(tokens, i2);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== " !important") node2.raws.important = string;
        break;
      } else if (token[1].toLowerCase() === "important") {
        var cache = tokens.slice(0);
        var str = "";

        for (var j = i2; j > 0; j--) {
          var _type2 = cache[j][0];

          if (str.trim().indexOf("!") === 0 && _type2 !== "space") {
            break;
          }

          str = cache.pop()[1] + str;
        }

        if (str.trim().indexOf("!") === 0) {
          node2.important = true;
          node2.raws.important = str;
          tokens = cache;
        }
      }

      if (token[0] !== "space" && token[0] !== "comment") {
        break;
      }
    }

    var hasWord = tokens.some(i2 => i2[0] !== "space" && i2[0] !== "comment");

    if (hasWord) {
      node2.raws.between += firstSpaces.map(i2 => i2[1]).join("");
      firstSpaces = [];
    }

    this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);

    if (node2.value.includes(":") && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }

  doubleColon(token) {
    throw this.input.error("Double colon", {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }

  emptyRule(token) {
    var node2 = new Rule$2();
    this.init(node2, token[2]);
    node2.selector = "";
    node2.raws.between = "";
    this.current = node2;
  }

  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.semicolon = false;
    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.spaces = "";

    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current.source.end.offset++;
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }

  endFile() {
    if (this.current.parent) this.unclosedBlock();

    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }

    this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    this.root.source.end = this.getPosition(this.tokenizer.position());
  }

  freeSemicolon(token) {
    this.spaces += token[1];

    if (this.current.nodes) {
      var prev = this.current.nodes[this.current.nodes.length - 1];

      if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = "";
      }
    }
  } // Helpers


  getPosition(offset) {
    var pos = this.input.fromOffset(offset);
    return {
      column: pos.col,
      line: pos.line,
      offset
    };
  }

  init(node2, offset) {
    this.current.push(node2);
    node2.source = {
      input: this.input,
      start: this.getPosition(offset)
    };
    node2.raws.before = this.spaces;
    this.spaces = "";
    if (node2.type !== "comment") this.semicolon = false;
  }

  other(start) {
    var end = false;
    var type = null;
    var colon = false;
    var bracket = null;
    var brackets = [];
    var customProperty = start[1].startsWith("--");
    var tokens = [];
    var token = start;

    while (token) {
      type = token[0];
      tokens.push(token);

      if (type === "(" || type === "[") {
        if (!bracket) bracket = token;
        brackets.push(type === "(" ? ")" : "]");
      } else if (customProperty && colon && type === "{") {
        if (!bracket) bracket = token;
        brackets.push("}");
      } else if (brackets.length === 0) {
        if (type === ";") {
          if (colon) {
            this.decl(tokens, customProperty);
            return;
          } else {
            break;
          }
        } else if (type === "{") {
          this.rule(tokens);
          return;
        } else if (type === "}") {
          this.tokenizer.back(tokens.pop());
          end = true;
          break;
        } else if (type === ":") {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }

      token = this.tokenizer.nextToken();
    }

    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);

    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== "space" && token !== "comment") break;
          this.tokenizer.back(tokens.pop());
        }
      }

      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }

  parse() {
    var token;

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      switch (token[0]) {
        case "space":
          this.spaces += token[1];
          break;

        case ";":
          this.freeSemicolon(token);
          break;

        case "}":
          this.end(token);
          break;

        case "comment":
          this.comment(token);
          break;

        case "at-word":
          this.atrule(token);
          break;

        case "{":
          this.emptyRule(token);
          break;

        default:
          this.other(token);
          break;
      }
    }

    this.endFile();
  }

  precheckMissedSemicolon() {}

  raw(node2, prop, tokens, customProperty) {
    var token, type;
    var length = tokens.length;
    var value = "";
    var clean = true;
    var next, prev;

    for (var i2 = 0; i2 < length; i2 += 1) {
      token = tokens[i2];
      type = token[0];

      if (type === "space" && i2 === length - 1 && !customProperty) {
        clean = false;
      } else if (type === "comment") {
        prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
        next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";

        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
          if (value.slice(-1) === ",") {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }

    if (!clean) {
      var raw = tokens.reduce((all, i2) => all + i2[1], "");
      node2.raws[prop] = {
        raw,
        value
      };
    }

    node2[prop] = value;
  }

  rule(tokens) {
    tokens.pop();
    var node2 = new Rule$2();
    this.init(node2, tokens[0][2]);
    node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node2, "selector", tokens);
    this.current = node2;
  }

  spacesAndCommentsFromEnd(tokens) {
    var lastTokenType;
    var spaces = "";

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space" && lastTokenType !== "comment") break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  } // Errors


  spacesAndCommentsFromStart(tokens) {
    var next;
    var spaces = "";

    while (tokens.length) {
      next = tokens[0][0];
      if (next !== "space" && next !== "comment") break;
      spaces += tokens.shift()[1];
    }

    return spaces;
  }

  spacesFromEnd(tokens) {
    var lastTokenType;
    var spaces = "";

    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== "space") break;
      spaces = tokens.pop()[1] + spaces;
    }

    return spaces;
  }

  stringFrom(tokens, from) {
    var result2 = "";

    for (var i2 = from; i2 < tokens.length; i2++) {
      result2 += tokens[i2][1];
    }

    tokens.splice(from, tokens.length - from);
    return result2;
  }

  unclosedBlock() {
    var pos = this.current.source.start;
    throw this.input.error("Unclosed block", pos.line, pos.column);
  }

  unclosedBracket(bracket) {
    throw this.input.error("Unclosed bracket", {
      offset: bracket[2]
    }, {
      offset: bracket[2] + 1
    });
  }

  unexpectedClose(token) {
    throw this.input.error("Unexpected }", {
      offset: token[2]
    }, {
      offset: token[2] + 1
    });
  }

  unknownWord(tokens) {
    throw this.input.error("Unknown word", {
      offset: tokens[0][2]
    }, {
      offset: tokens[0][2] + tokens[0][1].length
    });
  }

  unnamedAtrule(node2, token) {
    throw this.input.error("At-rule without name", {
      offset: token[2]
    }, {
      offset: token[2] + token[1].length
    });
  }

};
var parser = Parser$1;
var Container$2 = container;
var Parser22 = parser;
var Input$2 = input;

function parse$3(css, opts) {
  var input2 = new Input$2(css, opts);
  var parser2 = new Parser22(input2);

  try {
    parser2.parse();
  } catch (e2) {
    if (process.env.NODE_ENV !== "production") {
      if (e2.name === "CssSyntaxError" && opts && opts.from) {
        if (/\.scss$/i.test(opts.from)) {
          e2.message += "\nYou tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser";
        } else if (/\.sass/i.test(opts.from)) {
          e2.message += "\nYou tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser";
        } else if (/\.less$/i.test(opts.from)) {
          e2.message += "\nYou tried to parse Less with the standard CSS parser; try again with the postcss-less parser";
        }
      }
    }

    throw e2;
  }

  return parser2.root;
}

var parse_1 = parse$3;
parse$3.default = parse$3;
Container$2.registerParse(parse$3);
var {
  isClean,
  my
} = symbols;
var MapGenerator$1 = mapGenerator;
var stringify$2 = stringify_1;
var Container$1 = container;
var Document$2 = document$1;
var warnOnce$1 = warnOnce$2;
var Result$2 = result;
var parse$2 = parse_1;
var Root$3 = root;
var TYPE_TO_CLASS_NAME = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
};
var PLUGIN_PROPS = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};
var NOT_VISITORS = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};
var CHILDREN = 0;

function isPromise(obj) {
  return typeof obj === "object" && typeof obj.then === "function";
}

function getEvents(node2) {
  var key = false;
  var type = TYPE_TO_CLASS_NAME[node2.type];

  if (node2.type === "decl") {
    key = node2.prop.toLowerCase();
  } else if (node2.type === "atrule") {
    key = node2.name.toLowerCase();
  }

  if (key && node2.append) {
    return [type, type + "-" + key, CHILDREN, type + "Exit", type + "Exit-" + key];
  } else if (key) {
    return [type, type + "-" + key, type + "Exit", type + "Exit-" + key];
  } else if (node2.append) {
    return [type, CHILDREN, type + "Exit"];
  } else {
    return [type, type + "Exit"];
  }
}

function toStack(node2) {
  var events;

  if (node2.type === "document") {
    events = ["Document", CHILDREN, "DocumentExit"];
  } else if (node2.type === "root") {
    events = ["Root", CHILDREN, "RootExit"];
  } else {
    events = getEvents(node2);
  }

  return {
    eventIndex: 0,
    events,
    iterator: 0,
    node: node2,
    visitorIndex: 0,
    visitors: []
  };
}

function cleanMarks(node2) {
  node2[isClean] = false;
  if (node2.nodes) node2.nodes.forEach(i2 => cleanMarks(i2));
  return node2;
}

var postcss$2 = {};
var LazyResult$2 = class LazyResult2 {
  constructor(processor2, css, opts) {
    this.stringified = false;
    this.processed = false;
    var root2;

    if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) {
      root2 = cleanMarks(css);
    } else if (css instanceof LazyResult2 || css instanceof Result$2) {
      root2 = cleanMarks(css.root);

      if (css.map) {
        if (typeof opts.map === "undefined") opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      var parser2 = parse$2;
      if (opts.syntax) parser2 = opts.syntax.parse;
      if (opts.parser) parser2 = opts.parser;
      if (parser2.parse) parser2 = parser2.parse;

      try {
        root2 = parser2(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root2 && !root2[my]) {
        Container$1.rebuild(root2);
      }
    }

    this.result = new Result$2(processor2, root2, opts);
    this.helpers = _objectSpread(_objectSpread({}, postcss$2), {}, {
      postcss: postcss$2,
      result: this.result
    });
    this.plugins = this.processor.plugins.map(plugin22 => {
      if (typeof plugin22 === "object" && plugin22.prepare) {
        return _objectSpread(_objectSpread({}, plugin22), plugin22.prepare(this.result));
      } else {
        return plugin22;
      }
    });
  }

  async() {
    if (this.error) return Promise.reject(this.error);
    if (this.processed) return Promise.resolve(this.result);

    if (!this.processing) {
      this.processing = this.runAsync();
    }

    return this.processing;
  }

  catch(onRejected) {
    return this.async().catch(onRejected);
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }

  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }

  handleError(error, node2) {
    var plugin22 = this.result.lastPlugin;

    try {
      if (node2) node2.addToError(error);
      this.error = error;

      if (error.name === "CssSyntaxError" && !error.plugin) {
        error.plugin = plugin22.postcssPlugin;
        error.setMessage();
      } else if (plugin22.postcssVersion) {
        if (process.env.NODE_ENV !== "production") {
          var pluginName = plugin22.postcssPlugin;
          var pluginVer = plugin22.postcssVersion;
          var runtimeVer = this.result.processor.version;
          var a2 = pluginVer.split(".");
          var b = runtimeVer.split(".");

          if (a2[0] !== b[0] || parseInt(a2[1]) > parseInt(b[1])) {
            console.error("Unknown error from PostCSS plugin. Your current PostCSS version is " + runtimeVer + ", but " + pluginName + " uses " + pluginVer + ". Perhaps this is the source of the error below.");
          }
        }
      }
    } catch (err) {
      if (console && console.error) console.error(err);
    }

    return error;
  }

  prepareVisitors() {
    this.listeners = {};

    var add = (plugin22, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin22, cb]);
    };

    for (var plugin22 of this.plugins) {
      if (typeof plugin22 === "object") {
        for (var event in plugin22) {
          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
            throw new Error("Unknown event ".concat(event, " in ").concat(plugin22.postcssPlugin, ". Try to update PostCSS (").concat(this.processor.version, " now)."));
          }

          if (!NOT_VISITORS[event]) {
            if (typeof plugin22[event] === "object") {
              for (var filter in plugin22[event]) {
                if (filter === "*") {
                  add(plugin22, event, plugin22[event][filter]);
                } else {
                  add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                }
              }
            } else if (typeof plugin22[event] === "function") {
              add(plugin22, event, plugin22[event]);
            }
          }
        }
      }
    }

    this.hasListener = Object.keys(this.listeners).length > 0;
  }

  runAsync() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      _this2.plugin = 0;

      for (var i2 = 0; i2 < _this2.plugins.length; i2++) {
        var plugin22 = _this2.plugins[i2];

        var promise = _this2.runOnRoot(plugin22);

        if (isPromise(promise)) {
          try {
            yield promise;
          } catch (error) {
            throw _this2.handleError(error);
          }
        }
      }

      _this2.prepareVisitors();

      if (_this2.hasListener) {
        var root2 = _this2.result.root;

        while (!root2[isClean]) {
          root2[isClean] = true;
          var stack = [toStack(root2)];

          while (stack.length > 0) {
            var _promise2 = _this2.visitTick(stack);

            if (isPromise(_promise2)) {
              try {
                yield _promise2;
              } catch (e2) {
                var node2 = stack[stack.length - 1].node;
                throw _this2.handleError(e2, node2);
              }
            }
          }
        }

        if (_this2.listeners.OnceExit) {
          var _loop2 = function* _loop2(visitor, _plugin2) {
            _this2.result.lastPlugin = _plugin2;

            try {
              if (root2.type === "document") {
                var roots = root2.nodes.map(subRoot => visitor(subRoot, _this2.helpers));
                yield Promise.all(roots);
              } else {
                yield visitor(root2, _this2.helpers);
              }
            } catch (e2) {
              throw _this2.handleError(e2);
            }
          };

          for (var [_plugin2, visitor] of _this2.listeners.OnceExit) {
            yield* _loop2(visitor, _plugin2);
          }
        }
      }

      _this2.processed = true;
      return _this2.stringify();
    })();
  }

  runOnRoot(plugin22) {
    this.result.lastPlugin = plugin22;

    try {
      if (typeof plugin22 === "object" && plugin22.Once) {
        if (this.result.root.type === "document") {
          var roots = this.result.root.nodes.map(root2 => plugin22.Once(root2, this.helpers));

          if (isPromise(roots[0])) {
            return Promise.all(roots);
          }

          return roots;
        }

        return plugin22.Once(this.result.root, this.helpers);
      } else if (typeof plugin22 === "function") {
        return plugin22(this.result.root, this.result);
      }
    } catch (error) {
      throw this.handleError(error);
    }
  }

  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = true;
    this.sync();
    var opts = this.result.opts;
    var str = stringify$2;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;
    var map = new MapGenerator$1(str, this.result.root, this.result.opts);
    var data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  }

  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    this.processed = true;

    if (this.processing) {
      throw this.getAsyncError();
    }

    for (var plugin22 of this.plugins) {
      var promise = this.runOnRoot(plugin22);

      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }

    this.prepareVisitors();

    if (this.hasListener) {
      var root2 = this.result.root;

      while (!root2[isClean]) {
        root2[isClean] = true;
        this.walkSync(root2);
      }

      if (this.listeners.OnceExit) {
        if (root2.type === "document") {
          for (var subRoot of root2.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root2);
        }
      }
    }

    return this.result;
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== "production") {
      if (!("from" in this.opts)) {
        warnOnce$1("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.");
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }

  toString() {
    return this.css;
  }

  visitSync(visitors, node2) {
    for (var [plugin22, visitor] of visitors) {
      this.result.lastPlugin = plugin22;
      var promise = void 0;

      try {
        promise = visitor(node2, this.helpers);
      } catch (e2) {
        throw this.handleError(e2, node2.proxyOf);
      }

      if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
        return true;
      }

      if (isPromise(promise)) {
        throw this.getAsyncError();
      }
    }
  }

  visitTick(stack) {
    var visit2 = stack[stack.length - 1];
    var {
      node: node2,
      visitors
    } = visit2;

    if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
      stack.pop();
      return;
    }

    if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
      var [plugin22, visitor] = visitors[visit2.visitorIndex];
      visit2.visitorIndex += 1;

      if (visit2.visitorIndex === visitors.length) {
        visit2.visitors = [];
        visit2.visitorIndex = 0;
      }

      this.result.lastPlugin = plugin22;

      try {
        return visitor(node2.toProxy(), this.helpers);
      } catch (e2) {
        throw this.handleError(e2, node2);
      }
    }

    if (visit2.iterator !== 0) {
      var iterator = visit2.iterator;
      var child;

      while (child = node2.nodes[node2.indexes[iterator]]) {
        node2.indexes[iterator] += 1;

        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return;
        }
      }

      visit2.iterator = 0;
      delete node2.indexes[iterator];
    }

    var events = visit2.events;

    while (visit2.eventIndex < events.length) {
      var event = events[visit2.eventIndex];
      visit2.eventIndex += 1;

      if (event === CHILDREN) {
        if (node2.nodes && node2.nodes.length) {
          node2[isClean] = true;
          visit2.iterator = node2.getIterator();
        }

        return;
      } else if (this.listeners[event]) {
        visit2.visitors = this.listeners[event];
        return;
      }
    }

    stack.pop();
  }

  walkSync(node2) {
    node2[isClean] = true;
    var events = getEvents(node2);

    for (var event of events) {
      if (event === CHILDREN) {
        if (node2.nodes) {
          node2.each(child => {
            if (!child[isClean]) this.walkSync(child);
          });
        }
      } else {
        var visitors = this.listeners[event];

        if (visitors) {
          if (this.visitSync(visitors, node2.toProxy())) return;
        }
      }
    }
  }

  warnings() {
    return this.sync().warnings();
  }

  get content() {
    return this.stringify().content;
  }

  get css() {
    return this.stringify().css;
  }

  get map() {
    return this.stringify().map;
  }

  get messages() {
    return this.sync().messages;
  }

  get opts() {
    return this.result.opts;
  }

  get processor() {
    return this.result.processor;
  }

  get root() {
    return this.sync().root;
  }

  get [Symbol.toStringTag]() {
    return "LazyResult";
  }

};

LazyResult$2.registerPostcss = dependant => {
  postcss$2 = dependant;
};

var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;
Root$3.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);
var MapGenerator22 = mapGenerator;
var stringify$1 = stringify_1;
var warnOnce22 = warnOnce$2;
var parse$1 = parse_1;
var Result$1 = result;
var NoWorkResult$1 = class NoWorkResult2 {
  constructor(processor2, css, opts) {
    css = css.toString();
    this.stringified = false;
    this._processor = processor2;
    this._css = css;
    this._opts = opts;
    this._map = void 0;
    var root2;
    var str = stringify$1;
    this.result = new Result$1(this._processor, root2, this._opts);
    this.result.css = css;
    var self = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return self.root;
      }

    });
    var map = new MapGenerator22(str, root2, this._opts, css);

    if (map.isMap()) {
      var [generatedCSS, generatedMap] = map.generate();

      if (generatedCSS) {
        this.result.css = generatedCSS;
      }

      if (generatedMap) {
        this.result.map = generatedMap;
      }
    } else {
      map.clearAnnotation();
      this.result.css = map.css;
    }
  }

  async() {
    if (this.error) return Promise.reject(this.error);
    return Promise.resolve(this.result);
  }

  catch(onRejected) {
    return this.async().catch(onRejected);
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }

  sync() {
    if (this.error) throw this.error;
    return this.result;
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== "production") {
      if (!("from" in this._opts)) {
        warnOnce22("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.");
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }

  toString() {
    return this._css;
  }

  warnings() {
    return [];
  }

  get content() {
    return this.result.css;
  }

  get css() {
    return this.result.css;
  }

  get map() {
    return this.result.map;
  }

  get messages() {
    return [];
  }

  get opts() {
    return this.result.opts;
  }

  get processor() {
    return this.result.processor;
  }

  get root() {
    if (this._root) {
      return this._root;
    }

    var root2;
    var parser2 = parse$1;

    try {
      root2 = parser2(this._css, this._opts);
    } catch (error) {
      this.error = error;
    }

    if (this.error) {
      throw this.error;
    } else {
      this._root = root2;
      return root2;
    }
  }

  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }

};
var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;
var NoWorkResult22 = noWorkResult;
var LazyResult$1 = lazyResult;
var Document$1 = document$1;
var Root$2 = root;
var Processor$1 = class Processor2 {
  constructor() {
    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.version = "8.4.38";
    this.plugins = this.normalize(plugins);
  }

  normalize(plugins) {
    var normalized = [];

    for (var i2 of plugins) {
      if (i2.postcss === true) {
        i2 = i2();
      } else if (i2.postcss) {
        i2 = i2.postcss;
      }

      if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
        normalized = normalized.concat(i2.plugins);
      } else if (typeof i2 === "object" && i2.postcssPlugin) {
        normalized.push(i2);
      } else if (typeof i2 === "function") {
        normalized.push(i2);
      } else if (typeof i2 === "object" && (i2.parse || i2.stringify)) {
        if (process.env.NODE_ENV !== "production") {
          throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.");
        }
      } else {
        throw new Error(i2 + " is not a PostCSS plugin");
      }
    }

    return normalized;
  }

  process(css) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
      return new NoWorkResult22(this, css, opts);
    } else {
      return new LazyResult$1(this, css, opts);
    }
  }

  use(plugin22) {
    this.plugins = this.plugins.concat(this.normalize([plugin22]));
    return this;
  }

};
var processor = Processor$1;
Processor$1.default = Processor$1;
Root$2.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);
var Declaration$1 = declaration;
var PreviousMap22 = previousMap;
var Comment$1 = comment;
var AtRule$1 = atRule;
var Input$1 = input;
var Root$1 = root;
var Rule$1 = rule;

function fromJSON$1(json, inputs) {
  if (Array.isArray(json)) return json.map(n2 => fromJSON$1(n2));

  var {
    inputs: ownInputs
  } = json,
      defaults = _objectWithoutProperties(json, _excluded3);

  if (ownInputs) {
    inputs = [];

    for (var input2 of ownInputs) {
      var inputHydrated = _objectSpread(_objectSpread({}, input2), {}, {
        __proto__: Input$1.prototype
      });

      if (inputHydrated.map) {
        inputHydrated.map = _objectSpread(_objectSpread({}, inputHydrated.map), {}, {
          __proto__: PreviousMap22.prototype
        });
      }

      inputs.push(inputHydrated);
    }
  }

  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n2 => fromJSON$1(n2, inputs));
  }

  if (defaults.source) {
    var _defaults$source2 = defaults.source,
        {
      inputId
    } = _defaults$source2,
        source = _objectWithoutProperties(_defaults$source2, _excluded4);

    defaults.source = source;

    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }

  if (defaults.type === "root") {
    return new Root$1(defaults);
  } else if (defaults.type === "decl") {
    return new Declaration$1(defaults);
  } else if (defaults.type === "rule") {
    return new Rule$1(defaults);
  } else if (defaults.type === "comment") {
    return new Comment$1(defaults);
  } else if (defaults.type === "atrule") {
    return new AtRule$1(defaults);
  } else {
    throw new Error("Unknown node type: " + json.type);
  }
}

var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;
var CssSyntaxError22 = cssSyntaxError;
var Declaration22 = declaration;
var LazyResult22 = lazyResult;
var Container22 = container;
var Processor22 = processor;
var stringify = stringify_1;
var fromJSON = fromJSON_1;
var Document222 = document$1;
var Warning22 = warning;
var Comment22 = comment;
var AtRule22 = atRule;
var Result22 = result;
var Input22 = input;
var parse = parse_1;
var list = list_1;
var Rule22 = rule;
var Root22 = root;
var Node22 = node;

function postcss() {
  for (var _len12 = arguments.length, plugins = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    plugins[_key12] = arguments[_key12];
  }

  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }

  return new Processor22(plugins);
}

postcss.plugin = function plugin2(name, initializer) {
  var warningPrinted = false;

  function creator() {
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");

      if (process.env.LANG && process.env.LANG.startsWith("cn")) {
        console.warn(name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226");
      }
    }

    var transformer = initializer(...arguments);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor22().version;
    return transformer;
  }

  var cache;
  Object.defineProperty(creator, "postcss", {
    get() {
      if (!cache) cache = creator();
      return cache;
    }

  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts);
  };

  return creator;
};

postcss.stringify = stringify;
postcss.parse = parse;
postcss.fromJSON = fromJSON;
postcss.list = list;

postcss.comment = defaults => new Comment22(defaults);

postcss.atRule = defaults => new AtRule22(defaults);

postcss.decl = defaults => new Declaration22(defaults);

postcss.rule = defaults => new Rule22(defaults);

postcss.root = defaults => new Root22(defaults);

postcss.document = defaults => new Document222(defaults);

postcss.CssSyntaxError = CssSyntaxError22;
postcss.Declaration = Declaration22;
postcss.Container = Container22;
postcss.Processor = Processor22;
postcss.Document = Document222;
postcss.Comment = Comment22;
postcss.Warning = Warning22;
postcss.AtRule = AtRule22;
postcss.Result = Result22;
postcss.Input = Input22;
postcss.Rule = Rule22;
postcss.Root = Root22;
postcss.Node = Node22;
LazyResult22.registerPostcss(postcss);
var postcss_1 = postcss;
postcss.default = postcss;
var postcss$1 = /* @__PURE__ */getDefaultExportFromCjs(postcss_1);
postcss$1.stringify;
postcss$1.fromJSON;
postcss$1.plugin;
postcss$1.parse;
postcss$1.list;
postcss$1.document;
postcss$1.comment;
postcss$1.atRule;
postcss$1.rule;
postcss$1.decl;
postcss$1.root;
postcss$1.CssSyntaxError;
postcss$1.Declaration;
postcss$1.Container;
postcss$1.Processor;
postcss$1.Document;
postcss$1.Comment;
postcss$1.Warning;
postcss$1.AtRule;
postcss$1.Result;
postcss$1.Input;
postcss$1.Rule;
postcss$1.Root;
postcss$1.Node;

var NodeType$1 = /* @__PURE__ */(NodeType2 => {
  NodeType2[NodeType2["Document"] = 0] = "Document";
  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
  NodeType2[NodeType2["Element"] = 2] = "Element";
  NodeType2[NodeType2["Text"] = 3] = "Text";
  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
  NodeType2[NodeType2["Comment"] = 5] = "Comment";
  return NodeType2;
})(NodeType$1 || {});

function parseCSSText(cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  var comment2 = /\/\*.*?\*\//g;
  cssText.replace(comment2, "").split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[camelize(tmp[0].trim())] = tmp[1].trim());
    }
  });
  return res;
}

function toCSSText(style) {
  var properties = [];

  for (var name in style) {
    var value = style[name];
    if (typeof value !== "string") continue;
    var normalizedName = hyphenate(name);
    properties.push("".concat(normalizedName, ": ").concat(value, ";"));
  }

  return properties.join(" ");
}

var camelizeRE = /-([a-z])/g;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;

var camelize = str => {
  if (CUSTOM_PROPERTY_REGEX.test(str)) return str;
  return str.replace(camelizeRE, (_, c2) => c2 ? c2.toUpperCase() : "");
};

var hyphenateRE = /\B([A-Z])/g;

var hyphenate = str => {
  return str.replace(hyphenateRE, "-$1").toLowerCase();
};

class BaseRRNode {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor() {
    __publicField2(this, "parentElement", null);

    __publicField2(this, "parentNode", null);

    __publicField2(this, "ownerDocument");

    __publicField2(this, "firstChild", null);

    __publicField2(this, "lastChild", null);

    __publicField2(this, "previousSibling", null);

    __publicField2(this, "nextSibling", null);

    __publicField2(this, "ELEMENT_NODE", 1);

    __publicField2(this, "TEXT_NODE", 3);

    __publicField2(this, "nodeType");

    __publicField2(this, "nodeName");

    __publicField2(this, "RRNodeType");
  }

  get childNodes() {
    var childNodes2 = [];
    var childIterator = this.firstChild;

    while (childIterator) {
      childNodes2.push(childIterator);
      childIterator = childIterator.nextSibling;
    }

    return childNodes2;
  }

  contains(node2) {
    if (!(node2 instanceof BaseRRNode)) return false;else if (node2.ownerDocument !== this.ownerDocument) return false;else if (node2 === this) return true;

    while (node2.parentNode) {
      if (node2.parentNode === this) return true;
      node2 = node2.parentNode;
    }

    return false;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  appendChild(_newChild) {
    throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  insertBefore(_newChild, _refChild) {
    throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  removeChild(_node) {
    throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
  }

  toString() {
    return "RRNode";
  }

}

class BaseRRDocument extends BaseRRNode {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor() {
    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }

    super(args);

    __publicField2(this, "nodeType", 9);

    __publicField2(this, "nodeName", "#document");

    __publicField2(this, "compatMode", "CSS1Compat");

    __publicField2(this, "RRNodeType", NodeType$1.Document);

    __publicField2(this, "textContent", null);

    this.ownerDocument = this;
  }

  get documentElement() {
    return this.childNodes.find(node2 => node2.RRNodeType === NodeType$1.Element && node2.tagName === "HTML") || null;
  }

  get body() {
    var _a2;

    return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find(node2 => node2.RRNodeType === NodeType$1.Element && node2.tagName === "BODY")) || null;
  }

  get head() {
    var _a2;

    return ((_a2 = this.documentElement) == null ? void 0 : _a2.childNodes.find(node2 => node2.RRNodeType === NodeType$1.Element && node2.tagName === "HEAD")) || null;
  }

  get implementation() {
    return this;
  }

  get firstElementChild() {
    return this.documentElement;
  }

  appendChild(newChild) {
    var nodeType = newChild.RRNodeType;

    if (nodeType === NodeType$1.Element || nodeType === NodeType$1.DocumentType) {
      if (this.childNodes.some(s2 => s2.RRNodeType === nodeType)) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': Only one ".concat(nodeType === NodeType$1.Element ? "RRElement" : "RRDoctype", " on RRDocument allowed."));
      }
    }

    var child = appendChild(this, newChild);
    child.parentElement = null;
    return child;
  }

  insertBefore(newChild, refChild) {
    var nodeType = newChild.RRNodeType;

    if (nodeType === NodeType$1.Element || nodeType === NodeType$1.DocumentType) {
      if (this.childNodes.some(s2 => s2.RRNodeType === nodeType)) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': Only one ".concat(nodeType === NodeType$1.Element ? "RRElement" : "RRDoctype", " on RRDocument allowed."));
      }
    }

    var child = insertBefore(this, newChild, refChild);
    child.parentElement = null;
    return child;
  }

  removeChild(node2) {
    return removeChild(this, node2);
  }

  open() {
    this.firstChild = null;
    this.lastChild = null;
  }

  close() {}
  /**
   * Adhoc implementation for setting xhtml namespace in rebuilt.ts (rrweb-snapshot).
   * There are two lines used this function:
   * 1. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" ""\>')
   * 2. doc.write('\<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" ""\>')
   */


  write(content) {
    var publicId;
    if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "">') publicId = "-//W3C//DTD XHTML 1.0 Transitional//EN";else if (content === '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "">') publicId = "-//W3C//DTD HTML 4.0 Transitional//EN";

    if (publicId) {
      var doctype = this.createDocumentType("html", publicId, "");
      this.open();
      this.appendChild(doctype);
    }
  }

  createDocument(_namespace, _qualifiedName, _doctype) {
    return new BaseRRDocument();
  }

  createDocumentType(qualifiedName, publicId, systemId) {
    var doctype = new BaseRRDocumentType(qualifiedName, publicId, systemId);
    doctype.ownerDocument = this;
    return doctype;
  }

  createElement(tagName) {
    var element = new BaseRRElement(tagName);
    element.ownerDocument = this;
    return element;
  }

  createElementNS(_namespaceURI, qualifiedName) {
    return this.createElement(qualifiedName);
  }

  createTextNode(data) {
    var text = new BaseRRText(data);
    text.ownerDocument = this;
    return text;
  }

  createComment(data) {
    var comment2 = new BaseRRComment(data);
    comment2.ownerDocument = this;
    return comment2;
  }

  createCDATASection(data) {
    var CDATASection = new BaseRRCDATASection(data);
    CDATASection.ownerDocument = this;
    return CDATASection;
  }

  toString() {
    return "RRDocument";
  }

}

class BaseRRDocumentType extends BaseRRNode {
  constructor(qualifiedName, publicId, systemId) {
    super();

    __publicField2(this, "nodeType", 10);

    __publicField2(this, "RRNodeType", NodeType$1.DocumentType);

    __publicField2(this, "name");

    __publicField2(this, "publicId");

    __publicField2(this, "systemId");

    __publicField2(this, "textContent", null);

    this.name = qualifiedName;
    this.publicId = publicId;
    this.systemId = systemId;
    this.nodeName = qualifiedName;
  }

  toString() {
    return "RRDocumentType";
  }

}

class BaseRRElement extends BaseRRNode {
  constructor(tagName) {
    super();

    __publicField2(this, "nodeType", 1);

    __publicField2(this, "RRNodeType", NodeType$1.Element);

    __publicField2(this, "tagName");

    __publicField2(this, "attributes", {});

    __publicField2(this, "shadowRoot", null);

    __publicField2(this, "scrollLeft");

    __publicField2(this, "scrollTop");

    this.tagName = tagName.toUpperCase();
    this.nodeName = tagName.toUpperCase();
  }

  get textContent() {
    var result2 = "";
    this.childNodes.forEach(node2 => result2 += node2.textContent);
    return result2;
  }

  set textContent(textContent2) {
    this.firstChild = null;
    this.lastChild = null;
    this.appendChild(this.ownerDocument.createTextNode(textContent2));
  }

  get classList() {
    return new ClassList(this.attributes.class, newClassName => {
      this.attributes.class = newClassName;
    });
  }

  get id() {
    return this.attributes.id || "";
  }

  get className() {
    return this.attributes.class || "";
  }

  get style() {
    var style = this.attributes.style ? parseCSSText(this.attributes.style) : {};
    var hyphenateRE2 = /\B([A-Z])/g;

    style.setProperty = (name, value, priority) => {
      if (hyphenateRE2.test(name)) return;
      var normalizedName = camelize(name);
      if (!value) delete style[normalizedName];else style[normalizedName] = value;
      if (priority === "important") style[normalizedName] += " !important";
      this.attributes.style = toCSSText(style);
    };

    style.removeProperty = name => {
      if (hyphenateRE2.test(name)) return "";
      var normalizedName = camelize(name);
      var value = style[normalizedName] || "";
      delete style[normalizedName];
      this.attributes.style = toCSSText(style);
      return value;
    };

    return style;
  }

  getAttribute(name) {
    if (this.attributes[name] === void 0) return null;
    return this.attributes[name];
  }

  setAttribute(name, attribute) {
    this.attributes[name] = attribute;
  }

  setAttributeNS(_namespace, qualifiedName, value) {
    this.setAttribute(qualifiedName, value);
  }

  removeAttribute(name) {
    delete this.attributes[name];
  }

  appendChild(newChild) {
    return appendChild(this, newChild);
  }

  insertBefore(newChild, refChild) {
    return insertBefore(this, newChild, refChild);
  }

  removeChild(node2) {
    return removeChild(this, node2);
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  attachShadow(_init) {
    var shadowRoot2 = this.ownerDocument.createElement("SHADOWROOT");
    this.shadowRoot = shadowRoot2;
    return shadowRoot2;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  dispatchEvent(_event) {
    return true;
  }

  toString() {
    var attributeString = "";

    for (var attribute in this.attributes) {
      attributeString += "".concat(attribute, "=\"").concat(this.attributes[attribute], "\" ");
    }

    return "".concat(this.tagName, " ").concat(attributeString);
  }

}

class BaseRRMediaElement extends BaseRRElement {
  constructor() {
    super(...arguments);

    __publicField2(this, "currentTime");

    __publicField2(this, "volume");

    __publicField2(this, "paused");

    __publicField2(this, "muted");

    __publicField2(this, "playbackRate");

    __publicField2(this, "loop");
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  attachShadow(_init) {
    throw new Error("RRDomException: Failed to execute 'attachShadow' on 'RRElement': This RRElement does not support attachShadow");
  }

  play() {
    this.paused = false;
  }

  pause() {
    this.paused = true;
  }

}

class BaseRRDialogElement extends BaseRRElement {
  constructor() {
    super(...arguments);

    __publicField2(this, "tagName", "DIALOG");

    __publicField2(this, "nodeName", "DIALOG");
  }

  get isModal() {
    return this.getAttribute("rr_open_mode") === "modal";
  }

  get open() {
    return this.getAttribute("open") !== null;
  }

  close() {
    this.removeAttribute("open");
    this.removeAttribute("rr_open_mode");
  }

  show() {
    this.setAttribute("open", "");
    this.setAttribute("rr_open_mode", "non-modal");
  }

  showModal() {
    this.setAttribute("open", "");
    this.setAttribute("rr_open_mode", "modal");
  }

}

class BaseRRText extends BaseRRNode {
  constructor(data) {
    super();

    __publicField2(this, "nodeType", 3);

    __publicField2(this, "nodeName", "#text");

    __publicField2(this, "RRNodeType", NodeType$1.Text);

    __publicField2(this, "data");

    this.data = data;
  }

  get textContent() {
    return this.data;
  }

  set textContent(textContent2) {
    this.data = textContent2;
  }

  toString() {
    return "RRText text=".concat(JSON.stringify(this.data));
  }

}

class BaseRRComment extends BaseRRNode {
  constructor(data) {
    super();

    __publicField2(this, "nodeType", 8);

    __publicField2(this, "nodeName", "#comment");

    __publicField2(this, "RRNodeType", NodeType$1.Comment);

    __publicField2(this, "data");

    this.data = data;
  }

  get textContent() {
    return this.data;
  }

  set textContent(textContent2) {
    this.data = textContent2;
  }

  toString() {
    return "RRComment text=".concat(JSON.stringify(this.data));
  }

}

class BaseRRCDATASection extends BaseRRNode {
  constructor(data) {
    super();

    __publicField2(this, "nodeName", "#cdata-section");

    __publicField2(this, "nodeType", 4);

    __publicField2(this, "RRNodeType", NodeType$1.CDATA);

    __publicField2(this, "data");

    this.data = data;
  }

  get textContent() {
    return this.data;
  }

  set textContent(textContent2) {
    this.data = textContent2;
  }

  toString() {
    return "RRCDATASection data=".concat(JSON.stringify(this.data));
  }

}

class ClassList {
  constructor(classText, onChange) {
    var _this3 = this;

    __publicField2(this, "onChange");

    __publicField2(this, "classes", []);

    __publicField2(this, "add", function () {
      for (var _len14 = arguments.length, classNames = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        classNames[_key14] = arguments[_key14];
      }

      for (var item of classNames) {
        var className = String(item);
        if (_this3.classes.indexOf(className) >= 0) continue;

        _this3.classes.push(className);
      }

      _this3.onChange && _this3.onChange(_this3.classes.join(" "));
    });

    __publicField2(this, "remove", function () {
      for (var _len15 = arguments.length, classNames = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        classNames[_key15] = arguments[_key15];
      }

      _this3.classes = _this3.classes.filter(item => classNames.indexOf(item) === -1);
      _this3.onChange && _this3.onChange(_this3.classes.join(" "));
    });

    if (classText) {
      var classes = classText.trim().split(/\s+/);
      this.classes.push(...classes);
    }

    this.onChange = onChange;
  }

}

function appendChild(parent, newChild) {
  if (newChild.parentNode) newChild.parentNode.removeChild(newChild);

  if (parent.lastChild) {
    parent.lastChild.nextSibling = newChild;
    newChild.previousSibling = parent.lastChild;
  } else {
    parent.firstChild = newChild;
    newChild.previousSibling = null;
  }

  parent.lastChild = newChild;
  newChild.nextSibling = null;
  newChild.parentNode = parent;
  newChild.parentElement = parent;
  newChild.ownerDocument = parent.ownerDocument;
  return newChild;
}

function insertBefore(parent, newChild, refChild) {
  if (!refChild) return appendChild(parent, newChild);
  if (refChild.parentNode !== parent) throw new Error("Failed to execute 'insertBefore' on 'RRNode': The RRNode before which the new node is to be inserted is not a child of this RRNode.");
  if (newChild === refChild) return newChild;
  if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
  newChild.previousSibling = refChild.previousSibling;
  refChild.previousSibling = newChild;
  newChild.nextSibling = refChild;
  if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;else parent.firstChild = newChild;
  newChild.parentElement = parent;
  newChild.parentNode = parent;
  newChild.ownerDocument = parent.ownerDocument;
  return newChild;
}

function removeChild(parent, child) {
  if (child.parentNode !== parent) throw new Error("Failed to execute 'removeChild' on 'RRNode': The RRNode to be removed is not a child of this RRNode.");
  if (child.previousSibling) child.previousSibling.nextSibling = child.nextSibling;else parent.firstChild = child.nextSibling;
  if (child.nextSibling) child.nextSibling.previousSibling = child.previousSibling;else parent.lastChild = child.previousSibling;
  child.previousSibling = null;
  child.nextSibling = null;
  child.parentElement = null;
  child.parentNode = null;
  return child;
}

var NodeType$2 = /* @__PURE__ */(NodeType2 => {
  NodeType2[NodeType2["PLACEHOLDER"] = 0] = "PLACEHOLDER";
  NodeType2[NodeType2["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
  NodeType2[NodeType2["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
  NodeType2[NodeType2["TEXT_NODE"] = 3] = "TEXT_NODE";
  NodeType2[NodeType2["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
  NodeType2[NodeType2["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
  NodeType2[NodeType2["ENTITY_NODE"] = 6] = "ENTITY_NODE";
  NodeType2[NodeType2["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
  NodeType2[NodeType2["COMMENT_NODE"] = 8] = "COMMENT_NODE";
  NodeType2[NodeType2["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
  NodeType2[NodeType2["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
  NodeType2[NodeType2["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
  return NodeType2;
})(NodeType$2 || {});

var NAMESPACES = {
  svg: "http://www.w3.org/2000/svg",
  "xlink:href": "http://www.w3.org/1999/xlink",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
var SVGTagMap = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient"
};
var createdNodeSet = null;

function diff(oldTree, newTree, replayer) {
  var rrnodeMirror = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : newTree.mirror || newTree.ownerDocument.mirror;
  oldTree = diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror);
  diffChildren(oldTree, newTree, replayer, rrnodeMirror);
  diffAfterUpdatingChildren(oldTree, newTree, replayer);
}

function diffBeforeUpdatingChildren(oldTree, newTree, replayer, rrnodeMirror) {
  var _a2;

  if (replayer.afterAppend && !createdNodeSet) {
    createdNodeSet = /* @__PURE__ */new WeakSet();
    setTimeout(() => {
      createdNodeSet = null;
    }, 0);
  }

  if (!sameNodeType(oldTree, newTree)) {
    var calibratedOldTree = createOrGetNode(newTree, replayer.mirror, rrnodeMirror);
    (_a2 = oldTree.parentNode) == null ? void 0 : _a2.replaceChild(calibratedOldTree, oldTree);
    oldTree = calibratedOldTree;
  }

  switch (newTree.RRNodeType) {
    case NodeType$1.Document:
      {
        if (!nodeMatching(oldTree, newTree, replayer.mirror, rrnodeMirror)) {
          var newMeta = rrnodeMirror.getMeta(newTree);

          if (newMeta) {
            replayer.mirror.removeNodeFromMap(oldTree);
            oldTree.close();
            oldTree.open();
            replayer.mirror.add(oldTree, newMeta);
            createdNodeSet == null ? void 0 : createdNodeSet.add(oldTree);
          }
        }

        break;
      }

    case NodeType$1.Element:
      {
        var oldElement = oldTree;
        var newRRElement = newTree;

        switch (newRRElement.tagName) {
          case "IFRAME":
            {
              var oldContentDocument = oldTree.contentDocument;
              if (!oldContentDocument) break;
              diff(oldContentDocument, newTree.contentDocument, replayer, rrnodeMirror);
              break;
            }
        }

        if (newRRElement.shadowRoot) {
          if (!oldElement.shadowRoot) oldElement.attachShadow({
            mode: "open"
          });
          diffChildren( // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          oldElement.shadowRoot, newRRElement.shadowRoot, replayer, rrnodeMirror);
        }

        diffProps(oldElement, newRRElement, rrnodeMirror);
        break;
      }
  }

  return oldTree;
}

function diffAfterUpdatingChildren(oldTree, newTree, replayer) {
  var _a2;

  switch (newTree.RRNodeType) {
    case NodeType$1.Document:
      {
        var scrollData = newTree.scrollData;
        scrollData && replayer.applyScroll(scrollData, true);
        break;
      }

    case NodeType$1.Element:
      {
        var oldElement = oldTree;
        var newRRElement = newTree;
        newRRElement.scrollData && replayer.applyScroll(newRRElement.scrollData, true);
        newRRElement.inputData && replayer.applyInput(newRRElement.inputData);

        switch (newRRElement.tagName) {
          case "AUDIO":
          case "VIDEO":
            {
              var oldMediaElement = oldTree;
              var newMediaRRElement = newRRElement;
              if (newMediaRRElement.paused !== void 0) newMediaRRElement.paused ? void oldMediaElement.pause() : void oldMediaElement.play();
              if (newMediaRRElement.muted !== void 0) oldMediaElement.muted = newMediaRRElement.muted;
              if (newMediaRRElement.volume !== void 0) oldMediaElement.volume = newMediaRRElement.volume;
              if (newMediaRRElement.currentTime !== void 0) oldMediaElement.currentTime = newMediaRRElement.currentTime;
              if (newMediaRRElement.playbackRate !== void 0) oldMediaElement.playbackRate = newMediaRRElement.playbackRate;
              if (newMediaRRElement.loop !== void 0) oldMediaElement.loop = newMediaRRElement.loop;
              break;
            }

          case "CANVAS":
            {
              var rrCanvasElement = newTree;

              if (rrCanvasElement.rr_dataURL !== null) {
                var image = document.createElement("img");

                image.onload = () => {
                  var ctx = oldElement.getContext("2d");

                  if (ctx) {
                    ctx.drawImage(image, 0, 0, image.width, image.height);
                  }
                };

                image.src = rrCanvasElement.rr_dataURL;
              }

              rrCanvasElement.canvasMutations.forEach(canvasMutation2 => replayer.applyCanvas(canvasMutation2.event, canvasMutation2.mutation, oldTree));
              break;
            }

          case "STYLE":
            {
              var styleSheet = oldElement.sheet;
              styleSheet && newTree.rules.forEach(data => replayer.applyStyleSheetMutation(data, styleSheet));
              break;
            }

          case "DIALOG":
            {
              var dialog = oldElement;
              var rrDialog = newRRElement;
              var wasOpen = dialog.open;
              var wasModal = dialog.matches("dialog:modal");
              var shouldBeOpen = rrDialog.open;
              var shouldBeModal = rrDialog.isModal;
              var modalChanged = wasModal !== shouldBeModal;
              var openChanged = wasOpen !== shouldBeOpen;
              if (modalChanged || wasOpen && openChanged) dialog.close();

              if (shouldBeOpen && (openChanged || modalChanged)) {
                try {
                  if (shouldBeModal) dialog.showModal();else dialog.show();
                } catch (e2) {
                  console.warn(e2);
                }
              }

              break;
            }
        }

        break;
      }

    case NodeType$1.Text:
    case NodeType$1.Comment:
    case NodeType$1.CDATA:
      {
        if (oldTree.textContent !== newTree.data) oldTree.textContent = newTree.data;
        break;
      }
  }

  if (createdNodeSet == null ? void 0 : createdNodeSet.has(oldTree)) {
    createdNodeSet.delete(oldTree);
    (_a2 = replayer.afterAppend) == null ? void 0 : _a2.call(replayer, oldTree, replayer.mirror.getId(oldTree));
  }
}

function diffProps(oldTree, newTree, rrnodeMirror) {
  var oldAttributes = oldTree.attributes;
  var newAttributes = newTree.attributes;

  for (var name in newAttributes) {
    var newValue = newAttributes[name];
    var sn = rrnodeMirror.getMeta(newTree);
    if ((sn == null ? void 0 : sn.isSVG) && NAMESPACES[name]) oldTree.setAttributeNS(NAMESPACES[name], name, newValue);else if (newTree.tagName === "CANVAS" && name === "rr_dataURL") {
      (function () {
        var image = document.createElement("img");
        image.src = newValue;

        image.onload = () => {
          var ctx = oldTree.getContext("2d");

          if (ctx) {
            ctx.drawImage(image, 0, 0, image.width, image.height);
          }
        };
      })();
    } else if (newTree.tagName === "IFRAME" && name === "srcdoc") continue;else {
      try {
        oldTree.setAttribute(name, newValue);
      } catch (err) {
        console.warn(err);
      }
    }
  }

  for (var {
    name: _name2
  } of Array.from(oldAttributes)) {
    if (!(_name2 in newAttributes)) oldTree.removeAttribute(_name2);
  }

  newTree.scrollLeft && (oldTree.scrollLeft = newTree.scrollLeft);
  newTree.scrollTop && (oldTree.scrollTop = newTree.scrollTop);
}

function diffChildren(oldTree, newTree, replayer, rrnodeMirror) {
  var oldChildren = Array.from(oldTree.childNodes);
  var newChildren = newTree.childNodes;
  if (oldChildren.length === 0 && newChildren.length === 0) return;
  var oldStartIndex = 0,
      oldEndIndex = oldChildren.length - 1,
      newStartIndex = 0,
      newEndIndex = newChildren.length - 1;
  var oldStartNode = oldChildren[oldStartIndex],
      oldEndNode = oldChildren[oldEndIndex],
      newStartNode = newChildren[newStartIndex],
      newEndNode = newChildren[newEndIndex];
  var oldIdToIndex = void 0,
      indexInOld = void 0;

  while (oldStartIndex <= oldEndIndex && newStartIndex <= newEndIndex) {
    if (oldStartNode === void 0) {
      oldStartNode = oldChildren[++oldStartIndex];
    } else if (oldEndNode === void 0) {
      oldEndNode = oldChildren[--oldEndIndex];
    } else if ( // same first node?
    nodeMatching(oldStartNode, newStartNode, replayer.mirror, rrnodeMirror)) {
      oldStartNode = oldChildren[++oldStartIndex];
      newStartNode = newChildren[++newStartIndex];
    } else if ( // same last node?
    nodeMatching(oldEndNode, newEndNode, replayer.mirror, rrnodeMirror)) {
      oldEndNode = oldChildren[--oldEndIndex];
      newEndNode = newChildren[--newEndIndex];
    } else if ( // is the first old node the same as the last new node?
    nodeMatching(oldStartNode, newEndNode, replayer.mirror, rrnodeMirror)) {
      try {
        oldTree.insertBefore(oldStartNode, oldEndNode.nextSibling);
      } catch (e2) {
        console.warn(e2);
      }

      oldStartNode = oldChildren[++oldStartIndex];
      newEndNode = newChildren[--newEndIndex];
    } else if ( // is the last old node the same as the first new node?
    nodeMatching(oldEndNode, newStartNode, replayer.mirror, rrnodeMirror)) {
      try {
        oldTree.insertBefore(oldEndNode, oldStartNode);
      } catch (e2) {
        console.warn(e2);
      }

      oldEndNode = oldChildren[--oldEndIndex];
      newStartNode = newChildren[++newStartIndex];
    } else {
      if (!oldIdToIndex) {
        oldIdToIndex = {};

        for (var i2 = oldStartIndex; i2 <= oldEndIndex; i2++) {
          var oldChild2 = oldChildren[i2];
          if (oldChild2 && replayer.mirror.hasNode(oldChild2)) oldIdToIndex[replayer.mirror.getId(oldChild2)] = i2;
        }
      }

      indexInOld = oldIdToIndex[rrnodeMirror.getId(newStartNode)];
      var nodeToMove = oldChildren[indexInOld];

      if (indexInOld !== void 0 && nodeToMove && nodeMatching(nodeToMove, newStartNode, replayer.mirror, rrnodeMirror)) {
        try {
          oldTree.insertBefore(nodeToMove, oldStartNode);
        } catch (e2) {
          console.warn(e2);
        }

        oldChildren[indexInOld] = void 0;
      } else {
        var newNode = createOrGetNode(newStartNode, replayer.mirror, rrnodeMirror);

        if (oldTree.nodeName === "#document" && oldStartNode && (
        /**
        * Special case 1: one document isn't allowed to have two doctype nodes at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A parent document in the old tree already has a doctype node with an id e.g. #1. A new full snapshot rebuilds the replayer with a new doctype node with another id #2. According to the algorithm, the new doctype node will be inserted before the old one, which is not allowed by the Document standard.
        */
        newNode.nodeType === newNode.DOCUMENT_TYPE_NODE && oldStartNode.nodeType === oldStartNode.DOCUMENT_TYPE_NODE ||
        /**
        * Special case 2: one document isn't allowed to have two HTMLElements at the same time, so we need to remove the old one first before inserting the new one.
        * How this case happens: A mounted iframe element has an automatically created HTML element. We should delete it before inserting a serialized one. Otherwise, an error 'Only one element on document allowed' will be thrown.
        */
        newNode.nodeType === newNode.ELEMENT_NODE && oldStartNode.nodeType === oldStartNode.ELEMENT_NODE)) {
          oldTree.removeChild(oldStartNode);
          replayer.mirror.removeNodeFromMap(oldStartNode);
          oldStartNode = oldChildren[++oldStartIndex];
        }

        try {
          oldTree.insertBefore(newNode, oldStartNode || null);
        } catch (e2) {
          console.warn(e2);
        }
      }

      newStartNode = newChildren[++newStartIndex];
    }
  }

  if (oldStartIndex > oldEndIndex) {
    var referenceRRNode = newChildren[newEndIndex + 1];
    var referenceNode = null;
    if (referenceRRNode) referenceNode = replayer.mirror.getNode(rrnodeMirror.getId(referenceRRNode));

    for (; newStartIndex <= newEndIndex; ++newStartIndex) {
      var _newNode = createOrGetNode(newChildren[newStartIndex], replayer.mirror, rrnodeMirror);

      try {
        oldTree.insertBefore(_newNode, referenceNode);
      } catch (e2) {
        console.warn(e2);
      }
    }
  } else if (newStartIndex > newEndIndex) {
    for (; oldStartIndex <= oldEndIndex; oldStartIndex++) {
      var node2 = oldChildren[oldStartIndex];
      if (!node2 || node2.parentNode !== oldTree) continue;

      try {
        oldTree.removeChild(node2);
        replayer.mirror.removeNodeFromMap(node2);
      } catch (e2) {
        console.warn(e2);
      }
    }
  }

  var oldChild = oldTree.firstChild;
  var newChild = newTree.firstChild;

  while (oldChild !== null && newChild !== null) {
    diff(oldChild, newChild, replayer, rrnodeMirror);
    oldChild = oldChild.nextSibling;
    newChild = newChild.nextSibling;
  }
}

function createOrGetNode(rrNode, domMirror, rrnodeMirror) {
  var nodeId = rrnodeMirror.getId(rrNode);
  var sn = rrnodeMirror.getMeta(rrNode);
  var node2 = null;
  if (nodeId > -1) node2 = domMirror.getNode(nodeId);
  if (node2 !== null && sameNodeType(node2, rrNode)) return node2;

  switch (rrNode.RRNodeType) {
    case NodeType$1.Document:
      node2 = new Document();
      break;

    case NodeType$1.DocumentType:
      node2 = document.implementation.createDocumentType(rrNode.name, rrNode.publicId, rrNode.systemId);
      break;

    case NodeType$1.Element:
      {
        var tagName = rrNode.tagName.toLowerCase();
        tagName = SVGTagMap[tagName] || tagName;

        if (sn && "isSVG" in sn && (sn == null ? void 0 : sn.isSVG)) {
          node2 = document.createElementNS(NAMESPACES["svg"], tagName);
        } else node2 = document.createElement(rrNode.tagName);

        break;
      }

    case NodeType$1.Text:
      node2 = document.createTextNode(rrNode.data);
      break;

    case NodeType$1.Comment:
      node2 = document.createComment(rrNode.data);
      break;

    case NodeType$1.CDATA:
      node2 = document.createCDATASection(rrNode.data);
      break;
  }

  if (sn) domMirror.add(node2, _objectSpread({}, sn));

  try {
    createdNodeSet == null ? void 0 : createdNodeSet.add(node2);
  } catch (e2) {}

  return node2;
}

function sameNodeType(node1, node2) {
  if (node1.nodeType !== node2.nodeType) return false;
  return node1.nodeType !== node1.ELEMENT_NODE || node1.tagName.toUpperCase() === node2.tagName;
}

function nodeMatching(node1, node2, domMirror, rrdomMirror) {
  var node1Id = domMirror.getId(node1);
  var node2Id = rrdomMirror.getId(node2);
  if (node1Id === -1 || node1Id !== node2Id) return false;
  return sameNodeType(node1, node2);
}

class RRDocument extends BaseRRDocument {
  constructor(mirror2) {
    super();

    __publicField2(this, "UNSERIALIZED_STARTING_ID", -2);

    __publicField2(this, "_unserializedId", this.UNSERIALIZED_STARTING_ID);

    __publicField2(this, "mirror", createMirror());

    __publicField2(this, "scrollData", null);

    if (mirror2) {
      this.mirror = mirror2;
    }
  }
  /**
   * Every time the id is used, it will minus 1 automatically to avoid collisions.
   */


  get unserializedId() {
    return this._unserializedId--;
  }

  createDocument(_namespace, _qualifiedName, _doctype) {
    return new RRDocument();
  }

  createDocumentType(qualifiedName, publicId, systemId) {
    var documentTypeNode = new RRDocumentType(qualifiedName, publicId, systemId);
    documentTypeNode.ownerDocument = this;
    return documentTypeNode;
  }

  createElement(tagName) {
    var upperTagName = tagName.toUpperCase();
    var element;

    switch (upperTagName) {
      case "AUDIO":
      case "VIDEO":
        element = new RRMediaElement(upperTagName);
        break;

      case "IFRAME":
        element = new RRIFrameElement(upperTagName, this.mirror);
        break;

      case "CANVAS":
        element = new RRCanvasElement(upperTagName);
        break;

      case "STYLE":
        element = new RRStyleElement(upperTagName);
        break;

      case "DIALOG":
        element = new RRDialogElement(upperTagName);
        break;

      default:
        element = new RRElement(upperTagName);
        break;
    }

    element.ownerDocument = this;
    return element;
  }

  createComment(data) {
    var commentNode = new RRComment(data);
    commentNode.ownerDocument = this;
    return commentNode;
  }

  createCDATASection(data) {
    var sectionNode = new RRCDATASection(data);
    sectionNode.ownerDocument = this;
    return sectionNode;
  }

  createTextNode(data) {
    var textNode = new RRText(data);
    textNode.ownerDocument = this;
    return textNode;
  }

  destroyTree() {
    this.firstChild = null;
    this.lastChild = null;
    this.mirror.reset();
  }

  open() {
    super.open();
    this._unserializedId = this.UNSERIALIZED_STARTING_ID;
  }

}

var RRDocumentType = BaseRRDocumentType;

class RRElement extends BaseRRElement {
  constructor() {
    super(...arguments);

    __publicField2(this, "inputData", null);

    __publicField2(this, "scrollData", null);
  }

}

class RRMediaElement extends BaseRRMediaElement {}

class RRDialogElement extends BaseRRDialogElement {}

class RRCanvasElement extends RRElement {
  constructor() {
    super(...arguments);

    __publicField2(this, "rr_dataURL", null);

    __publicField2(this, "canvasMutations", []);
  }
  /**
   * This is a dummy implementation to distinguish RRCanvasElement from real HTMLCanvasElement.
   */


  getContext() {
    return null;
  }

}

class RRStyleElement extends RRElement {
  constructor() {
    super(...arguments);

    __publicField2(this, "rules", []);
  }

}

class RRIFrameElement extends RRElement {
  constructor(upperTagName, mirror2) {
    super(upperTagName);

    __publicField2(this, "contentDocument", new RRDocument());

    this.contentDocument.mirror = mirror2;
  }

}

var RRText = BaseRRText;
var RRComment = BaseRRComment;
var RRCDATASection = BaseRRCDATASection;

function getValidTagName(element) {
  if (element instanceof HTMLFormElement) {
    return "FORM";
  }

  return element.tagName.toUpperCase();
}

function buildFromNode(node2, rrdom, domMirror, parentRRNode) {
  var rrNode;

  switch (node2.nodeType) {
    case NodeType$2.DOCUMENT_NODE:
      if (parentRRNode && parentRRNode.nodeName === "IFRAME") rrNode = parentRRNode.contentDocument;else {
        rrNode = rrdom;
        rrNode.compatMode = node2.compatMode;
      }
      break;

    case NodeType$2.DOCUMENT_TYPE_NODE:
      {
        var documentType = node2;
        rrNode = rrdom.createDocumentType(documentType.name, documentType.publicId, documentType.systemId);
        break;
      }

    case NodeType$2.ELEMENT_NODE:
      {
        var elementNode = node2;
        var tagName = getValidTagName(elementNode);
        rrNode = rrdom.createElement(tagName);
        var rrElement = rrNode;

        for (var {
          name,
          value
        } of Array.from(elementNode.attributes)) {
          rrElement.attributes[name] = value;
        }

        elementNode.scrollLeft && (rrElement.scrollLeft = elementNode.scrollLeft);
        elementNode.scrollTop && (rrElement.scrollTop = elementNode.scrollTop);
        break;
      }

    case NodeType$2.TEXT_NODE:
      rrNode = rrdom.createTextNode(node2.textContent || "");
      break;

    case NodeType$2.CDATA_SECTION_NODE:
      rrNode = rrdom.createCDATASection(node2.data);
      break;

    case NodeType$2.COMMENT_NODE:
      rrNode = rrdom.createComment(node2.textContent || "");
      break;

    case NodeType$2.DOCUMENT_FRAGMENT_NODE:
      rrNode = parentRRNode.attachShadow({
        mode: "open"
      });
      break;

    default:
      return null;
  }

  var sn = domMirror.getMeta(node2);

  if (rrdom instanceof RRDocument) {
    if (!sn) {
      sn = getDefaultSN(rrNode, rrdom.unserializedId);
      domMirror.add(node2, sn);
    }

    rrdom.mirror.add(rrNode, _objectSpread({}, sn));
  }

  return rrNode;
}

function buildFromDom(dom) {
  var domMirror = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createMirror$1();
  var rrdom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new RRDocument();

  function walk2(node2, parentRRNode) {
    var rrNode = buildFromNode(node2, rrdom, domMirror, parentRRNode);
    if (rrNode === null) return;

    if ( // if the parentRRNode isn't a RRIFrameElement
    (parentRRNode == null ? void 0 : parentRRNode.nodeName) !== "IFRAME" && // if node isn't a shadow root
    node2.nodeType !== NodeType$2.DOCUMENT_FRAGMENT_NODE) {
      parentRRNode == null ? void 0 : parentRRNode.appendChild(rrNode);
      rrNode.parentNode = parentRRNode;
      rrNode.parentElement = parentRRNode;
    }

    if (node2.nodeName === "IFRAME") {
      var iframeDoc = node2.contentDocument;
      iframeDoc && walk2(iframeDoc, rrNode);
    } else if (node2.nodeType === NodeType$2.DOCUMENT_NODE || node2.nodeType === NodeType$2.ELEMENT_NODE || node2.nodeType === NodeType$2.DOCUMENT_FRAGMENT_NODE) {
      if (node2.nodeType === NodeType$2.ELEMENT_NODE && node2.shadowRoot) walk2(node2.shadowRoot, rrNode);
      node2.childNodes.forEach(childNode => walk2(childNode, rrNode));
    }
  }

  walk2(dom, null);
  return rrdom;
}

function createMirror() {
  return new Mirror22();
}

class Mirror22 {
  constructor() {
    __publicField2(this, "idNodeMap", /* @__PURE__ */new Map());

    __publicField2(this, "nodeMetaMap", /* @__PURE__ */new WeakMap());
  }

  getId(n2) {
    var _a2;

    if (!n2) return -1;
    var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
    return id !== null && id !== void 0 ? id : -1;
  }

  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }

  getIds() {
    return Array.from(this.idNodeMap.keys());
  }

  getMeta(n2) {
    return this.nodeMetaMap.get(n2) || null;
  } // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap


  removeNodeFromMap(n2) {
    var id = this.getId(n2);
    this.idNodeMap.delete(id);

    if (n2.childNodes) {
      n2.childNodes.forEach(childNode => this.removeNodeFromMap(childNode));
    }
  }

  has(id) {
    return this.idNodeMap.has(id);
  }

  hasNode(node2) {
    return this.nodeMetaMap.has(node2);
  }

  add(n2, meta) {
    var id = meta.id;
    this.idNodeMap.set(id, n2);
    this.nodeMetaMap.set(n2, meta);
  }

  replace(id, n2) {
    var oldNode = this.getNode(id);

    if (oldNode) {
      var meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n2, meta);
    }

    this.idNodeMap.set(id, n2);
  }

  reset() {
    this.idNodeMap = /* @__PURE__ */new Map();
    this.nodeMetaMap = /* @__PURE__ */new WeakMap();
  }

}

function getDefaultSN(node2, id) {
  switch (node2.RRNodeType) {
    case NodeType$1.Document:
      return {
        id,
        type: node2.RRNodeType,
        childNodes: []
      };

    case NodeType$1.DocumentType:
      {
        var doctype = node2;
        return {
          id,
          type: node2.RRNodeType,
          name: doctype.name,
          publicId: doctype.publicId,
          systemId: doctype.systemId
        };
      }

    case NodeType$1.Element:
      return {
        id,
        type: node2.RRNodeType,
        tagName: node2.tagName.toLowerCase(),
        // In rrweb data, all tagNames are lowercase.
        attributes: {},
        childNodes: []
      };

    case NodeType$1.Text:
      return {
        id,
        type: node2.RRNodeType,
        textContent: node2.textContent || ""
      };

    case NodeType$1.Comment:
      return {
        id,
        type: node2.RRNodeType,
        textContent: node2.textContent || ""
      };

    case NodeType$1.CDATA:
      return {
        id,
        type: node2.RRNodeType,
        textContent: ""
      };
  }
}

var testableAccessors = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
};
var testableMethods = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
};
var untaintedBasePrototype = {};

var isAngularZonePresent = () => {
  return !!globalThis.Zone;
};

function getUntaintedPrototype(key) {
  if (untaintedBasePrototype[key]) return untaintedBasePrototype[key];
  var defaultObj = globalThis[key];
  var defaultPrototype = defaultObj.prototype;
  var accessorNames = key in testableAccessors ? testableAccessors[key] : void 0;
  var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
  accessorNames.every(accessor => {
    var _a2, _b;

    return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
  }));
  var methodNames = key in testableMethods ? testableMethods[key] : void 0;
  var isUntaintedMethods = Boolean(methodNames && methodNames.every( // @ts-expect-error 2345
  method => {
    var _a2;

    return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
  }));

  if (isUntaintedAccessors && isUntaintedMethods && !isAngularZonePresent()) {
    untaintedBasePrototype[key] = defaultObj.prototype;
    return defaultObj.prototype;
  }

  try {
    var iframeEl = document.createElement("iframe");
    document.body.appendChild(iframeEl);
    var win = iframeEl.contentWindow;
    if (!win) return defaultObj.prototype;
    var untaintedObject = win[key].prototype;
    document.body.removeChild(iframeEl);
    if (!untaintedObject) return defaultPrototype;
    return untaintedBasePrototype[key] = untaintedObject;
  } catch (_unused2) {
    return defaultPrototype;
  }
}

var untaintedAccessorCache = {};

function getUntaintedAccessor(key, instance, accessor) {
  var _a2;

  var cacheKey = "".concat(key, ".").concat(String(accessor));
  if (untaintedAccessorCache[cacheKey]) return untaintedAccessorCache[cacheKey].call(instance);
  var untaintedPrototype = getUntaintedPrototype(key);
  var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
  if (!untaintedAccessor) return instance[accessor];
  untaintedAccessorCache[cacheKey] = untaintedAccessor;
  return untaintedAccessor.call(instance);
}

var untaintedMethodCache = {};

function getUntaintedMethod(key, instance, method) {
  var cacheKey = "".concat(key, ".").concat(String(method));
  if (untaintedMethodCache[cacheKey]) return untaintedMethodCache[cacheKey].bind(instance);
  var untaintedPrototype = getUntaintedPrototype(key);
  var untaintedMethod = untaintedPrototype[method];
  if (typeof untaintedMethod !== "function") return instance[method];
  untaintedMethodCache[cacheKey] = untaintedMethod;
  return untaintedMethod.bind(instance);
}

function childNodes(n2) {
  return getUntaintedAccessor("Node", n2, "childNodes");
}

function parentNode(n2) {
  return getUntaintedAccessor("Node", n2, "parentNode");
}

function parentElement(n2) {
  return getUntaintedAccessor("Node", n2, "parentElement");
}

function textContent(n2) {
  return getUntaintedAccessor("Node", n2, "textContent");
}

function contains(n2, other) {
  return getUntaintedMethod("Node", n2, "contains")(other);
}

function getRootNode(n2) {
  return getUntaintedMethod("Node", n2, "getRootNode")();
}

function host(n2) {
  if (!n2 || !("host" in n2)) return null;
  return getUntaintedAccessor("ShadowRoot", n2, "host");
}

function styleSheets(n2) {
  return n2.styleSheets;
}

function shadowRoot(n2) {
  if (!n2 || !("shadowRoot" in n2)) return null;
  return getUntaintedAccessor("Element", n2, "shadowRoot");
}

function querySelector(n2, selectors) {
  return getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}

function querySelectorAll(n2, selectors) {
  return getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}

function mutationObserverCtor() {
  return getUntaintedPrototype("MutationObserver").constructor;
}

var index = {
  childNodes,
  parentNode,
  parentElement,
  textContent,
  contains,
  getRootNode,
  host,
  styleSheets,
  shadowRoot,
  querySelector,
  querySelectorAll,
  mutationObserver: mutationObserverCtor
};

function on(type, fn) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var options = {
    capture: true,
    passive: true
  };
  target.addEventListener(type, fn, options);
  return () => target.removeEventListener(type, fn, options);
}

var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
  map: {},

  getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },

  getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },

  removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },

  has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },

  reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }

};

if (typeof window !== "undefined" && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get(target, prop, receiver) {
      if (prop === "map") {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }

      return Reflect.get(target, prop, receiver);
    }

  });
}

function throttle(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout = null;
  var previous = 0;
  return function () {
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }

    var now = Date.now();

    if (!previous && options.leading === false) {
      previous = now;
    }

    var remaining = wait - (now - previous);
    var context = this;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(() => {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}

function hookSetter(target, key, d, isRevoked) {
  var win = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set(value) {
      setTimeout(() => {
        d.set.call(this, value);
      }, 0);

      if (original && original.set) {
        original.set.call(this, value);
      }
    }

  });
  return () => hookSetter(target, key, original || {}, true);
}

function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return () => {};
    }

    var original = source[name];
    var wrapped = replacement(original);

    if (typeof wrapped === "function") {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }

    source[name] = wrapped;
    return () => {
      source[name] = original;
    };
  } catch (_unused3) {
    return () => {};
  }
}

var nowTimestamp = Date.now;

if (! /* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = () => /* @__PURE__ */new Date().getTime();
}

function getWindowScroll(win) {
  var _a2, _b, _c, _d;

  var doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
  };
}

function getWindowHeight() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}

function getWindowWidth() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}

function closestElementOfNode(node2) {
  if (!node2) {
    return null;
  }

  var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : index.parentElement(node2);
  return el;
}

function isBlocked(node2, blockClass, blockSelector, checkAncestors) {
  if (!node2) {
    return false;
  }

  var el = closestElementOfNode(node2);

  if (!el) {
    return false;
  }

  try {
    if (typeof blockClass === "string") {
      if (el.classList.contains(blockClass)) return true;
      if (checkAncestors && el.closest("." + blockClass) !== null) return true;
    } else {
      if (classMatchesRegex(el, blockClass, checkAncestors)) return true;
    }
  } catch (e2) {}

  if (blockSelector) {
    if (el.matches(blockSelector)) return true;
    if (checkAncestors && el.closest(blockSelector) !== null) return true;
  }

  return false;
}

function isSerialized(n2, mirror2) {
  return mirror2.getId(n2) !== -1;
}

function isIgnored(n2, mirror2, slimDOMOptions) {
  if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) {
    return true;
  }

  return mirror2.getId(n2) === IGNORED_NODE;
}

function isAncestorRemoved(target, mirror2) {
  if (isShadowRoot(target)) {
    return false;
  }

  var id = mirror2.getId(target);

  if (!mirror2.has(id)) {
    return true;
  }

  var parent = index.parentNode(target);

  if (parent && parent.nodeType === target.DOCUMENT_NODE) {
    return false;
  }

  if (!parent) {
    return true;
  }

  return isAncestorRemoved(parent, mirror2);
}

function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}

function polyfill$1() {
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if ("NodeList" in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }

  if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }
}

function queueToResolveTrees(queue) {
  var queueNodeMap = {};

  var putIntoMap = (m, parent) => {
    var nodeInTree = {
      value: m,
      parent,
      children: []
    };
    queueNodeMap[m.node.id] = nodeInTree;
    return nodeInTree;
  };

  var queueNodeTrees = [];

  for (var mutation of queue) {
    var {
      nextId,
      parentId
    } = mutation;

    if (nextId && nextId in queueNodeMap) {
      var nextInTree = queueNodeMap[nextId];

      if (nextInTree.parent) {
        var idx = nextInTree.parent.children.indexOf(nextInTree);
        nextInTree.parent.children.splice(idx, 0, putIntoMap(mutation, nextInTree.parent));
      } else {
        var _idx = queueNodeTrees.indexOf(nextInTree);

        queueNodeTrees.splice(_idx, 0, putIntoMap(mutation, null));
      }

      continue;
    }

    if (parentId in queueNodeMap) {
      var parentInTree = queueNodeMap[parentId];
      parentInTree.children.push(putIntoMap(mutation, parentInTree));
      continue;
    }

    queueNodeTrees.push(putIntoMap(mutation, null));
  }

  return queueNodeTrees;
}

function iterateResolveTree(tree, cb) {
  cb(tree.value);

  for (var i2 = tree.children.length - 1; i2 >= 0; i2--) {
    iterateResolveTree(tree.children[i2], cb);
  }
}

function isSerializedIframe(n2, mirror2) {
  return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}

function isSerializedStylesheet(n2, mirror2) {
  return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}

function getBaseDimension(node2, rootIframe) {
  var _a2, _b;

  var frameElement = (_b = (_a2 = node2.ownerDocument) == null ? void 0 : _a2.defaultView) == null ? void 0 : _b.frameElement;

  if (!frameElement || frameElement === rootIframe) {
    return {
      x: 0,
      y: 0,
      relativeScale: 1,
      absoluteScale: 1
    };
  }

  var frameDimension = frameElement.getBoundingClientRect();
  var frameBaseDimension = getBaseDimension(frameElement, rootIframe);
  var relativeScale = frameDimension.height / frameElement.clientHeight;
  return {
    x: frameDimension.x * frameBaseDimension.relativeScale + frameBaseDimension.x,
    y: frameDimension.y * frameBaseDimension.relativeScale + frameBaseDimension.y,
    relativeScale,
    absoluteScale: frameBaseDimension.absoluteScale * relativeScale
  };
}

function hasShadowRoot(n2) {
  if (!n2) return false;

  if (n2 instanceof BaseRRNode && "shadowRoot" in n2) {
    return Boolean(n2.shadowRoot);
  }

  return Boolean(index.shadowRoot(n2));
}

function getNestedRule(rules2, position) {
  var rule2 = rules2[position[0]];

  if (position.length === 1) {
    return rule2;
  } else {
    return getNestedRule(rule2.cssRules[position[1]].cssRules, position.slice(2));
  }
}

function getPositionsAndIndex(nestedIndex) {
  var positions = [...nestedIndex];
  var index2 = positions.pop();
  return {
    positions,
    index: index2
  };
}

function uniqueTextMutations(mutations) {
  var idSet = /* @__PURE__ */new Set();
  var uniqueMutations = [];

  for (var i2 = mutations.length; i2--;) {
    var mutation = mutations[i2];

    if (!idSet.has(mutation.id)) {
      uniqueMutations.push(mutation);
      idSet.add(mutation.id);
    }
  }

  return uniqueMutations;
}

class StyleSheetMirror {
  constructor() {
    __publicField(this, "id", 1);

    __publicField(this, "styleIDMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "idStyleMap", /* @__PURE__ */new Map());
  }

  getId(stylesheet) {
    var _this$styleIDMap$get;

    return (_this$styleIDMap$get = this.styleIDMap.get(stylesheet)) !== null && _this$styleIDMap$get !== void 0 ? _this$styleIDMap$get : -1;
  }

  has(stylesheet) {
    return this.styleIDMap.has(stylesheet);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */


  add(stylesheet, id) {
    if (this.has(stylesheet)) return this.getId(stylesheet);
    var newId;

    if (id === void 0) {
      newId = this.id++;
    } else newId = id;

    this.styleIDMap.set(stylesheet, newId);
    this.idStyleMap.set(newId, stylesheet);
    return newId;
  }

  getStyle(id) {
    return this.idStyleMap.get(id) || null;
  }

  reset() {
    this.styleIDMap = /* @__PURE__ */new WeakMap();
    this.idStyleMap = /* @__PURE__ */new Map();
    this.id = 1;
  }

  generateId() {
    return this.id++;
  }

}

function getShadowHost(n2) {
  var _a2;

  var shadowHost = null;
  if ("getRootNode" in n2 && ((_a2 = index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && index.host(index.getRootNode(n2))) shadowHost = index.host(index.getRootNode(n2));
  return shadowHost;
}

function getRootShadowHost(n2) {
  var rootShadowHost = n2;
  var shadowHost;

  while (shadowHost = getShadowHost(rootShadowHost)) {
    rootShadowHost = shadowHost;
  }

  return rootShadowHost;
}

function shadowHostInDom(n2) {
  var doc = n2.ownerDocument;
  if (!doc) return false;
  var shadowHost = getRootShadowHost(n2);
  return index.contains(doc, shadowHost);
}

function inDom(n2) {
  var doc = n2.ownerDocument;
  if (!doc) return false;
  return index.contains(doc, n2) || shadowHostInDom(n2);
}

var utils = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  StyleSheetMirror,

  get _mirror() {
    return _mirror;
  },

  closestElementOfNode,
  getBaseDimension,
  getNestedRule,
  getPositionsAndIndex,
  getRootShadowHost,
  getShadowHost,
  getWindowHeight,
  getWindowScroll,
  getWindowWidth,
  hasShadowRoot,
  hookSetter,
  inDom,
  isAncestorRemoved,
  isBlocked,
  isIgnored,
  isSerialized,
  isSerializedIframe,
  isSerializedStylesheet,
  iterateResolveTree,
  legacy_isTouchEvent,

  get nowTimestamp() {
    return nowTimestamp;
  },

  on,
  patch,
  polyfill: polyfill$1,
  queueToResolveTrees,
  shadowHostInDom,
  throttle,
  uniqueTextMutations
}, Symbol.toStringTag, {
  value: "Module"
}));

var EventType = /* @__PURE__ */(EventType2 => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});

var IncrementalSource = /* @__PURE__ */(IncrementalSource2 => {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
  return IncrementalSource2;
})(IncrementalSource || {});

var MouseInteractions = /* @__PURE__ */(MouseInteractions2 => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});

var PointerTypes = /* @__PURE__ */(PointerTypes2 => {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
})(PointerTypes || {});

var CanvasContext = /* @__PURE__ */(CanvasContext2 => {
  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
  return CanvasContext2;
})(CanvasContext || {});

var MediaInteractions = /* @__PURE__ */(MediaInteractions2 => {
  MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
  MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
  MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
  MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
  MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
  return MediaInteractions2;
})(MediaInteractions || {});

var ReplayerEvents = /* @__PURE__ */(ReplayerEvents2 => {
  ReplayerEvents2["Start"] = "start";
  ReplayerEvents2["Pause"] = "pause";
  ReplayerEvents2["Resume"] = "resume";
  ReplayerEvents2["Resize"] = "resize";
  ReplayerEvents2["Finish"] = "finish";
  ReplayerEvents2["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
  ReplayerEvents2["LoadStylesheetStart"] = "load-stylesheet-start";
  ReplayerEvents2["LoadStylesheetEnd"] = "load-stylesheet-end";
  ReplayerEvents2["SkipStart"] = "skip-start";
  ReplayerEvents2["SkipEnd"] = "skip-end";
  ReplayerEvents2["MouseInteraction"] = "mouse-interaction";
  ReplayerEvents2["EventCast"] = "event-cast";
  ReplayerEvents2["CustomEvent"] = "custom-event";
  ReplayerEvents2["Flush"] = "flush";
  ReplayerEvents2["StateChange"] = "state-change";
  ReplayerEvents2["PlayBack"] = "play-back";
  ReplayerEvents2["Destroy"] = "destroy";
  return ReplayerEvents2;
})(ReplayerEvents || {});

var NodeType = /* @__PURE__ */(NodeType2 => {
  NodeType2[NodeType2["Document"] = 0] = "Document";
  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
  NodeType2[NodeType2["Element"] = 2] = "Element";
  NodeType2[NodeType2["Text"] = 3] = "Text";
  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
  NodeType2[NodeType2["Comment"] = 5] = "Comment";
  return NodeType2;
})(NodeType || {});

function isNodeInLinkedList(n2) {
  return "__ln" in n2;
}

class DoubleLinkedList {
  constructor() {
    __publicField(this, "length", 0);

    __publicField(this, "head", null);

    __publicField(this, "tail", null);
  }

  get(position) {
    if (position >= this.length) {
      throw new Error("Position outside of list range");
    }

    var current = this.head;

    for (var index2 = 0; index2 < position; index2++) {
      current = (current == null ? void 0 : current.next) || null;
    }

    return current;
  }

  addNode(n2) {
    var node2 = {
      value: n2,
      previous: null,
      next: null
    };
    n2.__ln = node2;

    if (n2.previousSibling && isNodeInLinkedList(n2.previousSibling)) {
      var current = n2.previousSibling.__ln.next;
      node2.next = current;
      node2.previous = n2.previousSibling.__ln;
      n2.previousSibling.__ln.next = node2;

      if (current) {
        current.previous = node2;
      }
    } else if (n2.nextSibling && isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
      var _current = n2.nextSibling.__ln.previous;
      node2.previous = _current;
      node2.next = n2.nextSibling.__ln;
      n2.nextSibling.__ln.previous = node2;

      if (_current) {
        _current.next = node2;
      }
    } else {
      if (this.head) {
        this.head.previous = node2;
      }

      node2.next = this.head;
      this.head = node2;
    }

    if (node2.next === null) {
      this.tail = node2;
    }

    this.length++;
  }

  removeNode(n2) {
    var current = n2.__ln;

    if (!this.head) {
      return;
    }

    if (!current.previous) {
      this.head = current.next;

      if (this.head) {
        this.head.previous = null;
      } else {
        this.tail = null;
      }
    } else {
      current.previous.next = current.next;

      if (current.next) {
        current.next.previous = current.previous;
      } else {
        this.tail = current.previous;
      }
    }

    if (n2.__ln) {
      delete n2.__ln;
    }

    this.length--;
  }

}

var moveKey = (id, parentId) => "".concat(id, "@").concat(parentId);

class MutationBuffer {
  constructor() {
    __publicField(this, "frozen", false);

    __publicField(this, "locked", false);

    __publicField(this, "texts", []);

    __publicField(this, "attributes", []);

    __publicField(this, "attributeMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "removes", []);

    __publicField(this, "mapRemoves", []);

    __publicField(this, "movedMap", {});
    /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */


    __publicField(this, "addedSet", /* @__PURE__ */new Set());

    __publicField(this, "movedSet", /* @__PURE__ */new Set());

    __publicField(this, "droppedSet", /* @__PURE__ */new Set());

    __publicField(this, "removesSubTreeCache", /* @__PURE__ */new Set());

    __publicField(this, "mutationCb");

    __publicField(this, "blockClass");

    __publicField(this, "blockSelector");

    __publicField(this, "maskTextClass");

    __publicField(this, "maskTextSelector");

    __publicField(this, "inlineStylesheet");

    __publicField(this, "maskInputOptions");

    __publicField(this, "maskTextFn");

    __publicField(this, "maskInputFn");

    __publicField(this, "keepIframeSrcFn");

    __publicField(this, "recordCanvas");

    __publicField(this, "inlineImages");

    __publicField(this, "slimDOMOptions");

    __publicField(this, "dataURLOptions");

    __publicField(this, "doc");

    __publicField(this, "mirror");

    __publicField(this, "iframeManager");

    __publicField(this, "stylesheetManager");

    __publicField(this, "shadowDomManager");

    __publicField(this, "canvasManager");

    __publicField(this, "processedNodeManager");

    __publicField(this, "unattachedDoc");

    __publicField(this, "processMutations", mutations => {
      mutations.forEach(this.processMutation);
      this.emit();
    });

    __publicField(this, "emit", () => {
      if (this.frozen || this.locked) {
        return;
      }

      var adds = [];
      var addedIds = /* @__PURE__ */new Set();
      var addList = new DoubleLinkedList();

      var getNextId = n2 => {
        var ns = n2;
        var nextId = IGNORED_NODE;

        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && this.mirror.getId(ns);
        }

        return nextId;
      };

      var pushAdd = n2 => {
        var parent = index.parentNode(n2);

        if (!parent || !inDom(n2)) {
          return;
        }

        var cssCaptured = false;

        if (n2.nodeType === Node.TEXT_NODE) {
          var parentTag = parent.tagName;

          if (parentTag === "TEXTAREA") {
            return;
          } else if (parentTag === "STYLE" && this.addedSet.has(parent)) {
            cssCaptured = true;
          }
        }

        var parentId = isShadowRoot(parent) ? this.mirror.getId(getShadowHost(n2)) : this.mirror.getId(parent);
        var nextId = getNextId(n2);

        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n2);
        }

        var sn = serializeNodeWithId(n2, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: currentN => {
            if (isSerializedIframe(currentN, this.mirror)) {
              this.iframeManager.addIframe(currentN);
            }

            if (isSerializedStylesheet(currentN, this.mirror)) {
              this.stylesheetManager.trackLinkElement(currentN);
            }

            if (hasShadowRoot(n2)) {
              this.shadowDomManager.addShadowRoot(index.shadowRoot(n2), this.doc);
            }
          },
          onIframeLoad: (iframe, childSn) => {
            this.iframeManager.attachIframe(iframe, childSn);
            this.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: (link, childSn) => {
            this.stylesheetManager.attachLinkElement(link, childSn);
          },
          cssCaptured
        });

        if (sn) {
          adds.push({
            parentId,
            nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };

      while (this.mapRemoves.length) {
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      }

      for (var n2 of this.movedSet) {
        if (isParentRemoved(this.removesSubTreeCache, n2, this.mirror) && !this.movedSet.has(index.parentNode(n2))) {
          continue;
        }

        pushAdd(n2);
      }

      for (var _n of this.addedSet) {
        if (!isAncestorInSet(this.droppedSet, _n) && !isParentRemoved(this.removesSubTreeCache, _n, this.mirror)) {
          pushAdd(_n);
        } else if (isAncestorInSet(this.movedSet, _n)) {
          pushAdd(_n);
        } else {
          this.droppedSet.add(_n);
        }
      }

      var candidate = null;

      while (addList.length) {
        var node2 = null;

        if (candidate) {
          var parentId = this.mirror.getId(index.parentNode(candidate.value));
          var nextId = getNextId(candidate.value);

          if (parentId !== -1 && nextId !== -1) {
            node2 = candidate;
          }
        }

        if (!node2) {
          var tailNode = addList.tail;

          while (tailNode) {
            var _node = tailNode;
            tailNode = tailNode.previous;

            if (_node) {
              var _parentId = this.mirror.getId(index.parentNode(_node.value));

              var _nextId = getNextId(_node.value);

              if (_nextId === -1) continue;else if (_parentId !== -1) {
                node2 = _node;
                break;
              } else {
                var unhandledNode = _node.value;
                var parent = index.parentNode(unhandledNode);

                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  var shadowHost = index.host(parent);
                  var parentId2 = this.mirror.getId(shadowHost);

                  if (parentId2 !== -1) {
                    node2 = _node;
                    break;
                  }
                }
              }
            }
          }
        }

        if (!node2) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }

          break;
        }

        candidate = node2.previous;
        addList.removeNode(node2.value);
        pushAdd(node2.value);
      }

      var payload = {
        texts: this.texts.map(text => {
          var n2 = text.node;
          var parent = index.parentNode(n2);

          if (parent && parent.tagName === "TEXTAREA") {
            this.genTextAreaValueMutation(parent);
          }

          return {
            id: this.mirror.getId(n2),
            value: text.value
          };
        }).filter(text => !addedIds.has(text.id)).filter(text => this.mirror.has(text.id)),
        attributes: this.attributes.map(attribute => {
          var {
            attributes
          } = attribute;

          if (typeof attributes.style === "string") {
            var diffAsStr = JSON.stringify(attribute.styleDiff);
            var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);

            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }

          return {
            id: this.mirror.getId(attribute.node),
            attributes
          };
        }).filter(attribute => !addedIds.has(attribute.id)).filter(attribute => this.mirror.has(attribute.id)),
        removes: this.removes,
        adds
      };

      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }

      this.texts = [];
      this.attributes = [];
      this.attributeMap = /* @__PURE__ */new WeakMap();
      this.removes = [];
      this.addedSet = /* @__PURE__ */new Set();
      this.movedSet = /* @__PURE__ */new Set();
      this.droppedSet = /* @__PURE__ */new Set();
      this.removesSubTreeCache = /* @__PURE__ */new Set();
      this.movedMap = {};
      this.mutationCb(payload);
    });

    __publicField(this, "genTextAreaValueMutation", textarea => {
      var item = this.attributeMap.get(textarea);

      if (!item) {
        item = {
          node: textarea,
          attributes: {},
          styleDiff: {},
          _unchangedStyles: {}
        };
        this.attributes.push(item);
        this.attributeMap.set(textarea, item);
      }

      var value = Array.from(index.childNodes(textarea), cn => index.textContent(cn) || "").join("");
      item.attributes.value = maskInputValue({
        element: textarea,
        maskInputOptions: this.maskInputOptions,
        tagName: textarea.tagName,
        type: getInputType(textarea),
        value,
        maskInputFn: this.maskInputFn
      });
    });

    __publicField(this, "processMutation", m => {
      if (isIgnored(m.target, this.mirror, this.slimDOMOptions)) {
        return;
      }

      switch (m.type) {
        case "characterData":
          {
            var value = index.textContent(m.target);

            if (!isBlocked(m.target, this.blockClass, this.blockSelector, false) && value !== m.oldValue) {
              this.texts.push({
                value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, true // checkAncestors
                ) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                node: m.target
              });
            }

            break;
          }

        case "attributes":
          {
            var target = m.target;
            var attributeName = m.attributeName;

            var _value3 = m.target.getAttribute(attributeName);

            if (attributeName === "value") {
              var type = getInputType(target);
              _value3 = maskInputValue({
                element: target,
                maskInputOptions: this.maskInputOptions,
                tagName: target.tagName,
                type,
                value: _value3,
                maskInputFn: this.maskInputFn
              });
            }

            if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || _value3 === m.oldValue) {
              return;
            }

            var item = this.attributeMap.get(m.target);

            if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(_value3)) {
              if (!target.contentDocument) {
                attributeName = "rr_src";
              } else {
                return;
              }
            }

            if (!item) {
              item = {
                node: m.target,
                attributes: {},
                styleDiff: {},
                _unchangedStyles: {}
              };
              this.attributes.push(item);
              this.attributeMap.set(m.target, item);
            }

            if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") {
              target.setAttribute("data-rr-is-password", "true");
            }

            if (!ignoreAttribute(target.tagName, attributeName)) {
              item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), _value3);

              if (attributeName === "style") {
                if (!this.unattachedDoc) {
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (e2) {
                    this.unattachedDoc = this.doc;
                  }
                }

                var old = this.unattachedDoc.createElement("span");

                if (m.oldValue) {
                  old.setAttribute("style", m.oldValue);
                }

                for (var pname of Array.from(target.style)) {
                  var newValue = target.style.getPropertyValue(pname);
                  var newPriority = target.style.getPropertyPriority(pname);

                  if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                    if (newPriority === "") {
                      item.styleDiff[pname] = newValue;
                    } else {
                      item.styleDiff[pname] = [newValue, newPriority];
                    }
                  } else {
                    item._unchangedStyles[pname] = [newValue, newPriority];
                  }
                }

                for (var _pname of Array.from(old.style)) {
                  if (target.style.getPropertyValue(_pname) === "") {
                    item.styleDiff[_pname] = false;
                  }
                }
              } else if (attributeName === "open" && target.tagName === "DIALOG") {
                if (target.matches("dialog:modal")) {
                  item.attributes["rr_open_mode"] = "modal";
                } else {
                  item.attributes["rr_open_mode"] = "non-modal";
                }
              }
            }

            break;
          }

        case "childList":
          {
            if (isBlocked(m.target, this.blockClass, this.blockSelector, true)) return;

            if (m.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(m.target);
              return;
            }

            m.addedNodes.forEach(n2 => this.genAdds(n2, m.target));
            m.removedNodes.forEach(n2 => {
              var nodeId = this.mirror.getId(n2);
              var parentId = isShadowRoot(m.target) ? this.mirror.getId(index.host(m.target)) : this.mirror.getId(m.target);

              if (isBlocked(m.target, this.blockClass, this.blockSelector, false) || isIgnored(n2, this.mirror, this.slimDOMOptions) || !isSerialized(n2, this.mirror)) {
                return;
              }

              if (this.addedSet.has(n2)) {
                deepDelete(this.addedSet, n2);
                this.droppedSet.add(n2);
              } else if (this.addedSet.has(m.target) && nodeId === -1) ;else if (isAncestorRemoved(m.target, this.mirror)) ;else if (this.movedSet.has(n2) && this.movedMap[moveKey(nodeId, parentId)]) {
                deepDelete(this.movedSet, n2);
              } else {
                this.removes.push({
                  parentId,
                  id: nodeId,
                  isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : void 0
                });
                processRemoves(n2, this.removesSubTreeCache);
              }

              this.mapRemoves.push(n2);
            });
            break;
          }
      }
    });
    /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */


    __publicField(this, "genAdds", (n2, target) => {
      if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
      if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;

      if (this.mirror.hasNode(n2)) {
        if (isIgnored(n2, this.mirror, this.slimDOMOptions)) {
          return;
        }

        this.movedSet.add(n2);
        var targetId = null;

        if (target && this.mirror.hasNode(target)) {
          targetId = this.mirror.getId(target);
        }

        if (targetId && targetId !== -1) {
          this.movedMap[moveKey(this.mirror.getId(n2), targetId)] = true;
        }
      } else {
        this.addedSet.add(n2);
        this.droppedSet.delete(n2);
      }

      if (!isBlocked(n2, this.blockClass, this.blockSelector, false)) {
        index.childNodes(n2).forEach(childN => this.genAdds(childN));

        if (hasShadowRoot(n2)) {
          index.childNodes(index.shadowRoot(n2)).forEach(childN => {
            this.processedNodeManager.add(childN, this);
            this.genAdds(childN, n2);
          });
        }
      }
    });
  }

  init(options) {
    ["mutationCb", "blockClass", "blockSelector", "maskTextClass", "maskTextSelector", "inlineStylesheet", "maskInputOptions", "maskTextFn", "maskInputFn", "keepIframeSrcFn", "recordCanvas", "inlineImages", "slimDOMOptions", "dataURLOptions", "doc", "mirror", "iframeManager", "stylesheetManager", "shadowDomManager", "canvasManager", "processedNodeManager"].forEach(key => {
      this[key] = options[key];
    });
  }

  freeze() {
    this.frozen = true;
    this.canvasManager.freeze();
  }

  unfreeze() {
    this.frozen = false;
    this.canvasManager.unfreeze();
    this.emit();
  }

  isFrozen() {
    return this.frozen;
  }

  lock() {
    this.locked = true;
    this.canvasManager.lock();
  }

  unlock() {
    this.locked = false;
    this.canvasManager.unlock();
    this.emit();
  }

  reset() {
    this.shadowDomManager.reset();
    this.canvasManager.reset();
  }

}

function deepDelete(addsSet, n2) {
  addsSet.delete(n2);
  index.childNodes(n2).forEach(childN => deepDelete(addsSet, childN));
}

function processRemoves(n2, cache) {
  var queue = [n2];

  while (queue.length) {
    var next = queue.pop();
    if (cache.has(next)) continue;
    cache.add(next);
    index.childNodes(next).forEach(n22 => queue.push(n22));
  }

  return;
}

function isParentRemoved(removes, n2, mirror2) {
  if (removes.size === 0) return false;
  return _isParentRemoved(removes, n2);
}

function _isParentRemoved(removes, n2, _mirror2) {
  var node2 = index.parentNode(n2);
  if (!node2) return false;
  return removes.has(node2);
}

function isAncestorInSet(set, n2) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n2);
}

function _isAncestorInSet(set, n2) {
  var parent = index.parentNode(n2);

  if (!parent) {
    return false;
  }

  if (set.has(parent)) {
    return true;
  }

  return _isAncestorInSet(set, parent);
}

var errorHandler;

function registerErrorHandler(handler) {
  errorHandler = handler;
}

function unregisterErrorHandler() {
  errorHandler = void 0;
}

var callbackWrapper = cb => {
  if (!errorHandler) {
    return cb;
  }

  var rrwebWrapped = function rrwebWrapped() {
    try {
      return cb(...arguments);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return;
      }

      throw error;
    }
  };

  return rrwebWrapped;
};

function externalFunctionWrapper(func) {
  return function () {
    try {
      return func(...arguments);
    } catch (error) {
      try {
        error._external_ = true;
      } catch (_unused4) {}

      throw error;
    }
  };
}

var mutationBuffers = [];

function getEventTarget(event) {
  try {
    if ("composedPath" in event) {
      var path = event.composedPath();

      if (path.length) {
        return path[0];
      }
    } else if ("path" in event && event.path.length) {
      return event.path[0];
    }
  } catch (_unused5) {}

  return event && event.target;
}

function initMutationObserver(options, rootEl) {
  var mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  var observer = new (mutationObserverCtor())(callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}

function initMoveObserver(_ref3) {
  var {
    mousemoveCb,
    sampling,
    doc,
    mirror: mirror2
  } = _ref3;

  if (sampling.mousemove === false) {
    return () => {};
  }

  var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
  var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
  var positions = [];
  var timeBaseline;
  var wrappedCb = throttle(callbackWrapper(source => {
    var totalOffset = Date.now() - timeBaseline;
    mousemoveCb(positions.map(p => {
      p.timeOffset -= totalOffset;
      return p;
    }), source);
    positions = [];
    timeBaseline = null;
  }), callbackThreshold);
  var updatePosition = callbackWrapper(throttle(callbackWrapper(evt => {
    var target = getEventTarget(evt);
    var {
      clientX,
      clientY
    } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;

    if (!timeBaseline) {
      timeBaseline = nowTimestamp();
    }

    positions.push({
      x: clientX,
      y: clientY,
      id: mirror2.getId(target),
      timeOffset: nowTimestamp() - timeBaseline
    });
    wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
  }), threshold, {
    trailing: false
  }));
  var handlers = [on("mousemove", updatePosition, doc), on("touchmove", updatePosition, doc), on("drag", updatePosition, doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}

function initMouseInteractionObserver(_ref4) {
  var {
    mouseInteractionCb,
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    sampling
  } = _ref4;

  if (sampling.mouseInteraction === false) {
    return () => {};
  }

  var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
  var handlers = [];
  var currentPointerType = null;

  var getHandler = eventKey => {
    return event => {
      var target = getEventTarget(event);

      if (isBlocked(target, blockClass, blockSelector, true)) {
        return;
      }

      var pointerType = null;
      var thisEventKey = eventKey;

      if ("pointerType" in event) {
        switch (event.pointerType) {
          case "mouse":
            pointerType = PointerTypes.Mouse;
            break;

          case "touch":
            pointerType = PointerTypes.Touch;
            break;

          case "pen":
            pointerType = PointerTypes.Pen;
            break;
        }

        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
            thisEventKey = "TouchStart";
          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
            thisEventKey = "TouchEnd";
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }

      if (pointerType !== null) {
        currentPointerType = pointerType;

        if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }

      var e2 = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;

      if (!e2) {
        return;
      }

      var id = mirror2.getId(target);
      var {
        clientX,
        clientY
      } = e2;
      callbackWrapper(mouseInteractionCb)(_objectSpread({
        type: MouseInteractions[thisEventKey],
        id,
        x: clientX,
        y: clientY
      }, pointerType !== null && {
        pointerType
      }));
    };
  };

  Object.keys(MouseInteractions).filter(key => Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach(eventKey => {
    var eventName = toLowerCase(eventKey);
    var handler = getHandler(eventKey);

    if (window.PointerEvent) {
      switch (MouseInteractions[eventKey]) {
        case MouseInteractions.MouseDown:
        case MouseInteractions.MouseUp:
          eventName = eventName.replace("mouse", "pointer");
          break;

        case MouseInteractions.TouchStart:
        case MouseInteractions.TouchEnd:
          return;
      }
    }

    handlers.push(on(eventName, handler, doc));
  });
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}

function initScrollObserver(_ref5) {
  var {
    scrollCb,
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    sampling
  } = _ref5;
  var updatePosition = callbackWrapper(throttle(callbackWrapper(evt => {
    var target = getEventTarget(evt);

    if (!target || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }

    var id = mirror2.getId(target);

    if (target === doc && doc.defaultView) {
      var scrollLeftTop = getWindowScroll(doc.defaultView);
      scrollCb({
        id,
        x: scrollLeftTop.left,
        y: scrollLeftTop.top
      });
    } else {
      scrollCb({
        id,
        x: target.scrollLeft,
        y: target.scrollTop
      });
    }
  }), sampling.scroll || 100));
  return on("scroll", updatePosition, doc);
}

function initViewportResizeObserver(_ref6, _ref7) {
  var {
    viewportResizeCb
  } = _ref6;
  var {
    win
  } = _ref7;
  var lastH = -1;
  var lastW = -1;
  var updateDimension = callbackWrapper(throttle(callbackWrapper(() => {
    var height = getWindowHeight();
    var width = getWindowWidth();

    if (lastH !== height || lastW !== width) {
      viewportResizeCb({
        width: Number(width),
        height: Number(height)
      });
      lastH = height;
      lastW = width;
    }
  }), 200));
  return on("resize", updateDimension, win);
}

var INPUT_TAGS = ["INPUT", "TEXTAREA", "SELECT"];
var lastInputValueMap = /* @__PURE__ */new WeakMap();

function initInputObserver(_ref8) {
  var {
    inputCb,
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    ignoreClass,
    ignoreSelector,
    maskInputOptions,
    maskInputFn,
    sampling,
    userTriggeredOnInput
  } = _ref8;

  function eventHandler(event) {
    var target = getEventTarget(event);
    var userTriggered = event.isTrusted;
    var tagName = target && target.tagName;

    if (target && tagName === "OPTION") {
      target = index.parentElement(target);
    }

    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }

    if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) {
      return;
    }

    var text = target.value;
    var isChecked = false;
    var type = getInputType(target) || "";

    if (type === "radio" || type === "checkbox") {
      isChecked = target.checked;
    } else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) {
      text = maskInputValue({
        element: target,
        maskInputOptions,
        tagName,
        type,
        value: text,
        maskInputFn
      });
    }

    cbWithDedup(target, userTriggeredOnInput ? {
      text,
      isChecked,
      userTriggered
    } : {
      text,
      isChecked
    });
    var name = target.name;

    if (type === "radio" && name && isChecked) {
      doc.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")).forEach(el => {
        if (el !== target) {
          var text2 = el.value;
          cbWithDedup(el, userTriggeredOnInput ? {
            text: text2,
            isChecked: !isChecked,
            userTriggered: false
          } : {
            text: text2,
            isChecked: !isChecked
          });
        }
      });
    }
  }

  function cbWithDedup(target, v2) {
    var lastInputValue = lastInputValueMap.get(target);

    if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
      lastInputValueMap.set(target, v2);
      var id = mirror2.getId(target);
      callbackWrapper(inputCb)(_objectSpread(_objectSpread({}, v2), {}, {
        id
      }));
    }
  }

  var events = sampling.input === "last" ? ["change"] : ["input", "change"];
  var handlers = events.map(eventName => on(eventName, callbackWrapper(eventHandler), doc));
  var currentWindow = doc.defaultView;

  if (!currentWindow) {
    return () => {
      handlers.forEach(h => h());
    };
  }

  var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
  var hookProperties = [[currentWindow.HTMLInputElement.prototype, "value"], [currentWindow.HTMLInputElement.prototype, "checked"], [currentWindow.HTMLSelectElement.prototype, "value"], [currentWindow.HTMLTextAreaElement.prototype, "value"], // Some UI library use selectedIndex to set select value
  [currentWindow.HTMLSelectElement.prototype, "selectedIndex"], [currentWindow.HTMLOptionElement.prototype, "selected"]];

  if (propertyDescriptor && propertyDescriptor.set) {
    handlers.push(...hookProperties.map(p => hookSetter(p[0], p[1], {
      set() {
        callbackWrapper(eventHandler)({
          target: this,
          isTrusted: false // userTriggered to false as this could well be programmatic

        });
      }

    }, false, currentWindow)));
  }

  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}

function getNestedCSSRulePositions(rule2) {
  var positions = [];

  function recurse(childRule, pos) {
    if (hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
      var rules2 = Array.from(childRule.parentRule.cssRules);
      var index2 = rules2.indexOf(childRule);
      pos.unshift(index2);
    } else if (childRule.parentStyleSheet) {
      var _rules = Array.from(childRule.parentStyleSheet.cssRules);

      var _index = _rules.indexOf(childRule);

      pos.unshift(_index);
    }

    return pos;
  }

  return recurse(rule2, positions);
}

function getIdAndStyleId(sheet, mirror2, styleMirror) {
  var id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);else styleId = styleMirror.getId(sheet);
  return {
    styleId,
    id
  };
}

function initStyleSheetObserver(_ref9, _ref10) {
  var {
    styleSheetRuleCb,
    mirror: mirror2,
    stylesheetManager
  } = _ref9;
  var {
    win
  } = _ref10;

  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return () => {};
  }

  var insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var [rule2, index2] = argumentsList;
      var {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          adds: [{
            rule: rule2,
            index: index2
          }]
        });
      }

      return externalFunctionWrapper(() => target.apply(thisArg, argumentsList))();
    })
  });

  win.CSSStyleSheet.prototype.addRule = function (selector, styleBlock) {
    var index2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.cssRules.length;
    var rule2 = "".concat(selector, " { ").concat(styleBlock, " }");
    return win.CSSStyleSheet.prototype.insertRule.apply(this, [rule2, index2]);
  };

  var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var [index2] = argumentsList;
      var {
        id,
        styleId
      } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleSheetRuleCb({
          id,
          styleId,
          removes: [{
            index: index2
          }]
        });
      }

      return externalFunctionWrapper(() => target.apply(thisArg, argumentsList))();
    })
  });

  win.CSSStyleSheet.prototype.removeRule = function (index2) {
    return win.CSSStyleSheet.prototype.deleteRule.apply(this, [index2]);
  };

  var replace;

  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        var [text] = argumentsList;
        var {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replace: text
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  }

  var replaceSync;

  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        var [text] = argumentsList;
        var {
          id,
          styleId
        } = getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror);

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            replaceSync: text
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  }

  var supportedNestedCSSRuleTypes = {};

  if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }

    if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }

    if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }

  var unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(_ref11 => {
    var [typeKey, type] = _ref11;
    unmodifiedFunctions[typeKey] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: type.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        var [rule2, index2] = argumentsList;
        var {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            adds: [{
              rule: rule2,
              index: [...getNestedCSSRulePositions(thisArg), index2 || 0 // defaults to 0
              ]
            }]
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
    type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
      apply: callbackWrapper((target, thisArg, argumentsList) => {
        var [index2] = argumentsList;
        var {
          id,
          styleId
        } = getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror);

        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            removes: [{
              index: [...getNestedCSSRulePositions(thisArg), index2]
            }]
          });
        }

        return target.apply(thisArg, argumentsList);
      })
    });
  });
  return callbackWrapper(() => {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(_ref12 => {
      var [typeKey, type] = _ref12;
      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}

function initAdoptedStyleSheetObserver(_ref13, host2) {
  var {
    mirror: mirror2,
    stylesheetManager
  } = _ref13;

  var _a2, _b, _c;

  var hostId = null;
  if (host2.nodeName === "#document") hostId = mirror2.getId(host2);else hostId = mirror2.getId(index.host(host2));
  var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
  var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return () => {};
  Object.defineProperty(host2, "adoptedStyleSheets", {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,

    get() {
      var _a3;

      return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
    },

    set(sheets) {
      var _a3;

      var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);

      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e2) {}
      }

      return result2;
    }

  });
  return callbackWrapper(() => {
    Object.defineProperty(host2, "adoptedStyleSheets", {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: originalPropertyDescriptor.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: originalPropertyDescriptor.set
    });
  });
}

function initStyleDeclarationObserver(_ref14, _ref15) {
  var {
    styleDeclarationCb,
    mirror: mirror2,
    ignoreCSSAttributes,
    stylesheetManager
  } = _ref14;
  var {
    win
  } = _ref15;
  var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var _a2;

      var [property, value, priority] = argumentsList;

      if (ignoreCSSAttributes.has(property)) {
        return setProperty.apply(thisArg, [property, value, priority]);
      }

      var {
        id,
        styleId
      } = getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          set: {
            property,
            value,
            priority
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }

      return target.apply(thisArg, argumentsList);
    })
  });
  var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper((target, thisArg, argumentsList) => {
      var _a2;

      var [property] = argumentsList;

      if (ignoreCSSAttributes.has(property)) {
        return removeProperty.apply(thisArg, [property]);
      }

      var {
        id,
        styleId
      } = getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror);

      if (id && id !== -1 || styleId && styleId !== -1) {
        styleDeclarationCb({
          id,
          styleId,
          remove: {
            property
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: getNestedCSSRulePositions(thisArg.parentRule)
        });
      }

      return target.apply(thisArg, argumentsList);
    })
  });
  return callbackWrapper(() => {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}

function initMediaInteractionObserver(_ref16) {
  var {
    mediaInteractionCb,
    blockClass,
    blockSelector,
    mirror: mirror2,
    sampling,
    doc
  } = _ref16;
  var handler = callbackWrapper(type => throttle(callbackWrapper(event => {
    var target = getEventTarget(event);

    if (!target || isBlocked(target, blockClass, blockSelector, true)) {
      return;
    }

    var {
      currentTime,
      volume,
      muted,
      playbackRate,
      loop
    } = target;
    mediaInteractionCb({
      type,
      id: mirror2.getId(target),
      currentTime,
      volume,
      muted,
      playbackRate,
      loop
    });
  }), sampling.media || 500));
  var handlers = [on("play", handler(MediaInteractions.Play), doc), on("pause", handler(MediaInteractions.Pause), doc), on("seeked", handler(MediaInteractions.Seeked), doc), on("volumechange", handler(MediaInteractions.VolumeChange), doc), on("ratechange", handler(MediaInteractions.RateChange), doc)];
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}

function initFontObserver(_ref17) {
  var {
    fontCb,
    doc
  } = _ref17;
  var win = doc.defaultView;

  if (!win) {
    return () => {};
  }

  var handlers = [];
  var fontMap = /* @__PURE__ */new WeakMap();
  var originalFontFace = win.FontFace;

  win.FontFace = function FontFace2(family, source, descriptors) {
    var fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family,
      buffer: typeof source !== "string",
      descriptors,
      fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };

  var restoreHandler = patch(doc.fonts, "add", function (original) {
    return function (fontFace) {
      setTimeout(callbackWrapper(() => {
        var p = fontMap.get(fontFace);

        if (p) {
          fontCb(p);
          fontMap.delete(fontFace);
        }
      }), 0);
      return original.apply(this, [fontFace]);
    };
  });
  handlers.push(() => {
    win.FontFace = originalFontFace;
  });
  handlers.push(restoreHandler);
  return callbackWrapper(() => {
    handlers.forEach(h => h());
  });
}

function initSelectionObserver(param) {
  var {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    selectionCb
  } = param;
  var collapsed = true;
  var updateSelection = callbackWrapper(() => {
    var selection = doc.getSelection();
    if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
    collapsed = selection.isCollapsed || false;
    var ranges = [];
    var count = selection.rangeCount || 0;

    for (var i2 = 0; i2 < count; i2++) {
      var range = selection.getRangeAt(i2);
      var {
        startContainer,
        startOffset,
        endContainer,
        endOffset
      } = range;
      var blocked = isBlocked(startContainer, blockClass, blockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, true);
      if (blocked) continue;
      ranges.push({
        start: mirror2.getId(startContainer),
        startOffset,
        end: mirror2.getId(endContainer),
        endOffset
      });
    }

    selectionCb({
      ranges
    });
  });
  updateSelection();
  return on("selectionchange", updateSelection);
}

function initCustomElementObserver(_ref18) {
  var {
    doc,
    customElementCb
  } = _ref18;
  var win = doc.defaultView;
  if (!win || !win.customElements) return () => {};
  var restoreHandler = patch(win.customElements, "define", function (original) {
    return function (name, constructor, options) {
      try {
        customElementCb({
          define: {
            name
          }
        });
      } catch (e2) {
        console.warn("Custom element callback failed for ".concat(name));
      }

      return original.apply(this, [name, constructor, options]);
    };
  });
  return restoreHandler;
}

function mergeHooks(o2, hooks) {
  var {
    mutationCb,
    mousemoveCb,
    mouseInteractionCb,
    scrollCb,
    viewportResizeCb,
    inputCb,
    mediaInteractionCb,
    styleSheetRuleCb,
    styleDeclarationCb,
    canvasMutationCb,
    fontCb,
    selectionCb,
    customElementCb
  } = o2;

  o2.mutationCb = function () {
    if (hooks.mutation) {
      hooks.mutation(...arguments);
    }

    mutationCb(...arguments);
  };

  o2.mousemoveCb = function () {
    if (hooks.mousemove) {
      hooks.mousemove(...arguments);
    }

    mousemoveCb(...arguments);
  };

  o2.mouseInteractionCb = function () {
    if (hooks.mouseInteraction) {
      hooks.mouseInteraction(...arguments);
    }

    mouseInteractionCb(...arguments);
  };

  o2.scrollCb = function () {
    if (hooks.scroll) {
      hooks.scroll(...arguments);
    }

    scrollCb(...arguments);
  };

  o2.viewportResizeCb = function () {
    if (hooks.viewportResize) {
      hooks.viewportResize(...arguments);
    }

    viewportResizeCb(...arguments);
  };

  o2.inputCb = function () {
    if (hooks.input) {
      hooks.input(...arguments);
    }

    inputCb(...arguments);
  };

  o2.mediaInteractionCb = function () {
    if (hooks.mediaInteaction) {
      hooks.mediaInteaction(...arguments);
    }

    mediaInteractionCb(...arguments);
  };

  o2.styleSheetRuleCb = function () {
    if (hooks.styleSheetRule) {
      hooks.styleSheetRule(...arguments);
    }

    styleSheetRuleCb(...arguments);
  };

  o2.styleDeclarationCb = function () {
    if (hooks.styleDeclaration) {
      hooks.styleDeclaration(...arguments);
    }

    styleDeclarationCb(...arguments);
  };

  o2.canvasMutationCb = function () {
    if (hooks.canvasMutation) {
      hooks.canvasMutation(...arguments);
    }

    canvasMutationCb(...arguments);
  };

  o2.fontCb = function () {
    if (hooks.font) {
      hooks.font(...arguments);
    }

    fontCb(...arguments);
  };

  o2.selectionCb = function () {
    if (hooks.selection) {
      hooks.selection(...arguments);
    }

    selectionCb(...arguments);
  };

  o2.customElementCb = function () {
    if (hooks.customElement) {
      hooks.customElement(...arguments);
    }

    customElementCb(...arguments);
  };
}

function initObservers(o2) {
  var hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentWindow = o2.doc.defaultView;

  if (!currentWindow) {
    return () => {};
  }

  mergeHooks(o2, hooks);
  var mutationObserver;

  if (o2.recordDOM) {
    mutationObserver = initMutationObserver(o2, o2.doc);
  }

  var mousemoveHandler = initMoveObserver(o2);
  var mouseInteractionHandler = initMouseInteractionObserver(o2);
  var scrollHandler = initScrollObserver(o2);
  var viewportResizeHandler = initViewportResizeObserver(o2, {
    win: currentWindow
  });
  var inputHandler = initInputObserver(o2);
  var mediaInteractionHandler = initMediaInteractionObserver(o2);

  var styleSheetObserver = () => {};

  var adoptedStyleSheetObserver = () => {};

  var styleDeclarationObserver = () => {};

  var fontObserver = () => {};

  if (o2.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o2, {
      win: currentWindow
    });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o2, o2.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o2, {
      win: currentWindow
    });

    if (o2.collectFonts) {
      fontObserver = initFontObserver(o2);
    }
  }

  var selectionObserver = initSelectionObserver(o2);
  var customElementObserver = initCustomElementObserver(o2);
  var pluginHandlers = [];

  for (var plugin3 of o2.plugins) {
    pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
  }

  return callbackWrapper(() => {
    mutationBuffers.forEach(b => b.reset());
    mutationObserver == null ? void 0 : mutationObserver.disconnect();
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    customElementObserver();
    pluginHandlers.forEach(h => h());
  });
}

function hasNestedCSSRule(prop) {
  return typeof window[prop] !== "undefined";
}

function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}

class CrossOriginIframeMirror {
  constructor(generateIdFn) {
    __publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */new WeakMap());

    this.generateIdFn = generateIdFn;
  }

  getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
    var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
    var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
    var id = idToRemoteIdMap.get(remoteId);

    if (!id) {
      id = this.generateIdFn();
      idToRemoteIdMap.set(remoteId, id);
      remoteIdToIdMap.set(id, remoteId);
    }

    return id;
  }

  getIds(iframe, remoteId) {
    var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
    var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return remoteId.map(id => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
  }

  getRemoteId(iframe, id, map) {
    var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
    if (typeof id !== "number") return id;
    var remoteId = remoteIdToIdMap.get(id);
    if (!remoteId) return -1;
    return remoteId;
  }

  getRemoteIds(iframe, ids) {
    var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return ids.map(id => this.getRemoteId(iframe, id, remoteIdToIdMap));
  }

  reset(iframe) {
    if (!iframe) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */new WeakMap();
      this.iframeRemoteIdToIdMap = /* @__PURE__ */new WeakMap();
      return;
    }

    this.iframeIdToRemoteIdMap.delete(iframe);
    this.iframeRemoteIdToIdMap.delete(iframe);
  }

  getIdToRemoteIdMap(iframe) {
    var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);

    if (!idToRemoteIdMap) {
      idToRemoteIdMap = /* @__PURE__ */new Map();
      this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
    }

    return idToRemoteIdMap;
  }

  getRemoteIdToIdMap(iframe) {
    var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);

    if (!remoteIdToIdMap) {
      remoteIdToIdMap = /* @__PURE__ */new Map();
      this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
    }

    return remoteIdToIdMap;
  }

}

class IframeManager {
  constructor(options) {
    __publicField(this, "iframes", /* @__PURE__ */new WeakMap());

    __publicField(this, "crossOriginIframeMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "crossOriginIframeMirror", new CrossOriginIframeMirror(genId));

    __publicField(this, "crossOriginIframeStyleMirror");

    __publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "mirror");

    __publicField(this, "mutationCb");

    __publicField(this, "wrappedEmit");

    __publicField(this, "loadListener");

    __publicField(this, "stylesheetManager");

    __publicField(this, "recordCrossOriginIframes");

    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
    this.mirror = options.mirror;

    if (this.recordCrossOriginIframes) {
      window.addEventListener("message", this.handleMessage.bind(this));
    }
  }

  addIframe(iframeEl) {
    this.iframes.set(iframeEl, true);
    if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
  }

  addLoadListener(cb) {
    this.loadListener = cb;
  }

  attachIframe(iframeEl, childSn) {
    var _a2, _b;

    this.mutationCb({
      adds: [{
        parentId: this.mirror.getId(iframeEl),
        nextId: null,
        node: childSn
      }],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: true
    });
    if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null ? void 0 : _a2.addEventListener("message", this.handleMessage.bind(this));
    (_b = this.loadListener) == null ? void 0 : _b.call(this, iframeEl);
    if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
  }

  handleMessage(message) {
    var crossOriginMessageEvent = message;
    if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
    var iframeSourceWindow = message.source;
    if (!iframeSourceWindow) return;
    var iframeEl = this.crossOriginIframeMap.get(message.source);
    if (!iframeEl) return;
    var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
    if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
  }

  transformCrossOriginEvent(iframeEl, e2) {
    var _a2;

    switch (e2.type) {
      case EventType.FullSnapshot:
        {
          this.crossOriginIframeMirror.reset(iframeEl);
          this.crossOriginIframeStyleMirror.reset(iframeEl);
          this.replaceIdOnNode(e2.data.node, iframeEl);
          var rootId = e2.data.node.id;
          this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
          this.patchRootIdOnNode(e2.data.node, rootId);
          return {
            timestamp: e2.timestamp,
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Mutation,
              adds: [{
                parentId: this.mirror.getId(iframeEl),
                nextId: null,
                node: e2.data.node
              }],
              removes: [],
              texts: [],
              attributes: [],
              isAttachIframe: true
            }
          };
        }

      case EventType.Meta:
      case EventType.Load:
      case EventType.DomContentLoaded:
        {
          return false;
        }

      case EventType.Plugin:
        {
          return e2;
        }

      case EventType.Custom:
        {
          this.replaceIds(e2.data.payload, iframeEl, ["id", "parentId", "previousId", "nextId"]);
          return e2;
        }

      case EventType.IncrementalSnapshot:
        {
          switch (e2.data.source) {
            case IncrementalSource.Mutation:
              {
                e2.data.adds.forEach(n2 => {
                  this.replaceIds(n2, iframeEl, ["parentId", "nextId", "previousId"]);
                  this.replaceIdOnNode(n2.node, iframeEl);
                  var rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                  rootId && this.patchRootIdOnNode(n2.node, rootId);
                });
                e2.data.removes.forEach(n2 => {
                  this.replaceIds(n2, iframeEl, ["parentId", "id"]);
                });
                e2.data.attributes.forEach(n2 => {
                  this.replaceIds(n2, iframeEl, ["id"]);
                });
                e2.data.texts.forEach(n2 => {
                  this.replaceIds(n2, iframeEl, ["id"]);
                });
                return e2;
              }

            case IncrementalSource.Drag:
            case IncrementalSource.TouchMove:
            case IncrementalSource.MouseMove:
              {
                e2.data.positions.forEach(p => {
                  this.replaceIds(p, iframeEl, ["id"]);
                });
                return e2;
              }

            case IncrementalSource.ViewportResize:
              {
                return false;
              }

            case IncrementalSource.MediaInteraction:
            case IncrementalSource.MouseInteraction:
            case IncrementalSource.Scroll:
            case IncrementalSource.CanvasMutation:
            case IncrementalSource.Input:
              {
                this.replaceIds(e2.data, iframeEl, ["id"]);
                return e2;
              }

            case IncrementalSource.StyleSheetRule:
            case IncrementalSource.StyleDeclaration:
              {
                this.replaceIds(e2.data, iframeEl, ["id"]);
                this.replaceStyleIds(e2.data, iframeEl, ["styleId"]);
                return e2;
              }

            case IncrementalSource.Font:
              {
                return e2;
              }

            case IncrementalSource.Selection:
              {
                e2.data.ranges.forEach(range => {
                  this.replaceIds(range, iframeEl, ["start", "end"]);
                });
                return e2;
              }

            case IncrementalSource.AdoptedStyleSheet:
              {
                this.replaceIds(e2.data, iframeEl, ["id"]);
                this.replaceStyleIds(e2.data, iframeEl, ["styleIds"]);
                (_a2 = e2.data.styles) == null ? void 0 : _a2.forEach(style => {
                  this.replaceStyleIds(style, iframeEl, ["styleId"]);
                });
                return e2;
              }
          }
        }
    }

    return false;
  }

  replace(iframeMirror, obj, iframeEl, keys) {
    for (var key of keys) {
      if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;

      if (Array.isArray(obj[key])) {
        obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
      } else {
        obj[key] = iframeMirror.getId(iframeEl, obj[key]);
      }
    }

    return obj;
  }

  replaceIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
  }

  replaceStyleIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
  }

  replaceIdOnNode(node2, iframeEl) {
    this.replaceIds(node2, iframeEl, ["id", "rootId"]);

    if ("childNodes" in node2) {
      node2.childNodes.forEach(child => {
        this.replaceIdOnNode(child, iframeEl);
      });
    }
  }

  patchRootIdOnNode(node2, rootId) {
    if (node2.type !== NodeType.Document && !node2.rootId) node2.rootId = rootId;

    if ("childNodes" in node2) {
      node2.childNodes.forEach(child => {
        this.patchRootIdOnNode(child, rootId);
      });
    }
  }

}

class ShadowDomManager {
  constructor(options) {
    __publicField(this, "shadowDoms", /* @__PURE__ */new WeakSet());

    __publicField(this, "mutationCb");

    __publicField(this, "scrollCb");

    __publicField(this, "bypassOptions");

    __publicField(this, "mirror");

    __publicField(this, "restoreHandlers", []);

    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }

  init() {
    this.reset();
    this.patchAttachShadow(Element, document);
  }

  addShadowRoot(shadowRoot2, doc) {
    if (!isNativeShadowDom(shadowRoot2)) return;
    if (this.shadowDoms.has(shadowRoot2)) return;
    this.shadowDoms.add(shadowRoot2);
    var observer = initMutationObserver(_objectSpread(_objectSpread({}, this.bypassOptions), {}, {
      doc,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }), shadowRoot2);
    this.restoreHandlers.push(() => observer.disconnect());
    this.restoreHandlers.push(initScrollObserver(_objectSpread(_objectSpread({}, this.bypassOptions), {}, {
      scrollCb: this.scrollCb,
      // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
      // scroll is not allowed to pass the boundary, so we need to listen the shadow document
      doc: shadowRoot2,
      mirror: this.mirror
    })));
    setTimeout(() => {
      if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, this.mirror.getId(index.host(shadowRoot2)));
      this.restoreHandlers.push(initAdoptedStyleSheetObserver({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, shadowRoot2));
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */


  observeAttachShadow(iframeElement) {
    if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
    this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */


  patchAttachShadow(element, doc) {
    var manager = this;
    this.restoreHandlers.push(patch(element.prototype, "attachShadow", function (original) {
      return function (option) {
        var sRoot = original.call(this, option);
        var shadowRootEl = index.shadowRoot(this);
        if (shadowRootEl && inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
        return sRoot;
      };
    }));
  }

  reset() {
    this.restoreHandlers.forEach(handler => {
      try {
        handler();
      } catch (e2) {}
    });
    this.restoreHandlers = [];
    this.shadowDoms = /* @__PURE__ */new WeakSet();
  }

}

var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);

for (var i$1 = 0; i$1 < chars.length; i$1++) {
  lookup[chars.charCodeAt(i$1)] = i$1;
}

var encode = function encode(arraybuffer) {
  var bytes = new Uint8Array(arraybuffer),
      i2,
      len = bytes.length,
      base64 = "";

  for (i2 = 0; i2 < len; i2 += 3) {
    base64 += chars[bytes[i2] >> 2];
    base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
    base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
    base64 += chars[bytes[i2 + 2] & 63];
  }

  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + "=";
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + "==";
  }

  return base64;
};

var decode = function decode(base64) {
  var bufferLength = base64.length * 0.75,
      len = base64.length,
      i2,
      p = 0,
      encoded1,
      encoded2,
      encoded3,
      encoded4;

  if (base64[base64.length - 1] === "=") {
    bufferLength--;

    if (base64[base64.length - 2] === "=") {
      bufferLength--;
    }
  }

  var arraybuffer = new ArrayBuffer(bufferLength),
      bytes = new Uint8Array(arraybuffer);

  for (i2 = 0; i2 < len; i2 += 4) {
    encoded1 = lookup[base64.charCodeAt(i2)];
    encoded2 = lookup[base64.charCodeAt(i2 + 1)];
    encoded3 = lookup[base64.charCodeAt(i2 + 2)];
    encoded4 = lookup[base64.charCodeAt(i2 + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }

  return arraybuffer;
};

var canvasVarMap = /* @__PURE__ */new Map();

function variableListFor$1(ctx, ctor) {
  var contextMap = canvasVarMap.get(ctx);

  if (!contextMap) {
    contextMap = /* @__PURE__ */new Map();
    canvasVarMap.set(ctx, contextMap);
  }

  if (!contextMap.has(ctor)) {
    contextMap.set(ctor, []);
  }

  return contextMap.get(ctor);
}

var saveWebGLVar = (value, win, ctx) => {
  if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
  var name = value.constructor.name;
  var list2 = variableListFor$1(ctx, name);
  var index2 = list2.indexOf(value);

  if (index2 === -1) {
    index2 = list2.length;
    list2.push(value);
  }

  return index2;
};

function serializeArg(value, win, ctx) {
  if (value instanceof Array) {
    return value.map(arg => serializeArg(arg, win, ctx));
  } else if (value === null) {
    return value;
  } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
    var name = value.constructor.name;
    return {
      rr_type: name,
      args: [Object.values(value)]
    };
  } else if ( // SharedArrayBuffer disabled on most browsers due to spectre.
  // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
  // value instanceof SharedArrayBuffer ||
  value instanceof ArrayBuffer) {
    var _name3 = value.constructor.name;
    var base64 = encode(value);
    return {
      rr_type: _name3,
      base64
    };
  } else if (value instanceof DataView) {
    var _name4 = value.constructor.name;
    return {
      rr_type: _name4,
      args: [serializeArg(value.buffer, win, ctx), value.byteOffset, value.byteLength]
    };
  } else if (value instanceof HTMLImageElement) {
    var _name5 = value.constructor.name;
    var {
      src
    } = value;
    return {
      rr_type: _name5,
      src
    };
  } else if (value instanceof HTMLCanvasElement) {
    var _name6 = "HTMLImageElement";

    var _src = value.toDataURL();

    return {
      rr_type: _name6,
      src: _src
    };
  } else if (value instanceof ImageData) {
    var _name7 = value.constructor.name;
    return {
      rr_type: _name7,
      args: [serializeArg(value.data, win, ctx), value.width, value.height]
    };
  } else if (isInstanceOfWebGLObject(value, win) || typeof value === "object") {
    var _name8 = value.constructor.name;
    var index2 = saveWebGLVar(value, win, ctx);
    return {
      rr_type: _name8,
      index: index2
    };
  }

  return value;
}

var serializeArgs = (args, win, ctx) => {
  return args.map(arg => serializeArg(arg, win, ctx));
};

var isInstanceOfWebGLObject = (value, win) => {
  var webGLConstructorNames = ["WebGLActiveInfo", "WebGLBuffer", "WebGLFramebuffer", "WebGLProgram", "WebGLRenderbuffer", "WebGLShader", "WebGLShaderPrecisionFormat", "WebGLTexture", "WebGLUniformLocation", "WebGLVertexArrayObject", // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"];
  var supportedWebGLConstructorNames = webGLConstructorNames.filter(name => typeof win[name] === "function");
  return Boolean(supportedWebGLConstructorNames.find(name => value instanceof win[name]));
};

function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
  var handlers = [];
  var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);

  var _loop3 = function _loop3(prop) {
    try {
      if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") {
        return "continue";
      }

      var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
        return function () {
          for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            args[_key17] = arguments[_key17];
          }

          if (!isBlocked(this.canvas, blockClass, blockSelector, true)) {
            setTimeout(() => {
              var recordArgs = serializeArgs(args, win, this);
              cb(this.canvas, {
                type: CanvasContext["2D"],
                property: prop,
                args: recordArgs
              });
            }, 0);
          }

          return original.apply(this, args);
        };
      });
      handlers.push(restoreHandler);
    } catch (_unused6) {
      var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
        set(v2) {
          cb(this.canvas, {
            type: CanvasContext["2D"],
            property: prop,
            args: [v2],
            setter: true
          });
        }

      });
      handlers.push(hookHandler);
    }
  };

  for (var prop of props2D) {
    var _ret2 = _loop3(prop);

    if (_ret2 === "continue") continue;
  }

  return () => {
    handlers.forEach(h => h());
  };
}

function getNormalizedContextName(contextType) {
  return contextType === "experimental-webgl" ? "webgl" : contextType;
}

function initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
  var handlers = [];

  try {
    var restoreHandler = patch(win.HTMLCanvasElement.prototype, "getContext", function (original) {
      return function (contextType) {
        for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
          args[_key18 - 1] = arguments[_key18];
        }

        if (!isBlocked(this, blockClass, blockSelector, true)) {
          var ctxName = getNormalizedContextName(contextType);
          if (!("__context" in this)) this.__context = ctxName;

          if (setPreserveDrawingBufferToTrue && ["webgl", "webgl2"].includes(ctxName)) {
            if (args[0] && typeof args[0] === "object") {
              var contextAttributes = args[0];

              if (!contextAttributes.preserveDrawingBuffer) {
                contextAttributes.preserveDrawingBuffer = true;
              }
            } else {
              args.splice(0, 1, {
                preserveDrawingBuffer: true
              });
            }
          }
        }

        return original.apply(this, [contextType, ...args]);
      };
    });
    handlers.push(restoreHandler);
  } catch (_unused7) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }

  return () => {
    handlers.forEach(h => h());
  };
}

function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
  var handlers = [];
  var props = Object.getOwnPropertyNames(prototype);

  var _loop4 = function _loop4(prop) {
    if ( //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
    ["isContextLost", "canvas", "drawingBufferWidth", "drawingBufferHeight"].includes(prop)) {
      return "continue";
    }

    try {
      if (typeof prototype[prop] !== "function") {
        return "continue";
      }

      var restoreHandler = patch(prototype, prop, function (original) {
        return function () {
          for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
            args[_key19] = arguments[_key19];
          }

          var result2 = original.apply(this, args);
          saveWebGLVar(result2, win, this);

          if ("tagName" in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, true)) {
            var recordArgs = serializeArgs(args, win, this);
            var mutation = {
              type,
              property: prop,
              args: recordArgs
            };
            cb(this.canvas, mutation);
          }

          return result2;
        };
      });
      handlers.push(restoreHandler);
    } catch (_unused8) {
      var hookHandler = hookSetter(prototype, prop, {
        set(v2) {
          cb(this.canvas, {
            type,
            property: prop,
            args: [v2],
            setter: true
          });
        }

      });
      handlers.push(hookHandler);
    }
  };

  for (var prop of props) {
    var _ret3 = _loop4(prop);

    if (_ret3 === "continue") continue;
  }

  return handlers;
}

function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
  var handlers = [];
  handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, win));

  if (typeof win.WebGL2RenderingContext !== "undefined") {
    handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, win));
  }

  return () => {
    handlers.forEach(h => h());
  };
}

var encodedJs = "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";

var decodeBase64 = base64 => Uint8Array.from(atob(base64), c2 => c2.charCodeAt(0));

var blob = typeof window !== "undefined" && window.Blob && new Blob([decodeBase64(encodedJs)], {
  type: "text/javascript;charset=utf-8"
});

function WorkerWrapper(options) {
  var objURL;

  try {
    objURL = blob && (window.URL || window.webkitURL).createObjectURL(blob);
    if (!objURL) throw "";
    var worker = new Worker(objURL, {
      name: options == null ? void 0 : options.name
    });
    worker.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(objURL);
    });
    return worker;
  } catch (e2) {
    return new Worker("data:text/javascript;base64," + encodedJs, {
      name: options == null ? void 0 : options.name
    });
  } finally {
    objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
  }
}

class CanvasManager {
  constructor(options) {
    __publicField(this, "pendingCanvasMutations", /* @__PURE__ */new Map());

    __publicField(this, "rafStamps", {
      latestId: 0,
      invokeId: null
    });

    __publicField(this, "mirror");

    __publicField(this, "mutationCb");

    __publicField(this, "resetObservers");

    __publicField(this, "frozen", false);

    __publicField(this, "locked", false);

    __publicField(this, "processMutation", (target, mutation) => {
      var newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
      if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;

      if (!this.pendingCanvasMutations.has(target)) {
        this.pendingCanvasMutations.set(target, []);
      }

      this.pendingCanvasMutations.get(target).push(mutation);
    });

    var {
      sampling = "all",
      win,
      blockClass,
      blockSelector,
      recordCanvas,
      dataURLOptions
    } = options;
    this.mutationCb = options.mutationCb;
    this.mirror = options.mirror;
    if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
    if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
      dataURLOptions
    });
  }

  reset() {
    this.pendingCanvasMutations.clear();
    this.resetObservers && this.resetObservers();
  }

  freeze() {
    this.frozen = true;
  }

  unfreeze() {
    this.frozen = false;
  }

  lock() {
    this.locked = true;
  }

  unlock() {
    this.locked = false;
  }

  initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
    var _this4 = this;

    var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, true);
    var snapshotInProgressMap = /* @__PURE__ */new Map();
    var worker = new WorkerWrapper();

    worker.onmessage = e2 => {
      var {
        id
      } = e2.data;
      snapshotInProgressMap.set(id, false);
      if (!("base64" in e2.data)) return;
      var {
        base64,
        type,
        width,
        height
      } = e2.data;
      this.mutationCb({
        id,
        type: CanvasContext["2D"],
        commands: [{
          property: "clearRect",
          // wipe canvas
          args: [0, 0, width, height]
        }, {
          property: "drawImage",
          // draws (semi-transparent) image
          args: [{
            rr_type: "ImageBitmap",
            args: [{
              rr_type: "Blob",
              data: [{
                rr_type: "ArrayBuffer",
                base64
              }],
              type
            }]
          }, 0, 0]
        }]
      });
    };

    var timeBetweenSnapshots = 1e3 / fps;
    var lastSnapshotTime = 0;
    var rafId;

    var getCanvas = () => {
      var matchedCanvas = [];
      win.document.querySelectorAll("canvas").forEach(canvas => {
        if (!isBlocked(canvas, blockClass, blockSelector, true)) {
          matchedCanvas.push(canvas);
        }
      });
      return matchedCanvas;
    };

    var takeCanvasSnapshots = timestamp => {
      if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        return;
      }

      lastSnapshotTime = timestamp;
      getCanvas().forEach( /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator(function* (canvas) {
          var _a2;

          var id = _this4.mirror.getId(canvas);

          if (snapshotInProgressMap.get(id)) return;
          if (canvas.width === 0 || canvas.height === 0) return;
          snapshotInProgressMap.set(id, true);

          if (["webgl", "webgl2"].includes(canvas.__context)) {
            var context = canvas.getContext(canvas.__context);

            if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) {
              context.clear(context.COLOR_BUFFER_BIT);
            }
          }

          var bitmap = yield createImageBitmap(canvas);
          worker.postMessage({
            id,
            bitmap,
            width: canvas.width,
            height: canvas.height,
            dataURLOptions: options.dataURLOptions
          }, [bitmap]);
        });

        return function (_x2) {
          return _ref19.apply(this, arguments);
        };
      }());
      rafId = requestAnimationFrame(takeCanvasSnapshots);
    };

    rafId = requestAnimationFrame(takeCanvasSnapshots);

    this.resetObservers = () => {
      canvasContextReset();
      cancelAnimationFrame(rafId);
    };
  }

  initCanvasMutationObserver(win, blockClass, blockSelector) {
    this.startRAFTimestamping();
    this.startPendingCanvasMutationFlusher();
    var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, false);
    var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
    var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);

    this.resetObservers = () => {
      canvasContextReset();
      canvas2DReset();
      canvasWebGL1and2Reset();
    };
  }

  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }

  startRAFTimestamping() {
    var setLatestRAFTimestamp = timestamp => {
      this.rafStamps.latestId = timestamp;
      requestAnimationFrame(setLatestRAFTimestamp);
    };

    requestAnimationFrame(setLatestRAFTimestamp);
  }

  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach((_values, canvas) => {
      var id = this.mirror.getId(canvas);
      this.flushPendingCanvasMutationFor(canvas, id);
    });
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }

  flushPendingCanvasMutationFor(canvas, id) {
    if (this.frozen || this.locked) {
      return;
    }

    var valuesWithType = this.pendingCanvasMutations.get(canvas);
    if (!valuesWithType || id === -1) return;
    var values = valuesWithType.map(value => {
      var {
        type: type2
      } = value,
          rest = _objectWithoutProperties(value, _excluded5);

      return rest;
    });
    var {
      type
    } = valuesWithType[0];
    this.mutationCb({
      id,
      type,
      commands: values
    });
    this.pendingCanvasMutations.delete(canvas);
  }

}

class StylesheetManager {
  constructor(options) {
    __publicField(this, "trackedLinkElements", /* @__PURE__ */new WeakSet());

    __publicField(this, "mutationCb");

    __publicField(this, "adoptedStyleSheetCb");

    __publicField(this, "styleMirror", new StyleSheetMirror());

    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }

  attachLinkElement(linkEl, childSn) {
    if ("_cssText" in childSn.attributes) this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [{
        id: childSn.id,
        attributes: childSn.attributes
      }]
    });
    this.trackLinkElement(linkEl);
  }

  trackLinkElement(linkEl) {
    if (this.trackedLinkElements.has(linkEl)) return;
    this.trackedLinkElements.add(linkEl);
    this.trackStylesheetInLinkElement(linkEl);
  }

  adoptStyleSheets(sheets, hostId) {
    var _this5 = this;

    if (sheets.length === 0) return;
    var adoptedStyleSheetData = {
      id: hostId,
      styleIds: []
    };
    var styles = [];

    var _loop5 = function _loop5(sheet) {
      var styleId = void 0;

      if (!_this5.styleMirror.has(sheet)) {
        styleId = _this5.styleMirror.add(sheet);
        styles.push({
          styleId,
          rules: Array.from(sheet.rules || CSSRule, (r2, index2) => ({
            rule: stringifyRule(r2, sheet.href),
            index: index2
          }))
        });
      } else styleId = _this5.styleMirror.getId(sheet);

      adoptedStyleSheetData.styleIds.push(styleId);
    };

    for (var sheet of sheets) {
      _loop5(sheet);
    }

    if (styles.length > 0) adoptedStyleSheetData.styles = styles;
    this.adoptedStyleSheetCb(adoptedStyleSheetData);
  }

  reset() {
    this.styleMirror.reset();
    this.trackedLinkElements = /* @__PURE__ */new WeakSet();
  } // TODO: take snapshot on stylesheet reload by applying event listener


  trackStylesheetInLinkElement(_linkEl) {}

}

class ProcessedNodeManager {
  constructor() {
    __publicField(this, "nodeMap", /* @__PURE__ */new WeakMap());

    __publicField(this, "active", false);
  }

  inOtherBuffer(node2, thisBuffer) {
    var buffers = this.nodeMap.get(node2);
    return buffers && Array.from(buffers).some(buffer => buffer !== thisBuffer);
  }

  add(node2, buffer) {
    if (!this.active) {
      this.active = true;
      requestAnimationFrame(() => {
        this.nodeMap = /* @__PURE__ */new WeakMap();
        this.active = false;
      });
    }

    this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */new Set()).add(buffer));
  }

  destroy() {}

}

var wrappedEmit;
var takeFullSnapshot$1;
var canvasManager;
var recording = false;

try {
  if (Array.from([1], x2 => x2 * 2)[0] !== 2) {
    var cleanFrame = document.createElement("iframe");
    document.body.appendChild(cleanFrame);
    Array.from = ((_a = cleanFrame.contentWindow) == null ? void 0 : _a.Array.from) || Array.from;
    document.body.removeChild(cleanFrame);
  }
} catch (err) {
  console.debug("Unable to override Array.from", err);
}

var mirror = createMirror$2();

function record() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
    emit,
    checkoutEveryNms,
    checkoutEveryNth,
    blockClass = "rr-block",
    blockSelector = null,
    ignoreClass = "rr-ignore",
    ignoreSelector = null,
    maskTextClass = "rr-mask",
    maskTextSelector = null,
    inlineStylesheet = true,
    maskAllInputs,
    maskInputOptions: _maskInputOptions,
    slimDOMOptions: _slimDOMOptions,
    maskInputFn,
    maskTextFn,
    hooks,
    packFn,
    sampling = {},
    dataURLOptions = {},
    mousemoveWait,
    recordDOM = true,
    recordCanvas = false,
    recordCrossOriginIframes = false,
    recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load",
    userTriggeredOnInput = false,
    collectFonts = false,
    inlineImages = false,
    plugins,
    keepIframeSrcFn = () => false,
    ignoreCSSAttributes = /* @__PURE__ */new Set([]),
    errorHandler: errorHandler2
  } = options;
  registerErrorHandler(errorHandler2);
  var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  var passEmitsToParent = false;

  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e2) {
      passEmitsToParent = true;
    }
  }

  if (inEmittingFrame && !emit) {
    throw new Error("emit function is required");
  }

  if (!inEmittingFrame && !passEmitsToParent) {
    return () => {};
  }

  if (mousemoveWait !== void 0 && sampling.mousemove === void 0) {
    sampling.mousemove = mousemoveWait;
  }

  mirror.reset();
  var maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    password: true
  } : _maskInputOptions !== void 0 ? _maskInputOptions : {
    password: true
  };
  var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: _slimDOMOptions === "all",
    headMetaDescKeywords: _slimDOMOptions === "all",
    headTitleMutations: _slimDOMOptions === "all"
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill$1();
  var lastFullSnapshotEvent;
  var incrementalSnapshotCount = 0;

  var eventProcessor = e2 => {
    for (var plugin3 of plugins || []) {
      if (plugin3.eventProcessor) {
        e2 = plugin3.eventProcessor(e2);
      }
    }

    if (packFn && // Disable packing events which will be emitted to parent frames.
    !passEmitsToParent) {
      e2 = packFn(e2);
    }

    return e2;
  };

  wrappedEmit = (r2, isCheckout) => {
    var _a2;

    var e2 = r2;
    e2.timestamp = nowTimestamp();

    if (((_a2 = mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== EventType.FullSnapshot && !(e2.type === EventType.IncrementalSnapshot && e2.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach(buf => buf.unfreeze());
    }

    if (inEmittingFrame) {
      emit == null ? void 0 : emit(eventProcessor(e2), isCheckout);
    } else if (passEmitsToParent) {
      var message = {
        type: "rrweb",
        event: eventProcessor(e2),
        origin: window.location.origin,
        isCheckout
      };
      window.parent.postMessage(message, "*");
    }

    if (e2.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e2;
      incrementalSnapshotCount = 0;
    } else if (e2.type === EventType.IncrementalSnapshot) {
      if (e2.data.source === IncrementalSource.Mutation && e2.data.isAttachIframe) {
        return;
      }

      incrementalSnapshotCount++;
      var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;

      if (exceedCount || exceedTime) {
        takeFullSnapshot$1(true);
      }
    }
  };

  var wrappedMutationEmit = m => {
    wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: _objectSpread({
        source: IncrementalSource.Mutation
      }, m)
    });
  };

  var wrappedScrollEmit = p => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: _objectSpread({
      source: IncrementalSource.Scroll
    }, p)
  });

  var wrappedCanvasMutationEmit = p => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: _objectSpread({
      source: IncrementalSource.CanvasMutation
    }, p)
  });

  var wrappedAdoptedStyleSheetEmit = a2 => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: _objectSpread({
      source: IncrementalSource.AdoptedStyleSheet
    }, a2)
  });

  var stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  var iframeManager = new IframeManager({
    mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager,
    recordCrossOriginIframes,
    wrappedEmit
  });

  for (var plugin3 of plugins || []) {
    if (plugin3.getMirror) plugin3.getMirror({
      nodeMirror: mirror,
      crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
  }

  var processedNodeManager = new ProcessedNodeManager();
  canvasManager = new CanvasManager({
    recordCanvas,
    mutationCb: wrappedCanvasMutationEmit,
    win: window,
    blockClass,
    blockSelector,
    mirror,
    sampling: sampling.canvas,
    dataURLOptions
  });
  var shadowDomManager = new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      inlineStylesheet,
      maskInputOptions,
      dataURLOptions,
      maskTextFn,
      maskInputFn,
      recordCanvas,
      inlineImages,
      sampling,
      slimDOMOptions,
      iframeManager,
      stylesheetManager,
      canvasManager,
      keepIframeSrcFn,
      processedNodeManager
    },
    mirror
  });

  takeFullSnapshot$1 = function takeFullSnapshot$1() {
    var isCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!recordDOM) {
      return;
    }

    wrappedEmit({
      type: EventType.Meta,
      data: {
        href: window.location.href,
        width: getWindowWidth(),
        height: getWindowHeight()
      }
    }, isCheckout);
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach(buf => buf.lock());
    var node2 = snapshot(document, {
      mirror,
      blockClass,
      blockSelector,
      maskTextClass,
      maskTextSelector,
      inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskTextFn,
      maskInputFn,
      slimDOM: slimDOMOptions,
      dataURLOptions,
      recordCanvas,
      inlineImages,
      onSerialize: n2 => {
        if (isSerializedIframe(n2, mirror)) {
          iframeManager.addIframe(n2);
        }

        if (isSerializedStylesheet(n2, mirror)) {
          stylesheetManager.trackLinkElement(n2);
        }

        if (hasShadowRoot(n2)) {
          shadowDomManager.addShadowRoot(index.shadowRoot(n2), document);
        }
      },
      onIframeLoad: (iframe, childSn) => {
        iframeManager.attachIframe(iframe, childSn);
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: (linkEl, childSn) => {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      keepIframeSrcFn
    });

    if (!node2) {
      return console.warn("Failed to snapshot the document");
    }

    wrappedEmit({
      type: EventType.FullSnapshot,
      data: {
        node: node2,
        initialOffset: getWindowScroll(window)
      }
    }, isCheckout);
    mutationBuffers.forEach(buf => buf.unlock());
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
  };

  try {
    var handlers = [];

    var observe = doc => {
      var _a2;

      return callbackWrapper(initObservers)({
        mutationCb: wrappedMutationEmit,
        mousemoveCb: (positions, source) => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: {
            source,
            positions
          }
        }),
        mouseInteractionCb: d => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.MouseInteraction
          }, d)
        }),
        scrollCb: wrappedScrollEmit,
        viewportResizeCb: d => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.ViewportResize
          }, d)
        }),
        inputCb: v2 => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.Input
          }, v2)
        }),
        mediaInteractionCb: p => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.MediaInteraction
          }, p)
        }),
        styleSheetRuleCb: r2 => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.StyleSheetRule
          }, r2)
        }),
        styleDeclarationCb: r2 => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.StyleDeclaration
          }, r2)
        }),
        canvasMutationCb: wrappedCanvasMutationEmit,
        fontCb: p => wrappedEmit({
          type: EventType.IncrementalSnapshot,
          data: _objectSpread({
            source: IncrementalSource.Font
          }, p)
        }),
        selectionCb: p => {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.Selection
            }, p)
          });
        },
        customElementCb: c2 => {
          wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: _objectSpread({
              source: IncrementalSource.CustomElement
            }, c2)
          });
        },
        blockClass,
        ignoreClass,
        ignoreSelector,
        maskTextClass,
        maskTextSelector,
        maskInputOptions,
        inlineStylesheet,
        sampling,
        recordDOM,
        recordCanvas,
        inlineImages,
        userTriggeredOnInput,
        collectFonts,
        doc,
        maskInputFn,
        maskTextFn,
        keepIframeSrcFn,
        blockSelector,
        slimDOMOptions,
        dataURLOptions,
        mirror,
        iframeManager,
        stylesheetManager,
        shadowDomManager,
        processedNodeManager,
        canvasManager,
        ignoreCSSAttributes,
        plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(p => p.observer)) == null ? void 0 : _a2.map(p => ({
          observer: p.observer,
          options: p.options,
          callback: payload => wrappedEmit({
            type: EventType.Plugin,
            data: {
              plugin: p.name,
              payload
            }
          })
        }))) || []
      }, hooks);
    };

    iframeManager.addLoadListener(iframeEl => {
      try {
        handlers.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });

    var init = () => {
      takeFullSnapshot$1();
      handlers.push(observe(document));
      recording = true;
    };

    if (document.readyState === "interactive" || document.readyState === "complete") {
      init();
    } else {
      handlers.push(on("DOMContentLoaded", () => {
        wrappedEmit({
          type: EventType.DomContentLoaded,
          data: {}
        });
        if (recordAfter === "DOMContentLoaded") init();
      }));
      handlers.push(on("load", () => {
        wrappedEmit({
          type: EventType.Load,
          data: {}
        });
        if (recordAfter === "load") init();
      }, window));
    }

    return () => {
      handlers.forEach(h => h());
      processedNodeManager.destroy();
      recording = false;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}

record.addCustomEvent = (tag, payload) => {
  if (!recording) {
    throw new Error("please add custom event after start recording");
  }

  wrappedEmit({
    type: EventType.Custom,
    data: {
      tag,
      payload
    }
  });
};

record.freezePage = () => {
  mutationBuffers.forEach(buf => buf.freeze());
};

record.takeFullSnapshot = isCheckout => {
  if (!recording) {
    throw new Error("please take full snapshot after start recording");
  }

  takeFullSnapshot$1(isCheckout);
};

record.mirror = mirror;

function mitt$1(n2) {
  return {
    all: n2 = n2 || /* @__PURE__ */new Map(),
    on: function on(t2, e2) {
      var i2 = n2.get(t2);
      i2 ? i2.push(e2) : n2.set(t2, [e2]);
    },
    off: function off(t2, e2) {
      var i2 = n2.get(t2);
      i2 && (e2 ? i2.splice(i2.indexOf(e2) >>> 0, 1) : n2.set(t2, []));
    },
    emit: function emit(t2, e2) {
      var i2 = n2.get(t2);
      i2 && i2.slice().map(function (n3) {
        n3(e2);
      }), (i2 = n2.get("*")) && i2.slice().map(function (n3) {
        n3(t2, e2);
      });
    }
  };
}

var mittProxy = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: mitt$1
}, Symbol.toStringTag, {
  value: "Module"
}));

function polyfill() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
    return;
  }

  var Element2 = w.HTMLElement || w.Element;
  var SCROLL_TIME = 468;
  var original = {
    scroll: w.scroll || w.scrollTo,
    scrollBy: w.scrollBy,
    elementScroll: Element2.prototype.scroll || scrollElement,
    scrollIntoView: Element2.prototype.scrollIntoView
  };
  var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;

  function isMicrosoftBrowser(userAgent) {
    var userAgentPatterns = ["MSIE ", "Trident/", "Edge/"];
    return new RegExp(userAgentPatterns.join("|")).test(userAgent);
  }

  var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

  function scrollElement(x2, y) {
    this.scrollLeft = x2;
    this.scrollTop = y;
  }

  function ease(k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  }

  function shouldBailOut(firstArg) {
    if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === void 0 || firstArg.behavior === "auto" || firstArg.behavior === "instant") {
      return true;
    }

    if (typeof firstArg === "object" && firstArg.behavior === "smooth") {
      return false;
    }

    throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
  }

  function hasScrollableSpace(el, axis) {
    if (axis === "Y") {
      return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
    }

    if (axis === "X") {
      return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
    }
  }

  function canOverflow(el, axis) {
    var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
    return overflowValue === "auto" || overflowValue === "scroll";
  }

  function isScrollable(el) {
    var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
    var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
    return isScrollableY || isScrollableX;
  }

  function findScrollableParent(el) {
    while (el !== d.body && isScrollable(el) === false) {
      el = el.parentNode || el.host;
    }

    return el;
  }

  function step(context) {
    var time = now();
    var value;
    var currentX;
    var currentY;
    var elapsed = (time - context.startTime) / SCROLL_TIME;
    elapsed = elapsed > 1 ? 1 : elapsed;
    value = ease(elapsed);
    currentX = context.startX + (context.x - context.startX) * value;
    currentY = context.startY + (context.y - context.startY) * value;
    context.method.call(context.scrollable, currentX, currentY);

    if (currentX !== context.x || currentY !== context.y) {
      w.requestAnimationFrame(step.bind(w, context));
    }
  }

  function smoothScroll(el, x2, y) {
    var scrollable;
    var startX;
    var startY;
    var method;
    var startTime = now();

    if (el === d.body) {
      scrollable = w;
      startX = w.scrollX || w.pageXOffset;
      startY = w.scrollY || w.pageYOffset;
      method = original.scroll;
    } else {
      scrollable = el;
      startX = el.scrollLeft;
      startY = el.scrollTop;
      method = scrollElement;
    }

    step({
      scrollable,
      method,
      startTime,
      startX,
      startY,
      x: x2,
      y
    });
  }

  w.scroll = w.scrollTo = function () {
    if (arguments[0] === void 0) {
      return;
    }

    if (shouldBailOut(arguments[0]) === true) {
      original.scroll.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
      arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : w.scrollY || w.pageYOffset);
      return;
    }

    smoothScroll.call(w, d.body, arguments[0].left !== void 0 ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== void 0 ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
  };

  w.scrollBy = function () {
    if (arguments[0] === void 0) {
      return;
    }

    if (shouldBailOut(arguments[0])) {
      original.scrollBy.call(w, arguments[0].left !== void 0 ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== void 0 ? arguments[0].top : arguments[1] !== void 0 ? arguments[1] : 0);
      return;
    }

    smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
  };

  Element2.prototype.scroll = Element2.prototype.scrollTo = function () {
    if (arguments[0] === void 0) {
      return;
    }

    if (shouldBailOut(arguments[0]) === true) {
      if (typeof arguments[0] === "number" && arguments[1] === void 0) {
        throw new SyntaxError("Value could not be converted");
      }

      original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
      arguments[0].left !== void 0 ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
      arguments[0].top !== void 0 ? ~~arguments[0].top : arguments[1] !== void 0 ? ~~arguments[1] : this.scrollTop);
      return;
    }

    var left = arguments[0].left;
    var top = arguments[0].top;
    smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
  };

  Element2.prototype.scrollBy = function () {
    if (arguments[0] === void 0) {
      return;
    }

    if (shouldBailOut(arguments[0]) === true) {
      original.elementScroll.call(this, arguments[0].left !== void 0 ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== void 0 ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
      return;
    }

    this.scroll({
      left: ~~arguments[0].left + this.scrollLeft,
      top: ~~arguments[0].top + this.scrollTop,
      behavior: arguments[0].behavior
    });
  };

  Element2.prototype.scrollIntoView = function () {
    if (shouldBailOut(arguments[0]) === true) {
      original.scrollIntoView.call(this, arguments[0] === void 0 ? true : arguments[0]);
      return;
    }

    var scrollableParent = findScrollableParent(this);
    var parentRects = scrollableParent.getBoundingClientRect();
    var clientRects = this.getBoundingClientRect();

    if (scrollableParent !== d.body) {
      smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);

      if (w.getComputedStyle(scrollableParent).position !== "fixed") {
        w.scrollBy({
          left: parentRects.left,
          top: parentRects.top,
          behavior: "smooth"
        });
      }
    } else {
      w.scrollBy({
        left: clientRects.left,
        top: clientRects.top,
        behavior: "smooth"
      });
    }
  };
}

class Timer {
  constructor() {
    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var config = arguments.length > 1 ? arguments[1] : undefined;

    __publicField(this, "timeOffset", 0);

    __publicField(this, "speed");

    __publicField(this, "actions");

    __publicField(this, "raf", null);

    __publicField(this, "lastTimestamp");

    this.actions = actions;
    this.speed = config.speed;
  }
  /**
   * Add an action, possibly after the timer starts.
   */


  addAction(action) {
    var rafWasActive = this.raf === true;

    if (!this.actions.length || this.actions[this.actions.length - 1].delay <= action.delay) {
      this.actions.push(action);
    } else {
      var index2 = this.findActionIndex(action);
      this.actions.splice(index2, 0, action);
    }

    if (rafWasActive) {
      this.raf = requestAnimationFrame(this.rafCheck.bind(this));
    }
  }

  start() {
    this.timeOffset = 0;
    this.lastTimestamp = performance.now();
    this.raf = requestAnimationFrame(this.rafCheck.bind(this));
  }

  rafCheck() {
    var time = performance.now();
    this.timeOffset += (time - this.lastTimestamp) * this.speed;
    this.lastTimestamp = time;

    while (this.actions.length) {
      var action = this.actions[0];

      if (this.timeOffset >= action.delay) {
        this.actions.shift();
        action.doAction();
      } else {
        break;
      }
    }

    if (this.actions.length > 0) {
      this.raf = requestAnimationFrame(this.rafCheck.bind(this));
    } else {
      this.raf = true;
    }
  }

  clear() {
    if (this.raf) {
      if (this.raf !== true) {
        cancelAnimationFrame(this.raf);
      }

      this.raf = null;
    }

    this.actions.length = 0;
  }

  setSpeed(speed) {
    this.speed = speed;
  }

  isActive() {
    return this.raf !== null;
  }

  findActionIndex(action) {
    var start = 0;
    var end = this.actions.length - 1;

    while (start <= end) {
      var mid = Math.floor((start + end) / 2);

      if (this.actions[mid].delay < action.delay) {
        start = mid + 1;
      } else if (this.actions[mid].delay > action.delay) {
        end = mid - 1;
      } else {
        return mid + 1;
      }
    }

    return start;
  }

}

function addDelay(event, baselineTime) {
  if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseMove && event.data.positions && event.data.positions.length) {
    var firstOffset = event.data.positions[0].timeOffset;
    var firstTimestamp = event.timestamp + firstOffset;
    event.delay = firstTimestamp - baselineTime;
    return firstTimestamp - baselineTime;
  }

  event.delay = event.timestamp - baselineTime;
  return event.delay;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function t(t2, n2) {
  var e2 = "function" == typeof Symbol && t2[Symbol.iterator];
  if (!e2) return t2;
  var r2,
      o2,
      i2 = e2.call(t2),
      a2 = [];

  try {
    for (; (void 0 === n2 || n2-- > 0) && !(r2 = i2.next()).done;) {
      a2.push(r2.value);
    }
  } catch (t3) {
    o2 = {
      error: t3
    };
  } finally {
    try {
      r2 && !r2.done && (e2 = i2.return) && e2.call(i2);
    } finally {
      if (o2) throw o2.error;
    }
  }

  return a2;
}

var n;
!function (t2) {
  t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}(n || (n = {}));
var e = {
  type: "xstate.init"
};

function r(t2) {
  return void 0 === t2 ? [] : [].concat(t2);
}

function o(t2) {
  return {
    type: "xstate.assign",
    assignment: t2
  };
}

function i(t2, n2) {
  return "string" == typeof (t2 = "string" == typeof t2 && n2 && n2[t2] ? n2[t2] : t2) ? {
    type: t2
  } : "function" == typeof t2 ? {
    type: t2.name,
    exec: t2
  } : t2;
}

function a(t2) {
  return function (n2) {
    return t2 === n2;
  };
}

function u(t2) {
  return "string" == typeof t2 ? {
    type: t2
  } : t2;
}

function c(t2, n2) {
  return {
    value: t2,
    context: n2,
    actions: [],
    changed: false,
    matches: a(t2)
  };
}

function f(t2, n2, e2) {
  var r2 = n2,
      o2 = false;
  return [t2.filter(function (t3) {
    if ("xstate.assign" === t3.type) {
      o2 = true;
      var n3 = Object.assign({}, r2);
      return "function" == typeof t3.assignment ? n3 = t3.assignment(r2, e2) : Object.keys(t3.assignment).forEach(function (o3) {
        n3[o3] = "function" == typeof t3.assignment[o3] ? t3.assignment[o3](r2, e2) : t3.assignment[o3];
      }), r2 = n3, false;
    }

    return true;
  }), r2, o2];
}

function s(n2, o2) {
  void 0 === o2 && (o2 = {});
  var s2 = t(f(r(n2.states[n2.initial].entry).map(function (t2) {
    return i(t2, o2.actions);
  }), n2.context, e), 2),
      l2 = s2[0],
      v2 = s2[1],
      y = {
    config: n2,
    _options: o2,
    initialState: {
      value: n2.initial,
      actions: l2,
      context: v2,
      matches: a(n2.initial)
    },
    transition: function transition(e2, o3) {
      var s3,
          l3,
          v3 = "string" == typeof e2 ? {
        value: e2,
        context: n2.context
      } : e2,
          p = v3.value,
          g = v3.context,
          d = u(o3),
          x2 = n2.states[p];

      if (x2.on) {
        var m = r(x2.on[d.type]);

        try {
          for (var h = function (t2) {
            var n3 = "function" == typeof Symbol && Symbol.iterator,
                e3 = n3 && t2[n3],
                r2 = 0;
            if (e3) return e3.call(t2);
            if (t2 && "number" == typeof t2.length) return {
              next: function next() {
                return t2 && r2 >= t2.length && (t2 = void 0), {
                  value: t2 && t2[r2++],
                  done: !t2
                };
              }
            };
            throw new TypeError(n3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
          }(m), b = h.next(); !b.done; b = h.next()) {
            var S = b.value;
            if (void 0 === S) return c(p, g);

            var w = "string" == typeof S ? {
              target: S
            } : S,
                j = w.target,
                E = w.actions,
                R = void 0 === E ? [] : E,
                N = w.cond,
                O = void 0 === N ? function () {
              return true;
            } : N,
                _ = void 0 === j,
                k = null != j ? j : p,
                T = n2.states[k];

            if (O(g, d)) {
              var q = t(f((_ ? r(R) : [].concat(x2.exit, R, T.entry).filter(function (t2) {
                return t2;
              })).map(function (t2) {
                return i(t2, y._options.actions);
              }), g, d), 3),
                  z = q[0],
                  A = q[1],
                  B = q[2],
                  C = null != j ? j : p;
              return {
                value: C,
                context: A,
                actions: z,
                changed: j !== p || z.length > 0 || B,
                matches: a(C)
              };
            }
          }
        } catch (t2) {
          s3 = {
            error: t2
          };
        } finally {
          try {
            b && !b.done && (l3 = h.return) && l3.call(h);
          } finally {
            if (s3) throw s3.error;
          }
        }
      }

      return c(p, g);
    }
  };
  return y;
}

var l = function l(t2, n2) {
  return t2.actions.forEach(function (e2) {
    var r2 = e2.exec;
    return r2 && r2(t2.context, n2);
  });
};

function v(t2) {
  var r2 = t2.initialState,
      o2 = n.NotStarted,
      i2 = /* @__PURE__ */new Set(),
      c2 = {
    _machine: t2,
    send: function send(e2) {
      o2 === n.Running && (r2 = t2.transition(r2, e2), l(r2, u(e2)), i2.forEach(function (t3) {
        return t3(r2);
      }));
    },
    subscribe: function subscribe(t3) {
      return i2.add(t3), t3(r2), {
        unsubscribe: function unsubscribe() {
          return i2.delete(t3);
        }
      };
    },
    start: function start(i3) {
      if (i3) {
        var u2 = "object" == typeof i3 ? i3 : {
          context: t2.config.context,
          value: i3
        };
        r2 = {
          value: u2.value,
          actions: [],
          context: u2.context,
          matches: a(u2.value)
        };
      }

      return o2 = n.Running, l(r2, e), c2;
    },
    stop: function stop() {
      return o2 = n.Stopped, i2.clear(), c2;
    },

    get state() {
      return r2;
    },

    get status() {
      return o2;
    }

  };
  return c2;
}

function discardPriorSnapshots(events, baselineTime) {
  for (var idx = events.length - 1; idx >= 0; idx--) {
    var event = events[idx];

    if (event.type === EventType.Meta) {
      if (event.timestamp <= baselineTime) {
        return events.slice(idx);
      }
    }
  }

  return events;
}

function createPlayerService(context, _ref20) {
  var {
    getCastFn,
    applyEventsSynchronously,
    emitter
  } = _ref20;
  var playerMachine = s({
    id: "player",
    context,
    initial: "paused",
    states: {
      playing: {
        on: {
          PAUSE: {
            target: "paused",
            actions: ["pause"]
          },
          CAST_EVENT: {
            target: "playing",
            actions: "castEvent"
          },
          END: {
            target: "paused",
            actions: ["resetLastPlayedEvent", "pause"]
          },
          ADD_EVENT: {
            target: "playing",
            actions: ["addEvent"]
          }
        }
      },
      paused: {
        on: {
          PLAY: {
            target: "playing",
            actions: ["recordTimeOffset", "play"]
          },
          CAST_EVENT: {
            target: "paused",
            actions: "castEvent"
          },
          TO_LIVE: {
            target: "live",
            actions: ["startLive"]
          },
          ADD_EVENT: {
            target: "paused",
            actions: ["addEvent"]
          }
        }
      },
      live: {
        on: {
          ADD_EVENT: {
            target: "live",
            actions: ["addEvent"]
          },
          CAST_EVENT: {
            target: "live",
            actions: ["castEvent"]
          }
        }
      }
    }
  }, {
    actions: {
      castEvent: o({
        lastPlayedEvent: (ctx, event) => {
          if (event.type === "CAST_EVENT") {
            return event.payload.event;
          }

          return ctx.lastPlayedEvent;
        }
      }),
      recordTimeOffset: o((ctx, event) => {
        var timeOffset = ctx.timeOffset;

        if ("payload" in event && "timeOffset" in event.payload) {
          timeOffset = event.payload.timeOffset;
        }

        return _objectSpread(_objectSpread({}, ctx), {}, {
          timeOffset,
          baselineTime: ctx.events[0].timestamp + timeOffset
        });
      }),

      play(ctx) {
        var _a2;

        var {
          timer,
          events,
          baselineTime,
          lastPlayedEvent
        } = ctx;
        timer.clear();

        for (var event of events) {
          addDelay(event, baselineTime);
        }

        var neededEvents = discardPriorSnapshots(events, baselineTime);
        var lastPlayedTimestamp = lastPlayedEvent == null ? void 0 : lastPlayedEvent.timestamp;

        if ((lastPlayedEvent == null ? void 0 : lastPlayedEvent.type) === EventType.IncrementalSnapshot && lastPlayedEvent.data.source === IncrementalSource.MouseMove) {
          lastPlayedTimestamp = lastPlayedEvent.timestamp + ((_a2 = lastPlayedEvent.data.positions[0]) == null ? void 0 : _a2.timeOffset);
        }

        if (baselineTime < (lastPlayedTimestamp || 0)) {
          emitter.emit(ReplayerEvents.PlayBack);
        }

        var syncEvents = new Array();

        for (var _event2 of neededEvents) {
          if (lastPlayedTimestamp && lastPlayedTimestamp < baselineTime && (_event2.timestamp <= lastPlayedTimestamp || _event2 === lastPlayedEvent)) {
            continue;
          }

          if (_event2.timestamp < baselineTime) {
            syncEvents.push(_event2);
          } else {
            (function () {
              var castFn = getCastFn(_event2, false);
              timer.addAction({
                doAction: () => {
                  castFn();
                },
                delay: _event2.delay
              });
            })();
          }
        }

        applyEventsSynchronously(syncEvents);
        emitter.emit(ReplayerEvents.Flush);
        timer.start();
      },

      pause(ctx) {
        ctx.timer.clear();
      },

      resetLastPlayedEvent: o(ctx => {
        return _objectSpread(_objectSpread({}, ctx), {}, {
          lastPlayedEvent: null
        });
      }),
      startLive: o({
        baselineTime: (ctx, event) => {
          ctx.timer.start();

          if (event.type === "TO_LIVE" && event.payload.baselineTime) {
            return event.payload.baselineTime;
          }

          return Date.now();
        }
      }),
      addEvent: o((ctx, machineEvent) => {
        var {
          baselineTime,
          timer,
          events
        } = ctx;

        if (machineEvent.type === "ADD_EVENT") {
          var {
            event
          } = machineEvent.payload;
          addDelay(event, baselineTime);
          var end = events.length - 1;

          if (!events[end] || events[end].timestamp <= event.timestamp) {
            events.push(event);
          } else {
            var insertionIndex = -1;
            var start = 0;

            while (start <= end) {
              var mid = Math.floor((start + end) / 2);

              if (events[mid].timestamp <= event.timestamp) {
                start = mid + 1;
              } else {
                end = mid - 1;
              }
            }

            if (insertionIndex === -1) {
              insertionIndex = start;
            }

            events.splice(insertionIndex, 0, event);
          }

          var isSync = event.timestamp < baselineTime;
          var castFn = getCastFn(event, isSync);

          if (isSync) {
            castFn();
          } else if (timer.isActive()) {
            timer.addAction({
              doAction: () => {
                castFn();
              },
              delay: event.delay
            });
          }
        }

        return _objectSpread(_objectSpread({}, ctx), {}, {
          events
        });
      })
    }
  });
  return v(playerMachine);
}

function createSpeedService(context) {
  var speedMachine = s({
    id: "speed",
    context,
    initial: "normal",
    states: {
      normal: {
        on: {
          FAST_FORWARD: {
            target: "skipping",
            actions: ["recordSpeed", "setSpeed"]
          },
          SET_SPEED: {
            target: "normal",
            actions: ["setSpeed"]
          }
        }
      },
      skipping: {
        on: {
          BACK_TO_NORMAL: {
            target: "normal",
            actions: ["restoreSpeed"]
          },
          SET_SPEED: {
            target: "normal",
            actions: ["setSpeed"]
          }
        }
      }
    }
  }, {
    actions: {
      setSpeed: (ctx, event) => {
        if ("payload" in event) {
          ctx.timer.setSpeed(event.payload.speed);
        }
      },
      recordSpeed: o({
        normalSpeed: ctx => ctx.timer.speed
      }),
      restoreSpeed: ctx => {
        ctx.timer.setSpeed(ctx.normalSpeed);
      }
    }
  });
  return v(speedMachine);
}

var rules = blockClass => [".".concat(blockClass, " { background: currentColor }"), "noscript { display: none !important; }"];

var webGLVarMap = /* @__PURE__ */new Map();

function variableListFor(ctx, ctor) {
  var contextMap = webGLVarMap.get(ctx);

  if (!contextMap) {
    contextMap = /* @__PURE__ */new Map();
    webGLVarMap.set(ctx, contextMap);
  }

  if (!contextMap.has(ctor)) {
    contextMap.set(ctor, []);
  }

  return contextMap.get(ctor);
}

function deserializeArg(imageMap, ctx, preload) {
  return /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator(function* (arg) {
      if (arg && typeof arg === "object" && "rr_type" in arg) {
        if (preload) preload.isUnchanged = false;

        if (arg.rr_type === "ImageBitmap" && "args" in arg) {
          var args = yield deserializeArg(imageMap, ctx, preload)(arg.args);
          return yield createImageBitmap.apply(null, args);
        } else if ("index" in arg) {
          if (preload || ctx === null) return arg;
          var {
            rr_type: name,
            index: index2
          } = arg;
          return variableListFor(ctx, name)[index2];
        } else if ("args" in arg) {
          var {
            rr_type: _name9,
            args: _args2
          } = arg;
          var ctor = window[_name9];
          return new ctor(...(yield Promise.all(_args2.map(deserializeArg(imageMap, ctx, preload)))));
        } else if ("base64" in arg) {
          return decode(arg.base64);
        } else if ("src" in arg) {
          var image = imageMap.get(arg.src);

          if (image) {
            return image;
          } else {
            var image2 = new Image();
            image2.src = arg.src;
            imageMap.set(arg.src, image2);
            return image2;
          }
        } else if ("data" in arg && arg.rr_type === "Blob") {
          var blobContents = yield Promise.all(arg.data.map(deserializeArg(imageMap, ctx, preload)));
          var blob2 = new Blob(blobContents, {
            type: arg.type
          });
          return blob2;
        }
      } else if (Array.isArray(arg)) {
        var result2 = yield Promise.all(arg.map(deserializeArg(imageMap, ctx, preload)));
        return result2;
      }

      return arg;
    });

    return function (_x3) {
      return _ref21.apply(this, arguments);
    };
  }();
}

function getContext(target, type) {
  try {
    if (type === CanvasContext.WebGL) {
      return target.getContext("webgl") || target.getContext("experimental-webgl");
    }

    return target.getContext("webgl2");
  } catch (e2) {
    return null;
  }
}

var WebGLVariableConstructorsNames = ["WebGLActiveInfo", "WebGLBuffer", "WebGLFramebuffer", "WebGLProgram", "WebGLRenderbuffer", "WebGLShader", "WebGLShaderPrecisionFormat", "WebGLTexture", "WebGLUniformLocation", "WebGLVertexArrayObject"];

function saveToWebGLVarMap(ctx, result2) {
  if (!(result2 == null ? void 0 : result2.constructor)) return;
  var {
    name
  } = result2.constructor;
  if (!WebGLVariableConstructorsNames.includes(name)) return;
  var variables = variableListFor(ctx, name);
  if (!variables.includes(result2)) variables.push(result2);
}

function webglMutation(_x4) {
  return _webglMutation.apply(this, arguments);
}

function _webglMutation() {
  _webglMutation = _asyncToGenerator(function* (_ref22) {
    var {
      mutation,
      target,
      type,
      imageMap,
      errorHandler: errorHandler2
    } = _ref22;

    try {
      var ctx = getContext(target, type);
      if (!ctx) return;

      if (mutation.setter) {
        ctx[mutation.property] = mutation.args[0];
        return;
      }

      var original = ctx[mutation.property];
      var args = yield Promise.all(mutation.args.map(deserializeArg(imageMap, ctx)));
      var result2 = original.apply(ctx, args);
      saveToWebGLVarMap(ctx, result2);
      var debugMode = false;
      if (debugMode) ;
    } catch (error) {
      errorHandler2(mutation, error);
    }
  });
  return _webglMutation.apply(this, arguments);
}

function canvasMutation$1(_x5) {
  return _canvasMutation$.apply(this, arguments);
}

function _canvasMutation$() {
  _canvasMutation$ = _asyncToGenerator(function* (_ref23) {
    var {
      event,
      mutations,
      target,
      imageMap,
      errorHandler: errorHandler2
    } = _ref23;
    var ctx = target.getContext("2d");

    if (!ctx) {
      errorHandler2(mutations[0], new Error("Canvas context is null"));
      return;
    }

    var mutationArgsPromises = mutations.map( /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator(function* (mutation) {
        return Promise.all(mutation.args.map(deserializeArg(imageMap, ctx)));
      });

      return function (_x8) {
        return _ref37.apply(this, arguments);
      };
    }());
    var args = yield Promise.all(mutationArgsPromises);
    args.forEach((args2, index2) => {
      var mutation = mutations[index2];

      try {
        if (mutation.setter) {
          ctx[mutation.property] = mutation.args[0];
          return;
        }

        var original = ctx[mutation.property];

        if (mutation.property === "drawImage" && typeof mutation.args[0] === "string") {
          imageMap.get(event);
          original.apply(ctx, mutation.args);
        } else {
          original.apply(ctx, args2);
        }
      } catch (error) {
        errorHandler2(mutation, error);
      }

      return;
    });
  });
  return _canvasMutation$.apply(this, arguments);
}

function canvasMutation(_x6) {
  return _canvasMutation.apply(this, arguments);
}

function _canvasMutation() {
  _canvasMutation = _asyncToGenerator(function* (_ref24) {
    var {
      event,
      mutation,
      target,
      imageMap,
      canvasEventMap,
      errorHandler: errorHandler2
    } = _ref24;

    try {
      var precomputedMutation = canvasEventMap.get(event) || mutation;
      var commands = "commands" in precomputedMutation ? precomputedMutation.commands : [precomputedMutation];

      if ([CanvasContext.WebGL, CanvasContext.WebGL2].includes(mutation.type)) {
        for (var i2 = 0; i2 < commands.length; i2++) {
          var command = commands[i2];
          yield webglMutation({
            mutation: command,
            type: mutation.type,
            target,
            imageMap,
            errorHandler: errorHandler2
          });
        }

        return;
      }

      yield canvasMutation$1({
        event,
        mutations: commands,
        target,
        imageMap,
        errorHandler: errorHandler2
      });
    } catch (error) {
      errorHandler2(mutation, error);
    }
  });
  return _canvasMutation.apply(this, arguments);
}

class MediaManager {
  constructor(options) {
    __publicField(this, "mediaMap", /* @__PURE__ */new Map());

    __publicField(this, "warn");

    __publicField(this, "service");

    __publicField(this, "speedService");

    __publicField(this, "emitter");

    __publicField(this, "getCurrentTime");

    __publicField(this, "metadataCallbackMap", /* @__PURE__ */new Map());

    this.warn = options.warn;
    this.service = options.service;
    this.speedService = options.speedService;
    this.emitter = options.emitter;
    this.getCurrentTime = options.getCurrentTime;
    this.emitter.on(ReplayerEvents.Start, this.start.bind(this));
    this.emitter.on(ReplayerEvents.SkipStart, this.start.bind(this));
    this.emitter.on(ReplayerEvents.Pause, this.pause.bind(this));
    this.emitter.on(ReplayerEvents.Finish, this.pause.bind(this));
    this.speedService.subscribe(() => {
      this.syncAllMediaElements();
    });
  }

  syncAllMediaElements() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      pause: false
    };
    this.mediaMap.forEach((_mediaState, target) => {
      this.syncTargetWithState(target);

      if (options.pause) {
        target.pause();
      }
    });
  }

  start() {
    this.syncAllMediaElements();
  }

  pause() {
    this.syncAllMediaElements({
      pause: true
    });
  }

  seekTo(_ref25) {
    var {
      time,
      target,
      mediaState
    } = _ref25;

    if (mediaState.isPlaying) {
      var differenceBetweenCurrentTimeAndMediaMutationTimestamp = time - mediaState.lastInteractionTimeOffset;
      var mediaPlaybackOffset = differenceBetweenCurrentTimeAndMediaMutationTimestamp / 1e3 * mediaState.playbackRate;
      var duration = "duration" in target && target.duration;

      if (Number.isNaN(duration)) {
        this.waitForMetadata(target);
        return;
      }

      var seekToTime = mediaState.currentTimeAtLastInteraction + mediaPlaybackOffset;

      if (target.loop && // RRMediaElement doesn't have a duration property
      duration !== false) {
        seekToTime = seekToTime % duration;
      }

      target.currentTime = seekToTime;
    } else {
      target.pause();
      target.currentTime = mediaState.currentTimeAtLastInteraction;
    }
  }

  waitForMetadata(target) {
    if (this.metadataCallbackMap.has(target)) return;
    if (!("addEventListener" in target)) return;

    var onLoadedMetadata = () => {
      this.metadataCallbackMap.delete(target);
      var mediaState = this.mediaMap.get(target);
      if (!mediaState) return;
      this.seekTo({
        time: this.getCurrentTime(),
        target,
        mediaState
      });
    };

    this.metadataCallbackMap.set(target, onLoadedMetadata);
    target.addEventListener("loadedmetadata", onLoadedMetadata, {
      once: true
    });
  }

  getMediaStateFromMutation(_ref26) {
    var _ref27, _ref28, _ref29, _ref30, _ref31;

    var {
      target,
      timeOffset,
      mutation
    } = _ref26;
    var lastState = this.mediaMap.get(target);
    var {
      type,
      playbackRate,
      currentTime,
      muted,
      volume,
      loop
    } = mutation;
    var isPlaying = type === MediaInteractions.Play || type !== MediaInteractions.Pause && ((lastState == null ? void 0 : lastState.isPlaying) || target.getAttribute("autoplay") !== null);
    var mediaState = {
      isPlaying,
      currentTimeAtLastInteraction: (_ref27 = currentTime !== null && currentTime !== void 0 ? currentTime : lastState == null ? void 0 : lastState.currentTimeAtLastInteraction) !== null && _ref27 !== void 0 ? _ref27 : 0,
      lastInteractionTimeOffset: timeOffset,
      playbackRate: (_ref28 = playbackRate !== null && playbackRate !== void 0 ? playbackRate : lastState == null ? void 0 : lastState.playbackRate) !== null && _ref28 !== void 0 ? _ref28 : 1,
      volume: (_ref29 = volume !== null && volume !== void 0 ? volume : lastState == null ? void 0 : lastState.volume) !== null && _ref29 !== void 0 ? _ref29 : 1,
      muted: (_ref30 = muted !== null && muted !== void 0 ? muted : lastState == null ? void 0 : lastState.muted) !== null && _ref30 !== void 0 ? _ref30 : target.getAttribute("muted") === null,
      loop: (_ref31 = loop !== null && loop !== void 0 ? loop : lastState == null ? void 0 : lastState.loop) !== null && _ref31 !== void 0 ? _ref31 : target.getAttribute("loop") === null
    };
    return mediaState;
  }

  syncTargetWithState(target) {
    var mediaState = this.mediaMap.get(target);
    if (!mediaState) return;
    var {
      muted,
      loop,
      volume,
      isPlaying
    } = mediaState;
    var playerIsPaused = this.service.state.matches("paused");
    var playbackRate = mediaState.playbackRate * this.speedService.state.context.timer.speed;

    try {
      this.seekTo({
        time: this.getCurrentTime(),
        target,
        mediaState
      });

      if (target.volume !== volume) {
        target.volume = volume;
      }

      target.muted = muted;
      target.loop = loop;

      if (target.playbackRate !== playbackRate) {
        target.playbackRate = playbackRate;
      }

      if (isPlaying && !playerIsPaused) {
        void target.play();
      } else {
        target.pause();
      }
    } catch (error) {
      this.warn( // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions
      "Failed to replay media interactions: ".concat(error.message || error));
    }
  }

  addMediaElements(node2, timeOffset, mirror2) {
    if (!["AUDIO", "VIDEO"].includes(node2.nodeName)) return;
    var target = node2;
    var serializedNode = mirror2.getMeta(target);
    if (!serializedNode || !("attributes" in serializedNode)) return;
    var playerIsPaused = this.service.state.matches("paused");
    var mediaAttributes = serializedNode.attributes;
    var isPlaying = false;

    if (mediaAttributes.rr_mediaState) {
      isPlaying = mediaAttributes.rr_mediaState === "played";
    } else {
      isPlaying = target.getAttribute("autoplay") !== null;
    }

    if (isPlaying && playerIsPaused) target.pause();
    var playbackRate = 1;

    if (typeof mediaAttributes.rr_mediaPlaybackRate === "number") {
      playbackRate = mediaAttributes.rr_mediaPlaybackRate;
    }

    var muted = false;

    if (typeof mediaAttributes.rr_mediaMuted === "boolean") {
      muted = mediaAttributes.rr_mediaMuted;
    } else {
      muted = target.getAttribute("muted") !== null;
    }

    var loop = false;

    if (typeof mediaAttributes.rr_mediaLoop === "boolean") {
      loop = mediaAttributes.rr_mediaLoop;
    } else {
      loop = target.getAttribute("loop") !== null;
    }

    var volume = 1;

    if (typeof mediaAttributes.rr_mediaVolume === "number") {
      volume = mediaAttributes.rr_mediaVolume;
    }

    var currentTimeAtLastInteraction = 0;

    if (typeof mediaAttributes.rr_mediaCurrentTime === "number") {
      currentTimeAtLastInteraction = mediaAttributes.rr_mediaCurrentTime;
    }

    this.mediaMap.set(target, {
      isPlaying,
      currentTimeAtLastInteraction,
      lastInteractionTimeOffset: timeOffset,
      playbackRate,
      volume,
      muted,
      loop
    });
    this.syncTargetWithState(target);
  }

  mediaMutation(_ref32) {
    var {
      target,
      timeOffset,
      mutation
    } = _ref32;
    this.mediaMap.set(target, this.getMediaStateFromMutation({
      target,
      timeOffset,
      mutation
    }));
    this.syncTargetWithState(target);
  }

  isSupportedMediaElement(node2) {
    return ["AUDIO", "VIDEO"].includes(node2.nodeName);
  }

  reset() {
    this.mediaMap.clear();
  }

}

function applyDialogToTopLevel(node2, attributeMutation) {
  if (node2.nodeName !== "DIALOG" || node2 instanceof BaseRRNode) return;
  var dialog = node2;
  var oldIsOpen = dialog.open;
  var oldIsModalState = oldIsOpen && dialog.matches("dialog:modal");
  var rrOpenMode = dialog.getAttribute("rr_open_mode");
  var newIsOpen = typeof (attributeMutation == null ? void 0 : attributeMutation.attributes.open) === "string" || typeof dialog.getAttribute("open") === "string";
  var newIsModalState = rrOpenMode === "modal";
  var newIsNonModalState = rrOpenMode === "non-modal";
  var modalStateChanged = oldIsModalState && newIsNonModalState || !oldIsModalState && newIsModalState;
  if (oldIsOpen && !modalStateChanged) return;

  if (!dialog.isConnected) {
    console.warn("dialog is not attached to the dom", dialog);
    return;
  }

  if (oldIsOpen) dialog.close();
  if (!newIsOpen) return;
  if (newIsModalState) dialog.showModal();else dialog.show();
}

function removeDialogFromTopLevel(node2, attributeMutation) {
  if (node2.nodeName !== "DIALOG" || node2 instanceof BaseRRNode) return;
  var dialog = node2;

  if (!dialog.isConnected) {
    console.warn("dialog is not attached to the dom", dialog);
    return;
  }

  if (attributeMutation.attributes.open === null) {
    dialog.removeAttribute("open");
    dialog.removeAttribute("rr_open_mode");
  }
}

var mitt = mitt$1 || mittProxy;
var REPLAY_CONSOLE_PREFIX = "[replayer]";
var defaultMouseTailConfig = {
  duration: 500,
  lineCap: "round",
  lineWidth: 3,
  strokeStyle: "red"
};

function indicatesTouchDevice(e2) {
  return e2.type == EventType.IncrementalSnapshot && (e2.data.source == IncrementalSource.TouchMove || e2.data.source == IncrementalSource.MouseInteraction && e2.data.type == MouseInteractions.TouchStart);
}

class Replayer {
  constructor(events, config) {
    var _this6 = this;

    __publicField(this, "wrapper");

    __publicField(this, "iframe");

    __publicField(this, "service");

    __publicField(this, "speedService");

    __publicField(this, "config"); // In the fast-forward process, if the virtual-dom optimization is used, this flag value is true.


    __publicField(this, "usingVirtualDom", false);

    __publicField(this, "virtualDom", new RRDocument());

    __publicField(this, "mouse");

    __publicField(this, "mouseTail", null);

    __publicField(this, "tailPositions", []);

    __publicField(this, "emitter", mitt());

    __publicField(this, "nextUserInteractionEvent");

    __publicField(this, "legacy_missingNodeRetryMap", {}); // The replayer uses the cache to speed up replay and scrubbing.


    __publicField(this, "cache", createCache());

    __publicField(this, "imageMap", /* @__PURE__ */new Map());

    __publicField(this, "canvasEventMap", /* @__PURE__ */new Map());

    __publicField(this, "mirror", createMirror$2()); // Used to track StyleSheetObjects adopted on multiple document hosts.


    __publicField(this, "styleMirror", new StyleSheetMirror()); // Used to track video & audio elements, and keep them in sync with general playback.


    __publicField(this, "mediaManager");

    __publicField(this, "firstFullSnapshot", null);

    __publicField(this, "newDocumentQueue", []);

    __publicField(this, "mousePos", null);

    __publicField(this, "touchActive", null);

    __publicField(this, "lastMouseDownEvent", null); // Keep the rootNode of the last hovered element. So  when hovering a new element, we can remove the last hovered element's :hover style.


    __publicField(this, "lastHoveredRootNode"); // In the fast-forward mode, only the last selection data needs to be applied.


    __publicField(this, "lastSelectionData", null); // In the fast-forward mode using VirtualDom optimization, all stylesheetRule, and styleDeclaration events on constructed StyleSheets will be delayed to get applied until the flush stage.


    __publicField(this, "constructedStyleMutations", []); // Similar to the reason for constructedStyleMutations.


    __publicField(this, "adoptedStyleSheets", []);

    __publicField(this, "handleResize", dimension => {
      this.iframe.style.display = "inherit";

      for (var el of [this.mouseTail, this.iframe]) {
        if (!el) {
          continue;
        }

        el.setAttribute("width", String(dimension.width));
        el.setAttribute("height", String(dimension.height));
      }
    });

    __publicField(this, "applyEventsSynchronously", events => {
      for (var event of events) {
        switch (event.type) {
          case EventType.DomContentLoaded:
          case EventType.Load:
          case EventType.Custom:
            continue;

          case EventType.FullSnapshot:
          case EventType.Meta:
          case EventType.Plugin:
          case EventType.IncrementalSnapshot:
            break;
        }

        var castFn = this.getCastFn(event, true);
        castFn();
      }
    });

    __publicField(this, "getCastFn", function (event) {
      var isSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var castFn;

      switch (event.type) {
        case EventType.DomContentLoaded:
        case EventType.Load:
          break;

        case EventType.Custom:
          castFn = () => {
            _this6.emitter.emit(ReplayerEvents.CustomEvent, event);
          };

          break;

        case EventType.Meta:
          castFn = () => _this6.emitter.emit(ReplayerEvents.Resize, {
            width: event.data.width,
            height: event.data.height
          });

          break;

        case EventType.FullSnapshot:
          castFn = () => {
            var _a2;

            if (_this6.firstFullSnapshot) {
              if (_this6.firstFullSnapshot === event) {
                _this6.firstFullSnapshot = true;
                return;
              }
            } else {
              _this6.firstFullSnapshot = true;
            }

            _this6.mediaManager.reset();

            _this6.styleMirror.reset();

            _this6.rebuildFullSnapshot(event, isSync);

            (_a2 = _this6.iframe.contentWindow) == null ? void 0 : _a2.scrollTo(event.data.initialOffset);
          };

          break;

        case EventType.IncrementalSnapshot:
          castFn = () => {
            _this6.applyIncremental(event, isSync);

            if (isSync) {
              return;
            }

            if (_this6.config.skipInactive && !_this6.nextUserInteractionEvent) {
              for (var _event of _this6.service.state.context.events) {
                if (_event.timestamp <= event.timestamp) {
                  continue;
                }

                if (_this6.isUserInteraction(_event)) {
                  if ( // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  _event.delay - event.delay > _this6.config.inactivePeriodThreshold * _this6.speedService.state.context.timer.speed) {
                    _this6.nextUserInteractionEvent = _event;
                  }

                  break;
                }
              }

              if (_this6.nextUserInteractionEvent) {
                var skipTime = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                _this6.nextUserInteractionEvent.delay - event.delay;

                _this6.play(_this6.getCurrentTime() + skipTime);

                _this6.nextUserInteractionEvent = null;
              }
            }
          };

          break;
      }

      var wrappedCastFn = () => {
        if (castFn) {
          castFn();
        }

        for (var plugin3 of _this6.config.plugins || []) {
          if (plugin3.handler) plugin3.handler(event, isSync, {
            replayer: _this6
          });
        }

        _this6.service.send({
          type: "CAST_EVENT",
          payload: {
            event
          }
        });

        var last_index = _this6.service.state.context.events.length - 1;

        if (!_this6.config.liveMode && event === _this6.service.state.context.events[last_index]) {
          var finish = () => {
            if (last_index < _this6.service.state.context.events.length - 1) {
              return;
            }

            _this6.backToNormal();

            _this6.service.send("END");

            _this6.emitter.emit(ReplayerEvents.Finish);
          };

          var finish_buffer = 50;

          if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.MouseMove && event.data.positions.length) {
            finish_buffer += Math.max(0, -event.data.positions[0].timeOffset);
          }

          setTimeout(finish, finish_buffer);
        }

        _this6.emitter.emit(ReplayerEvents.EventCast, event);
      };

      return wrappedCastFn;
    });

    if (!(config == null ? void 0 : config.liveMode) && events.length < 2) {
      throw new Error("Replayer need at least 2 events.");
    }

    var defaultConfig = {
      speed: 1,
      maxSpeed: 360,
      root: document.body,
      loadTimeout: 0,
      skipInactive: false,
      inactivePeriodThreshold: 10 * 1e3,
      showWarning: true,
      showDebug: false,
      blockClass: "rr-block",
      liveMode: false,
      insertStyleRules: [],
      triggerFocus: true,
      UNSAFE_replayCanvas: false,
      pauseAnimation: true,
      mouseTail: defaultMouseTailConfig,
      useVirtualDom: true,
      // Virtual-dom optimization is enabled by default.
      logger: console
    };
    this.config = Object.assign({}, defaultConfig, config);
    this.handleResize = this.handleResize.bind(this);
    this.getCastFn = this.getCastFn.bind(this);
    this.applyEventsSynchronously = this.applyEventsSynchronously.bind(this);
    this.emitter.on(ReplayerEvents.Resize, this.handleResize);
    this.setupDom();

    for (var plugin3 of this.config.plugins || []) {
      if (plugin3.getMirror) plugin3.getMirror({
        nodeMirror: this.mirror
      });
    }

    this.emitter.on(ReplayerEvents.Flush, () => {
      if (this.usingVirtualDom) {
        var replayerHandler = {
          mirror: this.mirror,
          applyCanvas: (canvasEvent, canvasMutationData, target) => {
            void canvasMutation({
              event: canvasEvent,
              mutation: canvasMutationData,
              target,
              imageMap: this.imageMap,
              canvasEventMap: this.canvasEventMap,
              errorHandler: this.warnCanvasMutationFailed.bind(this)
            });
          },
          applyInput: this.applyInput.bind(this),
          applyScroll: this.applyScroll.bind(this),
          applyStyleSheetMutation: (data, styleSheet) => {
            if (data.source === IncrementalSource.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);else if (data.source === IncrementalSource.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
          },
          afterAppend: (node2, id) => {
            for (var _plugin3 of this.config.plugins || []) {
              if (_plugin3.onBuild) _plugin3.onBuild(node2, {
                id,
                replayer: this
              });
            }
          }
        };
        if (this.iframe.contentDocument) try {
          diff(this.iframe.contentDocument, this.virtualDom, replayerHandler, this.virtualDom.mirror);
        } catch (e2) {
          console.warn(e2);
        }
        this.virtualDom.destroyTree();
        this.usingVirtualDom = false;

        if (Object.keys(this.legacy_missingNodeRetryMap).length) {
          for (var key in this.legacy_missingNodeRetryMap) {
            try {
              var value = this.legacy_missingNodeRetryMap[key];
              var realNode = createOrGetNode(value.node, this.mirror, this.virtualDom.mirror);
              diff(realNode, value.node, replayerHandler, this.virtualDom.mirror);
              value.node = realNode;
            } catch (error) {
              this.warn(error);
            }
          }
        }

        this.constructedStyleMutations.forEach(data => {
          this.applyStyleSheetMutation(data);
        });
        this.constructedStyleMutations = [];
        this.adoptedStyleSheets.forEach(data => {
          this.applyAdoptedStyleSheet(data);
        });
        this.adoptedStyleSheets = [];
      }

      if (this.mousePos) {
        this.moveAndHover(this.mousePos.x, this.mousePos.y, this.mousePos.id, true, this.mousePos.debugData);
        this.mousePos = null;
      }

      if (this.touchActive === true) {
        this.mouse.classList.add("touch-active");
      } else if (this.touchActive === false) {
        this.mouse.classList.remove("touch-active");
      }

      this.touchActive = null;

      if (this.lastMouseDownEvent) {
        var [target, event] = this.lastMouseDownEvent;
        target.dispatchEvent(event);
      }

      this.lastMouseDownEvent = null;

      if (this.lastSelectionData) {
        this.applySelection(this.lastSelectionData);
        this.lastSelectionData = null;
      }
    });
    this.emitter.on(ReplayerEvents.PlayBack, () => {
      this.firstFullSnapshot = null;
      this.mirror.reset();
      this.styleMirror.reset();
      this.mediaManager.reset();
    });
    var timer = new Timer([], {
      speed: this.config.speed
    });
    this.service = createPlayerService({
      events: events.map(e2 => {
        if (config && config.unpackFn) {
          return config.unpackFn(e2);
        }

        return e2;
      }).sort((a1, a2) => a1.timestamp - a2.timestamp),
      timer,
      timeOffset: 0,
      baselineTime: 0,
      lastPlayedEvent: null
    }, {
      getCastFn: this.getCastFn,
      applyEventsSynchronously: this.applyEventsSynchronously,
      emitter: this.emitter
    });
    this.service.start();
    this.service.subscribe(state => {
      this.emitter.emit(ReplayerEvents.StateChange, {
        player: state
      });
    });
    this.speedService = createSpeedService({
      normalSpeed: -1,
      timer
    });
    this.speedService.start();
    this.speedService.subscribe(state => {
      this.emitter.emit(ReplayerEvents.StateChange, {
        speed: state
      });
    });
    this.mediaManager = new MediaManager({
      warn: this.warn.bind(this),
      service: this.service,
      speedService: this.speedService,
      emitter: this.emitter,
      getCurrentTime: this.getCurrentTime.bind(this)
    });
    var firstMeta = this.service.state.context.events.find(e2 => e2.type === EventType.Meta);
    var firstFullsnapshot = this.service.state.context.events.find(e2 => e2.type === EventType.FullSnapshot);

    if (firstMeta) {
      var {
        width,
        height
      } = firstMeta.data;
      setTimeout(() => {
        this.emitter.emit(ReplayerEvents.Resize, {
          width,
          height
        });
      }, 0);
    }

    if (firstFullsnapshot) {
      setTimeout(() => {
        var _a2;

        if (this.firstFullSnapshot) {
          return;
        }

        this.firstFullSnapshot = firstFullsnapshot;
        this.rebuildFullSnapshot(firstFullsnapshot);
        (_a2 = this.iframe.contentWindow) == null ? void 0 : _a2.scrollTo(firstFullsnapshot.data.initialOffset);
      }, 1);
    }

    if (this.service.state.context.events.find(indicatesTouchDevice)) {
      this.mouse.classList.add("touch-device");
    }
  }

  get timer() {
    return this.service.state.context.timer;
  }

  on(event, handler) {
    this.emitter.on(event, handler);
    return this;
  }

  off(event, handler) {
    this.emitter.off(event, handler);
    return this;
  }

  setConfig(config) {
    Object.keys(config).forEach(key => {
      config[key];
      this.config[key] = config[key];
    });

    if (!this.config.skipInactive) {
      this.backToNormal();
    }

    if (typeof config.speed !== "undefined") {
      this.speedService.send({
        type: "SET_SPEED",
        payload: {
          speed: config.speed
        }
      });
    }

    if (typeof config.mouseTail !== "undefined") {
      if (config.mouseTail === false) {
        if (this.mouseTail) {
          this.mouseTail.style.display = "none";
        }
      } else {
        if (!this.mouseTail) {
          this.mouseTail = document.createElement("canvas");
          this.mouseTail.width = Number.parseFloat(this.iframe.width);
          this.mouseTail.height = Number.parseFloat(this.iframe.height);
          this.mouseTail.classList.add("replayer-mouse-tail");
          this.wrapper.insertBefore(this.mouseTail, this.iframe);
        }

        this.mouseTail.style.display = "inherit";
      }
    }
  }

  getMetaData() {
    var firstEvent = this.service.state.context.events[0];
    var lastEvent = this.service.state.context.events[this.service.state.context.events.length - 1];
    return {
      startTime: firstEvent.timestamp,
      endTime: lastEvent.timestamp,
      totalTime: lastEvent.timestamp - firstEvent.timestamp
    };
  }
  /**
   * Get the actual time offset the player is at now compared to the first event.
   */


  getCurrentTime() {
    return this.timer.timeOffset + this.getTimeOffset();
  }
  /**
   * Get the time offset the player is at now compared to the first event, but without regard for the timer.
   */


  getTimeOffset() {
    var {
      baselineTime,
      events
    } = this.service.state.context;
    return baselineTime - events[0].timestamp;
  }

  getMirror() {
    return this.mirror;
  }
  /**
   * This API was designed to be used as play at any time offset.
   * Since we minimized the data collected from recorder, we do not
   * have the ability of undo an event.
   * So the implementation of play at any time offset will always iterate
   * all of the events, cast event before the offset synchronously
   * and cast event after the offset asynchronously with timer.
   * @param timeOffset - number
   */


  play() {
    var timeOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var _a2, _b;

    if (this.service.state.matches("paused")) {
      this.service.send({
        type: "PLAY",
        payload: {
          timeOffset
        }
      });
    } else {
      this.service.send({
        type: "PAUSE"
      });
      this.service.send({
        type: "PLAY",
        payload: {
          timeOffset
        }
      });
    }

    (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null ? void 0 : _b.classList.remove("rrweb-paused");
    this.emitter.emit(ReplayerEvents.Start);
  }

  pause(timeOffset) {
    var _a2, _b;

    if (timeOffset === void 0 && this.service.state.matches("playing")) {
      this.service.send({
        type: "PAUSE"
      });
    }

    if (typeof timeOffset === "number") {
      this.play(timeOffset);
      this.service.send({
        type: "PAUSE"
      });
    }

    (_b = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.getElementsByTagName("html")[0]) == null ? void 0 : _b.classList.add("rrweb-paused");
    this.emitter.emit(ReplayerEvents.Pause);
  }

  resume() {
    var timeOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    this.warn("The 'resume' was deprecated in 1.0. Please use 'play' method which has the same interface.");
    this.play(timeOffset);
    this.emitter.emit(ReplayerEvents.Resume);
  }
  /**
   * Totally destroy this replayer and please be careful that this operation is irreversible.
   * Memory occupation can be released by removing all references to this replayer.
   */


  destroy() {
    this.pause();
    this.mirror.reset();
    this.styleMirror.reset();
    this.mediaManager.reset();
    this.config.root.removeChild(this.wrapper);
    this.emitter.emit(ReplayerEvents.Destroy);
  }

  startLive(baselineTime) {
    this.service.send({
      type: "TO_LIVE",
      payload: {
        baselineTime
      }
    });
  }

  addEvent(rawEvent) {
    var event = this.config.unpackFn ? this.config.unpackFn(rawEvent) : rawEvent;

    if (indicatesTouchDevice(event)) {
      this.mouse.classList.add("touch-device");
    }

    void Promise.resolve().then(() => this.service.send({
      type: "ADD_EVENT",
      payload: {
        event
      }
    }));
  }

  enableInteract() {
    this.iframe.setAttribute("scrolling", "auto");
    this.iframe.style.pointerEvents = "auto";
  }

  disableInteract() {
    this.iframe.setAttribute("scrolling", "no");
    this.iframe.style.pointerEvents = "none";
  }
  /**
   * Empties the replayer's cache and reclaims memory.
   * The replayer will use this cache to speed up the playback.
   */


  resetCache() {
    this.cache = createCache();
  }

  setupDom() {
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("replayer-wrapper");
    this.config.root.appendChild(this.wrapper);
    this.mouse = document.createElement("div");
    this.mouse.classList.add("replayer-mouse");
    this.wrapper.appendChild(this.mouse);

    if (this.config.mouseTail !== false) {
      this.mouseTail = document.createElement("canvas");
      this.mouseTail.classList.add("replayer-mouse-tail");
      this.mouseTail.style.display = "inherit";
      this.wrapper.appendChild(this.mouseTail);
    }

    this.iframe = document.createElement("iframe");
    var attributes = ["allow-same-origin"];

    if (this.config.UNSAFE_replayCanvas) {
      attributes.push("allow-scripts");
    }

    this.iframe.style.display = "none";
    this.iframe.setAttribute("sandbox", attributes.join(" "));
    this.disableInteract();
    this.wrapper.appendChild(this.iframe);

    if (this.iframe.contentWindow && this.iframe.contentDocument) {
      polyfill(this.iframe.contentWindow, this.iframe.contentDocument);
      polyfill$1(this.iframe.contentWindow);
    }
  }

  rebuildFullSnapshot(event) {
    var _this7 = this;

    var isSync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!this.iframe.contentDocument) {
      return this.warn("Looks like your replayer has been destroyed.");
    }

    if (Object.keys(this.legacy_missingNodeRetryMap).length) {
      this.warn("Found unresolved missing node map", this.legacy_missingNodeRetryMap);
    }

    this.legacy_missingNodeRetryMap = {};
    var collectedIframes = [];
    var collectedDialogs = /* @__PURE__ */new Set();

    var afterAppend = (builtNode, id) => {
      if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
      this.collectIframeAndAttachDocument(collectedIframes, builtNode);

      if (this.mediaManager.isSupportedMediaElement(builtNode)) {
        var {
          events
        } = this.service.state.context;
        this.mediaManager.addMediaElements(builtNode, event.timestamp - events[0].timestamp, this.mirror);
      }

      for (var plugin3 of this.config.plugins || []) {
        if (plugin3.onBuild) plugin3.onBuild(builtNode, {
          id,
          replayer: this
        });
      }
    };

    if (this.usingVirtualDom) {
      this.virtualDom.destroyTree();
      this.usingVirtualDom = false;
    }

    this.mirror.reset();
    rebuild(event.data.node, {
      doc: this.iframe.contentDocument,
      afterAppend,
      cache: this.cache,
      mirror: this.mirror
    });
    afterAppend(this.iframe.contentDocument, event.data.node.id);

    var _loop6 = function _loop6(mutationInQueue, builtNode) {
      _this7.attachDocumentToIframe(mutationInQueue, builtNode);

      _this7.newDocumentQueue = _this7.newDocumentQueue.filter(m => m !== mutationInQueue);
    };

    for (var {
      mutationInQueue,
      builtNode
    } of collectedIframes) {
      _loop6(mutationInQueue, builtNode);
    }

    var {
      documentElement,
      head
    } = this.iframe.contentDocument;
    this.insertStyleRules(documentElement, head);
    collectedDialogs.forEach(d => applyDialogToTopLevel(d));

    if (!this.service.state.matches("playing")) {
      this.iframe.contentDocument.getElementsByTagName("html")[0].classList.add("rrweb-paused");
    }

    this.emitter.emit(ReplayerEvents.FullsnapshotRebuilded, event);

    if (!isSync) {
      this.waitForStylesheetLoad();
    }

    if (this.config.UNSAFE_replayCanvas) {
      void this.preloadAllImages();
    }
  }

  insertStyleRules(documentElement, head) {
    var _a2;

    var injectStylesRules = rules(this.config.blockClass).concat(this.config.insertStyleRules);

    if (this.config.pauseAnimation) {
      injectStylesRules.push("html.rrweb-paused *, html.rrweb-paused *:before, html.rrweb-paused *:after { animation-play-state: paused !important; }");
    }

    if (!injectStylesRules.length) {
      return;
    }

    if (this.usingVirtualDom) {
      var styleEl = this.virtualDom.createElement("style");
      this.virtualDom.mirror.add(styleEl, getDefaultSN(styleEl, this.virtualDom.unserializedId));
      documentElement.insertBefore(styleEl, head);
      styleEl.rules.push({
        source: IncrementalSource.StyleSheetRule,
        adds: injectStylesRules.map((cssText, index2) => ({
          rule: cssText,
          index: index2
        }))
      });
    } else {
      var _styleEl = document.createElement("style");

      documentElement.insertBefore(_styleEl, head);

      for (var idx = 0; idx < injectStylesRules.length; idx++) {
        (_a2 = _styleEl.sheet) == null ? void 0 : _a2.insertRule(injectStylesRules[idx], idx);
      }
    }
  }

  attachDocumentToIframe(mutation, iframeEl) {
    var _this8 = this;

    var mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
    var collectedIframes = [];
    var collectedDialogs = /* @__PURE__ */new Set();

    var afterAppend = (builtNode, id) => {
      if (builtNode.nodeName === "DIALOG") collectedDialogs.add(builtNode);
      this.collectIframeAndAttachDocument(collectedIframes, builtNode);
      var sn = mirror2.getMeta(builtNode);

      if ((sn == null ? void 0 : sn.type) === NodeType.Element && (sn == null ? void 0 : sn.tagName.toUpperCase()) === "HTML") {
        var {
          documentElement,
          head
        } = iframeEl.contentDocument;
        this.insertStyleRules(documentElement, head);
      }

      if (this.usingVirtualDom) return;

      for (var plugin3 of this.config.plugins || []) {
        if (plugin3.onBuild) plugin3.onBuild(builtNode, {
          id,
          replayer: this
        });
      }
    };

    buildNodeWithSN(mutation.node, {
      doc: iframeEl.contentDocument,
      mirror: mirror2,
      hackCss: true,
      skipChild: false,
      afterAppend,
      cache: this.cache
    });
    afterAppend(iframeEl.contentDocument, mutation.node.id);

    var _loop7 = function _loop7(mutationInQueue, builtNode) {
      _this8.attachDocumentToIframe(mutationInQueue, builtNode);

      _this8.newDocumentQueue = _this8.newDocumentQueue.filter(m => m !== mutationInQueue);
    };

    for (var {
      mutationInQueue,
      builtNode
    } of collectedIframes) {
      _loop7(mutationInQueue, builtNode);
    }

    collectedDialogs.forEach(d => applyDialogToTopLevel(d));
  }

  collectIframeAndAttachDocument(collected, builtNode) {
    if (isSerializedIframe(builtNode, this.mirror)) {
      var mutationInQueue = this.newDocumentQueue.find(m => m.parentId === this.mirror.getId(builtNode));

      if (mutationInQueue) {
        collected.push({
          mutationInQueue,
          builtNode
        });
      }
    }
  }
  /**
   * pause when loading style sheet, resume when loaded all timeout exceed
   */


  waitForStylesheetLoad() {
    var _a2;

    var head = (_a2 = this.iframe.contentDocument) == null ? void 0 : _a2.head;

    if (head) {
      var unloadSheets = /* @__PURE__ */new Set();
      var timer;
      var beforeLoadState = this.service.state;

      var stateHandler = () => {
        beforeLoadState = this.service.state;
      };

      this.emitter.on(ReplayerEvents.Start, stateHandler);
      this.emitter.on(ReplayerEvents.Pause, stateHandler);

      var unsubscribe = () => {
        this.emitter.off(ReplayerEvents.Start, stateHandler);
        this.emitter.off(ReplayerEvents.Pause, stateHandler);
      };

      head.querySelectorAll('link[rel="stylesheet"]').forEach(css => {
        if (!css.sheet) {
          unloadSheets.add(css);
          css.addEventListener("load", () => {
            unloadSheets.delete(css);

            if (unloadSheets.size === 0 && timer !== -1) {
              if (beforeLoadState.matches("playing")) {
                this.play(this.getCurrentTime());
              }

              this.emitter.emit(ReplayerEvents.LoadStylesheetEnd);

              if (timer) {
                clearTimeout(timer);
              }

              unsubscribe();
            }
          });
        }
      });

      if (unloadSheets.size > 0) {
        this.service.send({
          type: "PAUSE"
        });
        this.emitter.emit(ReplayerEvents.LoadStylesheetStart);
        timer = setTimeout(() => {
          if (beforeLoadState.matches("playing")) {
            this.play(this.getCurrentTime());
          }

          timer = -1;
          unsubscribe();
        }, this.config.loadTimeout);
      }
    }
  }
  /**
   * pause when there are some canvas drawImage args need to be loaded
   */


  preloadAllImages() {
    var _this9 = this;

    return _asyncToGenerator(function* () {
      var promises = [];

      var _loop8 = function _loop8(event) {
        if (event.type === EventType.IncrementalSnapshot && event.data.source === IncrementalSource.CanvasMutation) {
          promises.push(_this9.deserializeAndPreloadCanvasEvents(event.data, event));
          var commands = "commands" in event.data ? event.data.commands : [event.data];
          commands.forEach(c2 => {
            _this9.preloadImages(c2, event);
          });
        }
      };

      for (var event of _this9.service.state.context.events) {
        _loop8(event);
      }

      return Promise.all(promises);
    })();
  }

  preloadImages(data, event) {
    if (data.property === "drawImage" && typeof data.args[0] === "string" && !this.imageMap.has(event)) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var imgd = ctx == null ? void 0 : ctx.createImageData(canvas.width, canvas.height);
      ctx == null ? void 0 : ctx.putImageData(imgd, 0, 0);
    }
  }

  deserializeAndPreloadCanvasEvents(data, event) {
    var _this10 = this;

    return _asyncToGenerator(function* () {
      if (!_this10.canvasEventMap.has(event)) {
        var status = {
          isUnchanged: true
        };

        if ("commands" in data) {
          var commands = yield Promise.all(data.commands.map( /*#__PURE__*/function () {
            var _ref33 = _asyncToGenerator(function* (c2) {
              var args = yield Promise.all(c2.args.map(deserializeArg(_this10.imageMap, null, status)));
              return _objectSpread(_objectSpread({}, c2), {}, {
                args
              });
            });

            return function (_x7) {
              return _ref33.apply(this, arguments);
            };
          }()));
          if (status.isUnchanged === false) _this10.canvasEventMap.set(event, _objectSpread(_objectSpread({}, data), {}, {
            commands
          }));
        } else {
          var args = yield Promise.all(data.args.map(deserializeArg(_this10.imageMap, null, status)));
          if (status.isUnchanged === false) _this10.canvasEventMap.set(event, _objectSpread(_objectSpread({}, data), {}, {
            args
          }));
        }
      }
    })();
  }

  applyIncremental(e2, isSync) {
    var _a2, _b, _c;

    var {
      data: d
    } = e2;

    switch (d.source) {
      case IncrementalSource.Mutation:
        {
          try {
            this.applyMutation(d, isSync);
          } catch (error) {
            this.warn("Exception in mutation ".concat(error.message || error), d);
          }

          break;
        }

      case IncrementalSource.Drag:
      case IncrementalSource.TouchMove:
      case IncrementalSource.MouseMove:
        if (isSync) {
          var lastPosition = d.positions[d.positions.length - 1];
          this.mousePos = {
            x: lastPosition.x,
            y: lastPosition.y,
            id: lastPosition.id,
            debugData: d
          };
        } else {
          d.positions.forEach(p => {
            var action = {
              doAction: () => {
                this.moveAndHover(p.x, p.y, p.id, isSync, d);
              },
              delay: p.timeOffset + e2.timestamp - this.service.state.context.baselineTime
            };
            this.timer.addAction(action);
          });
          this.timer.addAction({
            doAction() {},

            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            delay: e2.delay - ((_a2 = d.positions[0]) == null ? void 0 : _a2.timeOffset)
          });
        }

        break;

      case IncrementalSource.MouseInteraction:
        {
          if (d.id === -1) {
            break;
          }

          var event = new Event(toLowerCase(MouseInteractions[d.type]));
          var target = this.mirror.getNode(d.id);

          if (!target) {
            return this.debugNodeNotFound(d, d.id);
          }

          this.emitter.emit(ReplayerEvents.MouseInteraction, {
            type: d.type,
            target
          });
          var {
            triggerFocus
          } = this.config;

          switch (d.type) {
            case MouseInteractions.Blur:
              if ("blur" in target) {
                target.blur();
              }

              break;

            case MouseInteractions.Focus:
              if (triggerFocus && target.focus) {
                target.focus({
                  preventScroll: true
                });
              }

              break;

            case MouseInteractions.Click:
            case MouseInteractions.TouchStart:
            case MouseInteractions.TouchEnd:
            case MouseInteractions.MouseDown:
            case MouseInteractions.MouseUp:
              if (isSync) {
                if (d.type === MouseInteractions.TouchStart) {
                  this.touchActive = true;
                } else if (d.type === MouseInteractions.TouchEnd) {
                  this.touchActive = false;
                }

                if (d.type === MouseInteractions.MouseDown) {
                  this.lastMouseDownEvent = [target, event];
                } else if (d.type === MouseInteractions.MouseUp) {
                  this.lastMouseDownEvent = null;
                }

                this.mousePos = {
                  x: d.x || 0,
                  y: d.y || 0,
                  id: d.id,
                  debugData: d
                };
              } else {
                if (d.type === MouseInteractions.TouchStart) {
                  this.tailPositions.length = 0;
                }

                this.moveAndHover(d.x || 0, d.y || 0, d.id, isSync, d);

                if (d.type === MouseInteractions.Click) {
                  this.mouse.classList.remove("active");
                  void this.mouse.offsetWidth;
                  this.mouse.classList.add("active");
                } else if (d.type === MouseInteractions.TouchStart) {
                  void this.mouse.offsetWidth;
                  this.mouse.classList.add("touch-active");
                } else if (d.type === MouseInteractions.TouchEnd) {
                  this.mouse.classList.remove("touch-active");
                } else {
                  target.dispatchEvent(event);
                }
              }

              break;

            case MouseInteractions.TouchCancel:
              if (isSync) {
                this.touchActive = false;
              } else {
                this.mouse.classList.remove("touch-active");
              }

              break;

            default:
              target.dispatchEvent(event);
          }

          break;
        }

      case IncrementalSource.Scroll:
        {
          if (d.id === -1) {
            break;
          }

          if (this.usingVirtualDom) {
            var _target = this.virtualDom.mirror.getNode(d.id);

            if (!_target) {
              return this.debugNodeNotFound(d, d.id);
            }

            _target.scrollData = d;
            break;
          }

          this.applyScroll(d, isSync);
          break;
        }

      case IncrementalSource.ViewportResize:
        this.emitter.emit(ReplayerEvents.Resize, {
          width: d.width,
          height: d.height
        });
        break;

      case IncrementalSource.Input:
        {
          if (d.id === -1) {
            break;
          }

          if (this.usingVirtualDom) {
            var _target2 = this.virtualDom.mirror.getNode(d.id);

            if (!_target2) {
              return this.debugNodeNotFound(d, d.id);
            }

            _target2.inputData = d;
            break;
          }

          this.applyInput(d);
          break;
        }

      case IncrementalSource.MediaInteraction:
        {
          var _target3 = this.usingVirtualDom ? this.virtualDom.mirror.getNode(d.id) : this.mirror.getNode(d.id);

          if (!_target3) {
            return this.debugNodeNotFound(d, d.id);
          }

          var mediaEl = _target3;
          var {
            events
          } = this.service.state.context;
          this.mediaManager.mediaMutation({
            target: mediaEl,
            timeOffset: e2.timestamp - events[0].timestamp,
            mutation: d
          });
          break;
        }

      case IncrementalSource.StyleSheetRule:
      case IncrementalSource.StyleDeclaration:
        {
          if (this.usingVirtualDom) {
            if (d.styleId) this.constructedStyleMutations.push(d);else if (d.id) (_b = this.virtualDom.mirror.getNode(d.id)) == null ? void 0 : _b.rules.push(d);
          } else this.applyStyleSheetMutation(d);

          break;
        }

      case IncrementalSource.CanvasMutation:
        {
          if (!this.config.UNSAFE_replayCanvas) {
            return;
          }

          if (this.usingVirtualDom) {
            var _target4 = this.virtualDom.mirror.getNode(d.id);

            if (!_target4) {
              return this.debugNodeNotFound(d, d.id);
            }

            _target4.canvasMutations.push({
              event: e2,
              mutation: d
            });
          } else {
            var _target5 = this.mirror.getNode(d.id);

            if (!_target5) {
              return this.debugNodeNotFound(d, d.id);
            }

            void canvasMutation({
              event: e2,
              mutation: d,
              target: _target5,
              imageMap: this.imageMap,
              canvasEventMap: this.canvasEventMap,
              errorHandler: this.warnCanvasMutationFailed.bind(this)
            });
          }

          break;
        }

      case IncrementalSource.Font:
        {
          try {
            var fontFace = new FontFace(d.family, d.buffer ? new Uint8Array(JSON.parse(d.fontSource)) : d.fontSource, d.descriptors);
            (_c = this.iframe.contentDocument) == null ? void 0 : _c.fonts.add(fontFace);
          } catch (error) {
            this.warn(error);
          }

          break;
        }

      case IncrementalSource.Selection:
        {
          if (isSync) {
            this.lastSelectionData = d;
            break;
          }

          this.applySelection(d);
          break;
        }

      case IncrementalSource.AdoptedStyleSheet:
        {
          if (this.usingVirtualDom) this.adoptedStyleSheets.push(d);else this.applyAdoptedStyleSheet(d);
          break;
        }
    }
  }
  /**
   * Apply the mutation to the virtual dom or the real dom.
   * @param d - The mutation data.
   * @param isSync - Whether the mutation should be applied synchronously (while fast-forwarding).
   */


  applyMutation(d, isSync) {
    if (this.config.useVirtualDom && !this.usingVirtualDom && isSync) {
      this.usingVirtualDom = true;
      buildFromDom(this.iframe.contentDocument, this.mirror, this.virtualDom);

      if (Object.keys(this.legacy_missingNodeRetryMap).length) {
        for (var key in this.legacy_missingNodeRetryMap) {
          try {
            var value = this.legacy_missingNodeRetryMap[key];
            var virtualNode = buildFromNode(value.node, this.virtualDom, this.mirror);
            if (virtualNode) value.node = virtualNode;
          } catch (error) {
            this.warn(error);
          }
        }
      }
    }

    var mirror2 = this.usingVirtualDom ? this.virtualDom.mirror : this.mirror;
    d.removes = d.removes.filter(mutation => {
      if (!mirror2.getNode(mutation.id)) {
        this.warnNodeNotFound(d, mutation.id);
        return false;
      }

      return true;
    });
    d.removes.forEach(mutation => {
      var _a2;

      var target = mirror2.getNode(mutation.id);

      if (!target) {
        return;
      }

      var parent = mirror2.getNode(mutation.parentId);

      if (!parent) {
        return this.warnNodeNotFound(d, mutation.parentId);
      }

      if (mutation.isShadow && hasShadowRoot(parent)) {
        parent = parent.shadowRoot;
      }

      mirror2.removeNodeFromMap(target);
      if (parent) try {
        parent.removeChild(target);
        if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_a2 = parent.rules) == null ? void 0 : _a2.length) > 0) parent.rules = [];
      } catch (error) {
        if (error instanceof DOMException) {
          this.warn("parent could not remove child in mutation", parent, target, d);
        } else {
          throw error;
        }
      }
    });

    var legacy_missingNodeMap = _objectSpread({}, this.legacy_missingNodeRetryMap);

    var queue = [];

    var nextNotInDOM = mutation => {
      var next = null;

      if (mutation.nextId) {
        next = mirror2.getNode(mutation.nextId);
      }

      if (mutation.nextId !== null && mutation.nextId !== void 0 && mutation.nextId !== -1 && !next) {
        return true;
      }

      return false;
    };

    var appendNode = mutation => {
      var _a2, _b;

      if (!this.iframe.contentDocument) {
        return this.warn("Looks like your replayer has been destroyed.");
      }

      var parent = mirror2.getNode(mutation.parentId);

      if (!parent) {
        if (mutation.node.type === NodeType.Document) {
          return this.newDocumentQueue.push(mutation);
        }

        return queue.push(mutation);
      }

      if (mutation.node.isShadow) {
        if (!hasShadowRoot(parent)) {
          parent.attachShadow({
            mode: "open"
          });
          parent = parent.shadowRoot;
        } else parent = parent.shadowRoot;
      }

      var previous = null;
      var next = null;

      if (mutation.previousId) {
        previous = mirror2.getNode(mutation.previousId);
      }

      if (mutation.nextId) {
        next = mirror2.getNode(mutation.nextId);
      }

      if (nextNotInDOM(mutation)) {
        return queue.push(mutation);
      }

      if (mutation.node.rootId && !mirror2.getNode(mutation.node.rootId)) {
        return;
      }

      var targetDoc = mutation.node.rootId ? mirror2.getNode(mutation.node.rootId) : this.usingVirtualDom ? this.virtualDom : this.iframe.contentDocument;

      if (isSerializedIframe(parent, mirror2)) {
        this.attachDocumentToIframe(mutation, parent);
        return;
      }

      var afterAppend = (node2, id) => {
        if (this.usingVirtualDom) return;
        applyDialogToTopLevel(node2);

        for (var plugin3 of this.config.plugins || []) {
          if (plugin3.onBuild) plugin3.onBuild(node2, {
            id,
            replayer: this
          });
        }
      };

      var target = buildNodeWithSN(mutation.node, {
        doc: targetDoc,
        // can be Document or RRDocument
        mirror: mirror2,
        // can be this.mirror or virtualDom.mirror
        skipChild: true,
        hackCss: true,
        cache: this.cache,

        /**
         * caveat: `afterAppend` only gets called on child nodes of target
         * we have to call it again below when this target was added to the DOM
         */
        afterAppend
      });

      if (mutation.previousId === -1 || mutation.nextId === -1) {
        legacy_missingNodeMap[mutation.node.id] = {
          node: target,
          mutation
        };
        return;
      }

      var parentSn = mirror2.getMeta(parent);

      if (parentSn && parentSn.type === NodeType.Element && mutation.node.type === NodeType.Text) {
        var prospectiveSiblings = Array.isArray(parent.childNodes) ? parent.childNodes : Array.from(parent.childNodes);

        if (parentSn.tagName === "textarea") {
          for (var c2 of prospectiveSiblings) {
            if (c2.nodeType === parent.TEXT_NODE) {
              parent.removeChild(c2);
            }
          }
        } else if (parentSn.tagName === "style" && prospectiveSiblings.length === 1) {
          for (var cssText of prospectiveSiblings) {
            if (cssText.nodeType === parent.TEXT_NODE && !mirror2.hasNode(cssText)) {
              target.textContent = cssText.textContent;
              parent.removeChild(cssText);
            }
          }
        }
      } else if ((parentSn == null ? void 0 : parentSn.type) === NodeType.Document) {
        var parentDoc = parent;
        if (mutation.node.type === NodeType.DocumentType && ((_a2 = parentDoc.childNodes[0]) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_TYPE_NODE) parentDoc.removeChild(parentDoc.childNodes[0]);
        if (target.nodeName === "HTML" && parentDoc.documentElement) parentDoc.removeChild(parentDoc.documentElement);
      }

      if (previous && previous.nextSibling && previous.nextSibling.parentNode) {
        parent.insertBefore(target, previous.nextSibling);
      } else if (next && next.parentNode) {
        parent.contains(next) ? parent.insertBefore(target, next) : parent.insertBefore(target, null);
      } else {
        parent.appendChild(target);
      }

      afterAppend(target, mutation.node.id);
      if (this.usingVirtualDom && target.nodeName === "#text" && parent.nodeName === "STYLE" && ((_b = parent.rules) == null ? void 0 : _b.length) > 0) parent.rules = [];

      if (isSerializedIframe(target, this.mirror)) {
        var targetId = this.mirror.getId(target);
        var mutationInQueue = this.newDocumentQueue.find(m => m.parentId === targetId);

        if (mutationInQueue) {
          this.attachDocumentToIframe(mutationInQueue, target);
          this.newDocumentQueue = this.newDocumentQueue.filter(m => m !== mutationInQueue);
        }
      }

      if (mutation.previousId || mutation.nextId) {
        this.legacy_resolveMissingNode(legacy_missingNodeMap, parent, target, mutation);
      }
    };

    d.adds.forEach(mutation => {
      appendNode(mutation);
    });
    var startTime = Date.now();

    while (queue.length) {
      var resolveTrees = queueToResolveTrees(queue);
      queue.length = 0;

      if (Date.now() - startTime > 500) {
        this.warn("Timeout in the loop, please check the resolve tree data:", resolveTrees);
        break;
      }

      for (var tree of resolveTrees) {
        var parent = mirror2.getNode(tree.value.parentId);

        if (!parent) {
          this.debug("Drop resolve tree since there is no parent for the root node.", tree);
        } else {
          iterateResolveTree(tree, mutation => {
            appendNode(mutation);
          });
        }
      }
    }

    if (Object.keys(legacy_missingNodeMap).length) {
      Object.assign(this.legacy_missingNodeRetryMap, legacy_missingNodeMap);
    }

    uniqueTextMutations(d.texts).forEach(mutation => {
      var _a2;

      var target = mirror2.getNode(mutation.id);

      if (!target) {
        if (d.removes.find(r2 => r2.id === mutation.id)) {
          return;
        }

        return this.warnNodeNotFound(d, mutation.id);
      }

      var parentEl = target.parentElement;

      if (mutation.value && parentEl && parentEl.tagName === "STYLE") {
        target.textContent = adaptCssForReplay(mutation.value, this.cache);
      } else {
        target.textContent = mutation.value;
      }

      if (this.usingVirtualDom) {
        var _parent = target.parentNode;
        if (((_a2 = _parent == null ? void 0 : _parent.rules) == null ? void 0 : _a2.length) > 0) _parent.rules = [];
      }
    });
    d.attributes.forEach(mutation => {
      var _a2;

      var target = mirror2.getNode(mutation.id);

      if (!target) {
        if (d.removes.find(r2 => r2.id === mutation.id)) {
          return;
        }

        return this.warnNodeNotFound(d, mutation.id);
      }

      for (var attributeName in mutation.attributes) {
        if (typeof attributeName === "string") {
          var _value4 = mutation.attributes[attributeName];

          if (_value4 === null) {
            target.removeAttribute(attributeName);
            if (attributeName === "open") removeDialogFromTopLevel(target, mutation);
          } else if (typeof _value4 === "string") {
            try {
              if (attributeName === "_cssText" && (target.nodeName === "LINK" || target.nodeName === "STYLE")) {
                try {
                  var newSn = mirror2.getMeta(target);
                  Object.assign(newSn.attributes, mutation.attributes);
                  var newNode = buildNodeWithSN(newSn, {
                    doc: target.ownerDocument,
                    // can be Document or RRDocument
                    mirror: mirror2,
                    skipChild: true,
                    hackCss: true,
                    cache: this.cache
                  });
                  var siblingNode = target.nextSibling;
                  var parentNode2 = target.parentNode;

                  if (newNode && parentNode2) {
                    parentNode2.removeChild(target);
                    parentNode2.insertBefore(newNode, siblingNode);
                    mirror2.replace(mutation.id, newNode);
                    break;
                  }
                } catch (e2) {}
              }

              if (attributeName === "value" && target.nodeName === "TEXTAREA") {
                (function () {
                  var textarea = target;
                  textarea.childNodes.forEach(c2 => textarea.removeChild(c2));
                  var tn = (_a2 = target.ownerDocument) == null ? void 0 : _a2.createTextNode(_value4);

                  if (tn) {
                    textarea.appendChild(tn);
                  }
                })();
              } else {
                target.setAttribute(attributeName, _value4);
              }

              if (attributeName === "rr_open_mode" && target.nodeName === "DIALOG") {
                applyDialogToTopLevel(target, mutation);
              }
            } catch (error) {
              this.warn("An error occurred may due to the checkout feature.", error);
            }
          } else if (attributeName === "style") {
            var styleValues = _value4;
            var targetEl = target;

            for (var s2 in styleValues) {
              if (styleValues[s2] === false) {
                targetEl.style.removeProperty(s2);
              } else if (styleValues[s2] instanceof Array) {
                var svp = styleValues[s2];
                targetEl.style.setProperty(s2, svp[0], svp[1]);
              } else {
                var svs = styleValues[s2];
                targetEl.style.setProperty(s2, svs);
              }
            }
          }
        }
      }
    });
  }
  /**
   * Apply the scroll data on real elements.
   * If the replayer is in sync mode, smooth scroll behavior should be disabled.
   * @param d - the scroll data
   * @param isSync - whether the replayer is in sync mode(fast-forward)
   */


  applyScroll(d, isSync) {
    var _a2, _b;

    var target = this.mirror.getNode(d.id);

    if (!target) {
      return this.debugNodeNotFound(d, d.id);
    }

    var sn = this.mirror.getMeta(target);

    if (target === this.iframe.contentDocument) {
      (_a2 = this.iframe.contentWindow) == null ? void 0 : _a2.scrollTo({
        top: d.y,
        left: d.x,
        behavior: isSync ? "auto" : "smooth"
      });
    } else if ((sn == null ? void 0 : sn.type) === NodeType.Document) {
      (_b = target.defaultView) == null ? void 0 : _b.scrollTo({
        top: d.y,
        left: d.x,
        behavior: isSync ? "auto" : "smooth"
      });
    } else {
      try {
        target.scrollTo({
          top: d.y,
          left: d.x,
          behavior: isSync ? "auto" : "smooth"
        });
      } catch (error) {}
    }
  }

  applyInput(d) {
    var target = this.mirror.getNode(d.id);

    if (!target) {
      return this.debugNodeNotFound(d, d.id);
    }

    try {
      target.checked = d.isChecked;
      target.value = d.text;
    } catch (error) {}
  }

  applySelection(d) {
    try {
      var selectionSet = /* @__PURE__ */new Set();
      var ranges = d.ranges.map(_ref34 => {
        var {
          start,
          startOffset,
          end,
          endOffset
        } = _ref34;
        var startContainer = this.mirror.getNode(start);
        var endContainer = this.mirror.getNode(end);
        if (!startContainer || !endContainer) return;
        var result2 = new Range();
        result2.setStart(startContainer, startOffset);
        result2.setEnd(endContainer, endOffset);
        var doc = startContainer.ownerDocument;
        var selection = doc == null ? void 0 : doc.getSelection();
        selection && selectionSet.add(selection);
        return {
          range: result2,
          selection
        };
      });
      selectionSet.forEach(s2 => s2.removeAllRanges());
      ranges.forEach(r2 => {
        var _a2;

        return r2 && ((_a2 = r2.selection) == null ? void 0 : _a2.addRange(r2.range));
      });
    } catch (error) {}
  }

  applyStyleSheetMutation(data) {
    var _a2;

    var styleSheet = null;
    if (data.styleId) styleSheet = this.styleMirror.getStyle(data.styleId);else if (data.id) styleSheet = ((_a2 = this.mirror.getNode(data.id)) == null ? void 0 : _a2.sheet) || null;
    if (!styleSheet) return;
    if (data.source === IncrementalSource.StyleSheetRule) this.applyStyleSheetRule(data, styleSheet);else if (data.source === IncrementalSource.StyleDeclaration) this.applyStyleDeclaration(data, styleSheet);
  }

  applyStyleSheetRule(data, styleSheet) {
    var _a2, _b, _c, _d;

    (_a2 = data.adds) == null ? void 0 : _a2.forEach(_ref35 => {
      var {
        rule: rule2,
        index: nestedIndex
      } = _ref35;

      try {
        if (Array.isArray(nestedIndex)) {
          var {
            positions,
            index: index2
          } = getPositionsAndIndex(nestedIndex);
          var nestedRule = getNestedRule(styleSheet.cssRules, positions);
          nestedRule.insertRule(rule2, index2);
        } else {
          var _index2 = nestedIndex === void 0 ? void 0 : Math.min(nestedIndex, styleSheet.cssRules.length);

          styleSheet == null ? void 0 : styleSheet.insertRule(rule2, _index2);
        }
      } catch (e2) {}
    });
    (_b = data.removes) == null ? void 0 : _b.forEach(_ref36 => {
      var {
        index: nestedIndex
      } = _ref36;

      try {
        if (Array.isArray(nestedIndex)) {
          var {
            positions,
            index: index2
          } = getPositionsAndIndex(nestedIndex);
          var nestedRule = getNestedRule(styleSheet.cssRules, positions);
          nestedRule.deleteRule(index2 || 0);
        } else {
          styleSheet == null ? void 0 : styleSheet.deleteRule(nestedIndex);
        }
      } catch (e2) {}
    });
    if (data.replace) try {
      void ((_c = styleSheet.replace) == null ? void 0 : _c.call(styleSheet, data.replace));
    } catch (e2) {}
    if (data.replaceSync) try {
      (_d = styleSheet.replaceSync) == null ? void 0 : _d.call(styleSheet, data.replaceSync);
    } catch (e2) {}
  }

  applyStyleDeclaration(data, styleSheet) {
    if (data.set) {
      var rule2 = getNestedRule(styleSheet.rules, data.index);
      rule2.style.setProperty(data.set.property, data.set.value, data.set.priority);
    }

    if (data.remove) {
      var _rule = getNestedRule(styleSheet.rules, data.index);

      _rule.style.removeProperty(data.remove.property);
    }
  }

  applyAdoptedStyleSheet(data) {
    var _a2;

    var targetHost = this.mirror.getNode(data.id);
    if (!targetHost) return;
    (_a2 = data.styles) == null ? void 0 : _a2.forEach(style => {
      var _a3;

      var newStyleSheet = null;
      var hostWindow = null;
      if (hasShadowRoot(targetHost)) hostWindow = ((_a3 = targetHost.ownerDocument) == null ? void 0 : _a3.defaultView) || null;else if (targetHost.nodeName === "#document") hostWindow = targetHost.defaultView;
      if (!hostWindow) return;

      try {
        newStyleSheet = new hostWindow.CSSStyleSheet();
        this.styleMirror.add(newStyleSheet, style.styleId);
        this.applyStyleSheetRule({
          source: IncrementalSource.StyleSheetRule,
          adds: style.rules
        }, newStyleSheet);
      } catch (e2) {}
    });
    var MAX_RETRY_TIME = 10;
    var count = 0;

    var adoptStyleSheets = (targetHost2, styleIds) => {
      var stylesToAdopt = styleIds.map(styleId => this.styleMirror.getStyle(styleId)).filter(style => style !== null);
      if (hasShadowRoot(targetHost2)) targetHost2.shadowRoot.adoptedStyleSheets = stylesToAdopt;else if (targetHost2.nodeName === "#document") targetHost2.adoptedStyleSheets = stylesToAdopt;

      if (stylesToAdopt.length !== styleIds.length && count < MAX_RETRY_TIME) {
        setTimeout(() => adoptStyleSheets(targetHost2, styleIds), 0 + 100 * count);
        count++;
      }
    };

    adoptStyleSheets(targetHost, data.styleIds);
  }

  legacy_resolveMissingNode(map, parent, target, targetMutation) {
    var {
      previousId,
      nextId
    } = targetMutation;
    var previousInMap = previousId && map[previousId];
    var nextInMap = nextId && map[nextId];

    if (previousInMap) {
      var {
        node: node2,
        mutation
      } = previousInMap;
      parent.insertBefore(node2, target);
      delete map[mutation.node.id];
      delete this.legacy_missingNodeRetryMap[mutation.node.id];

      if (mutation.previousId || mutation.nextId) {
        this.legacy_resolveMissingNode(map, parent, node2, mutation);
      }
    }

    if (nextInMap) {
      var {
        node: _node2,
        mutation: _mutation
      } = nextInMap;
      parent.insertBefore(_node2, target.nextSibling);
      delete map[_mutation.node.id];
      delete this.legacy_missingNodeRetryMap[_mutation.node.id];

      if (_mutation.previousId || _mutation.nextId) {
        this.legacy_resolveMissingNode(map, parent, _node2, _mutation);
      }
    }
  }

  moveAndHover(x2, y, id, isSync, debugData) {
    var target = this.mirror.getNode(id);

    if (!target) {
      return this.debugNodeNotFound(debugData, id);
    }

    var base = getBaseDimension(target, this.iframe);

    var _x = x2 * base.absoluteScale + base.x;

    var _y = y * base.absoluteScale + base.y;

    this.mouse.style.left = "".concat(_x, "px");
    this.mouse.style.top = "".concat(_y, "px");

    if (!isSync) {
      this.drawMouseTail({
        x: _x,
        y: _y
      });
    }

    this.hoverElements(target);
  }

  drawMouseTail(position) {
    if (!this.mouseTail) {
      return;
    }

    var {
      lineCap,
      lineWidth,
      strokeStyle,
      duration
    } = this.config.mouseTail === true ? defaultMouseTailConfig : Object.assign({}, defaultMouseTailConfig, this.config.mouseTail);

    var draw = () => {
      if (!this.mouseTail) {
        return;
      }

      var ctx = this.mouseTail.getContext("2d");

      if (!ctx || !this.tailPositions.length) {
        return;
      }

      ctx.clearRect(0, 0, this.mouseTail.width, this.mouseTail.height);
      ctx.beginPath();
      ctx.lineWidth = lineWidth;
      ctx.lineCap = lineCap;
      ctx.strokeStyle = strokeStyle;
      ctx.moveTo(this.tailPositions[0].x, this.tailPositions[0].y);
      this.tailPositions.forEach(p => ctx.lineTo(p.x, p.y));
      ctx.stroke();
    };

    this.tailPositions.push(position);
    draw();
    setTimeout(() => {
      this.tailPositions = this.tailPositions.filter(p => p !== position);
      draw();
    }, duration / this.speedService.state.context.timer.speed);
  }

  hoverElements(el) {
    var _a2;

    (_a2 = this.lastHoveredRootNode || this.iframe.contentDocument) == null ? void 0 : _a2.querySelectorAll(".\\:hover").forEach(hoveredEl => {
      hoveredEl.classList.remove(":hover");
    });
    this.lastHoveredRootNode = el.getRootNode();
    var currentEl = el;

    while (currentEl) {
      if (currentEl.classList) {
        currentEl.classList.add(":hover");
      }

      currentEl = currentEl.parentElement;
    }
  }

  isUserInteraction(event) {
    if (event.type !== EventType.IncrementalSnapshot) {
      return false;
    }

    return event.data.source > IncrementalSource.Mutation && event.data.source <= IncrementalSource.Input;
  }

  backToNormal() {
    this.nextUserInteractionEvent = null;

    if (this.speedService.state.matches("normal")) {
      return;
    }

    this.speedService.send({
      type: "BACK_TO_NORMAL"
    });
    this.emitter.emit(ReplayerEvents.SkipEnd, {
      speed: this.speedService.state.context.normalSpeed
    });
  }

  warnNodeNotFound(d, id) {
    this.warn("Node with id '".concat(id, "' not found. "), d);
  }

  warnCanvasMutationFailed(d, error) {
    this.warn("Has error on canvas update", error, "canvas mutation:", d);
  }

  debugNodeNotFound(d, id) {
    this.debug("Node with id '".concat(id, "' not found. "), d);
  }

  warn() {
    if (!this.config.showWarning) {
      return;
    }

    for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
      args[_key20] = arguments[_key20];
    }

    this.config.logger.warn(REPLAY_CONSOLE_PREFIX, ...args);
  }

  debug() {
    if (!this.config.showDebug) {
      return;
    }

    for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      args[_key21] = arguments[_key21];
    }

    this.config.logger.log(REPLAY_CONSOLE_PREFIX, ...args);
  }

}

var {
  addCustomEvent
} = record;
var {
  freezePage
} = record;
var {
  takeFullSnapshot
} = record;
export { EventType, IncrementalSource, MouseInteractions, Replayer, ReplayerEvents, addCustomEvent, canvasMutation, freezePage, _mirror as mirror, record, takeFullSnapshot, utils };